(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1927],{

/***/ 36556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ AccordionItem; },
/* harmony export */   "U": function() { return /* binding */ Accordion; }
/* harmony export */ });
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73352);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28658);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Accordion = _DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Accordion;
var AccordionItem = function AccordionItem(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      activeAccordion = _useState[0],
      setActiveAccordion = _useState[1];

  var toggleClass = function toggleClass(eventKey) {
    return props.activeAccordion === eventKey ? "toggle--active ".concat((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["accordion__toggle--active"])) : "";
  };

  var CustomToggle = function CustomToggle(_ref) {
    var _jsx2;

    var children = _ref.children,
        eventKey = _ref.eventKey;
    var decoratedOnClick = (0,_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.useAccordionToggle)(eventKey, function () {
      if (eventKey === activeAccordion) {
        setActiveAccordion("");
      } else {
        setActiveAccordion(eventKey);
      }
    });
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", (_jsx2 = {
      className: "".concat((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().accordion__toggle), " ").concat(props.className, " ").concat(toggleClass(eventKey)),
      id: props.id,
      onClick: function onClick() {
        decoratedOnClick();
        props.handleOnClick(eventKey);
      }
    }, (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_jsx2, "id", props.id ? props.id : "accordion"), (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_jsx2, "children", children), _jsx2));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: (_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().accordion),
    id: props.id,
    "data-cms-title": props.dataCMSTitle,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Col, {
      xs: 12,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CustomToggle, {
        eventKey: props.eventKey,
        children: props.title
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Accordion.Collapse, {
      eventKey: props.eventKey,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: (_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().accordion__collapse),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Col, {
          xs: 12,
          children: props.children
        })
      })
    })]
  });
};

/***/ }),

/***/ 24761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46176);
/* harmony import */ var _AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var AddressTile = function AddressTile(_ref) {
  var type = _ref.type,
      variant = _ref.variant,
      data = _ref.data,
      handleOnEdit = _ref.handleOnEdit,
      handleOnDelete = _ref.handleOnDelete,
      handleOnClick = _ref.handleOnClick,
      selectedAddress = _ref.selectedAddress,
      deleteOption = _ref.deleteOption,
      id = _ref.id,
      className = _ref.className;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      highlightedAddress = _useState[0],
      setHighlightedAddress = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      content = _useState2[0],
      setContent = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
      addressData = _useState3[0],
      setAddressData = _useState3[1];

  var env = (_config_index__WEBPACK_IMPORTED_MODULE_1___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_1___default().envConfigs)[env].imagePrefix;

  var createStreetString = function createStreetString(arr) {
    var res = "";

    if (arr && Array.isArray(arr) && arr.length > 0) {
      res = arr.join(", ");
    }

    return res;
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (data) {
      var newData = {
        id: data.id,
        name: data.address_name ? data.address_name : null,
        street: data.street_number && data.street_number != "" && data.street ? data.street_number + ", " + createStreetString(data.street) : data.street_number && data.street_number != "" ? data.street_number : data.street ? createStreetString(data.street) : null,
        suburb: data.suburb ? data.suburb : null,
        postcode: data.postcode ? data.postcode : null
      };

      if (newData.street && newData.suburb && newData.postcode) {
        setContent(newData.street + ", " + newData.suburb + ", " + newData.postcode);
      } else if (newData.suburb && newData.postcode) {
        setContent(newData.suburb + ", " + newData.postcode);
      }

      setAddressData(newData);
    }
  }, [data]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setHighlightedAddress(selectedAddress);
  }, [selectedAddress]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "".concat((_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().addressTile), " ").concat(highlightedAddress == data.id ? (_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["addressTile-greenBorder"]) : [""], " ").concat(className),
      id: "".concat(id, " ").concat(highlightedAddress == data.id ? id + "-green-tick" : ""),
      onClick: function onClick() {
        handleOnClick(data, type);
      },
      children: [data.address_name && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: (_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().addressTile__heading),
        children: data.address_name
      }), content && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: (_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().addressTile__content),
        children: content
      }), (data.firstname || data.telephone) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: (_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().addressTile__value),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
          className: (_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().addressTile__value__first),
          children: data.firstname
        }), data.telephone && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
          className: (_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().addressTile__value__second),
          children: data.telephone
        })]
      }), data && variant == "edit" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: (_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["addressTile__action-btn"]),
          children: [deleteOption && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
            className: "".concat((_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btn), " ").concat((_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["delete"])),
            id: "".concat(id, "-delete"),
            onClick: function onClick(e) {
              e.stopPropagation();
              handleOnDelete(addressData, type);
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("i", {
              className: "".concat((_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon), " ").concat((_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon__delete))
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: (_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().label),
              children: "Delete"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
            className: "".concat((_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btn), " ").concat((_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().edit)),
            id: "".concat(id, "-edit"),
            onClick: function onClick(e) {
              e.stopPropagation();
              handleOnEdit(type, "edit", data);
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("i", {
              className: "".concat((_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon), " ").concat((_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon__edit))
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: (_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().label),
              children: "Edit"
            })]
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "".concat(highlightedAddress == data.id ? (_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().addressTile__triangle) : ["d-none"]),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: (_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default().addressTile__click),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
            className: (_AddressTile_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["addressTile__click-tick"]),
            src: "".concat(imagePrefix, "/assets/images/tick.svg"),
            alt: "tick"
          })
        })
      })]
    })
  });
};

AddressTile.defaultProps = {
  type: "delivery",
  variant: "edit",
  data: {},
  deleteOption: true
};
/* harmony default export */ __webpack_exports__["Z"] = (AddressTile);

/***/ }),

/***/ 10626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64036);
/* harmony import */ var _CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12426);
/* harmony import */ var _CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _TermsCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22210);
/* harmony import */ var _TermsCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_TermsCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








var TermsCheckbox = function TermsCheckbox(_ref) {
  var formName = _ref.formName,
      label = _ref.label,
      fieldName = _ref.fieldName,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      onChangeHandler = _ref.onChangeHandler,
      onBlurHandler = _ref.onBlurHandler,
      className = _ref.className;
  var errorClass = fieldErrors[fieldName] ? (_TermsCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : "";

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
      className: "".concat(errorClass, " ").concat((_TermsCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["main-container"]), " ").concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["main-container"]), " ").concat(className),
      id: "".concat(fieldName, "-checkout-condition"),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Row, {
        className: "".concat((_TermsCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["main-row"]), " ").concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["main-row"])),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          sm: "12",
          md: "12",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-group"]),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Check, {
            custom: true,
            className: "".concat((_TermsCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-checkbox-label"]), " ").concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-checkbox-label"])),
            id: "validationFormtc101-".concat(fieldName),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Check.Input, {
              name: fieldName,
              type: "checkbox",
              checked: fieldValues[fieldName],
              onChange: handleChange,
              onBlur: handleBlur
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Check.Label, {
              id: "validationFormtc101-".concat(fieldName, "-label"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
                dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .createMarkup */ .KU)(label)
              })
            })]
          })
        })
      })
    }), fieldErrors[fieldName] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
      className: (_TermsCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
      children: fieldErrorsMessage[fieldName]
    })]
  });
};

TermsCheckbox.defaultProps = {
  formName: "termsCheckbox",
  fieldName: "terms",
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (TermsCheckbox);

/***/ }),

/***/ 76284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkoutPageError_CheckoutPageError; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./Redux/actions/cartAction.js
var cartAction = __webpack_require__(35311);
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
;// CONCATENATED MODULE: ./Redux/actions/checkoutPageErorAction.js

var memorizeSelectedPreference = function memorizeSelectedPreference(value) {
  return function (dispatch) {
    dispatch({
      type: actionTypes/* CHECKOUT_PAGE_ERROR_SELECTED_PREFERENCE */.VV,
      payload: value
    });
  };
};
// EXTERNAL MODULE: ./components/atoms/checkoutPageError/CheckoutPageError.module.scss
var CheckoutPageError_module = __webpack_require__(92930);
var CheckoutPageError_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutPageError_module);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/checkoutPageError/CheckoutPageError.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var CheckoutPageError = function CheckoutPageError(_ref) {
  var type = _ref.type,
      title = _ref.title,
      desc = _ref.desc,
      className = _ref.className,
      primaryLabel = _ref.primaryLabel,
      primaryUrl = _ref.primaryUrl,
      secondaryLabel = _ref.secondaryLabel,
      secondaryUrl = _ref.secondaryUrl,
      handlePrimaryClick = _ref.handlePrimaryClick,
      handleSecondaryClick = _ref.handleSecondaryClick,
      imgUrl = _ref.imgUrl,
      pageName = _ref.pageName,
      pageErrorType = _ref.pageErrorType,
      id = _ref.id,
      additionalUtagData = _ref.additionalUtagData,
      dividerLine = _ref.dividerLine,
      subTitle = _ref.subTitle,
      subDesc = _ref.subDesc,
      ctaTitle = _ref.ctaTitle,
      disablePrimary = _ref.disablePrimary,
      preferences = _ref.preferences,
      defaultPreference = _ref.defaultPreference,
      dealProducts = _ref.dealProducts,
      cartItems = _ref.cartItems,
      showGuestCart = _ref.showGuestCart,
      memorizeSelectedPreference = _ref.memorizeSelectedPreference,
      multicartFlag = _ref.multicartFlag,
      analyticsPageErrorCode = _ref.analyticsPageErrorCode,
      analyticsPageErrorMessage = _ref.analyticsPageErrorMessage,
      onceOffCartProducts = _ref.onceOffCartProducts;
  var btnPrimaryClass;
  var cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");

  var _useState = (0,react.useState)(defaultPreference),
      selectedPreference = _useState[0],
      setSelectedPreference = _useState[1];

  var _useState2 = (0,react.useState)(disablePrimary),
      disabledPrimary = _useState2[0],
      setDisabledPrimary = _useState2[1];

  switch (type) {
    case "success":
      btnPrimaryClass = (CheckoutPageError_module_default())["p-success"];
      break;

    case "error":
      btnPrimaryClass = (CheckoutPageError_module_default())["p-error"];
      break;

    default:
      btnPrimaryClass = (CheckoutPageError_module_default())["p-default"];
      break;
  }

  (0,react.useEffect)(function () {
    if (pageName) {
      var errorType = pageErrorType ? pageErrorType : type == "error" ? "technical error" : type;
      memorizeSelectedPreference(undefined);
      var pageAnalyticsData = {
        page_name: "".concat(pageName, ": ").concat(errorType)
      };

      if (errorType == "technical error" && analyticsPageErrorCode && analyticsPageErrorMessage) {
        pageAnalyticsData.page_errors_code = analyticsPageErrorCode;
        pageAnalyticsData.page_errors = analyticsPageErrorMessage;
      }

      analyticsUtag/* view */.ei(_objectSpread(_objectSpread({
        page_event: "view"
      }, pageAnalyticsData), {}, {
        multicart_flag: multicartFlag ? true : false
      }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type", additionalUtagData])));
    }
  }, []);

  var handlePreferenceChange = function handlePreferenceChange(id, analyticsLabel) {
    setSelectedPreference(id);
    memorizeSelectedPreference(id);
    setDisabledPrimary(false);
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(analyticsLabel),
      page_name: "".concat(pageName)
    });
  };

  var primaryButtonClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(url) {
      var dealProductsIds, query, onceOffCartProductsIds, _query, nonVasProducts, cartItemsIds, _query2;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(selectedPreference && (selectedPreference == "once-off" || selectedPreference == "check-once-off-only") && dealProducts.length > 0)) {
                _context.next = 11;
                break;
              }

              //delete deals products from cart before redirecting user to normal checkout page
              dealProductsIds = dealProducts.map(function (item) {
                return item === null || item === void 0 ? void 0 : item.id;
              });
              (0,helperServices/* showSpinner */.yh)();
              query = (0,helperServices/* getClearCartQuery */.Bn)(dealProductsIds);
              _context.next = 6;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(query);

            case 6:
              _context.next = 8;
              return showGuestCart(cartId);

            case 8:
              (0,helperServices/* hideSpinner */.v3)();
              _context.next = 32;
              break;

            case 11:
              if (!(selectedPreference && selectedPreference == "select-another-deal-dont-need-once-off" && onceOffCartProducts.length > 0)) {
                _context.next = 22;
                break;
              }

              onceOffCartProductsIds = onceOffCartProducts.map(function (item) {
                return item === null || item === void 0 ? void 0 : item.id;
              });
              (0,helperServices/* showSpinner */.yh)();
              _query = (0,helperServices/* getClearCartQuery */.Bn)(onceOffCartProductsIds);
              _context.next = 17;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(_query);

            case 17:
              _context.next = 19;
              return showGuestCart(cartId);

            case 19:
              (0,helperServices/* hideSpinner */.v3)();
              _context.next = 32;
              break;

            case 22:
              if (!(url && url === "/" && cartItems.length > 0)) {
                _context.next = 32;
                break;
              }

              //delete all products from cart before redirecting user to home page
              nonVasProducts = cartItems.filter(function (item) {
                return !(item !== null && item !== void 0 && item.parent_product_sku);
              });
              cartItemsIds = nonVasProducts.map(function (item) {
                return item === null || item === void 0 ? void 0 : item.id;
              });
              (0,helperServices/* showSpinner */.yh)();
              _query2 = (0,helperServices/* getClearCartQuery */.Bn)(cartItemsIds);
              _context.next = 29;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(_query2);

            case 29:
              _context.next = 31;
              return showGuestCart(cartId);

            case 31:
              (0,helperServices/* hideSpinner */.v3)();

            case 32:
              handlePrimaryClick(selectedPreference);

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function primaryButtonClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var secondaryButtonClick = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(url) {
      var nonVasProducts, cartItemsIds, query;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(url && url === "/" && cartItems.length > 0)) {
                _context2.next = 10;
                break;
              }

              //delete all products from cart before redirecting user to home page
              nonVasProducts = cartItems.filter(function (item) {
                return !(item !== null && item !== void 0 && item.parent_product_sku);
              });
              cartItemsIds = nonVasProducts.map(function (item) {
                return item === null || item === void 0 ? void 0 : item.id;
              });
              (0,helperServices/* showSpinner */.yh)();
              query = (0,helperServices/* getClearCartQuery */.Bn)(cartItemsIds);
              _context2.next = 7;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(query);

            case 7:
              _context2.next = 9;
              return showGuestCart(cartId);

            case 9:
              (0,helperServices/* hideSpinner */.v3)();

            case 10:
              handleSecondaryClick();

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function secondaryButtonClick(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((CheckoutPageError_module_default())["main-container"], " ").concat(className),
    children: [imgUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((CheckoutPageError_module_default()).icon),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
        img_path: imgUrl
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((CheckoutPageError_module_default()).title),
      children: [" ", title, " "]
    }), desc && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CheckoutPageError_module_default()).desc,
      dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(desc)
    }), dividerLine && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CheckoutPageError_module_default()).divider
    }), subTitle && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CheckoutPageError_module_default())["sub-title"],
      dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(subTitle)
    }), subDesc && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CheckoutPageError_module_default())["sub-desc"],
      dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(subDesc)
    }), ctaTitle && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CheckoutPageError_module_default())["cta-title"],
      dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(ctaTitle)
    }), preferences.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CheckoutPageError_module_default())["radio-buttons-wrapper"],
      children: preferences.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((CheckoutPageError_module_default()).button),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "radio",
            name: "preference",
            value: item.label,
            checked: selectedPreference === item.id,
            onChange: function onChange() {
              return handlePreferenceChange(item.id, item === null || item === void 0 ? void 0 : item.analyticsLabel);
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            onClick: function onClick() {
              return handlePreferenceChange(item.id, item === null || item === void 0 ? void 0 : item.analyticsLabel);
            },
            children: item.label
          })]
        }, index);
      })
    }), (primaryLabel || secondaryLabel) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CheckoutPageError_module_default())["button-wrapper"],
      children: [primaryLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        id: "primary-btn-".concat(type, "-").concat(id),
        onClick: function onClick() {
          return primaryButtonClick(primaryUrl);
        },
        className: "".concat((CheckoutPageError_module_default()).button, " ").concat((CheckoutPageError_module_default()).primary, " ").concat(btnPrimaryClass),
        disabled: disabledPrimary,
        children: primaryLabel
      }), secondaryLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        id: "secondary-btn-".concat(type, "-").concat(id),
        onClick: function onClick() {
          return secondaryButtonClick(secondaryUrl);
        },
        className: "".concat((CheckoutPageError_module_default()).button, " ").concat((CheckoutPageError_module_default()).secondary),
        children: secondaryLabel
      })]
    })]
  });
};

CheckoutPageError.defaultProps = {
  type: "success",
  title: "We’ll be in contact soon!",
  desc: null,
  primaryLabel: null,
  primaryUrl: null,
  secondaryLabel: null,
  secondaryUrl: null,
  handlePrimaryClick: function handlePrimaryClick() {},
  handleSecondaryClick: function handleSecondaryClick() {},
  imgUrl: null,
  pageName: null,
  pageErrorType: null,
  id: "0",
  dividerLine: false,
  subTitle: null,
  subDesc: null,
  ctaTitle: null,
  disablePrimary: false,
  preferences: [],
  defaultPreference: null,
  analyticsPageErrorCode: null,
  analyticsPageErrorMessage: null
};
/* harmony default export */ var checkoutPageError_CheckoutPageError = ((0,DependencyHelper.connect)(null, {
  showGuestCart: cartAction/* showGuestCart */.cD,
  memorizeSelectedPreference: memorizeSelectedPreference
})(CheckoutPageError));

/***/ }),

/***/ 41759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64036);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _DeliveryTitle_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71127);
/* harmony import */ var _DeliveryTitle_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_DeliveryTitle_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var DeliveryTitle = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function (_ref) {
  var title = _ref.title,
      contents = _ref.contents,
      className = _ref.className,
      id = _ref.id,
      iconType = _ref.iconType,
      descClassName = _ref.descClassName;
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_2___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_2___default().envConfigs)[env].imagePrefix;

  var checkIcon = function checkIcon(icon) {
    switch (icon) {
      case "tick":
        return "tick.svg";

      case "info-white":
        return "info_white.svg";

      case "error-circle":
        return "error-circle.svg";

      case "error-circle-white":
        return "error-circle-white.svg";

      default:
        return "error-circle-white.svg";
    }
  };

  var iconTypeSvg = checkIcon(iconType);
  var iconTypePath = "".concat(imagePrefix, "/assets/images/").concat(iconTypeSvg);

  var ListItem = function ListItem(_ref2) {
    var index = _ref2.index,
        icon = _ref2.icon,
        desc = _ref2.desc;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      children: iconType == "dot" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("li", {
        id: "".concat(id, "-item-").concat(index),
        className: (_DeliveryTitle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().desc),
        dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .createMarkup */ .KU)(desc)
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: (_DeliveryTitle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
          className: (_DeliveryTitle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
          src: icon
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          id: "".concat(id, "-item-").concat(index),
          className: "".concat((_DeliveryTitle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().desc), " ").concat(descClassName),
          dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .createMarkup */ .KU)(desc)
        })]
      }, index)
    });
  };

  var listItems = contents.map(function (item, index) {
    return item ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ListItem, {
        index: index,
        icon: item.icon ? item.icon : iconTypePath,
        desc: item.description ? item.description : item
      })
    }, index) : null;
  });

  var ContentInformation = function ContentInformation() {
    if (iconType == "dot") {
      return contents.some(function (txt) {
        return txt;
      }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ul", {
        className: "".concat((_DeliveryTitle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().deliveryTitle__content), " ").concat((_DeliveryTitle_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["content-ul"])),
        children: listItems
      });
    } else {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "".concat((_DeliveryTitle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().deliveryTitle__content)),
        children: listItems
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: "".concat((_DeliveryTitle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().deliveryTitle), " ").concat(className),
    id: id,
    children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: (_DeliveryTitle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().deliveryTitle__title),
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ContentInformation, {})]
  });
});
DeliveryTitle.defaultProps = {
  title: null,
  contents: [],
  iconType: "tick"
};
/* harmony default export */ __webpack_exports__["Z"] = (DeliveryTitle);

/***/ }),

/***/ 85092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28658);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2814);
/* harmony import */ var _DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var DropDownComponent = function DropDownComponent(props) {
  var selectedValue = props.selectedValue,
      data = props.data,
      handleSelect = props.handleSelect,
      longest = props.longest,
      menuClassName = props.menuClassName,
      id = props.id;

  var checkVal = function checkVal(e) {
    handleSelect(e);
  };

  var menuWidth = (longest + 2) * 2 / 3;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.DropdownButton, {
    id: "drop-down-button-".concat(id),
    title: selectedValue,
    alignRight: true,
    bsPrefix: "".concat((_DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["dropdown-button"]), " ").concat(props.customClass, " selected-").concat((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .toDesignation */ .ke)(selectedValue)),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      style: {
        width: "".concat(menuWidth, "rem")
      },
      className: (_DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[menuClassName],
      children: data.map(function (item, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Dropdown.Item, {
          className: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .toDesignation */ .ke)(item.label),
          eventKey: item.label,
          bsPrefix: (_DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().dropdown),
          onSelect: checkVal,
          id: "".concat(index, "_").concat(item.label),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("label", {
            className: (_DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item),
            children: item.label
          })
        }, index);
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (DropDownComponent);

/***/ }),

/***/ 75221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86801);
/* harmony import */ var _storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79549);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69152);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);









var StoreCard = function StoreCard(_ref) {
  var data = _ref.data,
      handleOnClick = _ref.handleOnClick,
      selectedStoreCard = _ref.selectedStoreCard,
      variant = _ref.variant,
      onSizeChange = _ref.onSizeChange,
      showFewerEnabled = _ref.showFewerEnabled,
      checkStoresShownLength = _ref.checkStoresShownLength,
      itemClassName = _ref.itemClassName,
      isFromModal = _ref.isFromModal,
      geoLocationIsAllowed = _ref.geoLocationIsAllowed;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      outOfStock = _useState[0],
      setOutOfStock = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      noClickandCollect = _useState2[0],
      setNoClickandCollect = _useState2[1];

  var env = (_config_index__WEBPACK_IMPORTED_MODULE_1___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_1___default().envConfigs)[env].imagePrefix;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(3),
      size = _useState3[0],
      setSize = _useState3[1];

  var dataLength = data === null || data === void 0 ? void 0 : data.length;

  var onShowmoreClick = function onShowmoreClick() {
    if (dataLength > size + 3) {
      setSize(size = size + 3);
      onSizeChange(size);
      checkStoresShownLength && checkStoresShownLength(size);
    } else {
      var val = dataLength - size;
      setSize(size + val);
      onSizeChange(size + val);
    }

    var pageName = _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_3__/* .getUtagData */ .GS(["page_name"]).page_name;
    _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_3__/* .link */ .p4({
      link_type: "o",
      link_name: "".concat(pageName, ": show more stores")
    });
  };

  var onShowfewerClick = function onShowfewerClick() {
    setSize(3);
    onSizeChange(3);
  };

  var itemImage = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
    className: (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["storeCard__tracker-icon"]),
    src: "".concat(imagePrefix, "/assets/images/tracker-red.png")
  });

  var renderItemName = function renderItemName(item) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default().storeCard__heading),
      children: item.name.toLowerCase()
    });
  };

  var renderItemDistance = function renderItemDistance(item) {
    return !isFromModal && geoLocationIsAllowed ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default().storeCard__location),
        children: Math.round(item.distance) + " km from your current location"
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["storeCard-modal-distance"]),
        children: geoLocationIsAllowed ? Math.round(item.distance) + " km from your current location" : ''
      })
    });
  };

  var renderDetailsCard = function renderDetailsCard(item) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["item-container"]),
        children: [itemImage, renderItemName(item)]
      }), renderItemDistance(item)]
    });
  };

  var renderCheckoutCard = function renderCheckoutCard(item, index) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["storeCard__heading-container"]),
        children: [itemImage, renderItemName(item), (item === null || item === void 0 ? void 0 : item.inStock) == false && !isFromModal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["storeCard__no-stock"]),
          children: "Out of stock"
        }), noClickandCollect && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["storeCard__no-click-and-collect"]),
          children: "No Click & Collect"
        })]
      }), !isFromModal && variant !== "closestStore" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default().storeCard__content),
        children: item.addressLineOne
      }), renderItemDistance(item), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "".concat(selectedStoreCard === index ? (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default().storeCard__triangle) : ["d-none"]),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default().storeCard__click),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
            className: (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["storeCard__click-tick"]),
            src: "".concat(imagePrefix, "/assets/images/tick.svg"),
            alt: "tick"
          })
        })
      })]
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [data === null || data === void 0 ? void 0 : data.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
        children: index < size && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: "".concat((_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default().storeCard), " ").concat(item.inStock == false ? (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default().greyOutCard) : "", " ").concat(selectedStoreCard === index ? (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["storeCard-greenBorder"]) : [""], " ").concat(itemClassName, " ").concat(isFromModal ? (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["storeCard-modal"]) : ''),
          onClick: function onClick() {
            handleOnClick(index, item);
          },
          children: itemClassName ? renderDetailsCard(item) : renderCheckoutCard(item, index)
        })
      });
    }), variant === "searchedStore" && variant !== "closestStore" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "text-center",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_2__["default"], {
        className: "styles[\"storeCard-button\"] ".concat(!isFromModal ? (_storeCard_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["show-more-btn"]) : ""),
        variant: "outline black",
        handleClick: (data === null || data === void 0 ? void 0 : data.length) > size ? onShowmoreClick : onShowfewerClick,
        children: (data === null || data === void 0 ? void 0 : data.length) > size ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("label", {
          children: "+ Show more stores"
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("label", {
          children: "- Show fewer stores"
        })
      })
    })]
  });
};

StoreCard.defaultProps = {
  isFromModal: false
};
StoreCard.defaultProps = {
  data: []
};
/* harmony default export */ __webpack_exports__["Z"] = (StoreCard);

/***/ }),

/***/ 15681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkoutOrderSummary_CheckoutOrderSummary; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./services/checkoutService.js
var checkoutService = __webpack_require__(34020);
// EXTERNAL MODULE: ./utils/featuresService.js
var featuresService = __webpack_require__(90760);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./utils/microServices.js
var microServices = __webpack_require__(49366);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./data/mockRenderComponent.js
var mockRenderComponent = __webpack_require__(29151);
// EXTERNAL MODULE: ./context/checkout-journey-context.js
var checkout_journey_context = __webpack_require__(62039);
// EXTERNAL MODULE: ./Redux/actions/checkoutAction.js
var checkoutAction = __webpack_require__(39166);
// EXTERNAL MODULE: ./Redux/actions/geoLocationAction.js
var geoLocationAction = __webpack_require__(28935);
// EXTERNAL MODULE: ./utils/logger.js
var logger = __webpack_require__(21534);
// EXTERNAL MODULE: ./components/organisms/buttonPayment/ButtonPayment.module.scss
var ButtonPayment_module = __webpack_require__(14305);
var ButtonPayment_module_default = /*#__PURE__*/__webpack_require__.n(ButtonPayment_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/buttonPayment/ButtonPayment.jsx






















var ButtonPayment = function ButtonPayment(_ref) {
  var _cartDetails$selected, _cartDetails$shipping, _cartDetails$selected2, _cartDetails$shipping2, _cartDetails$shipping3, _cartDetails$prices, _cartDetails$prices$g;

  var btnSecure = _ref.btnSecure,
      btnLable = _ref.btnLable,
      btnDisabled = _ref.btnDisabled,
      navigate = _ref.navigate,
      customerStatus = _ref.customerStatus,
      setPageErr = _ref.setPageErr,
      deal = _ref.deal,
      dealID = _ref.dealID,
      applicationType = _ref.applicationType,
      cartDetails = _ref.cartDetails,
      currentJourneyType = _ref.currentJourneyType,
      authDetailsData = _ref.authDetailsData,
      paymentMethodCode = _ref.paymentMethodCode,
      shippingAddress = _ref.shippingAddress,
      addressTypes = _ref.addressTypes,
      selectedUpgradeMsisdn = _ref.selectedUpgradeMsisdn,
      unMaskedMsisdn = _ref.unMaskedMsisdn,
      pageName = _ref.pageName,
      geoLocation = _ref.geoLocation,
      creditVettingDetails = _ref.creditVettingDetails,
      paymentOptionsEnabled = _ref.paymentOptionsEnabled,
      setPostOrderResponse = _ref.setPostOrderResponse,
      setChangeStore = _ref.setChangeStore,
      setChangeMethods = _ref.setChangeMethods,
      setStoreDetails = _ref.setStoreDetails,
      continueDisable = _ref.continueDisable,
      selectedUpgradeResponse = _ref.selectedUpgradeResponse;
  var router = (0,DependencyHelper.useRouter)();
  var cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
  var otpAuthtoken = (0,helperServices/* getCookieValue */.Do)("vod-web-auth-otp-token");
  var authToken = (0,helperServices/* getCookieValue */.Do)("auth_token");
  var vodAuthToken = (0,helperServices/* getCookieValue */.Do)("vod-web-auth-token");
  var carrierCode = (cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$selected = cartDetails.selected_shipping_method) === null || _cartDetails$selected === void 0 ? void 0 : _cartDetails$selected.carrier_code) == "clickandcollect" ? "clickandcollect" : cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping === void 0 ? void 0 : _cartDetails$shipping.carrier_code;
  var methodCode = (cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$selected2 = cartDetails.selected_shipping_method) === null || _cartDetails$selected2 === void 0 ? void 0 : _cartDetails$selected2.method_code) == "clickandcollect" ? "clickandcollect" : cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping2 = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping2 === void 0 ? void 0 : _cartDetails$shipping2.method_code;
  var totalZero = parseFloat(cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping3 = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping3 === void 0 ? void 0 : _cartDetails$shipping3.shipping_fee) + parseFloat(cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$prices = cartDetails.prices) === null || _cartDetails$prices === void 0 ? void 0 : (_cartDetails$prices$g = _cartDetails$prices.grand_total) === null || _cartDetails$prices$g === void 0 ? void 0 : _cartDetails$prices$g.value) == parseFloat(0) ? "true" : "false";
  var addressTypesOptions = addressTypes ? addressTypes : [];

  var createStreetString = function createStreetString(arr) {
    var res = "";

    if (Array.isArray(arr) && arr.length > 0) {
      res = arr.join(", ");
    }

    return res;
  };
  /**
   * Upgrade customer request payload
   *
   * @usage map the key-value pair request
   */


  var mapUpgradeData = function mapUpgradeData() {
    var _addressType$;

    var dealPrice;
    var sessionMsisdn = sessionStorage.getItem('upgradeMsisdn');

    try {
      var _deal$;

      dealPrice = (_deal$ = deal[0]) === null || _deal$ === void 0 ? void 0 : _deal$.monthly_recurring.toString();
    } catch (error) {
      dealPrice = "0";
    }

    var addressType = addressTypesOptions.filter(function (address) {
      return address.id == (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.address_type_name);
    });

    if (!selectedUpgradeMsisdn || !unMaskedMsisdn) {
      analyticsUtag/* error */.vU("Upgrade Journey: Missing MSISDN ".concat(selectedUpgradeMsisdn));
    }

    if (currentJourneyType === checkout_journey_context/* journeyType.upgrade */.w.upgrade && !selectedUpgradeMsisdn && !unMaskedMsisdn && !sessionMsisdn) {
      (0,helperServices/* hideSpinner */.v3)();
      handleMissingMsisdn("chk-dxl-p-po-200", "Upgrade journey missing msisdn");
    }

    var sessionCartSummary = (0,helperServices/* getSessionStorage */.wJ)(labels/* default.Session_Keys.lbl_cart_summary */.Z.Session_Keys.lbl_cart_summary);
    var cssHandsetDetails = Array.isArray(sessionCartSummary) ? sessionCartSummary.map(function (item) {
      return {
        productSKUCode: item.line500CODE,
        familyGroupId: item.groupid
      };
    }) : [];
    return {
      context: "UPGRADE",
      dealSheetId: dealID,
      idNumber: authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber,
      idType: authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType,
      upgradeMsisdn: selectedUpgradeMsisdn ? selectedUpgradeMsisdn : unMaskedMsisdn ? unMaskedMsisdn : sessionMsisdn ? sessionMsisdn : null,
      dealCost: dealPrice,
      updateAddressDetails: {
        inputType: "ADDRESS",
        addressType: addressType[0] ? (_addressType$ = addressType[0]) === null || _addressType$ === void 0 ? void 0 : _addressType$.label : "Residential",
        addressDetails: {
          addressType: shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.complex_name ? constants/* BUILDING_ADDR */.YY : constants/* STREET_ADDR */.Dz,
          buildingName: shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.company ? shippingAddress.company : "",
          city: shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.city ? shippingAddress.city : "",
          complexName: shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.complex_name ? shippingAddress.complex_name : "",
          complexNumber: "",
          complexStreet: "",
          country: "South Africa",
          deliveryAddressFlag: "true",
          lineOne: "",
          postalCode: shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.postcode ? shippingAddress.postcode : "",
          postalDeliveryFlag: "false",
          primaryAddressFlag: "false",
          privateBagNumber: "",
          province: shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.region ? shippingAddress.region.label : "",
          ricaFlag: "false",
          seoid: "",
          streetName: shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.street ? createStreetString(shippingAddress.street) : "",
          streetNo: shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.street_number && (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.street_number) !== "" ? shippingAddress.street_number : "00",
          suburb: shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.suburb ? shippingAddress.suburb : "",
          unitNumber: shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.unit_number ? shippingAddress.unit_number : ""
        }
      },
      otpToken: otpAuthtoken,
      listOfCSSHandsetDetailsList: {
        cssHandsetDetails: cssHandsetDetails
      }
    };
  };

  var placeOrder = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var shippingMethodData, paymentMethodData, _paymentMethodData$er, _shippingMethodData$e;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0,helperServices/* showSpinner */.yh)();

              if (currentJourneyType == checkout_journey_context/* journeyType.upgrade */.w.upgrade) {
                carrierCode = "flatrate";
                methodCode = "flatrate";
              }

              _context.next = 5;
              return (0,checkoutService/* setShippingMethodsOnCartService */.YD)(cartId, carrierCode, methodCode);

            case 5:
              shippingMethodData = _context.sent;

              if (shippingMethodData.fail) {
                _context.next = 13;
                break;
              }

              _context.next = 9;
              return (0,checkoutService/* setPaymentMethod */.$P)(cartId, totalZero, paymentMethodCode);

            case 9:
              paymentMethodData = _context.sent;

              if (!paymentMethodData.fail) {
                if (currentJourneyType == checkout_journey_context/* journeyType.upgrade */.w.upgrade) {
                  submitUpgrade();
                } else {
                  orderRouter();
                }
              } else {
                (0,helperServices/* hideSpinner */.v3)();
                handleApiFailure("chk-mg-p-pm-".concat(paymentMethodData === null || paymentMethodData === void 0 ? void 0 : paymentMethodData.status), paymentMethodData === null || paymentMethodData === void 0 ? void 0 : (_paymentMethodData$er = paymentMethodData.errors[0]) === null || _paymentMethodData$er === void 0 ? void 0 : _paymentMethodData$er.message);
              }

              _context.next = 15;
              break;

            case 13:
              (0,helperServices/* hideSpinner */.v3)();
              handleApiFailure("chk-mg-p-sm-".concat(shippingMethodData === null || shippingMethodData === void 0 ? void 0 : shippingMethodData.status), shippingMethodData === null || shippingMethodData === void 0 ? void 0 : (_shippingMethodData$e = shippingMethodData.errors[0]) === null || _shippingMethodData$e === void 0 ? void 0 : _shippingMethodData$e.message);

            case 15:
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);
              (0,helperServices/* hideSpinner */.v3)();
              handleApiFailure("chk-mg-p-sm-500", _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 17]]);
    }));

    return function placeOrder() {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Upgrade customer
   *
   * @usage submit the data with request payload
   */


  var submitUpgrade = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var inputObj, _responseData$respons, responseData, _responseData$error, _responseData$respons2, _responseData$respons3, _responseData$respons6, _responseData$respons7, _responseData$respons4, _responseData$respons5, _responseData$respons8, _responseData$respons9;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              inputObj = mapUpgradeData();

              if (featuresService/* Features.get */.A.get("simOnlyEarlyUpgradeEnabled") && (inputObj === null || inputObj === void 0 ? void 0 : inputObj.context) === "UPGRADE") {
                inputObj.simOnlyUpgradeFlg = selectedUpgradeResponse === null || selectedUpgradeResponse === void 0 ? void 0 : selectedUpgradeResponse.simOnlyUpgradeFlg;
              }

              _context2.prev = 2;
              _context2.next = 5;
              return microServices/* default.put */.Z.put("api", "customerDetails", inputObj, null, true);

            case 5:
              responseData = _context2.sent;

              if (responseData !== null && responseData !== void 0 && (_responseData$respons = responseData.response) !== null && _responseData$respons !== void 0 && _responseData$respons.data) {
                orderRouter();
              } else {
                if (responseData !== null && responseData !== void 0 && (_responseData$error = responseData.error) !== null && _responseData$error !== void 0 && _responseData$error.status) {
                  fetchErrorDetails("updateCustomerDetails_".concat(responseData.error.status), "chk-dxl-p-ucd-".concat(responseData.error.status), "UpdateCustomerDetails data not found");
                } else if (responseData && (responseData === null || responseData === void 0 ? void 0 : (_responseData$respons2 = responseData.response) === null || _responseData$respons2 === void 0 ? void 0 : (_responseData$respons3 = _responseData$respons2.data) === null || _responseData$respons3 === void 0 ? void 0 : _responseData$respons3.responseCode) == "ORDER_CREATION_ERROR") {
                  (0,helperServices/* hideSpinner */.v3)();
                  analyticsStoreError(responseData === null || responseData === void 0 ? void 0 : (_responseData$respons4 = responseData.response) === null || _responseData$respons4 === void 0 ? void 0 : (_responseData$respons5 = _responseData$respons4.data) === null || _responseData$respons5 === void 0 ? void 0 : _responseData$respons5.responseCode, "store reservation technical error");
                  fetchErrorDetails(labels/* default.lbl_store_reservation_technical_error */.Z.lbl_store_reservation_technical_error, "chk-dxl-p-ucd-500-store_reservation_technical_error", "store reservation technical error");
                } else if (responseData && (responseData === null || responseData === void 0 ? void 0 : (_responseData$respons6 = responseData.response) === null || _responseData$respons6 === void 0 ? void 0 : (_responseData$respons7 = _responseData$respons6.data) === null || _responseData$respons7 === void 0 ? void 0 : _responseData$respons7.responseCode) == "ORDER_CREATION_NOSTORESTOCK") {
                  (0,helperServices/* hideSpinner */.v3)();
                  analyticsStoreError(responseData === null || responseData === void 0 ? void 0 : (_responseData$respons8 = responseData.response) === null || _responseData$respons8 === void 0 ? void 0 : (_responseData$respons9 = _responseData$respons8.data) === null || _responseData$respons9 === void 0 ? void 0 : _responseData$respons9.responseCode, "store reservation business error");
                  fetchErrorDetails(labels/* default.lbl_store_reservation_business_error */.Z.lbl_store_reservation_business_error, "chk-dxl-p-ucd-424-store_reservation_business_error", "store reservation business error");
                } else {
                  fetchErrorDetails(labels/* default.auth.errorCodes.api_time_out */.Z.auth.errorCodes.api_time_out, "chk-dxl-p-ucd-504", "UpdateCustomerDetails api time out");
                }
              }

              _context2.next = 13;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](2);
              (0,helperServices/* hideSpinner */.v3)();
              handleApiFailure("chk-dxl-p-ucd-500", _context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 9]]);
    }));

    return function submitUpgrade() {
      return _ref3.apply(this, arguments);
    };
  }();

  var orderRouter = function orderRouter() {
    var _creditVettingDetails;

    var headers = {};
    var isPendedReferredOffline = false;
    var postOrder = JSON.parse(JSON.stringify(mockRenderComponent.productOrderReq).replace(/\:null/gi, ':""')); //replace null with "" for all attributes

    postOrder.productOrder[0].externalId = cartId;

    if (geoLocation && geoLocation !== null && geoLocation !== void 0 && geoLocation.storeDetails) {
      postOrder.productOrder[0].storeCode = geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.storeDetails;
    }

    if (applicationType !== "normal") {
      postOrder.productOrder[0].journeyType = currentJourneyType;
      postOrder.productOrder[0].contact.identificationID = authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber;
      postOrder.productOrder[0].contact.identificationType = authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType;
    }

    if (creditVettingDetails && ((creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode) === labels/* default.creditVetting.lbl_resultcode_pended */.Z.creditVetting.lbl_resultcode_pended || (creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode) === labels/* default.creditVetting.lbl_resultcode_pending */.Z.creditVetting.lbl_resultcode_pending || (creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode) === labels/* default.creditVetting.lbl_resultcode_referred */.Z.creditVetting.lbl_resultcode_referred || (creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode) === labels/* default.creditVetting.lbl_resultcode_offline */.Z.creditVetting.lbl_resultcode_offline || creditVettingDetails !== null && creditVettingDetails !== void 0 && (_creditVettingDetails = creditVettingDetails.resultCode) !== null && _creditVettingDetails !== void 0 && _creditVettingDetails.toUpperCase().includes(labels/* default.creditVetting.lbl_unprocessed */.Z.creditVetting.lbl_unprocessed))) {
      postOrder.productOrder[0]["removeStandalone"] = true;
      isPendedReferredOffline = true;
    } else {
      postOrder.productOrder[0]["removeStandalone"] = false;
      isPendedReferredOffline = false;
    }

    if (vodAuthToken) {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-auth-jwt": "Bearer ".concat(vodAuthToken),
        "x-magento-token": "Bearer ".concat(authToken)
      };
    } else {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json"
      };
    }

    var url = "".concat((config_default()).envConfigs[(config_default()).env].dxl.url).concat((config_default()).api.postpaidProductOrder);
    axios_default().post(url, postOrder, {
      headers: headers
    }).then(function (response) {
      var _data$productOrders;

      var _ref4 = response || {},
          data = _ref4.data;

      if (data && data !== null && data !== void 0 && (_data$productOrders = data.productOrders) !== null && _data$productOrders !== void 0 && _data$productOrders.length) {
        var _data$productOrders$, _data$productOrders$2, _data$productOrders$3, _data$productOrders$4;

        var sessionMsisdn = sessionStorage.getItem('upgradeMsisdn');
        setPostOrderResponse(data.productOrders[0]);
        (0,helperServices/* setCookieConsentWrapper */.ol)("cookie_".concat((config_default()).order_id), [(config_default()).cookie_category.strictly_necessary], "document.cookie='".concat((config_default()).order_id, "=").concat((_data$productOrders$ = data.productOrders[0]) === null || _data$productOrders$ === void 0 ? void 0 : _data$productOrders$.productOrderId, ";path=/'"));
        DependencyHelper.Cookie.remove("cart_id");

        if (isPendedReferredOffline) {
          var newCartId = response.data.productOrders[0].newCartId;
          (0,helperServices/* setCookieConsentWrapper */.ol)("cart_id", [(config_default()).cookie_category.strictly_necessary], "document.cookie='cart_id=".concat(newCartId, ";path=/'"));
          (0,helperServices/* cartUpdateEvent */.Px)();
        }

        continueDisable(true);

        if (((_data$productOrders$2 = data.productOrders[0]) === null || _data$productOrders$2 === void 0 ? void 0 : _data$productOrders$2.niMigrationFeatureToggle) === true && !((_data$productOrders$3 = data.productOrders[0]) !== null && _data$productOrders$3 !== void 0 && _data$productOrders$3.payment) || (_data$productOrders$4 = data.productOrders[0]) !== null && _data$productOrders$4 !== void 0 && _data$productOrders$4.payment) {
          (0,helperServices/* hideSpinner */.v3)();

          if (paymentOptionsEnabled) {
            navigate("payment");
          } else {
            navigate("paymentRedirect");
          }
        } else {
          (0,helperServices/* hideSpinner */.v3)();

          if (currentJourneyType === checkout_journey_context/* journeyType.upgrade */.w.upgrade && !selectedUpgradeMsisdn && !unMaskedMsisdn && !sessionMsisdn) {
            handleMissingMsisdn("chk-dxl-p-po-200", "Upgrade journey missing msisdn");
          } else {
            navigate("orderConfirmation");
          }
        }

        if (geoLocation && geoLocation !== null && geoLocation !== void 0 && geoLocation.storeDetails) {
          setStoreDetails(false);
          setChangeMethods(false);
          setChangeStore(false);
        }
      } else if (data && (data === null || data === void 0 ? void 0 : data.responseCode) == "ORDER_CREATION_ERROR") {
        (0,helperServices/* hideSpinner */.v3)();
        analyticsStoreError(data === null || data === void 0 ? void 0 : data.responseCode, "store reservation technical error");
        fetchErrorDetails(labels/* default.lbl_store_reservation_technical_error */.Z.lbl_store_reservation_technical_error, "chk-dxl-p-ucd-500-store_reservation_technical_error", "store reservation technical error");
      } else if (data && (data === null || data === void 0 ? void 0 : data.responseCode) == "ORDER_CREATION_NOSTORESTOCK") {
        (0,helperServices/* hideSpinner */.v3)();
        analyticsStoreError(data === null || data === void 0 ? void 0 : data.responseCode, "store reservation business error");
        fetchErrorDetails(labels/* default.lbl_store_reservation_business_error */.Z.lbl_store_reservation_business_error, "chk-dxl-p-ucd-424-store_reservation_business_error", "store reservation business error");
      } else {
        (0,helperServices/* hideSpinner */.v3)();
        handleApiFailure("chk-dxl-p-po-200", "productOrderId not found in product orders array");
      }
    })["catch"](function (err) {
      (0,helperServices/* hideSpinner */.v3)();
      checkOrderCreation(err);
      handleApiFailure("chk-dxl-p-po-500", err === null || err === void 0 ? void 0 : err.message);
    });
  };

  function checkOrderCreation(result) {
    if (result.messages) {
      var len = result.messages.length;

      for (var i = 0; i < len; i++) {
        if (result.messages[i].key == "orderStatus" && (0,helperServices/* getOrderCreated */.Yn)(result.messages[i].message)) {
          DependencyHelper.Cookie.remove("cart_id");
        }
      }
    }
  }

  function handleMissingMsisdn(errorCode, errorMessage) {
    var pageName = "checkout: ".concat(pageName, ": ").concat(customerStatus);
    var leadBucket = "upgrade_service_down";
    setPageErr({
      type: "error",
      title: labels/* default.checkout.lbl_technical_error_title */.Z.checkout.lbl_technical_error_title,
      desc: labels/* default.checkout.lbl_technical_error_desc */.Z.checkout.lbl_technical_error_desc,
      primaryLabel: "Call me back",
      secondaryLabel: "Exit checkout",
      handlePrimaryClick: function handlePrimaryClick() {
        return _handlePrimaryClick("/forms/ecommerce?bucket=".concat(leadBucket), "call me back");
      },
      handleSecondaryClick: function handleSecondaryClick() {
        return _handleSecondaryClick(null, "exit checkout");
      },
      imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
      pageName: pageName,
      pageErrorType: "technical error",
      analyticsPageErrorCode: errorCode,
      analyticsPageErrorMessage: errorMessage
    });
    navigate("pageError");
  }
  /**
   * Get the error display data
   * @usage Redirect to checkout error with error details
   */


  var fetchErrorDetails = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(resultCode, errorCode, errorMessage) {
      var pageName, result;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              pageName = "checkout: ".concat(pageName, ": ").concat(customerStatus);
              _context3.prev = 1;
              _context3.next = 4;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [resultCode]);

            case 4:
              result = _context3.sent;
              setPageErr({
                type: "error",
                title: result[0].resultTitle,
                desc: result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML,
                primaryLabel: result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                primaryUrl: result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                secondaryLabel: result[0].secondaryEnabled === "Yes" ? result[0].secondaryCTAText : null,
                secondaryUrl: result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                handlePrimaryClick: function handlePrimaryClick() {
                  return _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].primaryCTAURL, result[0].leadType, result[0].primaryCTAType), result[0].primaryCTAText);
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].secondaryCTAURL, result[0].leadType, result[0].secondaryCTAType), result[0].secondaryCTAText);
                },
                imgUrl: result[0].icon,
                pageName: pageName,
                analyticsPageErrorCode: errorCode,
                analyticsPageErrorMessage: errorMessage
              });
              logger/* Logger.error */.Y.error(result[0].resultTitle || "fetchErrorDetails - ButtonPayment - error", "ButtonPayment", {
                response: JSON.stringify(result),
                "function": "fetchErrorDetails",
                functionParams: {
                  resultCode: resultCode,
                  errorCode: errorCode,
                  errorMessage: errorMessage
                }
              });
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");
              _context3.next = 17;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);
              logger/* Logger.error */.Y.error(_context3.t0, "ButtonPayment", {
                "function": "fetchErrorDetails",
                functionParams: {
                  resultCode: resultCode,
                  errorCode: errorCode,
                  errorMessage: errorMessage
                }
              });
              setPageErr({
                type: "error",
                title: labels/* default.auth.lbl_technical_error_title */.Z.auth.lbl_technical_error_title,
                desc: labels/* default.auth.lbl_technical_error_desc */.Z.auth.lbl_technical_error_desc,
                primaryLabel: "Call me back",
                secondaryLabel: "Exit checkout",
                handlePrimaryClick: function handlePrimaryClick() {
                  return _handlePrimaryClick(null, "call me back");
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick(null, "exit checkout");
                },
                imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                pageName: pageName,
                analyticsPageErrorCode: errorCode,
                analyticsPageErrorMessage: errorMessage
              });
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 11]]);
    }));

    return function fetchErrorDetails(_x, _x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  function handleApiFailure(errorCode, errorMessage) {
    logger/* Logger.error */.Y.error(errorMessage, "ButtonPayment", {}, {
      utag_code: errorCode || "unknown"
    });

    if (applicationType == "normal" || cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti) {
      navigate("paymentError");
    } else {
      var _pageName = "checkout: ".concat(_pageName, ": ").concat(customerStatus);

      setPageErr({
        type: "error",
        title: labels/* default.checkout.lbl_technical_error_title */.Z.checkout.lbl_technical_error_title,
        desc: labels/* default.checkout.lbl_technical_error_desc */.Z.checkout.lbl_technical_error_desc,
        primaryLabel: "Call me back",
        secondaryLabel: "Exit checkout",
        handlePrimaryClick: function handlePrimaryClick() {
          return _handlePrimaryClick(null, "call me back");
        },
        handleSecondaryClick: function handleSecondaryClick() {
          return _handleSecondaryClick(null, "exit checkout");
        },
        imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
        pageName: _pageName,
        pageErrorType: "technical error",
        analyticsPageErrorCode: errorCode,
        analyticsPageErrorMessage: errorMessage
      });
      navigate("pageError");
    }
  }

  var _handlePrimaryClick = function _handlePrimaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label),
      page_name: "".concat(pageName)
    });

    if (url && label == "Choose another store") {
      setChangeStore(true);
      setChangeMethods(false);
      (0,helperServices/* hideSpinner */.v3)();
      navigate("delivery");
    } else {
      if (url) {
        router.push("".concat(helperServices/* urlPrefix */.wn).concat(url)).then(function () {
          (0,helperServices/* hideSpinner */.v3)();
        });
      } else {
        router.push("".concat(helperServices/* urlPrefix */.wn, "/forms/ecommerce")).then(function () {
          (0,helperServices/* hideSpinner */.v3)();
        });
      }
    }
  };

  var _handleSecondaryClick = function _handleSecondaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label),
      page_name: "".concat(pageName)
    });

    if (url && label == "Choose delivery option instead") {
      setChangeMethods(true);
      setStoreDetails(false);
      (0,helperServices/* hideSpinner */.v3)();
      navigate("delivery");
    } else {
      if (url) {
        router.push("".concat(helperServices/* urlPrefix */.wn).concat(url)).then(function () {
          (0,helperServices/* hideSpinner */.v3)();
        });
      } else {
        router.push("/").then(function () {
          (0,helperServices/* hideSpinner */.v3)();
        });
      }
    }
  };

  function handleSubmit(event) {
    event.preventDefault();
    var linkUrl = applicationType == "normal" ? "checkout" : "post-checkout";
    var linkName = applicationType == "normal" || cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? "continue" : currentJourneyType == checkout_journey_context/* journeyType.upgrade */.w.upgrade ? "submit upgrade" : "submit application";
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "checkout: ".concat(pageName, ": ").concat(customerStatus, ": ").concat(linkName),
      link_url: "".concat(helperServices/* urlPrefix */.wn, "/").concat(linkUrl)
    });
    placeOrder();
  }

  var analyticsStoreError = function analyticsStoreError(errorType, errorMessage) {
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    var types = errorMessage == "store reservation business error" ? "business error" : "service error";
    analyticsUtag/* view */.ei({
      page_event: "view",
      page_name: "".concat(pageName, ": ").concat(types),
      page_form_event: "error",
      page_errors: errorType,
      page_error_type: "page"
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      type: "button",
      onClick: handleSubmit,
      className: "".concat((ButtonPayment_module_default())["payment-button"], " ").concat(btnSecure ? (ButtonPayment_module_default()).secure : ""),
      name: btnLable,
      value: applicationType == "normal" && totalZero == "true" && methodCode == "freeshipping" ? "Confirm Order" : btnLable,
      disabled: btnDisabled,
      id: "make-payment"
    })
  });
};

ButtonPayment.defaultProps = {
  btnSecure: false,
  btnDisabled: false,
  btnClass: ""
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    cartDetails: state.cartDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    selectedUpgradeMsisdn: state.upgrade.selectedUpgradeMsisdn,
    selectedUpgradeResponse: state.upgrade.selectedUpgradeResponse,
    creditVettingDetails: state.checkoutDetails.creditVettingResult,
    unMaskedMsisdn: state.upgrade.unMaskedMsisdn,
    geoLocation: state.geoLocation,
    paymentMethodCode: state.checkoutDetails.paymentMethodCode
  };
};

var mapDispatchToProps = {
  setChangeStore: geoLocationAction/* setChangeStore */.oA,
  setStoreDetails: geoLocationAction/* setStoreDetails */.Gi,
  setChangeMethods: geoLocationAction/* setChangeMethods */.p5,
  setPostOrderResponse: checkoutAction/* setPostOrderResponse */.wg
};
/* harmony default export */ var buttonPayment_ButtonPayment = ((0,DependencyHelper.connect)(mapStateToProps, mapDispatchToProps)(ButtonPayment));
// EXTERNAL MODULE: ./components/molecules/checkoutOrderSummary/CheckoutOrderSummary.module.scss
var CheckoutOrderSummary_module = __webpack_require__(58628);
var CheckoutOrderSummary_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutOrderSummary_module);
;// CONCATENATED MODULE: ./components/molecules/checkoutOrderSummary/CheckoutOrderSummary.jsx









var CheckoutOrderSummary = function CheckoutOrderSummary(_ref) {
  var _dealProduct$product, _monthlyCartProducts$, _monthlyCartProducts$2, _monthlyCartProducts$3, _monthlyCartProducts$4, _dealProduct$product7, _monthlyCartProducts$5, _monthlyCartProducts$6, _monthlyCartProducts$7, _monthlyCartProducts$8, _monthlyCartProducts$9, _dealProducts$, _dealProducts$$produc;

  var variant = _ref.variant,
      subTotal = _ref.subTotal,
      totalSaving = _ref.totalSaving,
      delivery = _ref.delivery,
      total = _ref.total,
      onClickSubmit = _ref.onClickSubmit,
      navigate = _ref.navigate,
      btnSecure = _ref.btnSecure,
      btnPayment = _ref.btnPayment,
      btnDisabled = _ref.btnDisabled,
      btnLable = _ref.btnLable,
      btnType = _ref.btnType,
      monthlyCartProducts = _ref.monthlyCartProducts,
      dealProducts = _ref.dealProducts,
      onceOffCartProducts = _ref.onceOffCartProducts,
      contractType = _ref.contractType,
      pageType = _ref.pageType,
      customerStatus = _ref.customerStatus,
      setPageErr = _ref.setPageErr,
      currentJourneyType = _ref.currentJourneyType,
      shippingAddress = _ref.shippingAddress,
      addressTypes = _ref.addressTypes,
      cartDetails = _ref.cartDetails,
      showOnceOffProducts = _ref.showOnceOffProducts,
      buttonPaymentPageName = _ref.buttonPaymentPageName,
      paymentOptionsEnabled = _ref.paymentOptionsEnabled,
      continueDisable = _ref.continueDisable;
  (0,react.useEffect)(function () {
    if (variant == "pop-up") {
      var dragDiv = document.getElementById("checkout-summary");
      dragDiv.addEventListener("touchstart", onTouchStart, false);
      return function () {
        dragDiv.removeEventListener("touchstart", onTouchStart);
      };
    }
  });
  var dealProduct = monthlyCartProducts.find(function (cartProduct) {
    var _cartProduct$product;

    return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product = cartProduct.product) === null || _cartProduct$product === void 0 ? void 0 : _cartProduct$product.is_deal_product) === 1;
  });
  var dealSku = dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product = dealProduct.product) === null || _dealProduct$product === void 0 ? void 0 : _dealProduct$product.sku;
  var vasPrice,
      dealVasPrice = 0;
  var dealVasProduct = monthlyCartProducts.filter(function (cartProduct) {
    return (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.parent_product_sku) == dealSku;
  });

  if (dealVasProduct) {
    dealVasPrice = dealVasProduct.reduce(function (accu, ele) {
      if (dealSku && (ele === null || ele === void 0 ? void 0 : ele.parent_product_sku) == dealSku) {
        accu += ele === null || ele === void 0 ? void 0 : ele.monthly_recurring;
        return accu;
      }
    }, 0);
  }

  var isSimonlyUpgrade = ((_monthlyCartProducts$ = monthlyCartProducts[0]) === null || _monthlyCartProducts$ === void 0 ? void 0 : (_monthlyCartProducts$2 = _monthlyCartProducts$.product) === null || _monthlyCartProducts$2 === void 0 ? void 0 : _monthlyCartProducts$2.deal_delivery) && monthlyCartProducts.length === 1 && !(contractType === "Upgrade" && (_monthlyCartProducts$3 = monthlyCartProducts[0]) !== null && _monthlyCartProducts$3 !== void 0 && (_monthlyCartProducts$4 = _monthlyCartProducts$3.product) !== null && _monthlyCartProducts$4 !== void 0 && _monthlyCartProducts$4.sim_only_flg);
  var dealPrice, contractDuration, totalDealPrice, firstMonthTotal;

  if (pageType == "contract") {
    var monthy = monthlyCartProducts && monthlyCartProducts.length > 1 ? true : false;

    if (monthy) {
      var counter = 0;
      monthlyCartProducts.forEach(function (item) {
        var _item$product;

        if ((item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.is_deal_product) === 1) {
          counter++;
        }
      });
      monthy = counter == 1;
    } else {
      monthy = monthlyCartProducts && monthlyCartProducts.length == 1 ? true : false;
    }

    if (monthy) {
      var _dealProduct$product2, _dealProduct$product3;

      dealPrice = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(Math.round((dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product2 = dealProduct.product) === null || _dealProduct$product2 === void 0 ? void 0 : _dealProduct$product2.monthly_recurring) * 100) / 100));
      contractDuration = "".concat(dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product3 = dealProduct.product) === null || _dealProduct$product3 === void 0 ? void 0 : _dealProduct$product3.payment_terms_label, " months");

      if (dealVasPrice) {
        var _dealProduct$product4, _dealProduct$product5;

        vasPrice = parseFloat(dealVasPrice);
        vasPrice = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(Math.round(vasPrice * 100) / 100));
        dealVasPrice = parseFloat(dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product4 = dealProduct.product) === null || _dealProduct$product4 === void 0 ? void 0 : _dealProduct$product4.monthly_recurring) + parseFloat(dealVasPrice);
        dealVasPrice = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(Math.round(dealVasPrice * 100) / 100));
        totalDealPrice = "".concat(dealVasPrice, " \xD7 ").concat(dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product5 = dealProduct.product) === null || _dealProduct$product5 === void 0 ? void 0 : _dealProduct$product5.payment_terms_label);
      } else {
        var _dealProduct$product6;

        totalDealPrice = "".concat(dealPrice, " \xD7 ").concat(dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product6 = dealProduct.product) === null || _dealProduct$product6 === void 0 ? void 0 : _dealProduct$product6.payment_terms_label);
      }
    } else {
      dealPrice = "-";
      contractDuration = "-";
      totalDealPrice = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(0));
    }
  }

  if (dealProduct !== null && dealProduct !== void 0 && (_dealProduct$product7 = dealProduct.product) !== null && _dealProduct$product7 !== void 0 && _dealProduct$product7.deal_delivery) {
    var _dealProduct$product8, _dealProduct$product9;

    firstMonthTotal = parseInt(totalDealPrice.replace(/^\D+/g, "").replace(/,/g, '')) + parseInt(dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product8 = dealProduct.product) === null || _dealProduct$product8 === void 0 ? void 0 : (_dealProduct$product9 = _dealProduct$product8.deal_delivery) === null || _dealProduct$product9 === void 0 ? void 0 : _dealProduct$product9.replace(/^\D+/g, ""));
  }

  var totalOnceOffItems = onceOffCartProducts.reduce(function (acc, curr) {
    return acc + (curr === null || curr === void 0 ? void 0 : curr.quantity);
  }, 0);

  var RenderDiv = function RenderDiv(label, value, subLabel) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CheckoutOrderSummary_module_default()).wrapper,
      id: "".concat(label, "-parent-checkout"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CheckoutOrderSummary_module_default()).label,
        id: "".concat(label, "-child-checkout"),
        children: label
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CheckoutOrderSummary_module_default()).value,
        id: "".concat(value, "-value-checkout"),
        children: [value, subLabel ? " " + subLabel : ""]
      })]
    });
  };

  var RenderWrapper = function RenderWrapper(label, value, subLabel) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((CheckoutOrderSummary_module_default()).wrapper, " ").concat(label === "Delivery:" ? (CheckoutOrderSummary_module_default())["delivery-lbl-spacing"] : ""),
      id: "".concat(label, "-parent-checkout"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((CheckoutOrderSummary_module_default())["wrapper-label"]),
        id: "".concat(label, "-child-checkout"),
        children: label
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((CheckoutOrderSummary_module_default())["wrapper-value"]),
        id: "".concat(value, "-value-checkout"),
        children: [value, subLabel ? " " + subLabel : ""]
      })]
    });
  };

  var navigateToNextPage = function navigateToNextPage() {
    if (onClickSubmit) {
      onClickSubmit();
    }
  };

  function onTouchStart(e) {
    var openClass = (CheckoutOrderSummary_module_default()).open;

    if (!e.target.classList.contains((CheckoutOrderSummary_module_default())["continue-button"]) && !e.target.classList.contains((CheckoutOrderSummary_module_default())["button-label"])) {
      // eslint-disable-next-line no-undef
      $("#checkout-summary").toggleClass(openClass);
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      draggable: "true",
      className: "".concat((CheckoutOrderSummary_module_default())["checkout-summary"], " ").concat((CheckoutOrderSummary_module_default())[variant]),
      id: "checkout-summary",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CheckoutOrderSummary_module_default()).swipe,
        children: "\xA0"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        className: pageType == "contract" ? (CheckoutOrderSummary_module_default())["wrapper-title"] : (CheckoutOrderSummary_module_default()).title,
        children: labels/* default.lbl_order_summary */.Z.lbl_order_summary
      }), (0,helperServices/* isArrayNotEmpty */.wh)(monthlyCartProducts) && cartDetails.contract && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [RenderWrapper(labels/* default.lbl_app_type */.Z.lbl_app_type, contractType), RenderWrapper(labels/* default.lbl_contract_duration */.Z.lbl_contract_duration, contractDuration), dealVasPrice != 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: RenderDiv(labels/* default.lbl_add_Ons */.Z.lbl_add_Ons, vasPrice)
          }), RenderWrapper(labels/* default.lbl_monthly_subtotal */.Z.lbl_monthly_subtotal, totalDealPrice), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (CheckoutOrderSummary_module_default())["horizantal-line"]
          })]
        })
      }), (0,helperServices/* isArrayNotEmpty */.wh)(onceOffCartProducts) && cartDetails.onceOff && showOnceOffProducts && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [RenderDiv(cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti ? "No. once-off items:" : labels/* default.lbl_no_items */.Z.lbl_no_items, totalOnceOffItems, "item"), (0,helperServices/* isArrayNotEmpty */.wh)(monthlyCartProducts) && RenderDiv(labels/* default.lbl_onceoff_subtotal */.Z.lbl_onceoff_subtotal, subTotal), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (CheckoutOrderSummary_module_default())["horizantal-line"]
        }), totalSaving ? RenderDiv(labels/* default.lbl_total_saving */.Z.lbl_total_saving, totalSaving) : ""]
      }), (0,helperServices/* isArrayNotEmpty */.wh)(onceOffCartProducts) && !(cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti) ? RenderDiv(labels/* default.lbl_sub_total */.Z.lbl_sub_total, subTotal) : null, delivery && (0,helperServices/* isArrayNotEmpty */.wh)(onceOffCartProducts) ? RenderDiv(labels/* default.lbl_delivery */.Z.lbl_delivery, delivery) : ((_monthlyCartProducts$5 = monthlyCartProducts[0]) === null || _monthlyCartProducts$5 === void 0 ? void 0 : _monthlyCartProducts$5.product.deal_delivery) && isSimonlyUpgrade && RenderDiv("Delivery fee (once-off):", "R" + (0,helperServices/* formatNumbersWithComma */.G0)((_monthlyCartProducts$6 = monthlyCartProducts[0]) === null || _monthlyCartProducts$6 === void 0 ? void 0 : (_monthlyCartProducts$7 = _monthlyCartProducts$6.product.deal_delivery) === null || _monthlyCartProducts$7 === void 0 ? void 0 : _monthlyCartProducts$7.replace(/^\D+/g, ""))), ((_monthlyCartProducts$8 = monthlyCartProducts[0]) === null || _monthlyCartProducts$8 === void 0 ? void 0 : _monthlyCartProducts$8.product.deal_delivery) && isSimonlyUpgrade && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((CheckoutOrderSummary_module_default())["horizantal-line"], " ").concat((CheckoutOrderSummary_module_default())["total-line"])
      }), (0,helperServices/* isArrayNotEmpty */.wh)(monthlyCartProducts) && cartDetails.contract && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [((_monthlyCartProducts$9 = monthlyCartProducts[0]) === null || _monthlyCartProducts$9 === void 0 ? void 0 : _monthlyCartProducts$9.product.deal_delivery) && isSimonlyUpgrade && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((CheckoutOrderSummary_module_default()).wrapper, " ").concat((CheckoutOrderSummary_module_default())["wrapper-total"]),
          id: "checkout-order-summary-amount-wrapper",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (CheckoutOrderSummary_module_default())["total-value"],
            id: "checkout-order-summary-amount-label",
            children: "First month's total:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (CheckoutOrderSummary_module_default())["total-value"],
            id: "checkout-order-summary-total-amount",
            children: "R" + (0,helperServices/* formatNumbersWithComma */.G0)(firstMonthTotal)
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((CheckoutOrderSummary_module_default()).wrapper, " ").concat((CheckoutOrderSummary_module_default())["wrapper-total"]),
          id: "checkout-order-summary-amount-wrapper",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (CheckoutOrderSummary_module_default())["total-value"],
            id: "checkout-order-summary-amount-label",
            children: labels/* default.lbl_monthly_total */.Z.lbl_monthly_total
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (CheckoutOrderSummary_module_default())["total-value"],
            id: "checkout-order-summary-total-amount",
            children: totalDealPrice
          })]
        })]
      }), (0,helperServices/* isArrayNotEmpty */.wh)(onceOffCartProducts) && cartDetails.onceOff && showOnceOffProducts && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((CheckoutOrderSummary_module_default()).wrapper, " ").concat((CheckoutOrderSummary_module_default())["wrapper-total"]),
        id: "checkout-order-summary-amount-wrapper",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (CheckoutOrderSummary_module_default()).total,
          id: "checkout-order-summary-amount-label",
          children: labels/* default.lbl_total_due */.Z.lbl_total_due
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (CheckoutOrderSummary_module_default()).total,
          id: "checkout-order-summary-total-amount",
          children: total ? total : "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(0))
        })]
      }), !btnPayment ? /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "".concat((CheckoutOrderSummary_module_default())["continue-button"]),
        onClick: navigateToNextPage,
        disabled: btnDisabled,
        type: btnType,
        id: "".concat(btnLable, "-checkout-btn"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (CheckoutOrderSummary_module_default())["button-label"],
          children: btnLable
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(buttonPayment_ButtonPayment, {
        btnSecure: btnSecure,
        btnLable: btnLable,
        btnDisabled: btnDisabled,
        navigate: navigate,
        customerStatus: customerStatus,
        deal: dealProducts,
        dealID: dealProducts && (dealProducts === null || dealProducts === void 0 ? void 0 : dealProducts.length) && ((_dealProducts$ = dealProducts[0]) === null || _dealProducts$ === void 0 ? void 0 : (_dealProducts$$produc = _dealProducts$.product) === null || _dealProducts$$produc === void 0 ? void 0 : _dealProducts$$produc.sku),
        applicationType: pageType,
        setPageErr: setPageErr,
        currentJourneyType: currentJourneyType,
        shippingAddress: shippingAddress,
        addressTypes: addressTypes,
        pageName: buttonPaymentPageName,
        paymentOptionsEnabled: paymentOptionsEnabled,
        continueDisable: continueDisable
      })]
    })
  });
};

CheckoutOrderSummary.defaultProps = {
  variant: "pop-up",
  btnClass: "",
  btnDisabled: false,
  btnSecure: false,
  btnLable: "Continue",
  btnType: "submit",
  pageType: "normal",
  showOnceOffProducts: true
};
/* harmony default export */ var checkoutOrderSummary_CheckoutOrderSummary = (CheckoutOrderSummary);

/***/ }),

/***/ 70021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73422);
/* harmony import */ var _ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64036);
/* harmony import */ var _atoms_select_Select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);









var ReceiveType = function ReceiveType(_ref) {
  var heading = _ref.heading,
      selectedType = _ref.selectedType,
      receiveTypes = _ref.receiveTypes,
      tabDisable = _ref.tabDisable,
      handleReceiveType = _ref.handleReceiveType,
      id = _ref.id,
      className = _ref.className;
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().envConfigs)[env].imagePrefix;
  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .componentResize */ .Y4)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""),
      selectedValue = _useState[0],
      setSelectedValue = _useState[1];

  var onRadioChange = function onRadioChange(item, index) {
    if (item.id !== selectedType) {
      handleReceiveType(item.id, index);
    }
  };

  var onDivChange = function onDivChange(item, index) {
    if (item.id !== selectedType) {
      if (tabDisable && item.id == "store") {} else {
        handleReceiveType(item.id, index);
      }
    }
  };

  var onDropdownChange = function onDropdownChange(val) {
    var value = "";
    setSelectedValue(val);

    if (val === "Collecting in store") {
      value = "store";
    } else {
      value = "courier";
    }

    if (tabDisable && val === "Collecting in store") {} else {
      handleReceiveType(value);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: "".concat((_ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["main-container"]), " ").concat(className),
      id: id,
      children: [heading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
        children: heading
      }) : null, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["buttons-wrapper"]),
        children: receiveTypes.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            onClick: function onClick() {
              return onDivChange(item, index);
            },
            className: "".concat(!isMobile ? (_ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5___default().button) : (_ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-view-tab"]), " ").concat((_ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[selectedType === item.id ? "checkedButton" : ""], " ").concat((_ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[tabDisable && item.id == "store" ? "disableTab" : ""], "  ").concat(item !== null && item !== void 0 && item.hide ? "d-none" : ""),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              value: item.label,
              checked: selectedType === item.id,
              onChange: function onChange() {
                return onDivChange(item, index);
              },
              className: (_ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["buttons-wrapper__container"]),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
                className: (_ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["delivery-icon"]),
                src: "".concat(imagePrefix, "/assets/images/").concat(item.img)
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("label", {
                className: "".concat((_ReceiveType_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[selectedType === item.id ? "checkedDiv" : ""]),
                children: !isMobile ? item.label : item.id == "store" ? "Collection" : "Delivery"
              })]
            })
          }, index);
        })
      })]
    })
  });
};

ReceiveType.defaultProps = {
  heading: null,
  receiveTypes: [],
  id: "receive-type"
};
/* harmony default export */ __webpack_exports__["Z"] = (ReceiveType);

/***/ }),

/***/ 54047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28658);
/* harmony import */ var _upgradeModal_UpgradeModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27575);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69152);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var SyncError = function SyncError(_ref) {
  var navigate = _ref.navigate,
      handleCancel = _ref.handleCancel;

  var sendAnalitycsLink = function sendAnalitycsLink(additionalInfo) {
    _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_5__/* .link */ .p4(_objectSpread(_objectSpread({}, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_5__/* .getUtagData */ .GS(["page_event", "page_name", "page_channel", "page_master_tab", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      link_type: "o"
    }, additionalInfo));
  };

  var router = (0,_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_upgradeModal_UpgradeModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    showModal: true,
    toggleModal: handleCancel,
    displayData: {
      iconUrl: "".concat(_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .imagePrefix */ .Sj, "/assets/images/error-warning-red.svg"),
      title: "Oops!",
      analyticTitle: "Login DID Sync Failure",
      description: "We are experiencing some technical difficulties right now.<br /><br />Please try again later.",
      primaryButtonText: "Call me back",
      onClickHandlerPrimary: function onClickHandlerPrimary() {
        sendAnalitycsLink({
          link_name: "checkout: did sync failure: call me back",
          link_type: "o"
        });
        router.push("".concat(_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .urlPrefix */ .wn, "/forms/ecommerce"));
      }
    }
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SyncError);

/***/ }),

/***/ 39986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkoutDelivery_CheckoutDelivery; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/deliveryAddress/DeliveryAddress.jsx
var DeliveryAddress = __webpack_require__(75178);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/CheckoutForms.module.scss
var CheckoutForms_module = __webpack_require__(12426);
var CheckoutForms_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutForms_module);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/selectDropDown/SelectDropDown.jsx
var SelectDropDown = __webpack_require__(31201);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/checkoutForms/billingAddress/BillingAddress.jsx







var BillingAddress = function BillingAddress(_ref) {
  var formName = _ref.formName,
      variant = _ref.variant,
      validations = _ref.validations,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      readOnlyValues = _ref.readOnlyValues,
      addressTypesOptions = _ref.addressTypesOptions,
      stateTypesOptions = _ref.stateTypesOptions,
      onChangeHandler = _ref.onChangeHandler,
      onBlurHandler = _ref.onBlurHandler,
      showBillingAddress = _ref.showBillingAddress,
      containerClassName = _ref.containerClassName,
      rowClassName = _ref.rowClassName;
  var BUSINESS_ADDRESS_TYPE = addressTypesOptions && addressTypesOptions.length > 0 && addressTypesOptions[1] ? addressTypesOptions[1].id : "";
  var POSTAL_ADDRESS_TYPE = addressTypesOptions && addressTypesOptions.length > 0 && addressTypesOptions[2] ? addressTypesOptions[2].id : "";
  var labels = {
    "default": {
      unitNo: "Unit no.",
      complexName: "Complex name",
      mobUnitNo: "Unit no. & Complex name",
      optional: " (Optional)"
    },
    business: {
      unitNo: "Unit / Floor no.",
      complexName: "Office park / Building name",
      mobUnitNo: "Unit / Floor no. & Office park / Building name",
      optional: " (Optional)"
    }
  };
  var selectedLables = fieldValues["addressType"] == BUSINESS_ADDRESS_TYPE ? labels.business : labels["default"];

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  var handleDropdown = function handleDropdown(event) {
    var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var formName = arguments.length > 2 ? arguments[2] : undefined;
    onChangeHandler(event, val, formName);
    onBlurHandler(event, val, formName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((CheckoutForms_module_default())[variant], " ").concat((CheckoutForms_module_default())["main-container"], "  ").concat(containerClassName),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
      className: "".concat((CheckoutForms_module_default())["main-row"], " ").concat(rowClassName),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: (CheckoutForms_module_default())["form-group"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Check, {
          custom: true,
          name: "addressCheck",
          label: "My billing address is the same as my delivery address",
          checked: fieldValues["addressCheck"],
          onChange: handleChange,
          onBlur: handleBlur,
          className: (CheckoutForms_module_default())["form-checkbox-label"],
          id: "validationFormikba112-".concat(variant, "-").concat(formName)
        })
      }), showBillingAddress && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (CheckoutForms_module_default())["form-group"],
          controlId: "validationFormba101-".concat(variant, "-").concat(formName),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (CheckoutForms_module_default())["form-label"],
            id: "validationFormba101-label-".concat(variant, "-").concat(formName),
            children: "Address name"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "addressName",
            value: fieldValues["addressName"],
            placeholder: "Add address name",
            onChange: handleChange,
            onBlur: handleBlur,
            readOnly: readOnlyValues["addressName"],
            isInvalid: fieldErrors["addressName"],
            className: fieldErrors["addressName"] ? (CheckoutForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (CheckoutForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["addressName"]
          }), !fieldErrors["addressName"] && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (CheckoutForms_module_default())["hint-text"],
            children: "What you normally call this address (e.g. Home)"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (CheckoutForms_module_default())["form-group"],
          controlId: "validationFormba102-".concat(variant, "-").concat(formName),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (CheckoutForms_module_default())["form-label"],
            id: "validationFormba102-label-".concat(variant, "-").concat(formName),
            children: "Address type"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectDropDown/* default */.Z, {
            formName: formName,
            name: "addressType",
            label: "Address Type",
            data: addressTypesOptions,
            handleSelect: handleDropdown,
            selectedId: fieldValues["addressType"],
            customId: "validationFormba102-".concat(variant, "-").concat(formName),
            fieldError: fieldErrors["addressType"]
          })]
        }), fieldValues["addressType"] == BUSINESS_ADDRESS_TYPE && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
            as: DependencyHelper.Col,
            sm: "12",
            md: "12",
            className: (CheckoutForms_module_default())["form-group"],
            controlId: "validationFormba113-".concat(variant, "-").concat(formName),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
              className: (CheckoutForms_module_default())["form-label"],
              id: "validationFormba113-label-".concat(variant, "-").concat(formName),
              children: "Company name"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
              type: "text",
              name: "companyName",
              value: fieldValues["companyName"],
              placeholder: "Add company name",
              onChange: handleChange,
              onBlur: handleBlur,
              readOnly: readOnlyValues["companyName"],
              isInvalid: fieldErrors["companyName"],
              className: fieldErrors["companyName"] ? (CheckoutForms_module_default()).invalid : ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
              type: "invalid",
              className: (CheckoutForms_module_default())["invalid-feedback"],
              children: fieldErrorsMessage["companyName"]
            })]
          })
        }), fieldValues["addressType"] == POSTAL_ADDRESS_TYPE && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
            as: DependencyHelper.Col,
            sm: "12",
            md: "12",
            className: (CheckoutForms_module_default())["form-group"],
            controlId: "validationFormba111-".concat(variant, "-").concat(formName),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
              className: (CheckoutForms_module_default())["form-label"],
              id: "validationFormba111-label-".concat(variant, "-").concat(formName),
              children: "Address line 1"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
              type: "text",
              name: "addressLine1",
              placeholder: "#",
              onChange: handleChange,
              onBlur: handleBlur,
              readOnly: readOnlyValues["addressLine1"],
              isInvalid: fieldErrors["addressLine1"],
              className: fieldErrors["addressLine1"] ? (CheckoutForms_module_default()).invalid : ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
              type: "invalid",
              className: (CheckoutForms_module_default())["invalid-feedback"],
              children: fieldErrorsMessage["addressLine1"]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
            as: DependencyHelper.Col,
            sm: "12",
            md: "12",
            className: (CheckoutForms_module_default())["form-group"],
            controlId: "validationFormba112-".concat(variant, "-").concat(formName),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
              className: (CheckoutForms_module_default())["form-label"],
              id: "validationFormba112-label-".concat(variant, "-").concat(formName),
              children: "Address line 2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
              type: "text",
              name: "addressLine2",
              placeholder: "#",
              onChange: handleChange,
              onBlur: handleBlur,
              readOnly: readOnlyValues["addressLine2"],
              isInvalid: fieldErrors["addressLine2"],
              className: fieldErrors["addressLine2"] ? (CheckoutForms_module_default()).invalid : ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
              type: "invalid",
              className: (CheckoutForms_module_default())["invalid-feedback"],
              children: fieldErrorsMessage["addressLine2"]
            })]
          })]
        }), fieldValues["addressType"] !== POSTAL_ADDRESS_TYPE && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
            className: (CheckoutForms_module_default())["form-row"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Label, {
              className: "d-block d-sm-none ".concat((CheckoutForms_module_default())["form-label"]),
              id: "validationFormba103-mob-label-".concat(variant, "-").concat(formName),
              children: [selectedLables.mobUnitNo, !validations["unitNo"] && !validations["complexName"] && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: selectedLables.optional
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
              as: DependencyHelper.Col,
              xs: "4",
              sm: "4",
              md: "4",
              className: (CheckoutForms_module_default())["form-group"],
              controlId: "validationFormba103-".concat(variant, "-").concat(formName),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Label, {
                className: "d-none d-sm-block ".concat((CheckoutForms_module_default())["form-label"]),
                id: "validationFormba103-label-".concat(variant, "-").concat(formName),
                children: [selectedLables.unitNo, !validations["unitNo"] && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: selectedLables.optional
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
                type: "text",
                name: "unitNo",
                value: fieldValues["unitNo"],
                placeholder: "#",
                onChange: handleChange,
                onBlur: handleBlur,
                readOnly: readOnlyValues["unitNo"],
                isInvalid: fieldErrors["unitNo"],
                className: fieldErrors["unitNo"] ? (CheckoutForms_module_default()).invalid : ""
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
                type: "invalid",
                className: (CheckoutForms_module_default())["invalid-feedback"],
                children: fieldErrorsMessage["unitNo"]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
              as: DependencyHelper.Col,
              xs: "8",
              sm: "8",
              md: "8",
              className: (CheckoutForms_module_default())["form-group"],
              controlId: "validationFormba104-".concat(variant, "-").concat(formName),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Label, {
                className: "d-none d-sm-block ".concat((CheckoutForms_module_default())["form-label"]),
                id: "validationFormba104-label-".concat(variant, "-").concat(formName),
                children: [selectedLables.complexName, !validations["complexName"] && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: selectedLables.optional
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
                type: "text",
                name: "complexName",
                value: fieldValues["complexName"],
                placeholder: "Add complex name",
                onChange: handleChange,
                onBlur: handleBlur,
                readOnly: readOnlyValues["complexName"],
                isInvalid: fieldErrors["complexName"],
                className: fieldErrors["complexName"] ? (CheckoutForms_module_default()).invalid : ""
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
                type: "invalid",
                className: (CheckoutForms_module_default())["invalid-feedback"],
                children: fieldErrorsMessage["complexName"]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
            className: (CheckoutForms_module_default())["form-row"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Label, {
              className: "d-block d-sm-none ".concat((CheckoutForms_module_default())["form-label"]),
              id: "validationFormba105-mob-label-".concat(variant, "-").concat(formName),
              children: ["Street no. & Street name", !validations["streetNo"] && validations["streetName"] && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: selectedLables.optional
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
              as: DependencyHelper.Col,
              xs: "4",
              sm: "4",
              md: "4",
              className: (CheckoutForms_module_default())["form-group"],
              controlId: "validationFormba105-".concat(variant, "-").concat(formName),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Label, {
                className: "d-none d-sm-block ".concat((CheckoutForms_module_default())["form-label"]),
                id: "validationFormba105-label-".concat(variant, "-").concat(formName),
                children: ["Street no.", !validations["streetNo"] && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: selectedLables.optional
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
                type: "text",
                name: "streetNo",
                value: fieldValues["streetNo"],
                placeholder: "#",
                onChange: handleChange,
                onBlur: handleBlur,
                readOnly: readOnlyValues["streetNo"],
                isInvalid: fieldErrors["streetNo"],
                className: fieldErrors["streetNo"] ? (CheckoutForms_module_default()).invalid : ""
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
                type: "invalid",
                className: (CheckoutForms_module_default())["invalid-feedback"],
                children: fieldErrorsMessage["streetNo"]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
              as: DependencyHelper.Col,
              xs: "8",
              sm: "8",
              md: "8",
              className: (CheckoutForms_module_default())["form-group"],
              controlId: "validationFormba106-".concat(variant, "-").concat(formName),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Label, {
                className: "d-none d-sm-block ".concat((CheckoutForms_module_default())["form-label"]),
                id: "validationFormba106-label-".concat(variant, "-").concat(formName),
                children: ["Street name", !validations["streetName"] && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: selectedLables.optional
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
                type: "text",
                name: "streetName",
                value: fieldValues["streetName"],
                placeholder: "Add street name",
                onChange: handleChange,
                onBlur: handleBlur,
                readOnly: readOnlyValues["streetName"],
                isInvalid: fieldErrors["streetName"],
                className: fieldErrors["streetName"] ? (CheckoutForms_module_default()).invalid : ""
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
                type: "invalid",
                className: (CheckoutForms_module_default())["invalid-feedback"],
                children: fieldErrorsMessage["streetName"]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
          className: (CheckoutForms_module_default())["form-row"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: "d-block d-sm-none ".concat((CheckoutForms_module_default())["form-label"]),
            id: "validationFormba107-mob-label-".concat(variant, "-").concat(formName),
            children: "Suburb & Postal code"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
            as: DependencyHelper.Col,
            xs: "8",
            sm: "8",
            md: "8",
            className: (CheckoutForms_module_default())["form-group"],
            controlId: "validationFormba107-".concat(variant, "-").concat(formName),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
              className: "d-none d-sm-block ".concat((CheckoutForms_module_default())["form-label"]),
              id: "validationFormba107-label-".concat(variant, "-").concat(formName),
              children: "Suburb"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
              type: "text",
              name: "suburb",
              value: fieldValues["suburb"],
              placeholder: "Add suburb",
              onChange: handleChange,
              onBlur: handleBlur,
              readOnly: readOnlyValues["suburb"],
              isInvalid: fieldErrors["suburb"],
              className: fieldErrors["suburb"] ? (CheckoutForms_module_default()).invalid : ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
              type: "invalid",
              className: (CheckoutForms_module_default())["invalid-feedback"],
              children: fieldErrorsMessage["suburb"]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
            as: DependencyHelper.Col,
            xs: "4",
            sm: "4",
            md: "4",
            className: (CheckoutForms_module_default())["form-group"],
            controlId: "validationFormba108-".concat(variant, "-").concat(formName),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
              className: "d-none d-sm-block ".concat((CheckoutForms_module_default())["form-label"]),
              id: "validationFormba108-label-".concat(variant, "-").concat(formName),
              children: "Postal code"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
              type: "text",
              name: "postalCode",
              value: fieldValues["postalCode"],
              placeholder: "#",
              maxLength: "4",
              onChange: handleChange,
              onBlur: handleBlur,
              readOnly: readOnlyValues["postalCode"],
              isInvalid: fieldErrors["postalCode"],
              className: fieldErrors["postalCode"] ? (CheckoutForms_module_default()).invalid : ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
              type: "invalid",
              className: (CheckoutForms_module_default())["invalid-feedback"],
              children: fieldErrorsMessage["postalCode"]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (CheckoutForms_module_default())["form-group"],
          controlId: "validationFormba109-".concat(variant, "-").concat(formName),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (CheckoutForms_module_default())["form-label"],
            id: "validationFormba109-label-".concat(variant, "-").concat(formName),
            children: "Town / City"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "town",
            value: fieldValues["town"],
            placeholder: "Add town / city",
            onChange: handleChange,
            onBlur: handleBlur,
            readOnly: readOnlyValues["town"],
            isInvalid: fieldErrors["town"],
            className: fieldErrors["town"] ? (CheckoutForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (CheckoutForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["town"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (CheckoutForms_module_default())["form-group"],
          controlId: "validationFormba110-".concat(variant, "-").concat(formName),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (CheckoutForms_module_default())["form-label"],
            id: "validationFormba110-label-".concat(variant, "-").concat(formName),
            children: "Province"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectDropDown/* default */.Z, {
            formName: formName,
            name: "province",
            label: "Province",
            data: stateTypesOptions,
            handleSelect: handleDropdown,
            selectedId: fieldValues["province"],
            customId: "validationFormba110-".concat(variant, "-").concat(formName),
            fieldError: fieldErrors["province"]
          })]
        })]
      })]
    })
  });
};

BillingAddress.defaultProps = {
  variant: "plain",
  formName: "billing",
  validations: {},
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
  addressTypesOptions: [],
  stateTypesOptions: []
};
/* harmony default export */ var billingAddress_BillingAddress = (BillingAddress);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/personDetails/PersonDetails.jsx
var PersonDetails = __webpack_require__(83197);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/companyVat/CompanyVat.module.scss
var CompanyVat_module = __webpack_require__(23935);
var CompanyVat_module_default = /*#__PURE__*/__webpack_require__.n(CompanyVat_module);
;// CONCATENATED MODULE: ./components/atoms/checkoutForms/companyVat/CompanyVat.jsx







var CompanyVat = function CompanyVat(_ref) {
  var formName = _ref.formName,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      readOnlyValues = _ref.readOnlyValues,
      onChangeHandler = _ref.onChangeHandler,
      onBlurHandler = _ref.onBlurHandler,
      validations = _ref.validations,
      stateTypesOptions = _ref.stateTypesOptions,
      containerClassName = _ref.containerClassName;

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((CheckoutForms_module_default())["main-container"], " ").concat((CompanyVat_module_default())["main-container"], " ").concat(containerClassName),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
      className: "".concat((CheckoutForms_module_default())["main-row"], " ").concat((CompanyVat_module_default())["address-check-row"]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: (CheckoutForms_module_default())["form-group"],
        controlId: "validationFormcv101",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
          className: (CheckoutForms_module_default())["form-label"],
          id: "validationFormcv101-label",
          children: "Company name"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
          type: "text",
          name: "companyVatName",
          value: fieldValues["companyVatName"],
          placeholder: "Add company name",
          onChange: handleChange,
          onBlur: handleBlur,
          readOnly: readOnlyValues["companyVatName"],
          isInvalid: fieldErrors["companyVatName"],
          className: fieldErrors["companyVatName"] ? (CheckoutForms_module_default()).invalid : ""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
          type: "invalid",
          className: (CheckoutForms_module_default())["invalid-feedback"],
          children: fieldErrorsMessage["companyVatName"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: "mb-0 ".concat((CheckoutForms_module_default())["form-group"]),
        controlId: "validationFormcv102",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
          className: (CheckoutForms_module_default())["form-label"],
          id: "validationFormcv102-label",
          children: "Company VAT Number"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
          type: "text",
          name: "companyVatNumber",
          value: fieldValues["companyVatNumber"],
          placeholder: "Add VAT number",
          onChange: handleChange,
          onBlur: handleBlur,
          readOnly: readOnlyValues["companyVatNumber"],
          isInvalid: fieldErrors["companyVatNumber"],
          className: fieldErrors["companyVatNumber"] ? (CheckoutForms_module_default()).invalid : ""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
          type: "invalid",
          className: (CheckoutForms_module_default())["invalid-feedback"],
          children: fieldErrorsMessage["companyVatNumber"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: "".concat((CheckoutForms_module_default())["form-group"], " ").concat((CompanyVat_module_default())["address-check-form-group"]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Check, {
          custom: true,
          name: "ciaddressCheck",
          label: "The company's address is the same as the delivery address",
          checked: fieldValues["ciaddressCheck"],
          onChange: handleChange,
          onBlur: handleBlur,
          className: (CheckoutForms_module_default())["form-checkbox-label"],
          id: "validationFormcv103"
        })
      })]
    }), !fieldValues["ciaddressCheck"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryAddress/* default */.Z, {
      formName: formName,
      validations: validations,
      fieldValues: fieldValues,
      fieldErrors: fieldErrors,
      fieldErrorsMessage: fieldErrorsMessage,
      readOnlyValues: readOnlyValues,
      stateTypesOptions: stateTypesOptions,
      onChangeHandler: onChangeHandler,
      onBlurHandler: onBlurHandler,
      containerClassName: (CompanyVat_module_default())["vat-address-container"],
      rowClassName: (CompanyVat_module_default())["vat-address-row"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Row, {
      className: "".concat((CheckoutForms_module_default())["main-row"], " ").concat((CompanyVat_module_default())["future-check-row"]),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: (CheckoutForms_module_default())["form-group"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Check, {
          custom: true,
          name: "cifutureCheck",
          label: "Save this company's details for next time",
          checked: fieldValues["cifutureCheck"],
          onChange: handleChange,
          onBlur: handleBlur,
          className: (CheckoutForms_module_default())["form-checkbox-label"],
          id: "validationFormcv104"
        })
      })
    })]
  });
};

CompanyVat.defaultProps = {
  formName: "companyInformation",
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
  validations: {}
};
/* harmony default export */ var companyVat_CompanyVat = ((/* unused pure expression or super */ null && (CompanyVat)));
// EXTERNAL MODULE: ./components/atoms/checkoutForms/formHeading/FormHeading.jsx
var FormHeading = __webpack_require__(81083);
// EXTERNAL MODULE: ./components/molecules/modals/checkoutFormsModal/CheckoutFormsModal.jsx + 1 modules
var CheckoutFormsModal = __webpack_require__(23060);
// EXTERNAL MODULE: ./components/atoms/deliveryTitle/DeliveryTitle.jsx
var DeliveryTitle = __webpack_require__(41759);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./components/atoms/DeliveryOptionTitle/DeliveryOptionTitle.module.scss
var DeliveryOptionTitle_module = __webpack_require__(65754);
var DeliveryOptionTitle_module_default = /*#__PURE__*/__webpack_require__.n(DeliveryOptionTitle_module);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./components/atoms/DeliveryOptionTitle/DeliveryOptionTitle.jsx







var DeliveryOptionTitle = function DeliveryOptionTitle(content) {
  var _content$content$, _content$content$2;

  var _useState = (0,react.useState)(false),
      showInfo = _useState[0],
      setShowInfo = _useState[1];

  var env = (config_default()).env;
  var isMobile = (0,helperServices/* componentResize */.Y4)();
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= 992;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var items = (_content$content$ = (content === null || content === void 0 ? void 0 : content.content)[0]) === null || _content$content$ === void 0 ? void 0 : _content$content$.description;
  var title = (_content$content$2 = (content === null || content === void 0 ? void 0 : content.content)[0]) === null || _content$content$2 === void 0 ? void 0 : _content$content$2.title;

  if (!items || !title) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((DeliveryOptionTitle_module_default())["delivery-option-step__infobox-wraper"], " ").concat(!showInfo ? (DeliveryOptionTitle_module_default())["wraper-height"] : ""),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: !showInfo ? (DeliveryOptionTitle_module_default())["delivery-option-step__subtitle-collapse"] : (DeliveryOptionTitle_module_default())["delivery-option-step__subtitle"],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        onClick: function onClick() {
          return setShowInfo(function (show) {
            return !show;
          });
        },
        children: [!showInfo && (isMobile || isTablet) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: title
          })
        }), (isMobile || isTablet) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(imagePrefix, "/assets/images/collapsible.svg"),
          className: "".concat(showInfo && (DeliveryOptionTitle_module_default())["delivery-option-step__icon-hide"])
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "".concat((DeliveryOptionTitle_module_default())["delivery-option-step__infobox"], " ").concat(!showInfo && (DeliveryOptionTitle_module_default())["delivery-option-step__infobox-hide"]),
      dangerouslySetInnerHTML: {
        __html: items
      }
    })]
  });
};

/* harmony default export */ var DeliveryOptionTitle_DeliveryOptionTitle = (DeliveryOptionTitle);
// EXTERNAL MODULE: ./components/atoms/addressTile/AddressTile.jsx
var AddressTile = __webpack_require__(24761);
// EXTERNAL MODULE: ./components/atoms/addAddress/AddAddress.module.scss
var AddAddress_module = __webpack_require__(5399);
var AddAddress_module_default = /*#__PURE__*/__webpack_require__.n(AddAddress_module);
;// CONCATENATED MODULE: ./components/atoms/addAddress/AddAddress.jsx





var AddAddress = function AddAddress(_ref) {
  var type = _ref.type,
      data = _ref.data,
      handleOnClick = _ref.handleOnClick,
      id = _ref.id,
      className = _ref.className;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((AddAddress_module_default()).addAddress, " ").concat(className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((AddAddress_module_default()).addAddress__section, " d-none d-lg-block"),
      onClick: function onClick() {
        handleOnClick(type, "add", {});
      },
      id: id,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (AddAddress_module_default())["addAddress-add"],
        src: "".concat(imagePrefix, "/assets/images/plus.svg"),
        alt: "add address"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (AddAddress_module_default()).addAddress__address,
        children: data.desktop_button
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((AddAddress_module_default()).addAddress__tile, " d-flex d-lg-none"),
      onClick: function onClick() {
        handleOnClick(type, "add", {});
      },
      id: "".concat(id, "-mob"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (AddAddress_module_default())["addAddress-add"],
        src: "".concat(imagePrefix, "/assets/images/plus.svg"),
        alt: "add address"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (AddAddress_module_default()).addAddress__address,
        children: data.mob_button
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: "".concat((AddAddress_module_default())["addAddress-arrow"]),
        src: "".concat(imagePrefix, "/assets/images/caret-right.svg"),
        alt: "add address"
      })]
    })]
  });
};

AddAddress.defaultProps = {
  type: "delivery",
  data: {},
  id: "add-address"
};
/* harmony default export */ var addAddress_AddAddress = (AddAddress);
// EXTERNAL MODULE: ./components/atoms/pageHeading/PageHeading.jsx
var PageHeading = __webpack_require__(19456);
// EXTERNAL MODULE: ./components/organisms/checkoutDelivery/CheckoutDelivery.module.scss
var CheckoutDelivery_module = __webpack_require__(55207);
var CheckoutDelivery_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutDelivery_module);
// EXTERNAL MODULE: ./components/atoms/contentSearchBox/ContentSearchBox.jsx
var ContentSearchBox = __webpack_require__(13616);
// EXTERNAL MODULE: ./components/atoms/confirmModal/ConfirmModal.jsx
var ConfirmModal = __webpack_require__(74183);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/termsCheckbox/TermsCheckbox.jsx
var TermsCheckbox = __webpack_require__(10626);
// EXTERNAL MODULE: ./config/errorMessages.js
var errorMessages = __webpack_require__(72210);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./services/checkoutService.js
var checkoutService = __webpack_require__(34020);
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
// EXTERNAL MODULE: ./Redux/actions/navAction.js
var navAction = __webpack_require__(42220);
// EXTERNAL MODULE: ./Redux/actions/geoLocationAction.js
var geoLocationAction = __webpack_require__(28935);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./components/atoms/storeCard/storeCard.jsx
var storeCard = __webpack_require__(75221);
// EXTERNAL MODULE: ./components/molecules/receiveType/ReceiveType.jsx
var ReceiveType = __webpack_require__(70021);
// EXTERNAL MODULE: ./components/atoms/label/LabelText.jsx
var LabelText = __webpack_require__(38975);
// EXTERNAL MODULE: ./components/atoms/dropDown/DropDown.jsx
var DropDown = __webpack_require__(85092);
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton = __webpack_require__(79549);
// EXTERNAL MODULE: ./components/organisms/emptyProductsContainer/EmptyProductsContainer.jsx
var EmptyProductsContainer = __webpack_require__(36603);
// EXTERNAL MODULE: ./context/checkout-journey-context.js
var checkout_journey_context = __webpack_require__(62039);
// EXTERNAL MODULE: ./data/StoreListData.js
var StoreListData = __webpack_require__(92197);
// EXTERNAL MODULE: ./utils/getStoreList.js
var getStoreList = __webpack_require__(16073);
;// CONCATENATED MODULE: ./components/organisms/checkoutDelivery/CheckoutDelivery.jsx




function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








































var CheckoutDelivery = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _addressTypesOptions$, _addressTypesOptions$2, _addressTypesOptions$3;

  var addressTypes = _ref.addressTypes,
      statesTypes = _ref.statesTypes,
      continueDisable = _ref.continueDisable,
      countryCode = _ref.countryCode,
      countryName = _ref.countryName,
      cartId = _ref.cartId,
      navigate = _ref.navigate,
      shippingMessageText = _ref.shippingMessageText,
      shippingFeeCalculateAmount = _ref.shippingFeeCalculateAmount,
      subTotal = _ref.subTotal,
      shippingAddress = _ref.shippingAddress,
      billingAddress = _ref.billingAddress,
      isGuestUser = _ref.isGuestUser,
      profileData = _ref.profileData,
      customerStatus = _ref.customerStatus,
      setShowSnackBar = _ref.setShowSnackBar,
      setPageErr = _ref.setPageErr,
      profileLoading = _ref.profileLoading,
      geoLocation = _ref.geoLocation,
      setReLogin = _ref.setReLogin,
      setGeoLocationStatus = _ref.setGeoLocationStatus,
      setGeoLocationPosition = _ref.setGeoLocationPosition,
      setStoreDetails = _ref.setStoreDetails,
      applicationType = _ref.applicationType,
      currentJourneyType = _ref.currentJourneyType,
      cartDetails = _ref.cartDetails,
      deliveryDetails = _ref.deliveryDetails,
      authDetailsData = _ref.authDetailsData,
      upgradeResponse = _ref.upgradeResponse,
      clickAndCollectEnabled = _ref.clickAndCollectEnabled,
      carrierCode = _ref.carrierCode,
      methodCode = _ref.methodCode,
      dealID = _ref.dealID,
      storeCollectDisabled = _ref.storeCollectDisabled,
      clickAndCollectDelivery = _ref.clickAndCollectDelivery;

  var _useState = (0,react.useState)(false),
      dataFail = _useState[0],
      setDataFail = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showContactDetails = _useState2[0],
      setShowContactDetails = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showBillingAddress = _useState3[0],
      setShowBillingAddress = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      finalAddress = _useState4[0],
      setFinalAddress = _useState4[1];

  var _useState5 = (0,react.useState)({
    firstName: "",
    surName: "",
    email: "",
    cellNumber: ""
  }),
      customerData = _useState5[0],
      setCustomerData = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      selectedDeliveryAddress = _useState6[0],
      setSelectedDeliveryAddress = _useState6[1];

  var _useState7 = (0,react.useState)(true),
      selectedBillingAddress = _useState7[0],
      setSelectedBillingAddress = _useState7[1];

  var _useState8 = (0,react.useState)(geoLocation !== null && geoLocation !== void 0 && geoLocation.storeDetails ? geoLocation !== null && geoLocation !== void 0 && geoLocation.changeMethods ? "courier" : "store" : "courier"),
      selectedReceiveType = _useState8[0],
      setSelectedReceiveType = _useState8[1];

  var _useState9 = (0,react.useState)("delivery"),
      modalType = _useState9[0],
      setModalType = _useState9[1];

  var _useState10 = (0,react.useState)("add"),
      modalVariant = _useState10[0],
      setModalVariant = _useState10[1];

  var _useState11 = (0,react.useState)({}),
      modalValues = _useState11[0],
      setModalValues = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      modalShow = _useState12[0],
      setModalShow = _useState12[1];

  var _useState13 = (0,react.useState)(" "),
      selectedClosestStoreCard = _useState13[0],
      setSelectedClosestStoreCard = _useState13[1];

  var _useState14 = (0,react.useState)(0),
      submitAttempt = _useState14[0],
      setSubmitAttempt = _useState14[1];

  var _useState15 = (0,react.useState)([]),
      storeLists = _useState15[0],
      setStoreLists = _useState15[1];

  var _useState16 = (0,react.useState)([]),
      closestStoreLists = _useState16[0],
      setClosestStoreLists = _useState16[1];

  var _useState17 = (0,react.useState)([]),
      storeListsFromSearch = _useState17[0],
      setStoreListsFromSearch = _useState17[1];

  var _useState18 = (0,react.useState)(false),
      showConfirmModal = _useState18[0],
      setShowConfirmModal = _useState18[1];

  var _useState19 = (0,react.useState)(""),
      confirmModalContent = _useState19[0],
      setConfirmModalContent = _useState19[1];

  var _useState20 = (0,react.useState)(null),
      deleteId = _useState20[0],
      setDeleteId = _useState20[1];

  var _useState21 = (0,react.useState)(""),
      deleteType = _useState21[0],
      setDeleteType = _useState21[1];

  var _useState22 = (0,react.useState)(""),
      selectedAddress = _useState22[0],
      setSelectedAddress = _useState22[1];

  var _useState23 = (0,react.useState)(false),
      deliveryAnalytics = _useState23[0],
      setDeliveryAnalytics = _useState23[1];

  var _useState24 = (0,react.useState)(false),
      contactAnalytics = _useState24[0],
      setContactAnalytics = _useState24[1];

  var _useState25 = (0,react.useState)(false),
      viewSent = _useState25[0],
      setViewSent = _useState25[1];

  var _useState26 = (0,react.useState)([]),
      courierPath = _useState26[0],
      setCourierPath = _useState26[1];

  var _useState27 = (0,react.useState)([]),
      storePath = _useState27[0],
      setStorePath = _useState27[1];

  var addressTypesOptions = addressTypes ? addressTypes : [];
  var stateTypesOptions = statesTypes ? statesTypes : [];
  var RESIDENTIAL_ADDRESS_TYPE = addressTypesOptions && addressTypesOptions.length > 0 ? (_addressTypesOptions$ = addressTypesOptions[0]) === null || _addressTypesOptions$ === void 0 ? void 0 : _addressTypesOptions$.id : "";
  var BUSINESS_ADDRESS_TYPE = addressTypesOptions && addressTypesOptions.length > 0 ? (_addressTypesOptions$2 = addressTypesOptions[1]) === null || _addressTypesOptions$2 === void 0 ? void 0 : _addressTypesOptions$2.id : "";
  var POSTAL_ADDRESS_TYPE = addressTypesOptions && addressTypesOptions.length > 0 ? (_addressTypesOptions$3 = addressTypesOptions[2]) === null || _addressTypesOptions$3 === void 0 ? void 0 : _addressTypesOptions$3.id : "";
  var titleContents = [shippingMessageText && shippingFeeCalculateAmount && subTotal > shippingFeeCalculateAmount && shippingMessageText.free_shipping_message + ", " + shippingMessageText.free_shipping_method_message, shippingMessageText && shippingMessageText.delivery_message];

  var _useState28 = (0,react.useState)(false),
      serviceDown = _useState28[0],
      setServiceDown = _useState28[1];

  var _useState29 = (0,react.useState)(false),
      deliveryOptionEnable = _useState29[0],
      setDeliveryOptionEnable = _useState29[1];

  var _useState30 = (0,react.useState)([]),
      deliveryAddresslists = _useState30[0],
      setDeliveryAddresslists = _useState30[1];

  var _useState31 = (0,react.useState)([]),
      billingAddresslists = _useState31[0],
      setBillingAddresslists = _useState31[1];

  var _useState32 = (0,react.useState)(0),
      totalDeliveryAddress = _useState32[0],
      setTotalDeliveryAddress = _useState32[1];

  var _useState33 = (0,react.useState)(3),
      dataSize = _useState33[0],
      setDataSize = _useState33[1];

  var _useState34 = (0,react.useState)(" "),
      selectedStoreCard = _useState34[0],
      setSelectedStoreCard = _useState34[1];

  var _useState35 = (0,react.useState)({}),
      customerPosition = _useState35[0],
      setCustomerPosition = _useState35[1];

  var _useState36 = (0,react.useState)({}),
      selectedStoreAddressItem = _useState36[0],
      setSelectedStoreAddressItem = _useState36[1];

  var _useState37 = (0,react.useState)(),
      selected = _useState37[0],
      setSelected = _useState37[1];

  var _useState38 = (0,react.useState)(false),
      searchResult = _useState38[0],
      setSearchResult = _useState38[1];

  var _useState39 = (0,react.useState)(geoLocation !== null && geoLocation !== void 0 && geoLocation.changeMethods ? true : false),
      tabDisable = _useState39[0],
      setTabDisable = _useState39[1];

  var numRegEx = RegExp(/^[0-9]*$/);
  var cellPhoneRegEx = RegExp(/^0|27[0-9]*$/);
  var streetNameRegEx = RegExp(/^[a-zA-Z0-9_ ]*$/);
  var emailRegEx = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
  var router = (0,DependencyHelper.useRouter)();
  var dispatch = (0,DependencyHelper.useDispatch)();

  var _useState40 = (0,react.useState)({}),
      storeDataDetails = _useState40[0],
      setStoreDataDetails = _useState40[1];

  var analyticsData = analyticsUtag/* getUtagData */.GS();

  var _useState41 = (0,react.useState)([{
    label: "Distance"
  }, {
    label: "Alphabetical (A-Z)"
  }, {
    label: "Alphabetical (Z-A)"
  }]),
      dropdownWithDistance = _useState41[0],
      setDropdownWithDistance = _useState41[1];

  var _useState42 = (0,react.useState)([{
    label: "Alphabetical (A-Z)"
  }, {
    label: "Alphabetical (Z-A)"
  }]),
      dropdownValues = _useState42[0],
      setDropdownValues = _useState42[1];

  var contactFormInfo = applicationType == "normal" ? null : {
    icon: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/info_teal.svg"),
    desc: labels/* default.delivery.contractTypeContactFormInfo */.Z.delivery.contractTypeContactFormInfo
  };
  (0,react.useEffect)(function () {
    if (customerStatus && !viewSent) {
      if (applicationType == "normal") {
        analyticsUtag/* view */.ei(_objectSpread({
          page_event: "view",
          page_name: "checkout: delivery: ".concat(customerStatus),
          page_channel: "checkout",
          page_master_tab: "personal"
        }, analyticsUtag/* getProfileData */.$y(!isGuestUser, profileData, authDetailsData)));
      } else {
        if (currentJourneyType == checkout_journey_context/* journeyType.upgrade */.w.upgrade) {
          analyticsUtag/* view */.ei(_objectSpread({
            page_event: "view",
            page_name: "checkout: delivery: ".concat(customerStatus),
            page_channel: "checkout",
            page_master_tab: "personal",
            delivery_type: (deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.receiveType) == "store" ? "collect" : "deliver",
            authentication_id_type: (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) == "PASSPORT" ? "passport" : "id",
            upgrade_eligibility_status: upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.eligibilityStatus,
            upgrade_eligible_date: (upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.upgradeDate) || "",
            upgrade_customer_type: upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.c3dCustomer ? "C3D" : upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.business ? "CBU" : "OTHER"
          }, analyticsUtag/* getProfileData */.$y(!isGuestUser, profileData, authDetailsData)));
        } else {
          analyticsUtag/* view */.ei(_objectSpread({
            page_event: "view",
            page_name: "checkout: delivery: ".concat(customerStatus),
            page_channel: "checkout",
            page_master_tab: "personal",
            delivery_type: (deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.receiveType) == "store" ? "collect" : "deliver",
            authentication_id_type: (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) == "PASSPORT" ? "passport" : "id"
          }, analyticsUtag/* getProfileData */.$y(!isGuestUser, profileData, authDetailsData)));
        }
      }

      setViewSent(true);
    }
  }, [customerStatus]);
  /* Enable when single devcice deals data dependecy resolved for Clcik and collect */
  // const enableClickAndCollect = () => {
  //   let physicalDevice = [], counter = 0;
  //   if (clickAndCollectDelivery) {
  //     cartDetails?.cartProductItems[0]?.product?.items.map(item => {
  //     item?.options.map(deviceOption => {
  //         if (deviceOption?.is_hidden_product == "1" && deviceOption?.price > 0) {
  //           physicalDevice.push(deviceOption?.product?.sku);
  //           counter += 1;
  //         }
  //       })
  //     })
  //     if (counter == 1) {
  //         return true;
  //     }
  //     return false;
  //   }
  // }

  function featuresCheck() {
    return _featuresCheck.apply(this, arguments);
  }

  function _featuresCheck() {
    _featuresCheck = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee17() {
      return regenerator_default().wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              if (clickAndCollectEnabled) {
                setDeliveryOptionEnable(true);
                tabDisable ? setTabDisable(true) : (0,helperServices/* checkPreOrder */.e_)(cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.cartProductItems) ? setTabDisable(true) : setTabDisable(false);
              } else {
                setSelectedReceiveType("courier");
                setDeliveryOptionEnable(false);
              }

            case 1:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));
    return _featuresCheck.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    featuresCheck();
    fetchPathData();

    if (storeCollectDisabled) {
      setSelectedReceiveType("courier");
    }

    if (selectedReceiveType == "store") {
      setSelected("Alphabetical (A-Z)");

      if (!(geoLocation !== null && geoLocation !== void 0 && geoLocation.allowed)) {
        (0,helperServices/* getCustomerPositionAsync */.dJ)().then(function (resultData) {
          var _resultData$result, _resultData$result2;

          var latitude = (_resultData$result = resultData.result) === null || _resultData$result === void 0 ? void 0 : _resultData$result.latitude;
          var longitude = (_resultData$result2 = resultData.result) === null || _resultData$result2 === void 0 ? void 0 : _resultData$result2.longitude;

          if (!!(latitude && longitude)) {
            setCustomerPosition(resultData === null || resultData === void 0 ? void 0 : resultData.result);
            setSelected("Distance");
            setGeoLocationPosition({
              latitude: latitude,
              longitude: longitude
            });
            setGeoLocationStatus(true);
            (0,getStoreList/* default */.Z)(resultData.result, dealID, setStoreLists, setServiceDown);
          }
        }, function (resultDataFailure) {
          setServiceDown(true);
          console.log({
            resultDataFailure: resultDataFailure
          });
        });
      } else {
        if (geoLocation !== null && geoLocation !== void 0 && geoLocation.allowed) {
          var locations = {
            result: {
              latitude: geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.latitude,
              longitude: geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.longitude
            }
          };
          setCustomerPosition(locations);
          setSelected("Distance");
          (0,getStoreList/* default */.Z)(locations === null || locations === void 0 ? void 0 : locations.result, dealID, setStoreLists, setServiceDown);
        }
      }
    }
  }, [selectedReceiveType]);
  (0,react.useEffect)(function () {
    if (selectedReceiveType == "store" && storeLists && storeLists.length > 0) {
      var listItems = storeLists.filter(function (listItem) {
        return (listItem === null || listItem === void 0 ? void 0 : listItem.inStock) != false;
      });

      if (geoLocation !== null && geoLocation !== void 0 && geoLocation.storeDetails) {
        closestStoreCardClickHandler(listItems.findIndex(function (ele) {
          return ele.storeID === (geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.storeDetails);
        }), listItems.find(function (ele) {
          return ele.storeID === (geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.storeDetails);
        }));
      }

      setClosestStoreLists(listItems);
    }
  }, [storeLists]);

  var _passSuggestedData = function passSuggestedData(filteredAddressData) {
    if (filteredAddressData.length == 0) {
      setSearchResult(true);
      setStoreListsFromSearch([]);
    }
  };

  (0,react.useEffect)(function () {
    refreshState();

    if (!isGuestUser && !profileLoading) {
      fetchData();
    }
  }, [profileLoading]);
  (0,react.useEffect)(function () {
    if (Object.keys(finalAddress).length != 0 && selectedReceiveType == "store") {
      var _finalAddress$geometr, _finalAddress$geometr2, _finalAddress$geometr3, _finalAddress$geometr4;

      var resultData = {
        result: {
          latitude: "",
          longitude: ""
        }
      };
      resultData.result.latitude = finalAddress === null || finalAddress === void 0 ? void 0 : (_finalAddress$geometr = finalAddress.geometry) === null || _finalAddress$geometr === void 0 ? void 0 : (_finalAddress$geometr2 = _finalAddress$geometr.location) === null || _finalAddress$geometr2 === void 0 ? void 0 : _finalAddress$geometr2.lat;
      resultData.result.longitude = finalAddress === null || finalAddress === void 0 ? void 0 : (_finalAddress$geometr3 = finalAddress.geometry) === null || _finalAddress$geometr3 === void 0 ? void 0 : (_finalAddress$geometr4 = _finalAddress$geometr3.location) === null || _finalAddress$geometr4 === void 0 ? void 0 : _finalAddress$geometr4.lng;
      (0,getStoreList/* default */.Z)(resultData.result, dealID, setStoreListsFromSearch, setServiceDown);
      setSearchResult(false);
    } else {
      addressSearchResultMap();
    }
  }, [finalAddress]);
  (0,react.useEffect)(function () {
    if (addressTypesOptions.length > 0) {
      fieldValues.delivery.addressType = RESIDENTIAL_ADDRESS_TYPE;
      fieldValues.billing.addressType = RESIDENTIAL_ADDRESS_TYPE;
      fieldValues.companyInformation.addressType = BUSINESS_ADDRESS_TYPE;
      setState(_objectSpread(_objectSpread({}, state), {}, {
        fieldValues: fieldValues
      }));
    }
  }, [addressTypesOptions]);
  (0,react.useEffect)(function () {
    if (stateTypesOptions.length > 0) {
      fieldValues.delivery.province = stateTypesOptions[0].id;
      fieldValues.billing.province = stateTypesOptions[0].id;
      fieldValues.companyInformation.province = stateTypesOptions[0].id;
      setState(_objectSpread(_objectSpread({}, state), {}, {
        fieldValues: fieldValues
      }));
    }
  }, [stateTypesOptions]);
  (0,react.useEffect)(function () {
    if (dataFail) {
      continueDisable(true);
    } else {
      if (totalDeliveryAddress == 0 && !checkFormError("delivery") && !checkFormError("details") && !checkFormError("contactDetails") && selectedBillingAddress) {
        continueDisable(false);
      } else if (totalDeliveryAddress !== 0 && selectedDeliveryAddress && (applicationType == "normal" ? selectedBillingAddress : !checkFormError("details"))) {
        continueDisable(false);
      } else {
        continueDisable(true);
      }
    }
  }, [dataFail, totalDeliveryAddress, selectedDeliveryAddress, selectedBillingAddress]);

  var handleSizeChange = function handleSizeChange(size) {
    setDataSize(size);
  };

  var receiveTypesOptions = [{
    id: "courier",
    label: "Deliver via courier",
    hide: false,
    img: "Path.svg"
  }, {
    id: "store",
    label: "Collecting in store",
    hide: storeCollectDisabled,
    img: "Collect.svg" // change to C&C icon when available

  }];

  var handleReceiveType = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(val, index) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSelectedReceiveType(val);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleReceiveType(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var storeCardClickHandler = function storeCardClickHandler(id, item) {
    if ((item === null || item === void 0 ? void 0 : item.inStock) != false) {
      setStoreDataDetails(item);
      setSelectedStoreCard(id);
      var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
      analyticsUtag/* link */.p4({
        link_type: "o",
        page_tool_event: "use",
        page_tool_name: "".concat(pageName, ": store selection"),
        filter_query: item.name
      });
      setStoreDetails(item.storeID);
      (0,geoLocationAction/* setChangeStore */.oA)(null);
      continueDisable(false);
    }
  };

  var closestStoreCardClickHandler = function closestStoreCardClickHandler(id, item) {
    setStoreDataDetails(item);
    setSelectedClosestStoreCard(id);
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "".concat(pageName, ": store selection"),
      filter_query: item.name
    });
    setStoreDetails(item.storeID);
    (0,geoLocationAction/* setChangeStore */.oA)(null);
    continueDisable(false);
  };

  function fetchPathData() {
    return _fetchPathData.apply(this, arguments);
  }

  function _fetchPathData() {
    _fetchPathData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee18() {
      var _cartDetails$shipping3;

      var url, resultsPath;
      return regenerator_default().wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              url = 'paidDeliveryCheckoutPath';

              if (cartDetails && (cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping3 = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping3 === void 0 ? void 0 : _cartDetails$shipping3.carrier_code) == 'freeshipping') {
                url = 'checkoutPath';
              }

              _context18.next = 4;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", url);

            case 4:
              resultsPath = _context18.sent;

              if ((resultsPath === null || resultsPath === void 0 ? void 0 : resultsPath.status) == "success") {
                courierPath.push(resultsPath.sections[0].items[0]);
                storePath.push(resultsPath.sections[0].items[1]);
              }

            case 6:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));
    return _fetchPathData.apply(this, arguments);
  }

  var mapDeliveryOnStoreFieldData = function mapDeliveryOnStoreFieldData() {
    if (storeDataDetails) {
      return {
        cart_id: cartId !== "" ? cartId : null,
        region: storeDataDetails && storeDataDetails !== null && storeDataDetails !== void 0 && storeDataDetails.state ? (storeDataDetails === null || storeDataDetails === void 0 ? void 0 : storeDataDetails.state) == "Southern Gauteng" ? "Gauteng" : storeDataDetails === null || storeDataDetails === void 0 ? void 0 : storeDataDetails.state : null,
        country_code: countryCode ? countryCode : null,
        instructions: null,
        street: createStreetFromAddressLines(storeDataDetails === null || storeDataDetails === void 0 ? void 0 : storeDataDetails.addressLineOne, storeDataDetails === null || storeDataDetails === void 0 ? void 0 : storeDataDetails.addressLineTwo),
        postcode: storeDataDetails === null || storeDataDetails === void 0 ? void 0 : storeDataDetails.postalCode,
        city: storeDataDetails === null || storeDataDetails === void 0 ? void 0 : storeDataDetails.city,
        address_type_name: storeDataDetails === null || storeDataDetails === void 0 ? void 0 : storeDataDetails.storeID,
        address_name: "Store",
        company: null,
        unit_number: null,
        complex_name: null,
        street_number: null,
        suburb: storeDataDetails !== null && storeDataDetails !== void 0 && storeDataDetails.district ? storeDataDetails === null || storeDataDetails === void 0 ? void 0 : storeDataDetails.district : storeDataDetails === null || storeDataDetails === void 0 ? void 0 : storeDataDetails.city,
        firstname: customerData === null || customerData === void 0 ? void 0 : customerData.firstName,
        lastname: customerData.surName ? customerData === null || customerData === void 0 ? void 0 : customerData.surName : customerData === null || customerData === void 0 ? void 0 : customerData.firstName,
        telephone: customerData === null || customerData === void 0 ? void 0 : customerData.cellNumber,
        save_in_address_book: false,
        is_shipping_address: 0,
        is_billing_address: 0
      };
    }
  };

  (0,react.useImperativeHandle)(ref, function () {
    return {
      submit: function submit() {
        analyticsUtag/* link */.p4({
          link_type: "o",
          link_name: "checkout: delivery: ".concat(customerStatus, ": continue")
        }); //Close warning snack bar if there is any

        closeSnackBar();

        if (applicationType == "normal") {
          if (isGuestUser) {
            addEmailAddress();
          } else if (totalDeliveryAddress == 0 && (customerData.firstName == "" || (0,helperServices/* getUpdatedSurname */.we)(customerData.surName) == "" || customerData.email == "" || !customerData.email || customerData.cellNumber == "" || !customerData.cellNumber)) {
            profileUpdate();
          } else {
            addDeliveryAddress();
          }
        } else {
          if (selectedReceiveType == "store") {
            addDeliveryAddress();
          } else {
            if (customerData.firstName == "" || (0,helperServices/* getUpdatedSurname */.we)(customerData.surName) == "" || customerData.email == "" || !customerData.email || customerData.cellNumber == "" || !customerData.cellNumber) {
              profileUpdate();
            } else {
              addDeliveryAddress();
            }
          }
        }
      },
      back: function back() {
        if (applicationType == "normal") {
          analyticsUtag/* link */.p4({
            link_type: "o",
            link_name: "checkout: delivery: ".concat(customerStatus, ": back to cart")
          });
        } else {
          analyticsUtag/* link */.p4({
            link_type: "o",
            link_name: "checkout: delivery: ".concat(customerStatus, ": back to lets get started")
          });
        }
      }
    };
  });

  var fetchData = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var results, _results$errors, _results$errors$;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              (0,helperServices/* showSpinner */.yh)();
              _context2.next = 4;
              return (0,checkoutService/* getAllCustomerAddressListsService */.ey)();

            case 4:
              results = _context2.sent;

              if (results.fail) {
                _context2.next = 14;
                break;
              }

              _context2.next = 8;
              return customerDetails(results.customerData);

            case 8:
              _context2.next = 10;
              return filterAddressLists(results.addressList);

            case 10:
              setDataFail(false);
              (0,helperServices/* hideSpinner */.v3)();
              _context2.next = 17;
              break;

            case 14:
              setDataFail(true);
              (0,helperServices/* hideSpinner */.v3)();

              if (results && results.errors) {
                technicalFailure((_results$errors = results.errors) === null || _results$errors === void 0 ? void 0 : (_results$errors$ = _results$errors[0]) === null || _results$errors$ === void 0 ? void 0 : _results$errors$.message);
              } else {
                technicalFailure();
              }

            case 17:
              _context2.next = 23;
              break;

            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2["catch"](0);
              (0,helperServices/* hideSpinner */.v3)();
              technicalFailure();

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 19]]);
    }));

    return function fetchData() {
      return _ref3.apply(this, arguments);
    };
  }();

  function customerDetails(customerData) {
    var newSurName = (0,helperServices/* getUpdatedSurname */.we)(customerData.surName);
    fieldValues.details.firstName = customerData.firstName ? customerData.firstName : "";
    fieldValues.details.surName = newSurName ? newSurName : "";
    fieldValues.details.email = customerData.email ? customerData.email : "";
    fieldValues.details.cellNumber = customerData.telephone ? customerData.telephone : "";
    errorStatus.details = checkFormError("details");
    var newCustomerData = {
      firstName: customerData.firstName,
      surName: newSurName,
      email: customerData.email,
      cellNumber: customerData.telephone
    };
    setCustomerData(newCustomerData);
    setState(_objectSpread(_objectSpread({}, state), {}, {
      fieldValues: fieldValues,
      errorStatus: errorStatus
    }));
  }

  var getProvinceValue = function getProvinceValue(name) {
    var finalID = statesTypes.filter(function (item) {
      return item.code == name;
    });

    if (finalID && finalID[0] && finalID[0].id) {
      return finalID[0].id;
    }
  };

  var filterAddressLists = function filterAddressLists(addressLists) {
    if (addressLists && addressLists.length > 0) {
      var deliveryLists = [];
      var billingLists = [];
      addressLists.map(function (address) {
        if (address.is_shipping_address) {
          deliveryLists.push(address);

          if (shippingAddress && shippingAddress.customer_address_id && shippingAddress.customer_address_id == address.id) {
            setSelectedDeliveryAddress(shippingAddress.customer_address_id);
          } else if (address.default_shipping && address.default_shipping == true && !selectedDeliveryAddress) {
            setSelectedDeliveryAddress(address.id);
          }
        }

        if (address.is_billing_address && applicationType == "normal") {
          billingLists.push(address);

          if (billingAddress && billingAddress.customer_address_id && billingAddress.customer_address_id == address.id) {
            setSelectedBillingAddress(billingAddress.customer_address_id);
          } else if (address.default_billing && address.default_billing == true && !selectedBillingAddress) {
            setSelectedBillingAddress(address.id);
          }
        }
      });
      setTotalDeliveryAddress(deliveryLists.length);
      setDeliveryAddresslists(deliveryLists);
      setBillingAddresslists(billingLists);
    } else {
      setTotalDeliveryAddress(0);
      setDeliveryAddresslists([]);
      setBillingAddresslists([]);
      errorStatus.delivery = true;
      setState(_objectSpread(_objectSpread({}, state), {}, {
        errorStatus: errorStatus
      }));
    }
  };

  var seperateStreetString = function seperateStreetString(str) {
    if (str && str !== "") {
      return str.split(", ");
    } else {
      return null;
    }
  };

  var getRegionValue = function getRegionValue(id) {
    return id && id !== "" ? statesTypes.find(function (item) {
      return item.id == id;
    }) : null;
  };

  var createStreetFromAddressLines = function createStreetFromAddressLines(str1, str2) {
    var res = [];

    if (str1) {
      res.push(str1);
    }

    if (str2) {
      res.push(str2);
    }

    return res;
  };

  var _useState43 = (0,react.useState)({
    validationsOn: {
      delivery: true,
      billing: false,
      companyInformation: false,
      details: true,
      contactDetails: false
    },
    errorStatus: {
      delivery: false,
      billing: false,
      companyInformation: false,
      details: false,
      contactDetails: false
    },
    validations: {
      delivery: {
        addressName: true,
        addressType: true,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: true,
        streetName: true,
        suburb: true,
        postalCode: true,
        town: true,
        province: true,
        instructions: false,
        futureCheck: false,
        contactCheck: false
      },
      billing: {
        addressName: true,
        addressType: true,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: true,
        suburb: true,
        postalCode: true,
        town: true,
        province: true,
        instructions: false,
        addressCheck: false
      },
      companyInformation: {
        addressName: false,
        addressType: true,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: true,
        complexName: true,
        streetNo: true,
        streetName: true,
        suburb: true,
        postalCode: true,
        town: true,
        province: true,
        instructions: false,
        companyVatName: true,
        companyVatNumber: true,
        informationCheck: false,
        ciaddressCheck: false,
        cifutureCheck: false
      },
      details: {
        firstName: true,
        surName: true,
        cellNumber: true,
        email: true,
        contactCheck: false
      },
      contactDetails: {
        firstName: true,
        surName: true,
        cellNumber: true
      }
    },
    fieldErrors: {
      delivery: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
        futureCheck: false,
        contactCheck: false
      },
      billing: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
        addressCheck: false
      },
      companyInformation: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
        companyVatName: false,
        companyVatNumber: false,
        informationCheck: false,
        ciaddressCheck: false,
        cifutureCheck: false
      },
      details: {
        firstName: false,
        surName: false,
        cellNumber: false,
        email: false,
        contactCheck: false
      },
      contactDetails: {
        firstName: false,
        surName: false,
        cellNumber: false
      },
      fail: false
    },
    fieldValues: {
      delivery: {
        addressName: "",
        addressType: RESIDENTIAL_ADDRESS_TYPE,
        companyName: "",
        addressLine1: "",
        addressLine2: "",
        unitNo: "",
        complexName: "",
        streetNo: "",
        streetName: "",
        suburb: "",
        postalCode: "",
        town: "",
        province: "",
        instructions: "",
        futureCheck: false,
        contactCheck: true
      },
      billing: {
        addressName: "",
        addressType: "",
        companyName: "",
        addressLine1: "",
        addressLine2: "",
        unitNo: "",
        complexName: "",
        streetNo: "",
        streetName: "",
        suburb: "",
        postalCode: "",
        town: "",
        province: "",
        instructions: "",
        addressCheck: true
      },
      companyInformation: {
        addressName: "",
        addressType: "",
        companyName: "",
        addressLine1: "",
        addressLine2: "",
        unitNo: "",
        complexName: "",
        streetNo: "",
        streetName: "",
        suburb: "",
        postalCode: "",
        town: "",
        province: "",
        instructions: "",
        companyVatName: "",
        companyVatNumber: "",
        informationCheck: false,
        ciaddressCheck: true,
        cifutureCheck: true
      },
      details: {
        firstName: "",
        surName: "",
        cellNumber: "",
        email: "",
        contactCheck: true
      },
      contactDetails: {
        firstName: "",
        surName: "",
        cellNumber: ""
      }
    },
    readOnlyValues: {
      delivery: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false
      },
      billing: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false
      },
      companyInformation: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
        companyVatName: false,
        companyVatNumber: false
      },
      details: {
        firstName: false,
        surName: false,
        cellNumber: false,
        email: false
      },
      contactDetails: {
        firstName: false,
        surName: false,
        cellNumber: false
      }
    },
    fieldErrorsMessage: {
      delivery: {
        addressName: "Please enter address type (e.g. Home, Work)",
        addressType: "Please select your address type",
        companyName: "Please enter your company name",
        addressLine1: "Please enter your postal address(Line 1)",
        addressLine2: "Please enter your postal address(Line 2)",
        unitNo: "Please enter a unit no.",
        floorNo: "Please enter a unit / floor no.",
        complexName: "Please enter your complex name",
        officeComplexName: "Please enter your office park / building name",
        streetNo: "Please enter your street no.",
        streetName: "Please enter your street name",
        suburb: "Please enter and select suburb",
        postalCode: "Please enter your postal code",
        town: "Please enter your town/city name",
        province: "Please select your province",
        instructions: "Please enter special instructions"
      },
      billing: {
        addressName: "Please enter a name for this address",
        addressType: "Please select your address type",
        companyName: "Please enter your company name",
        addressLine1: "Please enter your postal address(Line 1)",
        addressLine2: "Please enter your postal address(Line 2)",
        unitNo: "Please enter a unit no.",
        floorNo: "Please enter a unit / floor no.",
        complexName: "Please enter your complex name",
        officeComplexName: "Please enter your office park / building name",
        streetNo: "Please enter your street no.",
        streetName: "Please enter your street name",
        suburb: "Please enter and select suburb",
        postalCode: "Please enter your postal code",
        town: "Please enter your town/city name",
        province: "Please select your province",
        instructions: "Please enter special instructions"
      },
      companyInformation: {
        addressName: "Please enter a name for this address",
        addressType: "Please select your address type",
        companyName: "Please enter your company name",
        addressLine1: "Please enter your postal address(Line 1)",
        addressLine2: "Please enter your postal address(Line 2)",
        unitNo: "Please enter a unit no.",
        floorNo: "Please enter a unit / floor no.",
        complexName: "Please enter your complex name",
        officeComplexName: "Please enter your office park / building name",
        streetNo: "Please enter your street no.",
        streetName: "Please enter your street name",
        suburb: "Please enter and select suburb",
        postalCode: "Please enter your postal code",
        town: "Please enter your town/city name",
        province: "Please select your province",
        instructions: "Please enter special instructions",
        companyVatName: "Please enter your company name",
        companyVatNumber: "Please enter your company VAT number"
      },
      details: {
        firstName: "Please enter your first name",
        surName: "Please enter your surname",
        cellNumber: "Please enter your cellphone number",
        email: "Please enter your email address"
      },
      contactDetails: {
        firstName: "Please enter your first name",
        surName: "Please enter your surname",
        cellNumber: "Please enter a cellphone number"
      }
    }
  }),
      state = _useState43[0],
      setState = _useState43[1];

  var validationsOn = state.validationsOn,
      errorStatus = state.errorStatus,
      validations = state.validations,
      fieldErrors = state.fieldErrors,
      fieldValues = state.fieldValues,
      readOnlyValues = state.readOnlyValues,
      fieldErrorsMessage = state.fieldErrorsMessage;
  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */

  var handleBlur = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(event, val, form) {
      var name, errMsg;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              event.persist();
              name = event.target.name;
              _context3.next = 4;
              return fieldValidationCheck(name, val, form, event);

            case 4:
              if (name == "addressType") {
                // Check form validation because field validation updated
                multipleFieldsValidationCheck(["companyName", "addressLine1", "addressLine2", "unitNo", "complexName", "streetNo", "streetName"], form, event);
              }

              _context3.next = 7;
              return checkFormError(form);

            case 7:
              errorStatus[form] = _context3.sent;
              setState(_objectSpread(_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (state.fieldErrors.fail) {
                continueDisable(true);
                errMsg = fieldErrorsMessage[form][name];
                inlineAnalytics(errMsg);
              } else {
                if (selectedBillingAddress || isGuestUser) {
                  checkErrorStatus();
                }
              }

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleBlur(_x3, _x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * Form input field change event handler
   *
   * @usage call updateFieldValues function
   * @call onChange event
   */


  var handleChange = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(event, val, form) {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              event.persist();

              if (!deliveryAnalytics && form == "delivery") {
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                  visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                  page_form_event: "start",
                  page_form_name: "checkout: delivery: ".concat(customerStatus, ": add delivery address")
                }));
                setDeliveryAnalytics(true);
              }

              if (!contactAnalytics && form == "details") {
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                  visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                  page_form_event: "start",
                  page_form_name: "checkout: delivery: ".concat(customerStatus, ": add contact details")
                }));
                setContactAnalytics(true);
              }

              _context4.next = 5;
              return updateFieldValues(event, val, form);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleChange(_x6, _x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * update input field values
   *
   * @usage Set the state of form validations, fieldValues
   */


  var updateFieldValues = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(event, val, form) {
      var name, value, selectionName;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;

              if (name == "addressType") {
                validations[form].companyName = false;
                validations[form].addressLine1 = false;
                validations[form].addressLine2 = false;
                validations[form].unitNo = false;
                validations[form].complexName = false;
                validations[form].streetNo = false;
                validations[form].streetName = true;

                if (value == POSTAL_ADDRESS_TYPE) {
                  validations[form].streetName = false;
                  validations[form].addressLine1 = true;
                  validations[form].addressLine2 = true;

                  if (fieldValues[form].addressLine1 == "" || fieldValues[form].addressLine2 == "") {
                    fieldErrors.fail = true;
                  } else {
                    fieldErrors.fail = false;
                  }
                } else if (value == BUSINESS_ADDRESS_TYPE) {
                  validations[form].companyName = true;
                  validations[form].unitNo = true;
                  validations[form].complexName = true;
                  validations[form].streetNo = true;

                  if (fieldValues[form].companyName == "" || fieldValues[form].unitNo == "" || fieldValues[form].complexName == "" || fieldValues[form].streetNo == "" || fieldValues[form].streetName == "") {
                    fieldErrors.fail = true;
                  } else {
                    fieldErrors.fail = false;
                  }
                } else if (value == RESIDENTIAL_ADDRESS_TYPE) {
                  validations[form].unitNo = true;
                  validations[form].complexName = true;
                  validations[form].streetNo = true;
                  validations[form].streetName = true;
                }

                if (fieldValues[form].unitNo == "" || fieldValues[form].complexName == "" || fieldValues[form].streetNo == "" || fieldValues[form].streetName == "") {
                  fieldErrors[form].fail = true;
                } else {
                  fieldErrors[form].fail = false;
                }
              }

              if (!(name == "futureCheck" || name == "contactCheck" || name == "addressCheck" || name == "informationCheck" || name == "cifutureCheck" || name == "ciaddressCheck")) {
                _context5.next = 48;
                break;
              }

              fieldValues[form][name] = event.target.checked;

              if (!(name == "contactCheck")) {
                _context5.next = 20;
                break;
              }

              if (!event.target.checked) {
                _context5.next = 12;
                break;
              }

              validationsOn.contactDetails = false;
              errorStatus.contactDetails = false;
              setShowContactDetails(false);
              _context5.next = 17;
              break;

            case 12:
              validationsOn.contactDetails = true;
              _context5.next = 15;
              return checkFormError("contactDetails");

            case 15:
              errorStatus.contactDetails = _context5.sent;
              setShowContactDetails(true);

            case 17:
              fieldErrors.fail = errorStatus.contactDetails;
              _context5.next = 46;
              break;

            case 20:
              if (!(name == "addressCheck")) {
                _context5.next = 35;
                break;
              }

              if (!event.target.checked) {
                _context5.next = 27;
                break;
              }

              validationsOn.billing = false;
              errorStatus.billing = false;
              setShowBillingAddress(false);
              _context5.next = 32;
              break;

            case 27:
              validationsOn.billing = true;
              _context5.next = 30;
              return checkFormError("billing");

            case 30:
              errorStatus.billing = _context5.sent;
              setShowBillingAddress(true);

            case 32:
              fieldErrors.fail = errorStatus.billing;
              _context5.next = 46;
              break;

            case 35:
              if (!(name == "ciaddressCheck")) {
                _context5.next = 46;
                break;
              }

              if (!event.target.checked) {
                _context5.next = 41;
                break;
              }

              validationsOn.companyInformation = false;
              errorStatus.companyInformation = false;
              _context5.next = 45;
              break;

            case 41:
              validationsOn.companyInformation = true;
              _context5.next = 44;
              return checkFormError("companyInformation");

            case 44:
              errorStatus.companyInformation = _context5.sent;

            case 45:
              fieldErrors.fail = errorStatus.companyInformation;

            case 46:
              _context5.next = 49;
              break;

            case 48:
              fieldValues[form][name] = value;

            case 49:
              if (!(name == "addressType" || name == "province" || name == "futureCheck")) {
                _context5.next = 59;
                break;
              }

              selectionName = name;
              _context5.t0 = name;
              _context5.next = _context5.t0 === "addressType" ? 54 : _context5.t0 === "futureCheck" ? 56 : 58;
              break;

            case 54:
              selectionName = "address type";
              return _context5.abrupt("break", 58);

            case 56:
              selectionName = "save address";
              return _context5.abrupt("break", 58);

            case 58:
              //capture analytics user selects addressType, province, futureCheck
              selectionAnalytics(selectionName, fieldValues[form][name]);

            case 59:
              setState(_objectSpread(_objectSpread({}, state), {}, {
                validationsOn: validationsOn,
                validations: validations,
                errorStatus: errorStatus,
                fieldErrors: fieldErrors,
                fieldValues: fieldValues
              }));

            case 60:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function updateFieldValues(_x9, _x10, _x11) {
      return _ref6.apply(this, arguments);
    };
  }();

  var multipleFieldsValidationCheck = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(fieldsArray, form, event) {
      var values, errors, entries, i;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              values = state.fieldValues[form];
              errors = state.fieldErrors[form];
              entries = fieldsArray.length;

              if (state.validationsOn[form]) {
                for (i = 0; i < entries; i++) {
                  if (values[fieldsArray[i]] !== "" || errors[fieldsArray[i]]) {
                    fieldValidationCheck(fieldsArray[i], values[fieldsArray[i]], form, event);
                  }
                }
              }

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function multipleFieldsValidationCheck(_x12, _x13, _x14) {
      return _ref7.apply(this, arguments);
    };
  }();

  var fieldValidationCheck = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(name, val, form, event) {
      var value;
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              value = val ? val : event.target.value;
              _context7.t0 = name;
              _context7.next = _context7.t0 === "addressName" ? 4 : _context7.t0 === "addressType" ? 6 : _context7.t0 === "companyName" ? 8 : _context7.t0 === "companyVatName" ? 10 : _context7.t0 === "companyVatNumber" ? 12 : _context7.t0 === "addressLine1" ? 14 : _context7.t0 === "addressLine2" ? 16 : _context7.t0 === "unitNo" ? 18 : _context7.t0 === "complexName" ? 21 : _context7.t0 === "streetNo" ? 25 : _context7.t0 === "streetName" ? 28 : _context7.t0 === "suburb" ? 30 : _context7.t0 === "town" ? 32 : _context7.t0 === "postalCode" ? 34 : _context7.t0 === "province" ? 36 : _context7.t0 === "firstName" ? 38 : _context7.t0 === "surName" ? 40 : _context7.t0 === "cellNumber" ? 42 : _context7.t0 === "email" ? 44 : _context7.t0 === "instructions" ? 46 : 48;
              break;

            case 4:
              if (state.validationsOn[form] && state.validations[form].addressName) {
                fieldErrors[form].addressName = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].addressName;
              } else {
                fieldErrors[form].addressName = false;
              }

              return _context7.abrupt("break", 48);

            case 6:
              if (state.validationsOn[form] && state.validations[form].addressType) {
                fieldErrors[form].addressType = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].addressType;
              } else {
                fieldErrors.addressType = false;
              }

              return _context7.abrupt("break", 48);

            case 8:
              if (state.validationsOn[form] && state.validations[form].companyName) {
                fieldErrors[form].companyName = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].companyName;
              } else {
                fieldErrors[form].companyName = false;
              }

              return _context7.abrupt("break", 48);

            case 10:
              if (state.validationsOn[form] && state.validations[form].companyVatName) {
                fieldErrors[form].companyVatName = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].companyVatName;
              } else {
                fieldErrors[form].companyVatName = false;
              }

              return _context7.abrupt("break", 48);

            case 12:
              if (state.validationsOn[form] && state.validations[form].companyVatNumber) {
                fieldErrors[form].companyVatNumber = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].companyVatNumber;
              } else {
                fieldErrors[form].companyVatNumber = false;
              }

              return _context7.abrupt("break", 48);

            case 14:
              if (state.validationsOn[form] && state.validations[form].addressLine1) {
                fieldErrors[form].addressLine1 = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].addressLine1;
              } else {
                fieldErrors[form].addressLine1 = false;
              }

              return _context7.abrupt("break", 48);

            case 16:
              if (state.validationsOn[form] && state.validations[form].addressLine2) {
                fieldErrors[form].addressLine2 = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].addressLine2;
              } else {
                fieldErrors[form].addressLine2 = false;
              }

              return _context7.abrupt("break", 48);

            case 18:
              if (value.length > 0) {
                fieldErrors[form].unitNo = numRegEx.test(value) ? false : true;

                if (fieldErrors[form].unitNo) {
                  if (state.fieldValues[form].addressType == BUSINESS_ADDRESS_TYPE) {
                    fieldErrorsMessage[form].unitNo = errorMessages/* default.checkout */.Z.checkout[form].floorNo.onlyNumber;
                  } else {
                    fieldErrorsMessage[form].unitNo = errorMessages/* default.checkout */.Z.checkout[form].unitNo.onlyNumber;
                  }
                }
              } else {
                if (state.validationsOn[form] && state.validations[form].unitNo) {
                  fieldErrors[form].unitNo = true;
                } else {
                  fieldErrors[form].unitNo = false;
                }

                if (state.fieldValues[form].addressType == BUSINESS_ADDRESS_TYPE) {
                  fieldErrorsMessage[form].unitNo = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].floorNo;
                } else {
                  fieldErrorsMessage[form].unitNo = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].unitNo;
                }
              }

              fieldErrors.fail = fieldErrors[form].unitNo;
              return _context7.abrupt("break", 48);

            case 21:
              if (state.validationsOn[form] && state.validations[form].complexName) {
                fieldErrors[form].complexName = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].complexName;

                if (state.fieldValues.addressType == BUSINESS_ADDRESS_TYPE) {
                  fieldErrorsMessage[form].complexName = state.fieldErrorsMessage[form].officeComplexName;
                } else {
                  fieldErrorsMessage[form].complexName = state.fieldErrorsMessage[form].complexName;
                }
              } else {
                fieldErrors[form].complexName = false;
              }

              if (state.fieldValues[form].complexName !== "") {
                state.validations.delivery.unitNo = true;
                state.fieldErrors.delivery.unitNo = true;
              }

              if (state.fieldValues[form].complexName == "") {
                state.validations.delivery.unitNo = false;
                state.fieldErrors.delivery.unitNo = false;
              }

              return _context7.abrupt("break", 48);

            case 25:
              if (value.length > 0) {
                fieldErrors[form].streetNo = numRegEx.test(value) ? false : true;

                if (fieldErrors[form].streetNo) {
                  fieldErrorsMessage[form].streetNo = errorMessages/* default.checkout */.Z.checkout[form].streetNo.onlyValid;
                }
              } else {
                if (state.validationsOn[form] && state.validations[form].streetNo) {
                  fieldErrors[form].streetNo = true;
                } else {
                  fieldErrors[form].streetNo = false;
                }

                fieldErrorsMessage[form].streetNo = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].streetNo;
              }

              fieldErrors.fail = fieldErrors[form].streetNo;
              return _context7.abrupt("break", 48);

            case 28:
              if (state.validationsOn[form] && state.validations[form].streetName) {
                if (value.length > 0) {
                  if (!streetNameRegEx.test(value)) {
                    fieldErrors[form].streetName = true;
                    fieldErrorsMessage[form].streetName = errorMessages/* default.checkout */.Z.checkout[form].streetName.onlyValid;
                  } else {
                    fieldErrors[form].streetName = false;
                  }
                } else {
                  fieldErrors[form].streetName = true;
                  fieldErrorsMessage[form].streetName = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].streetName;
                }

                fieldErrors.fail = fieldErrors[form].streetName;
              } else {
                fieldErrors[form].streetName = false;
              }

              return _context7.abrupt("break", 48);

            case 30:
              if (state.validationsOn[form] && state.validations[form].suburb) {
                fieldErrors[form].suburb = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].suburb;
              } else {
                fieldErrors[form].suburb = false;
              }

              return _context7.abrupt("break", 48);

            case 32:
              if (state.validationsOn[form] && state.validations[form].town) {
                fieldErrors[form].town = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].town;
              } else {
                fieldErrors[form].town = false;
              }

              return _context7.abrupt("break", 48);

            case 34:
              if (state.validationsOn[form] && state.validations[form].postalCode) {
                if (value.length > 0) {
                  if (!numRegEx.test(value)) {
                    fieldErrors[form].postalCode = true;
                    fieldErrorsMessage[form].postalCode = errorMessages/* default.checkout */.Z.checkout[form].postalCode.onlyNumber;
                  } else if (value.length < 4) {
                    fieldErrors[form].postalCode = true;
                    fieldErrorsMessage[form].postalCode = errorMessages/* default.checkout */.Z.checkout[form].postalCode.onlyValid;
                  } else {
                    fieldErrors[form].postalCode = false;
                  }
                } else {
                  fieldErrors[form].postalCode = true;
                  fieldErrorsMessage[form].postalCode = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].postalCode;
                }

                fieldErrors.fail = fieldErrors[form].postalCode;
              } else {
                fieldErrors[form].postalCode = false;
              }

              return _context7.abrupt("break", 48);

            case 36:
              if (state.validationsOn[form] && state.validations[form].province) {
                fieldErrors[form].province = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].province;
              } else {
                fieldErrors[form].province = false;
              }

              return _context7.abrupt("break", 48);

            case 38:
              if (state.validationsOn[form] && state.validations[form].firstName) {
                if (value.length > 0) {
                  if (value.length <= 2) {
                    fieldErrors[form].firstName = true;
                    fieldErrorsMessage[form].firstName = errorMessages/* default.checkout */.Z.checkout[form].firstName.minCharacters;
                  } else {
                    fieldErrors[form].firstName = false;
                  }
                } else {
                  fieldErrors[form].firstName = true;
                  fieldErrorsMessage[form].firstName = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].firstName;
                }

                fieldErrors.fail = fieldErrors[form].firstName;
              } else {
                fieldErrors[form].firstName = false;
              }

              return _context7.abrupt("break", 48);

            case 40:
              if (state.validationsOn[form] && state.validations[form].surName) {
                if (value.length > 0) {
                  if (value.length <= 2) {
                    fieldErrors[form].surName = true;
                    fieldErrorsMessage[form].surName = errorMessages/* default.checkout */.Z.checkout[form].surName.minCharacters;
                  } else {
                    fieldErrors[form].surName = false;
                  }
                } else {
                  fieldErrors[form].surName = true;
                  fieldErrorsMessage[form].surName = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].surName;
                }

                fieldErrors.fail = fieldErrors[form].surName;
              } else {
                fieldErrors[form].surName = false;
              }

              return _context7.abrupt("break", 48);

            case 42:
              if (state.validationsOn[form] && state.validations[form].cellNumber) {
                if (value.length > 0) {
                  if (!numRegEx.test(value)) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkout */.Z.checkout[form].cellNumber.onlyNumber;
                  } else if (!cellPhoneRegEx.test(value)) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkout */.Z.checkout[form].cellNumber.startWith;
                  } else if ((0,helperServices/* africaCountryCode */.xJ)(value) && value.length < 11) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].cellNumber;
                  } else if (value.length < 10) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].cellNumber;
                  } else {
                    fieldErrors[form].cellNumber = false;
                  }
                } else {
                  fieldErrors[form].cellNumber = true;
                  fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].cellNumber;
                }

                fieldErrors.fail = fieldErrors[form].cellNumber;
              } else {
                fieldErrors[form].cellNumber = false;
              }

              return _context7.abrupt("break", 48);

            case 44:
              if (state.validationsOn[form] && state.validations[form].email) {
                if (value.length > 0) {
                  fieldErrors[form].email = emailRegEx.test(value) ? false : true;

                  if (fieldErrors[form].email) {
                    fieldErrorsMessage.email = errorMessages/* default.checkout */.Z.checkout[form].email.onlyValid;
                  }
                } else {
                  fieldErrors[form].email = true;
                  fieldErrorsMessage[form].email = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].email;
                }

                fieldErrors.fail = fieldErrors[form].email;
              } else {
                fieldErrors[form].email = false;
              }

              return _context7.abrupt("break", 48);

            case 46:
              if (state.validationsOn[form] && state.validations[form].instructions) {
                fieldErrors[form].instructions = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].instructions;
              } else {
                fieldErrors[form].instructions = false;
              }

              return _context7.abrupt("break", 48);

            case 48:
              setState(_objectSpread(_objectSpread({}, state), {}, {
                fieldErrors: fieldErrors,
                fieldErrorsMessage: fieldErrorsMessage
              }));

            case 49:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function fieldValidationCheck(_x15, _x16, _x17, _x18) {
      return _ref8.apply(this, arguments);
    };
  }();
  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */


  var inlineAnalytics = function inlineAnalytics(message) {
    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
      visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
      page_form_event: "error",
      page_errors: message,
      page_form_name: "checkout: delivery: ".concat(customerStatus, ": form"),
      page_error_type: "form"
    }));
  };
  /**
   * Set the selection analytics(link)
   *
   * @call when dropdown value change
   */


  var selectionAnalytics = function selectionAnalytics(selectionType, value) {
    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
      visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
      page_tool_event: "use",
      page_tool_name: "checkout: delivery: ".concat(customerStatus, ": ").concat(selectionType),
      filter_query: value
    }));
  };

  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      var _iterator = _createForOfIteratorHelper(entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (values[key] == "" && value || errors[key]) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    } else {
      return false;
    }
  }

  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (var _i = 0, _errValues = errValues; _i < _errValues.length; _i++) {
      var err = _errValues[_i];

      if (err) {
        continueDisable(true);
        return;
      }
    }

    if (totalDeliveryAddress !== 0) {
      if (selectedDeliveryAddress) {
        continueDisable(false);
      } else {
        continueDisable(true);
      }
    } else {
      continueDisable(false);
    }
  }

  var addressSearchResultMap = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8() {
      var localityType;
      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              localityType = finalAddress.address_components;

              if (!(localityType && localityType.length > 0)) {
                _context8.next = 9;
                break;
              }

              _context8.next = 4;
              return mapAddressSearchData(localityType);

            case 4:
              _context8.next = 6;
              return checkFormError("delivery");

            case 6:
              errorStatus["delivery"] = _context8.sent;
              setState(_objectSpread(_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (errorStatus["delivery"]) {
                continueDisable(true);
              } else {
                if (selectedBillingAddress || isGuestUser) {
                  checkErrorStatus();
                }
              }

            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function addressSearchResultMap() {
      return _ref9.apply(this, arguments);
    };
  }();

  var mapAddressSearchData = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(localityType) {
      var i;
      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              readOnlyValues.delivery.postalCode = false;
              fieldValues.delivery.unitNo = "";
              fieldValues.delivery.complexName = "";
              fieldValues.delivery.streetNo = "";
              fieldValues.delivery.streetName = "";
              fieldValues.delivery.suburb = "";
              fieldValues.delivery.province = "";
              fieldValues.delivery.town = "";
              fieldValues.delivery.postalCode = "";
              fieldErrors.delivery.unitNo = false;
              fieldErrors.delivery.complexName = false;
              fieldErrors.delivery.streetNo = false;
              fieldErrors.delivery.streetName = false;
              fieldErrors.delivery.suburb = false;
              fieldErrors.delivery.province = false;
              fieldErrors.delivery.town = false;
              fieldErrors.delivery.postalCode = false;

              for (i = 0; i < localityType.length; i++) {
                if (localityType[i].administrative_type == "unit") {
                  if (localityType[i].long_name) {
                    fieldValues.delivery.unitNo = localityType[i].long_name;
                  }
                }

                if (localityType[i].administrative_type == "building") {
                  fieldValues.delivery.complexName = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == "street_number") {
                  fieldValues.delivery.streetNo = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == "route") {
                  fieldValues.delivery.streetName = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == "suburb") {
                  fieldValues.delivery.suburb = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == "province") {
                  fieldValues.delivery.province = getProvinceValue(localityType[i].long_name);
                }

                if (localityType[i].administrative_type == "town" || localityType[i].administrative_type == "city") {
                  fieldValues.delivery.town = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == "post_street") {
                  if (localityType[i].long_name.length > 0) {
                    readOnlyValues.delivery.postalCode = true;
                  }

                  fieldValues.delivery.postalCode = localityType[i].long_name;
                }
              }

              setState(_objectSpread(_objectSpread({}, state), {}, {
                readOnlyValues: readOnlyValues,
                fieldValues: fieldValues,
                fieldErrors: fieldErrors
              }));

            case 19:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function mapAddressSearchData(_x19) {
      return _ref10.apply(this, arguments);
    };
  }();

  var mapContactFormData = function mapContactFormData() {
    var contactData = {
      firstName: "",
      surName: "",
      cellNumber: ""
    };

    if (isGuestUser) {
      contactData.firstName = state.fieldValues["delivery"].contactCheck ? state.fieldValues["details"].firstName : state.fieldValues["contactDetails"].firstName;
      contactData.surName = state.fieldValues["delivery"].contactCheck ? state.fieldValues["details"].surName : state.fieldValues["contactDetails"].surName;
      contactData.cellNumber = state.fieldValues["delivery"].contactCheck ? state.fieldValues["details"].cellNumber : state.fieldValues["contactDetails"].cellNumber;
    } else {
      contactData.firstName = state.fieldValues["details"].contactCheck ? state.fieldValues["details"].firstName : state.fieldValues["contactDetails"].firstName;
      contactData.surName = state.fieldValues["details"].contactCheck ? state.fieldValues["details"].surName : state.fieldValues["contactDetails"].surName;
      contactData.cellNumber = state.fieldValues["details"].contactCheck ? state.fieldValues["details"].cellNumber : state.fieldValues["contactDetails"].cellNumber;
    }

    return contactData;
  };

  var handleSelected = function handleSelected(value) {
    setSelected(value);
    var sortedSearchList;

    if (value === "Distance") {
      sortedSearchList = storeListsFromSearch.sort(function (a, b) {
        if (a.distance < b.distance) {
          return -1;
        }

        if (a.distance > b.distance) {
          return 1;
        }

        return 0;
      });
    } else if (value === "Alphabetical (A-Z)") {
      sortedSearchList = storeListsFromSearch.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }

        if (a.name > b.name) {
          return 1;
        }

        return 0;
      });
    } else {
      sortedSearchList = storeListsFromSearch.sort(function (a, b) {
        if (a.name > b.name) {
          return -1;
        }

        if (a.name < b.name) {
          return 1;
        }

        return 0;
      });
    }

    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "".concat(pageName, ": sort filter"),
      filter_query: value
    }); //setSelectedSearchFromStore(sortedSearchList);
  };

  var mapDeliveryFieldData = function mapDeliveryFieldData() {
    var regionValue = getRegionValue(state.fieldValues["delivery"].province);
    var contactFormData = mapContactFormData();
    return {
      cart_id: cartId !== "" ? cartId : null,
      region: regionValue && regionValue.code ? regionValue.code : null,
      country_code: countryCode ? countryCode : null,
      instructions: state.fieldValues["delivery"].instructions !== "" ? state.fieldValues["delivery"].instructions : null,
      street: state.fieldValues["delivery"].streetName !== "" && state.validations["delivery"].streetName ? seperateStreetString(state.fieldValues["delivery"].streetName) : state.fieldValues["delivery"].addressLine1 !== "" && state.fieldValues["delivery"].addressLine2 !== "" && state.validations["delivery"].addressLine1 && state.validations["delivery"].addressLine2 ? createStreetFromAddressLines(state.fieldValues["delivery"].addressLine1, state.fieldValues["delivery"].addressLine2) : null,
      postcode: state.fieldValues["delivery"].postalCode !== "" ? state.fieldValues["delivery"].postalCode : null,
      city: state.fieldValues["delivery"].town !== "" ? state.fieldValues["delivery"].town : null,
      address_type_name: state.fieldValues["delivery"].addressType !== "" ? state.fieldValues["delivery"].addressType : null,
      address_name: state.fieldValues["delivery"].addressName !== "" ? state.fieldValues["delivery"].addressName : null,
      company: state.fieldValues["delivery"].companyName !== "" ? state.fieldValues["delivery"].companyName : null,
      unit_number: state.fieldValues["delivery"].unitNo !== "" ? state.fieldValues["delivery"].unitNo : null,
      complex_name: state.fieldValues["delivery"].complexName !== "" ? state.fieldValues["delivery"].complexName : null,
      street_number: state.fieldValues["delivery"].streetNo !== "" ? state.fieldValues["delivery"].streetNo : null,
      suburb: state.fieldValues["delivery"].suburb !== "" ? state.fieldValues["delivery"].suburb : null,
      firstname: contactFormData.firstName,
      lastname: contactFormData.surName,
      telephone: contactFormData.cellNumber,
      save_in_address_book: isGuestUser ? false : state.fieldValues["delivery"].futureCheck,
      default_shipping: false,
      default_billing: false,
      is_shipping_address: 0,
      is_billing_address: 0
    };
  };

  var mapBillingFieldData = function mapBillingFieldData() {
    var regionValue = getRegionValue(state.fieldValues["billing"].province);
    var contactFormData = mapContactFormData();
    return {
      cart_id: cartId !== "" ? cartId : null,
      region: regionValue && regionValue.code ? regionValue.code : null,
      country_code: countryCode ? countryCode : null,
      instructions: state.fieldValues["billing"].instructions !== "" ? state.fieldValues["billing"].instructions : null,
      street: state.fieldValues["billing"].streetName !== "" && state.validations["billing"].streetName ? seperateStreetString(state.fieldValues["billing"].streetName) : state.fieldValues["billing"].addressLine1 !== "" && state.fieldValues["billing"].addressLine2 !== "" && state.validations["billing"].addressLine1 && state.validations["billing"].addressLine2 ? createStreetFromAddressLines(state.fieldValues["billing"].addressLine1, state.fieldValues["billing"].addressLine2) : null,
      postcode: state.fieldValues["billing"].postalCode !== "" ? state.fieldValues["billing"].postalCode : null,
      city: state.fieldValues["billing"].town !== "" ? state.fieldValues["billing"].town : null,
      address_type_name: state.fieldValues["billing"].addressType !== "" ? state.fieldValues["billing"].addressType : null,
      address_name: state.fieldValues["billing"].addressName !== "" ? state.fieldValues["billing"].addressName : null,
      company: state.fieldValues["billing"].companyName !== "" ? state.fieldValues["billing"].companyName : null,
      unit_number: state.fieldValues["billing"].unitNo !== "" ? state.fieldValues["billing"].unitNo : null,
      complex_name: state.fieldValues["billing"].complexName !== "" ? state.fieldValues["billing"].complexName : null,
      street_number: state.fieldValues["billing"].streetNo !== "" ? state.fieldValues["billing"].streetNo : null,
      suburb: state.fieldValues["billing"].suburb !== "" ? state.fieldValues["billing"].suburb : null,
      firstname: contactFormData.firstName,
      lastname: contactFormData.surName,
      telephone: contactFormData.cellNumber,
      save_in_address_book: isGuestUser ? false : true,
      default_shipping: false,
      default_billing: false,
      is_shipping_address: 0,
      is_billing_address: 0
    };
  };

  var mapProfileFieldData = function mapProfileFieldData() {
    return {
      didData: {
        profileId: profileData && profileData.profileID ? profileData.profileID : null,
        firstName: state.fieldValues["details"].firstName !== "" ? state.fieldValues["details"].firstName : null,
        lastName: state.fieldValues["details"].surName !== "" ? state.fieldValues["details"].surName : null,
        telephone: state.fieldValues["details"].cellNumber !== "" ? state.fieldValues["details"].cellNumber : null,
        emailID: state.fieldValues["details"].email !== "" ? state.fieldValues["details"].email : null,
        dob: profileData && profileData.dob ? profileData.dob : null,
        gender: profileData && profileData.gender ? profileData.gender : null
      }
    };
  };

  var profileUpdate = /*#__PURE__*/function () {
    var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10() {
      var inputProfileData, results, _results$errors2, _results$errors2$;

      return regenerator_default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              inputProfileData = mapProfileFieldData();
              _context10.prev = 1;
              (0,helperServices/* showSpinner */.yh)();
              _context10.next = 5;
              return (0,checkoutService/* updateProfileDataService */.tO)(inputProfileData);

            case 5:
              results = _context10.sent;

              if (!results.fail) {
                if (applicationType == "normal") {
                  addDeliveryAddress();
                } else {
                  addDeliveryAddress();
                }
              } else {
                (0,helperServices/* hideSpinner */.v3)();

                if (results && results.errors) {
                  technicalFailure((_results$errors2 = results.errors) === null || _results$errors2 === void 0 ? void 0 : (_results$errors2$ = _results$errors2[0]) === null || _results$errors2$ === void 0 ? void 0 : _results$errors2$.message);
                } else {
                  technicalFailure();
                }
              }

              _context10.next = 13;
              break;

            case 9:
              _context10.prev = 9;
              _context10.t0 = _context10["catch"](1);
              (0,helperServices/* hideSpinner */.v3)();
              technicalFailure();

            case 13:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[1, 9]]);
    }));

    return function profileUpdate() {
      return _ref11.apply(this, arguments);
    };
  }();

  var addEmailAddress = /*#__PURE__*/function () {
    var _ref12 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee11() {
      var cart_id, email, results, _results$errors3, _results$errors3$;

      return regenerator_default().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              cart_id = cartId !== "" ? cartId : null;
              email = state.fieldValues["details"].email !== "" ? state.fieldValues["details"].email : null;
              _context11.prev = 2;
              (0,helperServices/* showSpinner */.yh)();
              _context11.next = 6;
              return (0,checkoutService/* setGuestEmailOnCartService */.pZ)(cart_id, email);

            case 6:
              results = _context11.sent;

              if (!results.fail) {
                addDeliveryAddress();
              } else {
                (0,helperServices/* hideSpinner */.v3)();

                if (results && results.errors) {
                  technicalFailure((_results$errors3 = results.errors) === null || _results$errors3 === void 0 ? void 0 : (_results$errors3$ = _results$errors3[0]) === null || _results$errors3$ === void 0 ? void 0 : _results$errors3$.message);
                } else {
                  technicalFailure();
                }
              }

              _context11.next = 14;
              break;

            case 10:
              _context11.prev = 10;
              _context11.t0 = _context11["catch"](2);
              (0,helperServices/* hideSpinner */.v3)();
              technicalFailure();

            case 14:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[2, 10]]);
    }));

    return function addEmailAddress() {
      return _ref12.apply(this, arguments);
    };
  }();

  var addDeliveryAddress = /*#__PURE__*/function () {
    var _ref13 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee12() {
      var inputAddressObj, results, _results$errors4, _results$errors4$, _results, _results$errors5, _results$errors5$;

      return regenerator_default().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              inputAddressObj = selectedReceiveType == "courier" ? mapDeliveryFieldData() : mapDeliveryOnStoreFieldData();

              if (!(totalDeliveryAddress == 0 || selectedReceiveType != "courier")) {
                _context12.next = 17;
                break;
              }

              inputAddressObj.is_shipping_address = 1;
              _context12.prev = 3;
              (0,helperServices/* showSpinner */.yh)();
              _context12.next = 7;
              return (0,checkoutService/* setNewShippingAddressService */.hQ)(inputAddressObj);

            case 7:
              results = _context12.sent;

              if (!results.fail) {
                dispatch({
                  type: actionTypes/* SET_SHIPPING */.sm,
                  payload: results
                });
                addShippingMethod();
                addBillingAddress();
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                  visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                  page_form_event: "success",
                  page_form_name: "checkout: delivery: ".concat(customerStatus, ": add delivery address")
                }));
              } else {
                (0,helperServices/* hideSpinner */.v3)();

                if (results && results.errors) {
                  technicalFailure((_results$errors4 = results.errors) === null || _results$errors4 === void 0 ? void 0 : (_results$errors4$ = _results$errors4[0]) === null || _results$errors4$ === void 0 ? void 0 : _results$errors4$.message);
                } else {
                  technicalFailure();
                }
              }

              _context12.next = 15;
              break;

            case 11:
              _context12.prev = 11;
              _context12.t0 = _context12["catch"](3);
              (0,helperServices/* hideSpinner */.v3)();
              technicalFailure();

            case 15:
              _context12.next = 29;
              break;

            case 17:
              _context12.prev = 17;
              (0,helperServices/* showSpinner */.yh)();
              _context12.next = 21;
              return (0,checkoutService/* setExistingShippingAddressService */.x$)(cartId, selectedDeliveryAddress);

            case 21:
              _results = _context12.sent;

              if (!_results.fail) {
                dispatch({
                  type: actionTypes/* SET_SHIPPING */.sm,
                  payload: _results
                });
                addShippingMethod();
                addBillingAddress();
              } else {
                (0,helperServices/* hideSpinner */.v3)();

                if (_results && _results.errors) {
                  technicalFailure((_results$errors5 = _results.errors) === null || _results$errors5 === void 0 ? void 0 : (_results$errors5$ = _results$errors5[0]) === null || _results$errors5$ === void 0 ? void 0 : _results$errors5$.message);
                } else {
                  technicalFailure();
                }
              }

              _context12.next = 29;
              break;

            case 25:
              _context12.prev = 25;
              _context12.t1 = _context12["catch"](17);
              (0,helperServices/* hideSpinner */.v3)();
              technicalFailure();

            case 29:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[3, 11], [17, 25]]);
    }));

    return function addDeliveryAddress() {
      return _ref13.apply(this, arguments);
    };
  }();

  var addShippingMethod = /*#__PURE__*/function () {
    var _ref14 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee13() {
      var _cartDetails$shipping, _cartDetails$shipping2;

      var cart_id, carrierCode, methodCode, results, retryCounter, _results2, _results2$shippingMet, _results2$shippingMet2, _results2$shippingMet3, _results3;

      return regenerator_default().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              cart_id = cartId !== "" ? cartId : null;
              carrierCode = selectedReceiveType == "store" ? "clickandcollect" : cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping === void 0 ? void 0 : _cartDetails$shipping.carrier_code;
              methodCode = selectedReceiveType == "store" ? "clickandcollect" : cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping2 = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping2 === void 0 ? void 0 : _cartDetails$shipping2.method_code;
              retryCounter = 0;

              if (currentJourneyType == checkout_journey_context/* journeyType.upgrade */.w.upgrade) {
                carrierCode = "flatrate";
                methodCode = "flatrate";
              }

            case 5:
              _context13.next = 7;
              return (0,checkoutService/* setShippingMethodsOnCartService */.YD)(cart_id, carrierCode, methodCode);

            case 7:
              results = _context13.sent;
              retryCounter += 1;

            case 9:
              if ((((_results2 = results) === null || _results2 === void 0 ? void 0 : (_results2$shippingMet = _results2.shippingMethod) === null || _results2$shippingMet === void 0 ? void 0 : (_results2$shippingMet2 = _results2$shippingMet.cart) === null || _results2$shippingMet2 === void 0 ? void 0 : (_results2$shippingMet3 = _results2$shippingMet2.shipping_addresses[0]) === null || _results2$shippingMet3 === void 0 ? void 0 : _results2$shippingMet3.selected_shipping_method) === null || (_results3 = results) !== null && _results3 !== void 0 && _results3.errors) && retryCounter < 3) {
                _context13.next = 5;
                break;
              }

            case 10:
              if (!results.fail) {
                dispatch({
                  type: actionTypes/* SET_SHIPPING_METHOD */.SQ,
                  payload: results
                });
              }

            case 11:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function addShippingMethod() {
      return _ref14.apply(this, arguments);
    };
  }();

  var addBillingAddress = /*#__PURE__*/function () {
    var _ref15 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee14() {
      var inputAddressObj, results, _results$errors6, _results$errors6$, _results4, _results4$errors, _results4$errors$;

      return regenerator_default().wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              if (isGuestUser && !state.fieldValues["billing"].addressCheck) {
                inputAddressObj = mapBillingFieldData();
              } else {
                inputAddressObj = selectedReceiveType == "courier" ? mapDeliveryFieldData() : mapDeliveryOnStoreFieldData();
              }

              if (!(totalDeliveryAddress == 0 && (selectedBillingAddress == true || isGuestUser) || selectedReceiveType == "store")) {
                _context14.next = 17;
                break;
              }

              if (applicationType == "normal") {
                inputAddressObj.is_billing_address = 1;
              } else {
                inputAddressObj.is_shipping_address = 1;
                inputAddressObj.is_billing_address = 1;
                inputAddressObj.same_as_shipping = true;
              }

              _context14.prev = 3;
              (0,helperServices/* showSpinner */.yh)();
              _context14.next = 7;
              return (0,checkoutService/* setNewBillingAddressService */.xz)(inputAddressObj);

            case 7:
              results = _context14.sent;

              if (!results.fail) {
                (0,helperServices/* hideSpinner */.v3)();

                if (applicationType !== "normal") {
                  //set shipping address as well for postpaid journey
                  dispatch({
                    type: actionTypes/* SET_SHIPPING */.sm,
                    payload: results
                  });
                }

                dispatch({
                  type: actionTypes/* SET_BILLING */.BP,
                  payload: results
                });
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                  visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                  page_form_event: "success",
                  page_form_name: applicationType == "normal" ? "checkout: delivery: ".concat(customerStatus, ": add billing address") : "checkout: delivery: ".concat(customerStatus, ": add delivery address")
                })); //navigate to review order

                navigate("review");
              } else {
                (0,helperServices/* hideSpinner */.v3)();

                if (results && results.errors) {
                  technicalFailure((_results$errors6 = results.errors) === null || _results$errors6 === void 0 ? void 0 : (_results$errors6$ = _results$errors6[0]) === null || _results$errors6$ === void 0 ? void 0 : _results$errors6$.message);
                } else {
                  technicalFailure();
                }
              }

              _context14.next = 15;
              break;

            case 11:
              _context14.prev = 11;
              _context14.t0 = _context14["catch"](3);
              (0,helperServices/* hideSpinner */.v3)();
              technicalFailure();

            case 15:
              _context14.next = 29;
              break;

            case 17:
              _context14.prev = 17;
              (0,helperServices/* showSpinner */.yh)();
              _context14.next = 21;
              return (0,checkoutService/* setExistingBillAddressService */.gR)(cartId, selectedBillingAddress == true ? selectedDeliveryAddress : selectedBillingAddress, applicationType == "normal" ? false : true);

            case 21:
              _results4 = _context14.sent;

              if (!_results4.fail) {
                (0,helperServices/* hideSpinner */.v3)();

                if (applicationType !== "normal") {
                  //set shipping address as well for postpaid journey
                  dispatch({
                    type: actionTypes/* SET_SHIPPING */.sm,
                    payload: _results4
                  });
                }

                dispatch({
                  type: actionTypes/* SET_BILLING */.BP,
                  payload: _results4
                });
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                  visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                  page_form_event: "success",
                  page_form_name: applicationType == "normal" ? "checkout: delivery: ".concat(customerStatus, ": add billing address") : "checkout: delivery: ".concat(customerStatus, ": add delivery address")
                })); //navigate to review order

                navigate("review");
              } else {
                (0,helperServices/* hideSpinner */.v3)();

                if (_results4 && _results4.errors) {
                  technicalFailure((_results4$errors = _results4.errors) === null || _results4$errors === void 0 ? void 0 : (_results4$errors$ = _results4$errors[0]) === null || _results4$errors$ === void 0 ? void 0 : _results4$errors$.message);
                } else {
                  technicalFailure();
                }
              }

              _context14.next = 29;
              break;

            case 25:
              _context14.prev = 25;
              _context14.t1 = _context14["catch"](17);
              (0,helperServices/* hideSpinner */.v3)();
              technicalFailure();

            case 29:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[3, 11], [17, 25]]);
    }));

    return function addBillingAddress() {
      return _ref15.apply(this, arguments);
    };
  }();

  var technicalFailure = function technicalFailure(errorMsg) {
    if ((0,helperServices/* matchWordInString */.Rn)(errorMsg, "authorized")) {
      displaySnackBar(labels/* default.checkout.lbl_session_invalid */.Z.checkout.lbl_session_invalid);
      setReLogin(true);
    } else if ((0,helperServices/* matchWordInString */.Rn)(errorMsg, "cart")) {
      displaySnackBar(labels/* default.checkout.lbl_cart_invalid */.Z.checkout.lbl_cart_invalid);
      setReLogin(true);
    } else if ((0,helperServices/* matchWordInString */.Rn)(errorMsg, "server")) {
      if (submitAttempt == 0) {
        displaySnackBar(labels/* default.checkout.lbl_something_went_wrong_try_again */.Z.checkout.lbl_something_went_wrong_try_again);
      } else {
        fetchErrorDetails("checkoutAPI_invalid");
        closeSnackBar();
      }

      setSubmitAttempt(submitAttempt + 1);
    } else {
      displaySnackBar(labels/* default.checkout.lbl_something_went_wrong_try_again */.Z.checkout.lbl_something_went_wrong_try_again);
    }
  };
  /**
   * Get the error display data
   * @usage Redirect to checkout error with error details
   */


  var fetchErrorDetails = /*#__PURE__*/function () {
    var _ref16 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee15(resultCode) {
      var pageName, result;
      return regenerator_default().wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              pageName = "checkout: delivery: ".concat(customerStatus);
              _context15.prev = 1;
              (0,helperServices/* showSpinner */.yh)();
              _context15.next = 5;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [resultCode]);

            case 5:
              result = _context15.sent;
              setPageErr({
                type: "error",
                title: result[0].resultTitle,
                desc: result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML,
                primaryLabel: result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                primaryUrl: result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                secondaryLabel: result[0].secondaryEnabled === "Yes" ? result[0].secondaryCTAText : null,
                secondaryUrl: result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                handlePrimaryClick: function handlePrimaryClick() {
                  return _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].primaryCTAURL, result[0].leadType, result[0].primaryCTAType), result[0].primaryCTAText);
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].secondaryCTAURL, result[0].leadType, result[0].secondaryCTAType), result[0].secondaryCTAText);
                },
                imgUrl: result[0].icon,
                pageName: pageName
              });
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");
              _context15.next = 16;
              break;

            case 11:
              _context15.prev = 11;
              _context15.t0 = _context15["catch"](1);
              setPageErr({
                type: "error",
                title: labels/* default.checkout.lbl_invalid_attempt_title */.Z.checkout.lbl_invalid_attempt_title,
                desc: labels/* default.checkout.lbl_invalid_attempt_desc */.Z.checkout.lbl_invalid_attempt_desc,
                primaryLabel: "Call me back",
                secondaryLabel: "Exit checkout",
                handlePrimaryClick: function handlePrimaryClick() {
                  return _handlePrimaryClick(null, "call me back");
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick(null, "exit checkout");
                },
                imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                pageName: pageName
              });
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");

            case 16:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[1, 11]]);
    }));

    return function fetchErrorDetails(_x20) {
      return _ref16.apply(this, arguments);
    };
  }();

  var _handlePrimaryClick = function _handlePrimaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label),
      page_name: "".concat(pageName)
    });

    if (url) {
      router.push("".concat(helperServices/* urlPrefix */.wn).concat(url)).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/forms/ecommerce")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  var _handleSecondaryClick = function _handleSecondaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label),
      page_name: "".concat(pageName)
    });

    if (url) {
      router.push("".concat(helperServices/* urlPrefix */.wn).concat(url)).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/cart")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  var displaySnackBar = function displaySnackBar(message) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "page_level";
    setShowSnackBar({
      visible: true,
      message: message
    });
    var pageAnalyticsData = {
      page_errors: message,
      page_error_type: "page"
    };

    if (level == "form_level") {
      pageAnalyticsData.page_form_event = "error";
      pageAnalyticsData.page_form_name = "checkout: delivery: ".concat(customerStatus, ": form");
      pageAnalyticsData.page_error_type = "form";
    }

    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
      visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid"
    }, pageAnalyticsData));
  };

  var closeSnackBar = function closeSnackBar() {
    setShowSnackBar({
      visible: false,
      message: ""
    });
  };

  var showModal = function showModal(popUpType, variant, addressData) {
    if (variant == "add") {
      addressData.firstName = state.fieldValues["details"].firstName;
      addressData.surName = state.fieldValues["details"].surName;
      addressData.cellNumber = state.fieldValues["details"].cellNumber;
    }

    setModalType(popUpType);
    setModalVariant(variant);
    setModalValues(addressData);
    setModalShow(true);
    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
      visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
      page_form_event: "start",
      page_form_name: "checkout: ".concat(popUpType, ": ").concat(customerStatus, ": ").concat(variant, " ").concat(popUpType, " address")
    }));
  };

  var hideModal = function hideModal(refresh) {
    setModalShow(false);

    if (refresh == true) {
      fetchData();
    }
  };

  var displyConfirmModal = function displyConfirmModal(addressData, popUpType) {
    var nameHTML = '<div class="' + (CheckoutDelivery_module_default()).value + '"><span class="' + (CheckoutDelivery_module_default()).value__first + '">' + addressData.name + "</span>";
    var streetHTML = "";

    if (addressData.street && addressData.suburb && addressData.postcode) {
      streetHTML = '<span class="' + (CheckoutDelivery_module_default()).value__second + '">' + addressData.street + ", " + addressData.suburb + ", " + addressData.postcode + "</span>";
    } else if (addressData.suburb && addressData.postcode) {
      streetHTML = '<span class="' + (CheckoutDelivery_module_default()).value__second + '">' + addressData.suburb + ", " + addressData.postcode + "</span>";
    }

    var closeHTML = "</div>";
    var contentHTML = streetHTML !== "" ? nameHTML + streetHTML + closeHTML : nameHTML + closeHTML;
    setConfirmModalContent(contentHTML);
    setDeleteId(addressData.id);
    setDeleteType(popUpType);
    setShowConfirmModal(true);
    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
      visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
      page_form_event: "start",
      page_form_name: "checkout: ".concat(popUpType, ": ").concat(customerStatus, ": delete ").concat(popUpType, " address")
    }));
  };

  var cancelConfirmModel = function cancelConfirmModel() {
    setShowConfirmModal(false);
  };

  var approveConfirmModel = /*#__PURE__*/function () {
    var _ref17 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee16() {
      var results, _results$errors7, _results$errors7$;

      return regenerator_default().wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              setShowConfirmModal(false);
              _context16.prev = 1;
              (0,helperServices/* showSpinner */.yh)();
              _context16.next = 5;
              return (0,checkoutService/* deleteCustomerAddressService */.mV)(deleteId);

            case 5:
              results = _context16.sent;

              if (!results.fail) {
                setSelectedDeliveryAddress(false);
                setSelectedBillingAddress(true);
                fetchData();
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                  visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                  page_form_event: "success",
                  page_form_name: "checkout: delivery: ".concat(customerStatus, ": delete ").concat(deleteType, " address")
                }));
              } else {
                (0,helperServices/* hideSpinner */.v3)();

                if (results && results.errors) {
                  technicalFailure((_results$errors7 = results.errors) === null || _results$errors7 === void 0 ? void 0 : (_results$errors7$ = _results$errors7[0]) === null || _results$errors7$ === void 0 ? void 0 : _results$errors7$.message);
                } else {
                  technicalFailure();
                }
              }

              _context16.next = 13;
              break;

            case 9:
              _context16.prev = 9;
              _context16.t0 = _context16["catch"](1);
              (0,helperServices/* hideSpinner */.v3)();
              technicalFailure();

            case 13:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, null, [[1, 9]]);
    }));

    return function approveConfirmModel() {
      return _ref17.apply(this, arguments);
    };
  }();

  var addressTileClickHandler = function addressTileClickHandler(data, type) {
    if (type == "delivery") {
      setSelectedDeliveryAddress(data.id);
      analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
        visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
        page_tool_event: "use",
        page_tool_name: "checkout: delivery: ".concat(customerStatus, ": select delivery address"),
        filter_query: data.address_name
      }));
    } else {
      setSelectedBillingAddress(data.id);
      analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
        visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
        page_tool_event: "use",
        page_tool_name: "checkout: delivery: ".concat(customerStatus, ": select billing address"),
        filter_query: data.address_name
      }));
    }
  };

  var refreshState = function refreshState() {
    errorStatus.delivery = isGuestUser ? true : false;
    errorStatus.details = isGuestUser ? true : false;
    setState(_objectSpread(_objectSpread({}, state), {}, {
      errorStatus: errorStatus
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (CheckoutDelivery_module_default())["delivery-container"],
      children: [deliveryOptionEnable && /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveType/* default */.Z, {
        heading: labels/* default.creditCheckout.deliveryDetails.lbl_receive_type_title */.Z.creditCheckout.deliveryDetails.lbl_receive_type_title,
        selectedType: selectedReceiveType,
        receiveTypes: receiveTypesOptions,
        handleReceiveType: handleReceiveType,
        tabDisable: tabDisable,
        id: "checkout-credit-check-receive-type-select"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryOptionTitle_DeliveryOptionTitle, {
        content: selectedReceiveType != "store" ? courierPath : storePath
      }), selectedReceiveType == "store" && Object.keys(customerPosition).length != 0 && closestStoreLists.length !== 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
        title: "Stores closest to you",
        desc: "These three stores close to you have your items in stock right now:",
        className: (CheckoutDelivery_module_default()).storeCard
      }), selectedReceiveType == "store" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CheckoutDelivery_module_default())["storeCard-container"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(storeCard/* default */.Z, {
          variant: "closestStore",
          handleOnClick: closestStoreCardClickHandler,
          selectedStoreCard: selectedClosestStoreCard,
          data: closestStoreLists,
          geoLocationIsAllowed: geoLocation !== null && geoLocation !== void 0 && geoLocation.allowed ? true : false
        })
      }), selectedReceiveType == "store" && serviceDown && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutDelivery_module_default()).serviceDown,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (CheckoutDelivery_module_default()).serviceDown__icon,
          src: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/warning-black.svg")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: labels/* default.lbl_no_store_list_found */.Z.lbl_no_store_list_found
        })]
      }), selectedReceiveType == "store" && /*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
        title: "Which store would you like to collect from?",
        desc: "Try searching for your town, suburb or favourite shopping centre",
        className: (CheckoutDelivery_module_default())["storeCard-list"]
      }), selectedReceiveType == "store" && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "d-none " + (CheckoutDelivery_module_default())["search-wrapper"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentSearchBox/* default */.Z, {
            className: (CheckoutDelivery_module_default())["search-wrapper__input"],
            placeholderText: "Type here to search",
            icon: "$black40",
            variant: "store-search",
            setFinalAddress: setFinalAddress,
            passSuggestedData: function passSuggestedData(filteredAddressData) {
              return _passSuggestedData(filteredAddressData);
            },
            pageName: "checkout: delivery: ".concat(customerStatus),
            analyticFormName: "delivery address"
          })
        })
      }), searchResult == true && selectedReceiveType == "store" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (CheckoutDelivery_module_default()).result,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
            className: (CheckoutDelivery_module_default())["result-label"],
            children: "0 - 0 of 0 results "
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (CheckoutDelivery_module_default())["dropdown-container"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
              className: (CheckoutDelivery_module_default())["dropdown-label"],
              children: [labels/* default.lbl_sort_by */.Z.lbl_sort_by, ":"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
              data: geoLocation !== null && geoLocation !== void 0 && geoLocation.allowed ? dropdownWithDistance : dropdownValues,
              handleSelect: handleSelected,
              menuClassName: "sort-menu",
              selectedValue: selected,
              id: "sort-menu"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutDelivery_module_default())["empty-wrapper"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(EmptyProductsContainer/* default */.Z, {
            message: "We couldn’t find any results for your search term. Please try again.",
            ctaHidden: true
          })
        })]
      }), selectedReceiveType == "store" && storeListsFromSearch.length !== 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutDelivery_module_default()).result,
        children: [storeListsFromSearch.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
          className: (CheckoutDelivery_module_default())["result-label"],
          children: "1 - ".concat(storeListsFromSearch.length > 3 ? dataSize : storeListsFromSearch.length, " of ").concat(storeListsFromSearch.length, " results ")
        }), storeListsFromSearch.length === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
          className: (CheckoutDelivery_module_default())["result-label"],
          children: "0 - 0 of 0 results "
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (CheckoutDelivery_module_default())["dropdown-container"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
            className: (CheckoutDelivery_module_default())["dropdown-label"],
            children: [labels/* default.lbl_sort_by */.Z.lbl_sort_by, ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            data: geoLocation !== null && geoLocation !== void 0 && geoLocation.allowed ? dropdownWithDistance : dropdownValues,
            handleSelect: handleSelected,
            menuClassName: "sort-menu",
            selectedValue: selected,
            id: "sort-menu"
          })]
        })]
      }), selectedReceiveType == "store" && storeListsFromSearch && storeListsFromSearch.length < 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(EmptyProductsContainer/* default */.Z, {
        message: "We couldn’t find any results for your search term. Please try again.",
        ctaHidden: true
      }), selectedReceiveType == "store" && storeListsFromSearch.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (CheckoutDelivery_module_default())["storeCard-container"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(storeCard/* default */.Z, {
          variant: "searchedStore",
          handleOnClick: storeCardClickHandler,
          selectedStoreCard: selectedStoreCard,
          data: storeListsFromSearch,
          onSizeChange: handleSizeChange,
          geoLocationIsAllowed: geoLocation !== null && geoLocation !== void 0 && geoLocation.allowed ? true : false
        })
      }), selectedReceiveType != "store" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form, {
        noValidate: true,
        id: "deliveryForm",
        children: [totalDeliveryAddress > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
          title: "Delivery address",
          desc: "Where would you like us to deliver your order?",
          id: "checkout-form-delivery-address"
        }), deliveryAddresslists.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutDelivery_module_default())["tiles-section"],
          children: deliveryAddresslists.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(AddressTile/* default */.Z, {
              type: "delivery",
              variant: "edit",
              data: item,
              handleOnEdit: showModal,
              handleOnDelete: displyConfirmModal,
              handleOnClick: addressTileClickHandler,
              selectedAddress: selectedDeliveryAddress,
              id: "checkout-delivery-address-tile-".concat(index)
            }, index);
          })
        }), totalDeliveryAddress > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(addAddress_AddAddress, {
          type: "delivery",
          className: (CheckoutDelivery_module_default())["tiles-section"],
          data: {
            desktop_button: "Add delivery address",
            mob_button: "Add another address"
          },
          handleOnClick: showModal,
          id: "checkout-form-add-delivery-address"
        }), (totalDeliveryAddress == 0 || applicationType !== "normal") && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "".concat(isGuestUser ? "d-flex flex-column" : ""),
            children: [totalDeliveryAddress == 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
                title: "Delivery address",
                desc: "Where would you like us to deliver your order?",
                id: "checkout-form-delivery-address"
              }), state.fieldValues["delivery"].addressType !== POSTAL_ADDRESS_TYPE && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: "d-none " + (CheckoutDelivery_module_default())["search-wrapper"],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentSearchBox/* default */.Z, {
                  className: (CheckoutDelivery_module_default())["search-wrapper__input"],
                  placeholderText: "Search for your address",
                  icon: "blue",
                  variant: "address-search",
                  setFinalAddress: setFinalAddress,
                  pageName: "checkout: delivery: ".concat(customerStatus),
                  analyticFormName: "delivery address"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryAddress/* default */.Z, {
                formName: "delivery",
                applicationType: applicationType,
                validations: state.validations["delivery"],
                fieldValues: state.fieldValues["delivery"],
                fieldErrors: state.fieldErrors["delivery"],
                fieldErrorsMessage: state.fieldErrorsMessage["delivery"],
                readOnlyValues: state.readOnlyValues["delivery"],
                stateTypesOptions: stateTypesOptions,
                onChangeHandler: handleChange,
                onBlurHandler: handleBlur,
                isGuestUser: isGuestUser,
                containerClassName: "".concat((CheckoutDelivery_module_default()).section)
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: "".concat(isGuestUser ? (CheckoutDelivery_module_default())["order-1"] : ""),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
                title: applicationType == "normal" ? "Your details" : "Your contact details",
                desc: applicationType == "normal" ? "We need your personal details to process this order" : "Where can the courier contact you when delivering your order?",
                id: "checkout-form-details"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(PersonDetails/* default */.Z, {
                formName: "details",
                applicationType: applicationType,
                fieldValues: state.fieldValues["details"],
                fieldErrors: state.fieldErrors["details"],
                fieldErrorsMessage: state.fieldErrorsMessage["details"],
                readOnlyValues: state.readOnlyValues["details"],
                onChangeHandler: handleChange,
                onBlurHandler: handleBlur,
                isGuestUser: isGuestUser,
                className: (CheckoutDelivery_module_default()).section,
                formInfo: contactFormInfo
              })]
            }), showContactDetails && applicationType == "normal" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
                title: "Your contact details",
                desc: "Who can we contact when we deliver at this address?",
                id: "checkout-form-contact-details"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(PersonDetails/* default */.Z, {
                formName: "contactDetails",
                applicationType: applicationType,
                fieldValues: state.fieldValues["contactDetails"],
                fieldErrors: state.fieldErrors["contactDetails"],
                fieldErrorsMessage: state.fieldErrorsMessage["contactDetails"],
                readOnlyValues: state.readOnlyValues["contactDetails"],
                onChangeHandler: handleChange,
                onBlurHandler: handleBlur,
                className: (CheckoutDelivery_module_default()).section
              })]
            })]
          })
        }), applicationType == "normal" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
            title: "Billing address",
            desc: "Where would you like us to send your bill?",
            id: "checkout-form-billing-address"
          }), isGuestUser && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(billingAddress_BillingAddress, {
              formName: "billing",
              validations: state.validations["billing"],
              fieldValues: state.fieldValues["billing"],
              fieldErrors: state.fieldErrors["billing"],
              fieldErrorsMessage: state.fieldErrorsMessage["billing"],
              readOnlyValues: state.readOnlyValues["billing"],
              addressTypesOptions: addressTypesOptions,
              stateTypesOptions: stateTypesOptions,
              onChangeHandler: handleChange,
              onBlurHandler: handleBlur,
              showBillingAddress: showBillingAddress,
              containerClassName: "".concat((CheckoutDelivery_module_default()).section)
            })
          })]
        }), !isGuestUser && applicationType == "normal" && /*#__PURE__*/(0,jsx_runtime.jsx)(AddressTile/* default */.Z, {
          type: "billing",
          className: "".concat((CheckoutDelivery_module_default())["tiles-section"]),
          data: {
            address_name: "Same as delivery address",
            id: true
          },
          variant: "default",
          handleOnClick: addressTileClickHandler,
          selectedAddress: selectedBillingAddress,
          id: "checkout-billing-address-tile-same-as-delivery"
        }), billingAddresslists.length > 0 && applicationType == "normal" && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((CheckoutDelivery_module_default())["tiles-section"]),
          children: billingAddresslists.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(AddressTile/* default */.Z, {
              type: "billing",
              variant: "edit",
              data: item,
              handleOnEdit: showModal,
              handleOnDelete: displyConfirmModal,
              handleOnClick: addressTileClickHandler,
              selectedAddress: selectedBillingAddress,
              id: "checkout-billing-address-tile-".concat(index)
            }, index);
          })
        }), !isGuestUser && applicationType == "normal" && /*#__PURE__*/(0,jsx_runtime.jsx)(addAddress_AddAddress, {
          type: "billing",
          className: (CheckoutDelivery_module_default())["tiles-section"],
          data: {
            desktop_button: "Add billing address",
            mob_button: "Add another address"
          },
          handleOnClick: showModal,
          id: "checkout-form-add-billing-address"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutFormsModal/* default */.Z, {
      show: modalShow,
      hide: hideModal,
      formType: modalType,
      variant: modalVariant,
      values: modalValues,
      addressTypes: addressTypesOptions,
      statesTypes: stateTypesOptions,
      countryCode: countryCode,
      countryName: countryName,
      cartId: cartId,
      step: "delivery",
      pageName: "checkout: delivery: ".concat(customerStatus),
      isGuestUser: isGuestUser,
      applicationType: applicationType
    }), showConfirmModal ? /*#__PURE__*/(0,jsx_runtime.jsx)(ConfirmModal/* default */.Z, {
      show: showConfirmModal,
      subtext: "You\u2019re about to delete this address:",
      text: confirmModalContent,
      handleConfirm: approveConfirmModel,
      handleCancel: cancelConfirmModel,
      confirmLabel: "Yes, delete this address"
    }) : null]
  });
});
CheckoutDelivery.defaultProps = {
  addressTypes: [],
  statesTypes: [],
  isGuestUser: false,
  applicationType: "normal"
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    profileLoading: state.navDetails.isProfileLoading,
    deliveryDetails: state.creditCheckDetails.deliveryDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    upgradeResponse: state.upgrade.upgradeResponse,
    cartDetails: state.cartDetails,
    geoLocation: state.geoLocation
  };
};

var mapDispatchToProps = {
  setReLogin: navAction/* setReLogin */.Lf,
  setGeoLocationStatus: geoLocationAction/* setGeoLocationStatus */.$q,
  setGeoLocationPosition: geoLocationAction/* setGeoLocationPosition */.pt,
  setStoreDetails: geoLocationAction/* setStoreDetails */.Gi,
  setChangeStore: geoLocationAction/* setChangeStore */.oA
};
/* harmony default export */ var checkoutDelivery_CheckoutDelivery = ((0,DependencyHelper.connect)(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(CheckoutDelivery));

/***/ }),

/***/ 34161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkoutOrderConfirmation_CheckoutOrderConfirmation; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./components/molecules/nextStepsInfo/NextStepsInfo.module.scss
var NextStepsInfo_module = __webpack_require__(73842);
var NextStepsInfo_module_default = /*#__PURE__*/__webpack_require__.n(NextStepsInfo_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/nextStepsInfo/NextStepsInfo.jsx







var NextStepsInfo = function NextStepsInfo(_ref) {
  var heading = _ref.heading,
      type = _ref.type,
      content = _ref.content,
      subContent = _ref.subContent,
      userEmail = _ref.userEmail,
      className = _ref.className,
      headingClassName = _ref.headingClassName;
  var stepCarousel;
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= 996;

  var next = function next() {
    if (stepCarousel) {
      stepCarousel.next(600);
    }
  };

  var prev = function prev() {
    if (stepCarousel) {
      stepCarousel.prev(600);
    }
  };

  var carouselOptions = {
    nav: false,
    autoplay: false,
    // animateIn: "animate__fadeIn",
    autoWidth: false,
    lazyLoad: true,
    navContainerClass: "owl--nav--container",
    dotsContainer: ".owl--next-step-dots",
    dotClass: "owl--next-step-dot",
    mouseDrag: true,
    touchDrag: true,
    slideBy: 1,
    dots: true,
    smartSpeed: 600,
    responsive: {
      0: {
        margin: 16,
        items: 1
      },
      576: {
        margin: 16,
        items: 2
      },
      768: {
        margin: 24,
        items: 3
      }
    }
  };

  var replaceStaticEmail = function replaceStaticEmail(str) {
    if (str && str !== "" && userEmail && str.match(/{{email}}/g)) {
      return str.replace("{{email}}", userEmail);
    } else {
      return str;
    }
  };

  var DisplayItemView = function DisplayItemView(_ref2) {
    var content = _ref2.content;

    if (isTablet) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.OwlCarousel, {
        ref: function ref(c) {
          return stepCarousel = c;
        },
        options: carouselOptions,
        children: content.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (NextStepsInfo_module_default()).item,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              id: "item-img",
              className: (NextStepsInfo_module_default()).icon,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: item.icon
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              id: "item-title",
              className: (NextStepsInfo_module_default()).title,
              children: item.title
            }), item.description && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              id: "item-desc",
              className: (NextStepsInfo_module_default()).desc,
              dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(replaceStaticEmail(item.description))
            })]
          }, index);
        })
      });
    } else {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: content.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (NextStepsInfo_module_default()).item,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              id: "item-img",
              className: (NextStepsInfo_module_default()).icon,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: item.icon
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              id: "item-title",
              className: (NextStepsInfo_module_default()).title,
              children: item.title
            }), item.description && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              id: "item-desc",
              className: (NextStepsInfo_module_default()).desc,
              dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(replaceStaticEmail(item.description))
            })]
          }, index);
        })
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((NextStepsInfo_module_default())["next-steps-info"], " ").concat(className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((NextStepsInfo_module_default())["section-heading"], " ").concat(headingClassName),
      children: heading
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (NextStepsInfo_module_default())["main-wrapper"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((NextStepsInfo_module_default()).items, " ").concat(type == "step" ? (NextStepsInfo_module_default())["step-type"] : ""),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DisplayItemView, {
          content: content
        })
      }), subContent && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (NextStepsInfo_module_default())["sub-content"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: subContent.icon,
          className: (NextStepsInfo_module_default()).icon
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          id: "sub-content-desc",
          className: (NextStepsInfo_module_default()).desc,
          dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(subContent.description)
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "owl--next-step-dots"
    })]
  });
};

NextStepsInfo.defaultProps = {
  type: "step",
  content: [],
  subContent: null
};
/* harmony default export */ var nextStepsInfo_NextStepsInfo = (NextStepsInfo);
// EXTERNAL MODULE: ./components/molecules/purchasedOrder/purchasedItems/PurchasedItems.jsx + 1 modules
var PurchasedItems = __webpack_require__(33250);
// EXTERNAL MODULE: ./components/atoms/label/LabelText.jsx
var LabelText = __webpack_require__(38975);
// EXTERNAL MODULE: ./context/checkout-journey-context.js
var checkout_journey_context = __webpack_require__(62039);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
// EXTERNAL MODULE: ./components/molecules/purchasedOrder/purchasedSectionInfo/PurchasedSectionInfo.module.scss
var PurchasedSectionInfo_module = __webpack_require__(44907);
var PurchasedSectionInfo_module_default = /*#__PURE__*/__webpack_require__.n(PurchasedSectionInfo_module);
;// CONCATENATED MODULE: ./components/molecules/purchasedOrder/purchasedSectionInfo/PurchasedSectionInfo.jsx












var PurchasedSectionInfo = function PurchasedSectionInfo(_ref) {
  var heading = _ref.heading,
      type = _ref.type,
      journey = _ref.journey,
      orderData = _ref.orderData;

  var SectionBlock = function SectionBlock(_ref2) {
    var titles = _ref2.titles,
        values = _ref2.values;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PurchasedSectionInfo_module_default())["section-heading"],
        children: heading
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "d-none d-md-block",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
          noGutters: true,
          className: (PurchasedSectionInfo_module_default()).container,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
            md: 5,
            lg: 5,
            xl: 5,
            className: "d-flex flex-column",
            children: titles.map(function (title, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
                className: (PurchasedSectionInfo_module_default()).title,
                children: [title, ":"]
              }, index);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
            md: 7,
            lg: 7,
            xl: 7,
            className: "d-flex flex-column",
            children: values.map(function (value, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
                className: (PurchasedSectionInfo_module_default()).value,
                children: value
              }, index);
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "d-block d-md-none",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
          noGutters: true,
          className: (PurchasedSectionInfo_module_default()).container,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
            xs: 12,
            className: "d-flex flex-column",
            children: titles.map(function (title, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
                  className: (PurchasedSectionInfo_module_default()).title,
                  children: [title, ":"]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
                  className: (PurchasedSectionInfo_module_default()).value,
                  children: values[index]
                })]
              }, index);
            })
          })
        })
      })]
    });
  };

  function getCreditStatus(creditStatus) {
    if (creditStatus == constants/* CREDIT_VETTING_STATUS.offline */.EL.offline) {
      return "Not checked yet";
    } else if (creditStatus) {
      return (0,helperServices/* capitalizeFirstLetter */.fm)(creditStatus);
    } else {
      return "-";
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [type == "order" && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionBlock, {
      titles: journey == checkout_journey_context/* journeyType.upgrade */.w.upgrade ? ["Order / Tracking number", "Order type"] : ["Order / Tracking number", "Order type", "Credit status"],
      values: journey == checkout_journey_context/* journeyType.upgrade */.w.upgrade ? [orderData !== null && orderData !== void 0 && orderData.tracking_number ? orderData.tracking_number : "-", orderData !== null && orderData !== void 0 && orderData.order_type ? orderData.order_type.join(", ") : "-"] : [orderData !== null && orderData !== void 0 && orderData.tracking_number ? orderData.tracking_number : "-", orderData !== null && orderData !== void 0 && orderData.order_type ? orderData.order_type : "-", orderData !== null && orderData !== void 0 && orderData.vetting_result ? getCreditStatus(orderData === null || orderData === void 0 ? void 0 : orderData.vetting_result) : "-"]
    }), type == "delivery" && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionBlock, {
      titles: ["Courier", "Delivery address", "Contact person"],
      values: [orderData !== null && orderData !== void 0 && orderData.courier_partner ? orderData.courier_partner : "-", orderData !== null && orderData !== void 0 && orderData.delivery_address ? orderData.delivery_address : "-", orderData !== null && orderData !== void 0 && orderData.contact_person ? (0,helperServices/* getUpdatedContactPerson */.DE)(orderData.contact_person) : "-"]
    }), type == "store" && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionBlock, {
      titles: ["Store name & address", "Collect by", "Contact person"],
      values: [orderData !== null && orderData !== void 0 && orderData.delivery_address ? orderData.delivery_address : "-", orderData !== null && orderData !== void 0 && orderData.estimated_delivery_date ? orderData.estimated_delivery_date : "-", orderData !== null && orderData !== void 0 && orderData.contact_person ? (0,helperServices/* getUpdatedContactPerson */.DE)(orderData.contact_person) : "-"]
    })]
  });
};

PurchasedSectionInfo.defaultProps = {
  heading: "Delivery details",
  type: "delivery",
  journey: "NEWLINE"
};
/* harmony default export */ var purchasedSectionInfo_PurchasedSectionInfo = (PurchasedSectionInfo);
// EXTERNAL MODULE: ./components/organisms/debicheckMandate/DebicheckLink.module.scss
var DebicheckLink_module = __webpack_require__(43550);
var DebicheckLink_module_default = /*#__PURE__*/__webpack_require__.n(DebicheckLink_module);
// EXTERNAL MODULE: ./components/atoms/staticForms/StaticForms.module.scss
var StaticForms_module = __webpack_require__(88192);
var StaticForms_module_default = /*#__PURE__*/__webpack_require__.n(StaticForms_module);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
;// CONCATENATED MODULE: ./components/organisms/debicheckMandate/DebicheckLink.jsx








var DebicheckLink = function DebicheckLink(_ref) {
  var msgType = _ref.msgType;
  var Debi_cust_msgs = {
    consent: {
      head: "DebiCheck has been enabled for this application",
      info: "To protect your account from fraudsters, DebiCheck lets you authorise debit orders electronically before transactions are processed. It's an extra layer of security for your peace of mind."
    },
    noConsent: {
      head: "DebiCheck was not enabled for this application",
      info: "We may, however, still submit your application for a DebiCheck. To protect your account from fraudsters, DebiCheck lets you authorise debit orders electronically before transactions are processed. It's an extra layer of security for your peace of mind."
    },
    educational: {
      head: "DebiCheck",
      info: "To protect your account from fraudsters, DebiCheck lets you authorise debit orders electronically before transactions are processed. It's an extra layer of security for your peace of mind."
    }
  };
  var MsgToShow = Debi_cust_msgs[msgType];
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;

  var handleMandateLinkClick = function handleMandateLinkClick() {
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": debicheck")
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((StaticForms_module_default())["main-container"], " ").concat((DebicheckLink_module_default()).debi_link_container),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((DebicheckLink_module_default()).debi_link_container_top),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: "".concat((DebicheckLink_module_default()).debi_link_icon),
        src: "".concat(imagePrefix, "/assets/images/debi-check-logo.svg")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((DebicheckLink_module_default()).debi_mandate_link_head),
        children: MsgToShow.head
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((DebicheckLink_module_default()).debi_link_info),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((DebicheckLink_module_default()).debi_mandate_link_descr),
        children: MsgToShow.info
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((DebicheckLink_module_default()).debi_mandate_action_link),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Link, {
          legacyBehavior: true,
          href: "/cloud/profile/debicheck",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            target: "_blank",
            onClick: handleMandateLinkClick,
            className: "".concat((DebicheckLink_module_default()).action_link),
            children: ["View my DebiCheck mandate", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "".concat((DebicheckLink_module_default()).debi_link_anc_icon),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                width: "13",
                height: "12",
                viewBox: "0 0 13 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M10.7 6L3.50001 12L3.50001 0L10.7 6Z",
                  fill: "#282828"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
                  id: "debi_link_anc_icon",
                  "mask-type": "alpha",
                  maskUnits: "userSpaceOnUse",
                  x: "3",
                  y: "0",
                  width: "8",
                  height: "12",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.7 6L3.50001 12L3.50001 0L10.7 6Z",
                    fill: "white"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
                  mask: "url(#debi_link_anc_icon)",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
                    x: "0.5",
                    width: "12",
                    height: "12",
                    fill: "#282828"
                  })
                })]
              })
            })]
          })
        })
      })]
    })]
  });
};

DebicheckLink.defaultProps = {
  msgType: "noConsent"
};
/* harmony default export */ var debicheckMandate_DebicheckLink = (DebicheckLink);
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton = __webpack_require__(79549);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./services/checkoutService.js
var checkoutService = __webpack_require__(34020);
// EXTERNAL MODULE: ./services/pageService.js
var pageService = __webpack_require__(76173);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./Redux/actions/checkoutAction.js
var checkoutAction = __webpack_require__(39166);
// EXTERNAL MODULE: ./components/organisms/checkoutOrderConfirmation/CheckoutOrderConfirmation.module.scss
var CheckoutOrderConfirmation_module = __webpack_require__(54006);
var CheckoutOrderConfirmation_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutOrderConfirmation_module);
// EXTERNAL MODULE: ./config/types.js
var types = __webpack_require__(69842);
;// CONCATENATED MODULE: ./components/organisms/checkoutOrderConfirmation/CheckoutOrderConfirmation.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























var CheckoutOrderConfirmation = function CheckoutOrderConfirmation(_ref) {
  var _orderData$order, _orderData$order2, _orderData$order3, _orderData$order4, _orderData$order5, _orderData$order6, _orderData$order7, _orderData$order8, _orderData$order9, _orderData$order10, _orderData$order11, _content$sections$, _orderData$order12, _orderData$order13, _orderData$order14, _orderData$order15, _orderData$order16, _content$sections$2, _content$sections$3, _content$sections$4, _content$sections$4$i, _content$sections$5, _orderData$order17, _orderData$order18, _orderData$order19, _content$sections$6, _content$sections$7, _content$sections$8, _orderData$order20, _orderData$order21, _orderData$order22, _orderData$order23;

  var cartProducts = _ref.cartProducts,
      userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      customerStatus = _ref.customerStatus,
      setShowSnackBar = _ref.setShowSnackBar,
      navigate = _ref.navigate,
      setPageErr = _ref.setPageErr,
      applicationType = _ref.applicationType,
      debitDetails = _ref.debitDetails,
      deliveryDetails = _ref.deliveryDetails,
      authDetailsData = _ref.authDetailsData,
      upgradeResponse = _ref.upgradeResponse,
      setNormalCheckoutCurrentStep = _ref.setNormalCheckoutCurrentStep,
      setPostCheckoutCurrentStep = _ref.setPostCheckoutCurrentStep,
      removeCreditCheckStates = _ref.removeCreditCheckStates,
      setPaymentMethodUrl = _ref.setPaymentMethodUrl,
      setPostOrderResponse = _ref.setPostOrderResponse;
  var orderId = (0,helperServices/* getCookieValue */.Do)((config_default()).order_id);

  var _useState = (0,react.useState)(false),
      viewSent = _useState[0],
      setViewSent = _useState[1];

  var _useState2 = (0,react.useState)(true),
      dataFail = _useState2[0],
      setDataFail = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      orderData = _useState3[0],
      setOrderData = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      content = _useState4[0],
      setContent = _useState4[1];

  var continueBtnConfig = {
    buttonStyle: "outline black",
    buttonLabel: "Continue shopping"
  };
  var emailDocBtnConfig = {
    buttonStyle: "solid black",
    buttonLabel: "Email documents now"
  };
  var upgradeAnalyticsData = {
    upgrade_eligibility_status: upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.eligibilityStatus,
    upgrade_eligible_date: (upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.upgradeDate) || "",
    upgrade_customer_type: upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.c3dCustomer ? "C3D" : upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.business ? "CBU" : "OTHER"
  };
  var router = (0,DependencyHelper.useRouter)();

  var getCategoriesArr = function getCategoriesArr() {
    if (cartProducts.length > 0) {
      if (applicationType == "normal") {
        return cartProducts.map(function (item) {
          var _item$product, _item$product$categor, _item$product$categor2;

          return item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : (_item$product$categor = _item$product.categories) === null || _item$product$categor === void 0 ? void 0 : (_item$product$categor2 = _item$product$categor[0]) === null || _item$product$categor2 === void 0 ? void 0 : _item$product$categor2.name;
        });
      } else {
        return cartProducts.map(function (item) {
          var _item$product2, _item$product2$catego, _item$product2$catego2;

          return item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : (_item$product2$catego = _item$product2.categories) === null || _item$product2$catego === void 0 ? void 0 : (_item$product2$catego2 = _item$product2$catego[1]) === null || _item$product2$catego2 === void 0 ? void 0 : _item$product2$catego2.name;
        });
      }
    }

    return [];
  };

  var getQuantityArr = function getQuantityArr() {
    if (cartProducts.length > 0) {
      return cartProducts.map(function (item) {
        return item === null || item === void 0 ? void 0 : item.quantity;
      });
    }

    return [];
  };

  function getDealFormattedPrice(item) {
    var _item$product3, _item$product4;

    return "".concat(item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.monthly_recurring, " x ").concat(item === null || item === void 0 ? void 0 : (_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.payment_terms_label);
  }

  var getPriceArr = function getPriceArr() {
    if (cartProducts.length > 0) {
      if (applicationType == "normal") {
        return cartProducts.map(function (item) {
          var _item$prices, _item$prices$row_tota;

          return item === null || item === void 0 ? void 0 : (_item$prices = item.prices) === null || _item$prices === void 0 ? void 0 : (_item$prices$row_tota = _item$prices.row_total_original) === null || _item$prices$row_tota === void 0 ? void 0 : _item$prices$row_tota.value;
        });
      } else {
        return cartProducts.map(function (item) {
          return getDealFormattedPrice(item);
        });
      }
    }

    return [];
  };

  var getProductSkuArr = function getProductSkuArr() {
    if (cartProducts.length > 0) {
      return cartProducts.map(function (item) {
        var _item$product5;

        return item === null || item === void 0 ? void 0 : (_item$product5 = item.product) === null || _item$product5 === void 0 ? void 0 : _item$product5.sku;
      });
    }

    return [];
  };

  var getProductNameArr = function getProductNameArr() {
    if (cartProducts.length > 0) {
      return cartProducts.map(function (item) {
        var _item$product6;

        return item === null || item === void 0 ? void 0 : (_item$product6 = item.product) === null || _item$product6 === void 0 ? void 0 : _item$product6.name;
      });
    }

    return [];
  };

  var dealCartProducts = ((orderData === null || orderData === void 0 ? void 0 : (_orderData$order = orderData.order) === null || _orderData$order === void 0 ? void 0 : _orderData$order.items) || []).filter(function (item) {
    return parseInt(item === null || item === void 0 ? void 0 : item.is_deal_product) === 1 || (item === null || item === void 0 ? void 0 : item.parent_product_sku) != null;
  });
  var onceOffCartProducts = ((orderData === null || orderData === void 0 ? void 0 : (_orderData$order2 = orderData.order) === null || _orderData$order2 === void 0 ? void 0 : _orderData$order2.items) || []).filter(function (item) {
    return parseInt(item === null || item === void 0 ? void 0 : item.is_deal_product) === 0 && (item === null || item === void 0 ? void 0 : item.parent_product_sku) == null;
  });

  var isPreOrder = function isPreOrder() {
    var preOrderFound = cartProducts.filter(function (item) {
      var _item$product7, _item$product8;

      return (item === null || item === void 0 ? void 0 : (_item$product7 = item.product) === null || _item$product7 === void 0 ? void 0 : _item$product7.badges_label) && (item === null || item === void 0 ? void 0 : (_item$product8 = item.product) === null || _item$product8 === void 0 ? void 0 : _item$product8.badges_label.toLowerCase().indexOf(types/* default.TYPE_PREORDER.toLowerCase */.Z.TYPE_PREORDER.toLowerCase())) > -1;
    });

    if (preOrderFound && preOrderFound.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  var salesAnalyticsData = {
    sales_product_category: getCategoriesArr(),
    sales_product_id: getProductNameArr(),
    sales_product_name: getProductSkuArr(),
    sales_product_price: getPriceArr(),
    sales_product_quantity: getQuantityArr(),
    preorder_sales_event: isPreOrder() ? "cbu_pre_order" : ""
  };
  salesAnalyticsData.multicart_flag = (dealCartProducts === null || dealCartProducts === void 0 ? void 0 : dealCartProducts.length) > 0 && (onceOffCartProducts === null || onceOffCartProducts === void 0 ? void 0 : onceOffCartProducts.length) > 0 ? true : false;

  var successAnalytics = function successAnalytics(journey, cerditStatus) {
    if (applicationType == "normal") {
      analyticsUtag/* view */.ei(_objectSpread(_objectSpread({
        page_event: "view",
        page_name: "checkout: order confirmation: ".concat(customerStatus)
      }, salesAnalyticsData), analyticsUtag/* getProfileData */.$y(userLoggedIn, profileData, authDetailsData)));
    } else {
      if (journey == checkout_journey_context/* journeyType.upgrade */.w.upgrade) {
        analyticsUtag/* view */.ei(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          page_event: "view",
          page_name: "checkout: order confirmation: ".concat(customerStatus),
          delivery_type: (deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.receiveType) == "store" ? "collect" : "deliver",
          authentication_id_type: (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) == "PASSPORT" ? "passport" : "id"
        }, upgradeAnalyticsData), salesAnalyticsData), analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
          visitor_subscription_type: "postpaid"
        }));
      } else {
        analyticsUtag/* view */.ei(_objectSpread(_objectSpread(_objectSpread({
          page_event: "view",
          page_name: "checkout: order confirmation: ".concat(customerStatus, ": ").concat(cerditStatus),
          delivery_type: (deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.receiveType) == "store" ? "collect" : "deliver",
          authentication_id_type: (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) == "PASSPORT" ? "passport" : "id"
        }, salesAnalyticsData), analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
          visitor_subscription_type: "postpaid"
        }));
      }
    }

    setViewSent(true);
  };

  function getOrder() {
    return _getOrder.apply(this, arguments);
  }

  function _getOrder() {
    _getOrder = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
      var results, _results$order, _results$order2, _results$order3, _results$order4, vettingResult, _results$order5, _results$order6, _results$errors;

      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              (0,helperServices/* showSpinner */.yh)();
              _context6.next = 4;
              return (0,checkoutService/* getSalesOrder */.It)(orderId);

            case 4:
              results = _context6.sent;

              if (!results.fail) {
                if (results.order && Object.keys(results.order).length > 0) {
                  if (((_results$order = results.order) === null || _results$order === void 0 ? void 0 : _results$order.order_status) == "CQFD_SUBMIT_FAIL") {
                    setDataFail(true);
                    redirectToTechnicalError("cqfd");
                  } else {
                    vettingResult = (results === null || results === void 0 ? void 0 : (_results$order2 = results.order) === null || _results$order2 === void 0 ? void 0 : _results$order2.journey_type) == checkout_journey_context/* journeyType.upgrade */.w.upgrade ? constants/* CREDIT_VETTING_STATUS.approved */.EL.approved : results === null || results === void 0 ? void 0 : (_results$order3 = results.order) === null || _results$order3 === void 0 ? void 0 : _results$order3.vetting_result;
                    setOrderData(results);

                    if (vettingResult && results !== null && results !== void 0 && (_results$order4 = results.order) !== null && _results$order4 !== void 0 && _results$order4.journey_type) {
                      fetchPageContent(results === null || results === void 0 ? void 0 : (_results$order5 = results.order) === null || _results$order5 === void 0 ? void 0 : _results$order5.journey_type, results === null || results === void 0 ? void 0 : (_results$order6 = results.order) === null || _results$order6 === void 0 ? void 0 : _results$order6.vetting_result);
                    } else {
                      if (!viewSent) {
                        successAnalytics(null, null);
                      }

                      setDataFail(false);
                      (0,helperServices/* hideSpinner */.v3)();
                    }
                  }
                } else {
                  setDataFail(true);
                  redirectToTechnicalError();
                }
              } else {
                if (results && results.errors) {
                  analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(results.errors[0] ? (_results$errors = results.errors) === null || _results$errors === void 0 ? void 0 : _results$errors[0].message : ""),
                    page_errors_code: "chk-dxl-g-so-".concat(results.status)
                  }));
                }

                setDataFail(true);
                redirectToTechnicalError();
              }

              _context6.next = 12;
              break;

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              setDataFail(true);
              redirectToTechnicalError();

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 8]]);
    }));
    return _getOrder.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    (0,helperServices/* showSpinner */.yh)();

    if (customerStatus) {
      getOrder();
    }
  }, [customerStatus]);

  var mapResultCode = function mapResultCode(journey, cerditStatus) {
    var endPoint;

    if (journey == checkout_journey_context/* journeyType.upgrade */.w.upgrade) {
      endPoint = labels/* default.orderConfirmation.errorCodes.upgradeApproved */.Z.orderConfirmation.errorCodes.upgradeApproved;
    } else if (journey == checkout_journey_context/* journeyType.newLine */.w.newLine) {
      switch (cerditStatus) {
        case constants/* CREDIT_VETTING_STATUS.approved */.EL.approved:
          endPoint = labels/* default.orderConfirmation.errorCodes.newLineApproved */.Z.orderConfirmation.errorCodes.newLineApproved;
          break;

        case constants/* CREDIT_VETTING_STATUS.pending */.EL.pending:
        case constants/* CREDIT_VETTING_STATUS.referred */.EL.referred:
          endPoint = (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) == "PASSPORT" ? labels/* default.orderConfirmation.errorCodes.newLinePendedPassport */.Z.orderConfirmation.errorCodes.newLinePendedPassport : labels/* default.orderConfirmation.errorCodes.newLinePendedId */.Z.orderConfirmation.errorCodes.newLinePendedId;
          break;

        case constants/* CREDIT_VETTING_STATUS.offline */.EL.offline:
          endPoint = labels/* default.orderConfirmation.errorCodes.newLineOffline */.Z.orderConfirmation.errorCodes.newLineOffline;
          break;

        case constants/* CREDIT_VETTING_STATUS.approvedWithConditions */.EL.approvedWithConditions:
          endPoint = labels/* default.orderConfirmation.errorCodes.newLineApprovedWithConditions */.Z.orderConfirmation.errorCodes.newLineApprovedWithConditions;
          break;
      }
    } else {
      switch (cerditStatus) {
        case constants/* CREDIT_VETTING_STATUS.approved */.EL.approved:
          endPoint = labels/* default.orderConfirmation.errorCodes.addLineApproved */.Z.orderConfirmation.errorCodes.addLineApproved;
          break;

        case constants/* CREDIT_VETTING_STATUS.pending */.EL.pending:
        case constants/* CREDIT_VETTING_STATUS.referred */.EL.referred:
          endPoint = (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) === "PASSPORT" ? labels/* default.orderConfirmation.errorCodes.addLinePendedPassport */.Z.orderConfirmation.errorCodes.addLinePendedPassport : labels/* default.orderConfirmation.errorCodes.addLinePendedId */.Z.orderConfirmation.errorCodes.addLinePendedId;
          break;

        case constants/* CREDIT_VETTING_STATUS.offline */.EL.offline:
          endPoint = labels/* default.orderConfirmation.errorCodes.addLineOffline */.Z.orderConfirmation.errorCodes.addLineOffline;
          break;

        case constants/* CREDIT_VETTING_STATUS.approvedWithConditions */.EL.approvedWithConditions:
          endPoint = labels/* default.orderConfirmation.errorCodes.addLineApprovedWithConditions */.Z.orderConfirmation.errorCodes.addLineApprovedWithConditions;
          break;
      }
    }

    return endPoint;
  };
  /**
   * Get the content display data
   */


  var fetchPageContent = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(journey, cerditStatus) {
      var endPoint, results;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              endPoint = mapResultCode(journey, cerditStatus);
              _context.prev = 1;
              _context.next = 4;
              return pageService/* getPageComponents */.eU(["".concat(endPoint, "/CBU")]);

            case 4:
              results = _context.sent;

              if (results && results.status === "error") {
                analyticsUtag/* link */.p4({
                  page_name: "checkout: order confirmation: ".concat(customerStatus),
                  page_form_event: "error",
                  page_errors: "".concat(results.reason ? results.reason : ""),
                  page_errors_code: "chck-d-g-seo"
                });
                setDataFail(true);
                redirectToTechnicalError();
              } else {
                if (applicationType !== "normal") {
                  setShowSnackBar({
                    visible: true,
                    message: labels/* default.orderConfirmation.lbl_order_fullfilment_stock_dependant */.Z.orderConfirmation.lbl_order_fullfilment_stock_dependant,
                    type: "alert",
                    className: (CheckoutOrderConfirmation_module_default())["top-notification"],
                    dismissClass: (CheckoutOrderConfirmation_module_default()).dismiss
                  });
                }

                if (!viewSent) {
                  successAnalytics(journey, cerditStatus);
                }
              }

              setContent(results);
              setDataFail(false);
              (0,helperServices/* hideSpinner */.v3)();
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              setDataFail(true);
              redirectToTechnicalError();

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    return function fetchPageContent(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var redirectToTechnicalError = function redirectToTechnicalError() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "error";
    var pageName = "checkout: order confirmation: ".concat(customerStatus);
    setPageErr({
      type: "error",
      title: type == "cqfd" ? labels/* default.orderConfirmation.lbl_cqfd_order_fail_heading */.Z.orderConfirmation.lbl_cqfd_order_fail_heading : labels/* default.orderConfirmation.lbl_order_fail_heading */.Z.orderConfirmation.lbl_order_fail_heading,
      desc: type == "cqfd" ? labels/* default.orderConfirmation.lbl_cqfd_order_fail_description */.Z.orderConfirmation.lbl_cqfd_order_fail_description : labels/* default.orderConfirmation.lbl_order_fail_description */.Z.orderConfirmation.lbl_order_fail_description,
      primaryLabel: "View order history",
      secondaryLabel: "Exit checkout",
      handlePrimaryClick: function handlePrimaryClick() {
        return _handlePrimaryClick("/view-order-history", "view order history");
      },
      handleSecondaryClick: function handleSecondaryClick() {
        return _handleSecondaryClick(null, "exit checkout");
      },
      imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
      pageName: pageName
    });
    (0,helperServices/* hideSpinner */.v3)();
    navigate("pageError");
  };

  var _handlePrimaryClick = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(url, label) {
      var pageName;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
              analyticsUtag/* link */.p4({
                link_type: "o",
                link_name: "".concat(pageName, ": ").concat(label),
                page_name: "".concat(pageName)
              });

              if (!url) {
                _context2.next = 8;
                break;
              }

              _context2.next = 6;
              return router.push("".concat(helperServices/* urlPrefix */.wn).concat(url)).then(function () {
                (0,helperServices/* hideSpinner */.v3)();
              });

            case 6:
              _context2.next = 10;
              break;

            case 8:
              _context2.next = 10;
              return router.push("".concat(helperServices/* urlPrefix */.wn, "/forms/ecommerce")).then(function () {
                (0,helperServices/* hideSpinner */.v3)();
              });

            case 10:
              _context2.next = 12;
              return clearReduxState();

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function _handlePrimaryClick(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  var _handleSecondaryClick = function _handleSecondaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label),
      page_name: "".concat(pageName)
    });
    clearReduxState();

    if (url) {
      router.push("".concat(helperServices/* urlPrefix */.wn).concat(url)).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/cart")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  var SubDescription = function SubDescription(_ref4) {
    var cerditStatus = _ref4.cerditStatus,
        journey = _ref4.journey,
        content = _ref4.content,
        referenceNumber = _ref4.referenceNumber,
        deliveryDays = _ref4.deliveryDays;

    if (applicationType == "normal") {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (CheckoutOrderConfirmation_module_default())["sub-content"],
          children: labels/* default.orderConfirmation.lbl_normal_sub_desc */.Z.orderConfirmation.lbl_normal_sub_desc
        })]
      });
    } else {
      if (journey == checkout_journey_context/* journeyType.upgrade */.w.upgrade || cerditStatus == constants/* CREDIT_VETTING_STATUS.approved */.EL.approved || cerditStatus == constants/* CREDIT_VETTING_STATUS.approvedWithConditions */.EL.approvedWithConditions) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (CheckoutOrderConfirmation_module_default())["sub-content"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (CheckoutOrderConfirmation_module_default()).title,
              dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(content)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (CheckoutOrderConfirmation_module_default()).days,
              children: deliveryDays
            })]
          })]
        });
      } else if (cerditStatus == constants/* CREDIT_VETTING_STATUS.pending */.EL.pending || cerditStatus == constants/* CREDIT_VETTING_STATUS.referred */.EL.referred || cerditStatus == constants/* CREDIT_VETTING_STATUS.offline */.EL.offline) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (CheckoutOrderConfirmation_module_default())["sub-content"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (CheckoutOrderConfirmation_module_default()).title,
              dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(content)
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (CheckoutOrderConfirmation_module_default()).reference,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (CheckoutOrderConfirmation_module_default()).title,
              children: labels/* default.orderConfirmation.lbl_your_reference_number */.Z.orderConfirmation.lbl_your_reference_number
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (CheckoutOrderConfirmation_module_default()).value,
              children: referenceNumber
            })]
          })]
        });
      } else {
        return null;
      }
    }
  };

  var PageHeading = function PageHeading(_ref5) {
    var journey = _ref5.journey,
        cerditStatus = _ref5.cerditStatus,
        customerName = _ref5.customerName;

    if (journey !== checkout_journey_context/* journeyType.upgrade */.w.upgrade && (cerditStatus == constants/* CREDIT_VETTING_STATUS.pending */.EL.pending || cerditStatus == constants/* CREDIT_VETTING_STATUS.referred */.EL.referred)) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CheckoutOrderConfirmation_module_default()).heading,
        id: "heading",
        children: labels/* default.orderConfirmation.lbl_we_need_documents */.Z.orderConfirmation.lbl_we_need_documents
      });
    } else {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CheckoutOrderConfirmation_module_default()).heading,
        id: "heading",
        children: ["Thank you, ", customerName, "!"]
      });
    }
  };

  var handleContinueShopping = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var pageName;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
              analyticsUtag/* link */.p4({
                link_type: "o",
                link_name: "".concat(pageName, ": continue shopping"),
                link_url: "".concat(helperServices/* urlPrefix */.wn, "/products")
              });
              _context3.next = 5;
              return router.push("".concat(helperServices/* urlPrefix */.wn, "/products"));

            case 5:
              _context3.next = 7;
              return clearReduxState();

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleContinueShopping() {
      return _ref6.apply(this, arguments);
    };
  }();

  var clearReduxState = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setNormalCheckoutCurrentStep(null);
              setPostCheckoutCurrentStep(null);
              removeCreditCheckStates(null);
              setPaymentMethodUrl(null);
              setPostOrderResponse({});
              DependencyHelper.Cookie.remove((config_default()).order_id);
              DependencyHelper.Cookie.remove((config_default()).pay_fail_count);
              DependencyHelper.Cookie.remove("guest_checkout");

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function clearReduxState() {
      return _ref7.apply(this, arguments);
    };
  }();

  var handleEmailDocument = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(cerditStatus) {
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              analyticsUtag/* link */.p4({
                link_type: "o",
                link_name: "checkout: order confirmation: ".concat(customerStatus, ": ").concat(cerditStatus === null || cerditStatus === void 0 ? void 0 : cerditStatus.toLowerCase(), ": email"),
                page_name: "checkout: order confirmation: ".concat(customerStatus)
              });

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleEmailDocument(_x5) {
      return _ref8.apply(this, arguments);
    };
  }();

  var debiCheckMessage = function debiCheckMessage(journey, cerditStatus) {
    if (applicationType === "normal") {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }

    if (cerditStatus == constants/* CREDIT_VETTING_STATUS.pending */.EL.pending || cerditStatus == constants/* CREDIT_VETTING_STATUS.referred */.EL.referred) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(debicheckMandate_DebicheckLink, {
        msgType: (debitDetails === null || debitDetails === void 0 ? void 0 : debitDetails.debiCheckFlag) === "Y" ? "consent" : "noConsent"
      });
    }

    if (journey === checkout_journey_context/* journeyType.upgrade */.w.upgrade || journey === checkout_journey_context/* journeyType.addLine */.w.addLine) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(debicheckMandate_DebicheckLink, {
        msgType: "educational"
      });
    } else {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(debicheckMandate_DebicheckLink, {
        msgType: (debitDetails === null || debitDetails === void 0 ? void 0 : debitDetails.debiCheckFlag) === "Y" ? "consent" : "noConsent"
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: !dataFail && orderData && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutOrderConfirmation_module_default())["success-container"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (CheckoutOrderConfirmation_module_default()).top,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
            id: "checkout-success-tick",
            img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/success-circle.svg"),
            className: (CheckoutOrderConfirmation_module_default()).icon
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading, {
            customerName: orderData === null || orderData === void 0 ? void 0 : (_orderData$order3 = orderData.order) === null || _orderData$order3 === void 0 ? void 0 : _orderData$order3.customer_name,
            cerditStatus: orderData === null || orderData === void 0 ? void 0 : (_orderData$order4 = orderData.order) === null || _orderData$order4 === void 0 ? void 0 : _orderData$order4.vetting_result,
            journey: orderData === null || orderData === void 0 ? void 0 : (_orderData$order5 = orderData.order) === null || _orderData$order5 === void 0 ? void 0 : _orderData$order5.journey_type
          }), applicationType !== "normal" && (orderData === null || orderData === void 0 ? void 0 : (_orderData$order6 = orderData.order) === null || _orderData$order6 === void 0 ? void 0 : _orderData$order6.vetting_result) !== constants/* CREDIT_VETTING_STATUS.offline */.EL.offline && (orderData === null || orderData === void 0 ? void 0 : (_orderData$order7 = orderData.order) === null || _orderData$order7 === void 0 ? void 0 : _orderData$order7.vetting_result) !== constants/* CREDIT_VETTING_STATUS.pending */.EL.pending && (orderData === null || orderData === void 0 ? void 0 : (_orderData$order8 = orderData.order) === null || _orderData$order8 === void 0 ? void 0 : _orderData$order8.vetting_result) !== constants/* CREDIT_VETTING_STATUS.referred */.EL.referred && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (CheckoutOrderConfirmation_module_default())["main-content"],
            children: (orderData === null || orderData === void 0 ? void 0 : (_orderData$order9 = orderData.order) === null || _orderData$order9 === void 0 ? void 0 : _orderData$order9.journey_type) == checkout_journey_context/* journeyType.upgrade */.w.upgrade ? labels/* default.orderConfirmation.lbl_contract_upgrade_desc */.Z.orderConfirmation.lbl_contract_upgrade_desc : labels/* default.orderConfirmation.lbl_contract_default_desc */.Z.orderConfirmation.lbl_contract_default_desc
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubDescription, {
            cerditStatus: orderData === null || orderData === void 0 ? void 0 : (_orderData$order10 = orderData.order) === null || _orderData$order10 === void 0 ? void 0 : _orderData$order10.vetting_result,
            journey: orderData === null || orderData === void 0 ? void 0 : (_orderData$order11 = orderData.order) === null || _orderData$order11 === void 0 ? void 0 : _orderData$order11.journey_type,
            content: content === null || content === void 0 ? void 0 : (_content$sections$ = content.sections[0]) === null || _content$sections$ === void 0 ? void 0 : _content$sections$.description,
            referenceNumber: orderData === null || orderData === void 0 ? void 0 : (_orderData$order12 = orderData.order) === null || _orderData$order12 === void 0 ? void 0 : _orderData$order12.tracking_number,
            deliveryDays: orderData === null || orderData === void 0 ? void 0 : (_orderData$order13 = orderData.order) === null || _orderData$order13 === void 0 ? void 0 : _orderData$order13.delivery_time_message
          }), ((orderData === null || orderData === void 0 ? void 0 : (_orderData$order14 = orderData.order) === null || _orderData$order14 === void 0 ? void 0 : _orderData$order14.vetting_result) == constants/* CREDIT_VETTING_STATUS.pending */.EL.pending || (orderData === null || orderData === void 0 ? void 0 : (_orderData$order15 = orderData.order) === null || _orderData$order15 === void 0 ? void 0 : _orderData$order15.vetting_result) == constants/* CREDIT_VETTING_STATUS.referred */.EL.referred) && (orderData === null || orderData === void 0 ? void 0 : (_orderData$order16 = orderData.order) === null || _orderData$order16 === void 0 ? void 0 : _orderData$order16.journey_type) !== checkout_journey_context/* journeyType.upgrade */.w.upgrade && (content === null || content === void 0 ? void 0 : (_content$sections$2 = content.sections[0]) === null || _content$sections$2 === void 0 ? void 0 : _content$sections$2.callToActionLabel) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((CheckoutOrderConfirmation_module_default())["button-section"]),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
              className: "".concat((CheckoutOrderConfirmation_module_default()).btn, " ").concat((CheckoutOrderConfirmation_module_default())["email-doc-btn"]),
              variant: emailDocBtnConfig.buttonStyle,
              url: "mailto:".concat(content === null || content === void 0 ? void 0 : (_content$sections$3 = content.sections[0]) === null || _content$sections$3 === void 0 ? void 0 : _content$sections$3.callToActionLabel),
              handleClick: function handleClick() {
                return handleEmailDocument(orderData.order.vetting_result);
              },
              children: emailDocBtnConfig.buttonLabel
            })
          })]
        }), applicationType !== "normal" && (content === null || content === void 0 ? void 0 : (_content$sections$4 = content.sections[0]) === null || _content$sections$4 === void 0 ? void 0 : (_content$sections$4$i = _content$sections$4.items) === null || _content$sections$4$i === void 0 ? void 0 : _content$sections$4$i.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((CheckoutOrderConfirmation_module_default()).mid, " ").concat((CheckoutOrderConfirmation_module_default())["next-steps"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(nextStepsInfo_NextStepsInfo, {
            heading: content === null || content === void 0 ? void 0 : (_content$sections$5 = content.sections[0]) === null || _content$sections$5 === void 0 ? void 0 : _content$sections$5.headingTitle,
            type: (orderData === null || orderData === void 0 ? void 0 : (_orderData$order17 = orderData.order) === null || _orderData$order17 === void 0 ? void 0 : _orderData$order17.journey_type) == checkout_journey_context/* journeyType.upgrade */.w.upgrade || constants/* CREDIT_VETTING_STATUS.approved */.EL.approved == (orderData === null || orderData === void 0 ? void 0 : (_orderData$order18 = orderData.order) === null || _orderData$order18 === void 0 ? void 0 : _orderData$order18.vetting_result) || constants/* CREDIT_VETTING_STATUS.approvedWithConditions */.EL.approvedWithConditions == (orderData === null || orderData === void 0 ? void 0 : (_orderData$order19 = orderData.order) === null || _orderData$order19 === void 0 ? void 0 : _orderData$order19.vetting_result) ? "step" : "document",
            content: content.sections[0].items,
            subContent: content !== null && content !== void 0 && (_content$sections$6 = content.sections[0]) !== null && _content$sections$6 !== void 0 && _content$sections$6.secondaryDescription ? {
              icon: content === null || content === void 0 ? void 0 : (_content$sections$7 = content.sections[0]) === null || _content$sections$7 === void 0 ? void 0 : _content$sections$7.icon,
              description: content === null || content === void 0 ? void 0 : (_content$sections$8 = content.sections[0]) === null || _content$sections$8 === void 0 ? void 0 : _content$sections$8.secondaryDescription
            } : null,
            userEmail: orderData === null || orderData === void 0 ? void 0 : (_orderData$order20 = orderData.order) === null || _orderData$order20 === void 0 ? void 0 : _orderData$order20.customer_email
          })
        }), debiCheckMessage(orderData === null || orderData === void 0 ? void 0 : (_orderData$order21 = orderData.order) === null || _orderData$order21 === void 0 ? void 0 : _orderData$order21.journey_type, orderData === null || orderData === void 0 ? void 0 : (_orderData$order22 = orderData.order) === null || _orderData$order22 === void 0 ? void 0 : _orderData$order22.vetting_result), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (CheckoutOrderConfirmation_module_default()).bottom,
          children: [applicationType !== "normal" && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (CheckoutOrderConfirmation_module_default())["info-section"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(purchasedSectionInfo_PurchasedSectionInfo, {
              heading: "Order details",
              type: "order",
              journey: orderData === null || orderData === void 0 ? void 0 : (_orderData$order23 = orderData.order) === null || _orderData$order23 === void 0 ? void 0 : _orderData$order23.journey_type,
              orderData: orderData === null || orderData === void 0 ? void 0 : orderData.order
            })
          }), (deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.receiveType) !== "store" ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (CheckoutOrderConfirmation_module_default())["info-section"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(purchasedSectionInfo_PurchasedSectionInfo, {
              heading: "Delivery details",
              type: "delivery",
              orderData: orderData === null || orderData === void 0 ? void 0 : orderData.order
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (CheckoutOrderConfirmation_module_default())["info-section"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(purchasedSectionInfo_PurchasedSectionInfo, {
              heading: "Collection Details",
              type: "store",
              orderData: orderData === null || orderData === void 0 ? void 0 : orderData.order
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "".concat((CheckoutOrderConfirmation_module_default())["info-section"], " ").concat((CheckoutOrderConfirmation_module_default())["purchased-items"]),
            children: [dealCartProducts !== null && dealCartProducts !== void 0 && dealCartProducts.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(PurchasedItems/* default */.Z, {
              orderData: _objectSpread(_objectSpread({}, orderData === null || orderData === void 0 ? void 0 : orderData.order), {}, {
                items: dealCartProducts
              }),
              applicationType: "contract",
              pageName: "orderConfirmation"
            }) : "", onceOffCartProducts !== null && onceOffCartProducts !== void 0 && onceOffCartProducts.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(PurchasedItems/* default */.Z, {
              orderData: _objectSpread(_objectSpread({}, orderData === null || orderData === void 0 ? void 0 : orderData.order), {}, {
                items: onceOffCartProducts
              }),
              applicationType: "normal",
              pageName: "orderConfirmation"
            }) : ""]
          }), applicationType !== "normal" && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (CheckoutOrderConfirmation_module_default())["continue-btn"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
              className: (CheckoutOrderConfirmation_module_default()).btn,
              variant: continueBtnConfig.buttonStyle,
              handleClick: handleContinueShopping,
              children: continueBtnConfig.buttonLabel
            })
          })]
        })]
      })
    })
  });
};

CheckoutOrderConfirmation.defaultProps = {
  cartProducts: []
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    debitDetails: state.creditCheckDetails.debitDetails,
    deliveryDetails: state.creditCheckDetails.deliveryDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    upgradeResponse: state.upgrade.upgradeResponse
  };
};

var mapDispatchToProps = {
  setNormalCheckoutCurrentStep: checkoutAction/* setNormalCheckoutCurrentStep */.Z9,
  setPostCheckoutCurrentStep: checkoutAction/* setPostCheckoutCurrentStep */.Gr,
  removeCreditCheckStates: checkoutAction/* removeCreditCheckStates */.nK,
  setPaymentMethodUrl: checkoutAction/* setPaymentMethodUrl */.RL,
  setPostOrderResponse: checkoutAction/* setPostOrderResponse */.wg
};
/* harmony default export */ var checkoutOrderConfirmation_CheckoutOrderConfirmation = ((0,DependencyHelper.connect)(mapStateToProps, mapDispatchToProps)(CheckoutOrderConfirmation));

/***/ }),

/***/ 27024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkoutPage_CheckoutPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./components/atoms/text/Text.jsx
var Text = __webpack_require__(72786);
// EXTERNAL MODULE: ./config/colors.js
var colors = __webpack_require__(93957);
// EXTERNAL MODULE: ./components/molecules/checkoutStepper/CheckoutStepper.module.scss
var CheckoutStepper_module = __webpack_require__(85665);
var CheckoutStepper_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutStepper_module);
// EXTERNAL MODULE: ./components/atoms/stepper/Step.module.scss
var Step_module = __webpack_require__(10161);
var Step_module_default = /*#__PURE__*/__webpack_require__.n(Step_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/stepper/Step.jsx



var Step = function Step(_ref) {
  var value = _ref.value,
      isActive = _ref.isActive,
      step = _ref.step,
      isComplete = _ref.isComplete,
      id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((Step_module_default()).step, " ").concat(isActive && (Step_module_default())["step--active"], " ").concat(isComplete && (Step_module_default())["step--complete"]),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((Step_module_default()).step__box),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((Step_module_default()).step__circle),
        children: isComplete ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Step_module_default())["step__circle--check"]
        }) : value
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Step_module_default()).step__title,
      id: "checkout-step-".concat(id),
      children: step
    })]
  });
};
// EXTERNAL MODULE: ./components/atoms/stepper/StepMobile.module.scss
var StepMobile_module = __webpack_require__(63511);
var StepMobile_module_default = /*#__PURE__*/__webpack_require__.n(StepMobile_module);
;// CONCATENATED MODULE: ./components/atoms/stepper/StepMobile.jsx




var StepMobile = function StepMobile(_ref) {
  var step = _ref.step,
      totalSteps = _ref.totalSteps,
      title = _ref.title,
      nextStepTitle = _ref.nextStepTitle,
      className = _ref.className,
      id = _ref.id,
      nextStepId = _ref.nextStepId;
  var progress = step / totalSteps * 100;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: className,
    children: [progress <= 100 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (StepMobile_module_default())["step-card"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (StepMobile_module_default())["step-card__count"],
        children: "Step ".concat(step, " of ").concat(totalSteps)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (StepMobile_module_default())["step-card__title"],
        id: "checkout-step-".concat(id),
        children: title
      }), progress !== 100 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (StepMobile_module_default())["step-card__next"],
        id: "checkout-step-".concat(nextStepId),
        children: "Next: ".concat(nextStepTitle)
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (StepMobile_module_default())["step-card-progress"],
      style: {
        width: "".concat(progress, "%")
      }
    })]
  });
};

StepMobile.defaultProps = {
  className: "d-lg-none"
};
/* harmony default export */ var stepper_StepMobile = (StepMobile);
// EXTERNAL MODULE: ./context/checkout-journey-context.js
var checkout_journey_context = __webpack_require__(62039);
;// CONCATENATED MODULE: ./components/molecules/checkoutStepper/CheckoutStepper.jsx





var CheckoutStepper = function CheckoutStepper(_ref) {
  var _ref$steps = _ref.steps,
      steps = _ref$steps === void 0 ? [] : _ref$steps,
      activeStepNo = _ref.activeStepNo,
      stepsWidth = _ref.stepsWidth;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(checkout_journey_context/* CheckoutJourneyContext.Consumer */.m.Consumer, {
    children: function children(context) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((CheckoutStepper_module_default())["stepper-container"]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((CheckoutStepper_module_default()).stepper, " ").concat((CheckoutStepper_module_default())[stepsWidth]),
          children: steps.map(function (step, index) {
            var _steps;

            var isComplete = activeStepNo > step.stepNo || activeStepNo === ((_steps = steps[steps.length - 1]) === null || _steps === void 0 ? void 0 : _steps.stepNo);
            var isActive = activeStepNo === step.stepNo;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Step, {
              value: step.stepNo,
              isActive: isActive,
              isComplete: isComplete,
              step: step.title,
              id: step.id
            }, index);
          })
        })
      });
    }
  });
};
var MobileCheckoutStepper = function MobileCheckoutStepper(_ref2) {
  var _ref2$steps = _ref2.steps,
      steps = _ref2$steps === void 0 ? [] : _ref2$steps,
      activeStepNo = _ref2.activeStepNo;
  var index = steps.findIndex(function (step) {
    return step.stepNo === activeStepNo;
  });
  var currentStep = steps[index];
  var nextStep = steps[index + 1 < steps.length ? index + 1 : index];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(stepper_StepMobile, {
    step: currentStep && currentStep.stepNo,
    totalSteps: steps && steps.length,
    title: currentStep && currentStep.heading,
    nextStepTitle: nextStep && nextStep.heading,
    id: currentStep && currentStep.id,
    nextStepId: nextStep && nextStep.id
  });
};
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton = __webpack_require__(79549);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./Redux/actions/checkoutAction.js
var checkoutAction = __webpack_require__(39166);
// EXTERNAL MODULE: ./Redux/actions/cartAction.js
var cartAction = __webpack_require__(35311);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./components/molecules/checkoutNav/CheckoutNav.module.scss
var CheckoutNav_module = __webpack_require__(77421);
var CheckoutNav_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutNav_module);
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
;// CONCATENATED MODULE: ./components/molecules/checkoutNav/CheckoutNav.jsx




















var CheckoutNav = function CheckoutNav(_ref) {
  var _ref$steps = _ref.steps,
      steps = _ref$steps === void 0 ? [] : _ref$steps,
      stepsShow = _ref.stepsShow,
      stepsWidth = _ref.stepsWidth,
      activeStep = _ref.activeStep,
      activeStepNo = _ref.activeStepNo,
      userLoggedIn = _ref.userLoggedIn,
      customerStatus = _ref.customerStatus,
      setNormalCheckoutCurrentStep = _ref.setNormalCheckoutCurrentStep,
      setPostCheckoutCurrentStep = _ref.setPostCheckoutCurrentStep,
      removeCreditCheckStates = _ref.removeCreditCheckStates,
      creditVettingResultData = _ref.creditVettingResultData,
      deleteItemsFromCart = _ref.deleteItemsFromCart,
      cartProducts = _ref.cartProducts,
      multicartFlag = _ref.multicartFlag,
      setPaymentMethodUrl = _ref.setPaymentMethodUrl,
      setPostOrderResponse = _ref.setPostOrderResponse;
  var router = (0,DependencyHelper.useRouter)();
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  var dispatch = (0,DependencyHelper.useDispatch)();
  var dealCartProduct = cartProducts.find(function (cartProduct) {
    var _cartProduct$product, _cartProduct$product2;

    return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product = cartProduct.product) === null || _cartProduct$product === void 0 ? void 0 : _cartProduct$product.is_deal_product) === 1 && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product2 = cartProduct.product) === null || _cartProduct$product2 === void 0 ? void 0 : _cartProduct$product2.__typename) === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle;
  });
  var cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
  var cartProductId = dealCartProduct === null || dealCartProduct === void 0 ? void 0 : dealCartProduct.id;

  var clearReduxState = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setNormalCheckoutCurrentStep(null);
              setPostCheckoutCurrentStep(null);
              removeCreditCheckStates(null);
              setPaymentMethodUrl(null);
              setPostOrderResponse({});
              DependencyHelper.Cookie.remove((config_default()).order_id);
              DependencyHelper.Cookie.remove((config_default()).pay_fail_count);
              DependencyHelper.Cookie.remove("guest_checkout");

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function clearReduxState() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleExtCheckout = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _creditVettingResultD, _creditVettingResultD2, _creditVettingResultD3, _creditVettingResultD4, resultCode, applicationStatus, vettingStatus, pageName, orderCreated;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();

              if (!creditVettingResultData) {
                _context2.next = 9;
                break;
              }

              resultCode = creditVettingResultData === null || creditVettingResultData === void 0 ? void 0 : creditVettingResultData.resultCode;
              applicationStatus = (_creditVettingResultD = creditVettingResultData.vettingOutcome) === null || _creditVettingResultD === void 0 ? void 0 : (_creditVettingResultD2 = _creditVettingResultD.vettingSummary) === null || _creditVettingResultD2 === void 0 ? void 0 : _creditVettingResultD2.applicationStatus;
              vettingStatus = (_creditVettingResultD3 = creditVettingResultData.vettingOutcome) === null || _creditVettingResultD3 === void 0 ? void 0 : (_creditVettingResultD4 = _creditVettingResultD3.vettingSummary) === null || _creditVettingResultD4 === void 0 ? void 0 : _creditVettingResultD4.vettingStatus;

              if (!(applicationStatus === labels/* default.creditVetting.lbl_processed */.Z.creditVetting.lbl_processed && vettingStatus === labels/* default.creditVetting.lbl_approved_with_condition_status */.Z.creditVetting.lbl_approved_with_condition_status && resultCode === labels/* default.creditVetting.lbl_resultcode_approved_with_condition */.Z.creditVetting.lbl_resultcode_approved_with_condition && dealCartProduct)) {
                _context2.next = 8;
                break;
              }

              _context2.next = 8;
              return deleteItemsFromCart(cartId, cartProductId);

            case 8:
              dispatch({
                type: actionTypes/* SET_CREDIT_VETTING_RESULT */.GE,
                payload: null
              });

            case 9:
              pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;

              if (activeStep == "xds") {
                analyticsUtag/* link */.p4({
                  link_type: "o",
                  link_name: "checkout: authentication: ".concat(customerStatus, ": exit checkout"),
                  page_name: "".concat(pageName)
                });
              } else if (activeStep == "otp") {
                analyticsUtag/* link */.p4({
                  link_type: "o",
                  link_name: "checkout: otp authentication: ".concat(customerStatus, ": exit checkout")
                });
              } else if (activeStep == "authentication") {
                analyticsUtag/* link */.p4({
                  link_type: "o",
                  link_name: "checkout: lets get started: ".concat(customerStatus, ": exit checkout"),
                  page_name: "".concat(pageName)
                });
              } else if (activeStep == "creditCheck") {
                analyticsUtag/* link */.p4({
                  link_type: "o",
                  link_name: "checkout: credit check: ".concat(customerStatus, ": exit checkout"),
                  page_name: "".concat(pageName)
                });
              } else if (activeStep == "delivery") {
                analyticsUtag/* link */.p4({
                  link_type: "o",
                  link_name: "checkout: delivery: ".concat(customerStatus, ": exit checkout"),
                  page_name: "".concat(pageName)
                });
              } else if (activeStep == "review") {
                analyticsUtag/* link */.p4({
                  link_type: "o",
                  link_name: "checkout: review order: ".concat(customerStatus, ": exit checkout"),
                  page_name: "".concat(pageName)
                });
              } else if (activeStep == "payment") {
                analyticsUtag/* link */.p4({
                  link_type: "o",
                  link_name: "checkout: payment: ".concat(customerStatus, ": exit checkout"),
                  page_name: "".concat(pageName)
                });
              } else if (activeStep == "paymentError" || activeStep == "paymentRedirect") {
                analyticsUtag/* link */.p4({
                  link_type: "o",
                  link_name: "checkout: make payment: ".concat(customerStatus, ": exit checkout"),
                  page_name: "".concat(pageName)
                });
              } else {
                analyticsUtag/* link */.p4({
                  link_type: "o",
                  link_name: "".concat(pageName, ": exit checkout"),
                  page_name: "".concat(pageName)
                });
              }

              if (!(activeStep == "orderConfirmation")) {
                _context2.next = 33;
                break;
              }

              orderCreated = (0,helperServices/* getCookieValue */.Do)((config_default()).order_id);

              if (!orderCreated) {
                _context2.next = 23;
                break;
              }

              if (!userLoggedIn) {
                _context2.next = 19;
                break;
              }

              _context2.next = 17;
              return router.push("".concat(urlPrefix, "/view-order-history"));

            case 17:
              _context2.next = 21;
              break;

            case 19:
              _context2.next = 21;
              return router.push("".concat(urlPrefix, "/products"));

            case 21:
              _context2.next = 31;
              break;

            case 23:
              if (!multicartFlag) {
                _context2.next = 28;
                break;
              }

              _context2.next = 26;
              return router.push("/");

            case 26:
              _context2.next = 30;
              break;

            case 28:
              _context2.next = 30;
              return router.push("".concat(urlPrefix, "/cart"));

            case 30:
              (0,helperServices/* hideSpinner */.v3)();

            case 31:
              _context2.next = 41;
              break;

            case 33:
              if (!multicartFlag) {
                _context2.next = 38;
                break;
              }

              _context2.next = 36;
              return router.push("/");

            case 36:
              _context2.next = 40;
              break;

            case 38:
              _context2.next = 40;
              return router.push("".concat(urlPrefix, "/cart"));

            case 40:
              (0,helperServices/* hideSpinner */.v3)();

            case 41:
              _context2.next = 43;
              return clearReduxState();

            case 43:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleExtCheckout() {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (CheckoutNav_module_default())["checkout-nav"],
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (CheckoutNav_module_default()).container,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
        noGutters: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
          className: "d-flex align-items-center ".concat((CheckoutNav_module_default()).logo, " ").concat((CheckoutNav_module_default())["col-side"]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "d-block d-lg-none",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              img_path: "".concat(imagePrefix, "/assets/images/global-header.svg"),
              img_width: "2rem",
              img_height: "2rem",
              id: "checkout-header-mob-logo"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "d-none d-lg-block",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              img_path: "".concat(imagePrefix, "/assets/images/global-header.svg"),
              img_width: "2.5rem",
              img_height: "2.5rem",
              id: "checkout-header-logo"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text.H5, {
            className: (CheckoutNav_module_default())["title-font"],
            color: colors/* default.White0 */.Z.White0,
            textAlign: "left",
            fontWeight: "bold",
            padding: "0 0 0 1rem",
            id: "checkout-header-title",
            children: labels/* default.lbl_checkout_header.title */.Z.lbl_checkout_header.title
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          className: "justify-content-center ".concat((CheckoutNav_module_default())["col-mid"]),
          children: stepsShow && /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutStepper, {
            steps: steps,
            activeStepNo: activeStepNo,
            stepsWidth: stepsWidth
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          className: "d-flex align-items-center justify-content-end ".concat((CheckoutNav_module_default())["col-side"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CTAButton["default"], {
            className: (CheckoutNav_module_default())["exit-btn"],
            variant: "outline white",
            handleClick: handleExtCheckout,
            id: "checkout-header-exit-button",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "d-none d-lg-inline d-md-inline d-sm-inline ".concat((CheckoutNav_module_default())["title-font"]),
              children: labels/* default.lbl_exit_checkout.desktop */.Z.lbl_exit_checkout.desktop
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "d-lg-none d-md-none d-sm-none",
              children: labels/* default.lbl_exit_checkout.mobile */.Z.lbl_exit_checkout.mobile
            })]
          })
        })]
      })
    })
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userLoggedIn: state.navDetails.isUserLoggedIn,
    creditVettingResultData: state.checkoutDetails.creditVettingResult,
    cartProducts: state.cartDetails.cartProductItems
  };
};

var mapDispatchToProps = {
  setNormalCheckoutCurrentStep: checkoutAction/* setNormalCheckoutCurrentStep */.Z9,
  setPostCheckoutCurrentStep: checkoutAction/* setPostCheckoutCurrentStep */.Gr,
  removeCreditCheckStates: checkoutAction/* removeCreditCheckStates */.nK,
  deleteItemsFromCart: cartAction/* deleteItemsFromCart */.dY,
  setPaymentMethodUrl: checkoutAction/* setPaymentMethodUrl */.RL,
  setPostOrderResponse: checkoutAction/* setPostOrderResponse */.wg
};
/* harmony default export */ var checkoutNav_CheckoutNav = ((0,DependencyHelper.connect)(mapStateToProps, mapDispatchToProps)(CheckoutNav));
// EXTERNAL MODULE: ./components/atoms/pageHeading/PageHeading.jsx
var PageHeading = __webpack_require__(19456);
// EXTERNAL MODULE: ./components/atoms/newLineForms/dropDown/DropDown.jsx
var DropDown = __webpack_require__(67061);
// EXTERNAL MODULE: ./components/atoms/faqItem/FaqItem.module.scss
var FaqItem_module = __webpack_require__(72819);
var FaqItem_module_default = /*#__PURE__*/__webpack_require__.n(FaqItem_module);
;// CONCATENATED MODULE: ./components/atoms/faqItem/FaqItem.jsx






var FaqItem = function FaqItem(_ref) {
  var _item$faqOptions$sele;

  var item = _ref.item,
      selectedFaqIndex = _ref.selectedFaqIndex,
      selectedFaqId = _ref.selectedFaqId,
      onChangeHandler = _ref.onChangeHandler,
      onResetHandler = _ref.onResetHandler;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (FaqItem_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FaqItem_module_default()).heading,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (FaqItem_module_default()).icon,
        src: item.icon
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (FaqItem_module_default()).label,
        id: item.quesId ? item.quesId : item.id,
        children: item.title
      })]
    }), item.faqOptions ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((FaqItem_module_default())["select-row"]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((FaqItem_module_default())["select-group"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            label: "Application process",
            name: "faqSelect-".concat(item.id),
            data: item.faqOptions,
            handleSelect: onChangeHandler,
            handleReset: onResetHandler,
            resetRequired: true,
            selectedId: selectedFaqId,
            customId: "checkout-faq-select-".concat(item.id)
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((FaqItem_module_default()).desc, " ").concat((FaqItem_module_default())["select-desc"]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)((_item$faqOptions$sele = item.faqOptions[selectedFaqIndex]) === null || _item$faqOptions$sele === void 0 ? void 0 : _item$faqOptions$sele.description)
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (FaqItem_module_default()).desc,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(item.description)
      })
    })]
  });
};
/* harmony default export */ var faqItem_FaqItem = (FaqItem);
// EXTERNAL MODULE: ./components/atoms/accordion/Accordion.jsx
var Accordion = __webpack_require__(36556);
// EXTERNAL MODULE: ./components/molecules/checkoutFaq/CheckoutFaq.module.scss
var CheckoutFaq_module = __webpack_require__(73872);
var CheckoutFaq_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutFaq_module);
;// CONCATENATED MODULE: ./components/molecules/checkoutFaq/CheckoutFaq.jsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var CheckoutFaq = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var heading = _ref.heading,
      headingId = _ref.headingId,
      faq = _ref.faq,
      customerStatus = _ref.customerStatus;
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= 992;

  var _useState = (0,react.useState)(""),
      activeAccordion = _useState[0],
      setActiveAccordion = _useState[1];

  var mainHeading = faq ? faq.title : heading;
  var faqSections = faq ? faq.faqs : [];

  var _useState2 = (0,react.useState)([]),
      faqOptions = _useState2[0],
      setFaqOptions = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      selectedFaqIndex = _useState3[0],
      setSelectedFaqIndex = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      selectedFaqId = _useState4[0],
      setSelectedFaqId = _useState4[1];

  var _useState5 = (0,react.useState)(null),
      defaultSelectedFaqId = _useState5[0],
      setDefaultSelectedFaqId = _useState5[1];
  /**
   * Set the zero index dropdown selected by default
   */


  (0,react.useEffect)(function () {
    if (faq && faq.faqs) {
      var totalFaq = faq.faqs.length;

      for (var i = 0; i < totalFaq; i++) {
        if (faq.faqs[i].faqOptions) {
          setFaqOptions(faq.faqs[i].faqOptions);
          setDefaultSelectedFaqId(faq.faqs[i].faqOptions[selectedFaqIndex].id);
          setSelectedFaqId(faq.faqs[i].faqOptions[selectedFaqIndex].id);
          break;
        }
      }
    }
  }, [faq]);

  var setActiveAccordionValue = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(eventKey) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (eventKey === activeAccordion) {
                setActiveAccordion("");
              } else {
                setActiveAccordion(eventKey);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function setActiveAccordionValue(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var generateClass = function generateClass(eventKey) {
    return eventKey === activeAccordion ? "".concat((CheckoutFaq_module_default())["accordion-wrapper__item"], " ").concat((CheckoutFaq_module_default())["accordion-wrapper__item--active"]) : (CheckoutFaq_module_default())["accordion-wrapper__item"];
  };
  /**
   * Dropdown change event handler
   *
   * @usage Set the id of selected faq
   * @usage Show the content of selected faq
   * @call onChange event
   */


  var handleChange = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, val, index) {
      var _faqOptions$index;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.persist();
              setSelectedFaqIndex(index);
              setSelectedFaqId(val);
              analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                page_tool_event: "use",
                page_tool_name: "checkout: lets get started: ".concat(customerStatus, ": application process"),
                filter_query: (_faqOptions$index = faqOptions[index]) === null || _faqOptions$index === void 0 ? void 0 : _faqOptions$index.name
              }));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Dropdown field reset handler
   *
   * @usage Set the default selected
   */


  var handleReset = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var _faqOptions$;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setSelectedFaqIndex(0);
              setSelectedFaqId(defaultSelectedFaqId);
              analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                page_tool_event: "use",
                page_tool_name: "checkout: lets get started: ".concat(customerStatus, ": application process"),
                filter_query: (_faqOptions$ = faqOptions[0]) === null || _faqOptions$ === void 0 ? void 0 : _faqOptions$.name
              }));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleReset() {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((CheckoutFaq_module_default())["main-container"]),
    id: headingId,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((CheckoutFaq_module_default()).container),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CheckoutFaq_module_default())["top-wrapper"]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
          text: mainHeading,
          className: (CheckoutFaq_module_default())["top-wrapper__heading"]
        })
      }), faqSections.length > 0 && !isTablet && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CheckoutFaq_module_default())["items-wrapper"]),
        children: faqSections.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(faqItem_FaqItem, {
            item: item,
            selectedFaqId: selectedFaqId,
            selectedFaqIndex: selectedFaqIndex,
            onChangeHandler: handleChange,
            onResetHandler: handleReset
          }, index);
        })
      }), faqSections.length > 0 && isTablet && /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
        className: (CheckoutFaq_module_default())["accordion-wrapper"],
        children: faqSections.map(function (item, index) {
          var _item$faqOptions$sele;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* AccordionItem */.Q, {
            title: item.title,
            className: generateClass(item.id),
            eventKey: item.id,
            id: item.quesId ? item.quesId : item.id,
            activeAccordion: activeAccordion,
            handleOnClick: function handleOnClick() {
              return setActiveAccordionValue(item.id);
            },
            children: item.faqOptions ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "".concat((CheckoutFaq_module_default())["select-row"]),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat((CheckoutFaq_module_default())["select-group"]),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
                    label: "Application process",
                    name: "faqSelect-".concat(item.id),
                    data: item.faqOptions,
                    handleSelect: handleChange,
                    handleReset: handleReset,
                    resetRequired: true,
                    selectedId: selectedFaqId,
                    customId: "checkout-faq-select-".concat(item.id)
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "".concat((CheckoutFaq_module_default())["accordion-wrapper__subitem"], " ").concat((CheckoutFaq_module_default())["select-desc"]),
                dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)((_item$faqOptions$sele = item.faqOptions[selectedFaqIndex]) === null || _item$faqOptions$sele === void 0 ? void 0 : _item$faqOptions$sele.description)
              })]
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (CheckoutFaq_module_default())["accordion-wrapper__subitem"],
              dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(item.description)
            })
          }, index);
        })
      })]
    })
  });
});
CheckoutFaq.defaultProps = {
  heading: "Frequently asked questions",
  headingId: "faqs"
};
/* harmony default export */ var checkoutFaq_CheckoutFaq = (CheckoutFaq);
// EXTERNAL MODULE: ./components/molecules/checkoutFooter/CheckoutFooter.module.scss
var CheckoutFooter_module = __webpack_require__(85871);
var CheckoutFooter_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutFooter_module);
;// CONCATENATED MODULE: ./components/molecules/checkoutFooter/CheckoutFooter.jsx






var CheckoutFooter = function CheckoutFooter(_ref) {
  var orderSummeryVariant = _ref.orderSummeryVariant;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.FooterContainer, {
    className: "".concat((CheckoutFooter_module_default())["checkout-footer"], " ").concat(orderSummeryVariant == "plain" ? (CheckoutFooter_module_default())["step-plain"] : (CheckoutFooter_module_default())["step-popup"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (CheckoutFooter_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CheckoutFooter_module_default())["left-section"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Text, {
          id: "checkout-footer-secure-by",
          children: "Secured by:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (CheckoutFooter_module_default())["secure-img"],
          src: "".concat(imagePrefix, "/assets/images/symantec.png"),
          id: "checkout-footer-secure-by-symantec"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (CheckoutFooter_module_default())["secure-img"],
          src: "".concat(imagePrefix, "/assets/images/digicert.png"),
          id: "checkout-footer-secure-by-digicert"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CheckoutFooter_module_default())["right-section"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (CheckoutFooter_module_default())["question-img"],
          src: "".concat(imagePrefix, "/assets/images/question.svg")
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Text, {
          className: (CheckoutFooter_module_default())["help-text"],
          id: "checkout-footer-help-text",
          children: ["Need help?", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: (CheckoutFooter_module_default())["contact-text"],
            id: "checkout-footer-contact",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: "d-none d-md-inline",
              id: "checkout-footer-contact-call",
              children: [" ", "Call 082 135"]
            }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "d-md-none",
              id: "checkout-footer-contact-call-mob",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "tel:082135",
                children: "Call us"
              })
            }), " ", "for assistance."]
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var checkoutFooter_CheckoutFooter = (CheckoutFooter);
// EXTERNAL MODULE: ./components/atoms/container/MainContainer.jsx
var MainContainer = __webpack_require__(40521);
// EXTERNAL MODULE: ./components/molecules/errorToolTip/ErrorTooltip.jsx
var ErrorTooltip = __webpack_require__(94029);
// EXTERNAL MODULE: ./components/organisms/checkoutPage/CheckoutPage.module.scss
var CheckoutPage_module = __webpack_require__(52923);
var CheckoutPage_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutPage_module);
;// CONCATENATED MODULE: ./components/organisms/checkoutPage/CheckoutPage.jsx


function CheckoutPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CheckoutPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CheckoutPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CheckoutPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var CheckoutPage = function CheckoutPage(_ref) {
  var children = _ref.children,
      _ref$steps = _ref.steps,
      steps = _ref$steps === void 0 ? [] : _ref$steps,
      stepsShow = _ref.stepsShow,
      stepsWidth = _ref.stepsWidth,
      activeStep = _ref.activeStep,
      activeStepNo = _ref.activeStepNo,
      className = _ref.className,
      customerStatus = _ref.customerStatus,
      orderSummeryVariant = _ref.orderSummeryVariant,
      faq = _ref.faq,
      showSnackBar = _ref.showSnackBar,
      setShowSnackBar = _ref.setShowSnackBar,
      multicartFlag = _ref.multicartFlag;
  var displayMobileStepper = activeStepNo + 1 > 0 && activeStepNo <= steps.length;

  var closeSnackBar = function closeSnackBar() {
    if (activeStep == "otp") {
      analyticsUtag/* link */.p4(CheckoutPage_objectSpread({
        page_tool_event: "use",
        page_tool_name: "checkout: authentication: ".concat(customerStatus, ": dismiss")
      }, getUtagViewData()));
    }

    setShowSnackBar({
      visible: false,
      message: "",
      type: "default",
      className: "",
      dismissClass: "",
      textClass: ""
    });
  };

  var getUtagViewData = function getUtagViewData() {
    return analyticsUtag/* getUtagData */.GS(["visitor_customer_id", "visitor_id_hash", "visitor_login_status", "visitor_subscription_type", "visitor_msisdn_hash", "page_name", "page_channel", "page_master_tab"]);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: (CheckoutPage_module_default())["main-wrapper"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(checkoutNav_CheckoutNav, {
      steps: steps,
      stepsShow: stepsShow,
      stepsWidth: stepsWidth,
      activeStep: activeStep,
      activeStepNo: activeStepNo,
      customerStatus: customerStatus,
      multicartFlag: multicartFlag
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((CheckoutPage_module_default())["content-wrapper"], " ").concat(activeStep == "orderConfirmation" ? (CheckoutPage_module_default()).success : activeStep == "pageError" || activeStep == "paymentError" || activeStep == "paymentRedirect" ? "justify-content-center" : ""),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(MainContainer/* default */.Z, {
        className: (CheckoutPage_module_default()).main,
        paddingTop: "4.5rem",
        mdPaddingTop: "6rem",
        lgPaddingTop: "6rem",
        children: [showSnackBar.visible && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTooltip/* default */.Z, {
          errorMsg: showSnackBar.message,
          buttonHandler: closeSnackBar,
          type: showSnackBar.type,
          className: "".concat((CheckoutPage_module_default())["error-tooltip"], " ").concat(showSnackBar.className),
          dismissClass: showSnackBar.dismissClass,
          textClass: showSnackBar.textClass,
          showAnalytics: false
        }), displayMobileStepper && stepsShow && /*#__PURE__*/(0,jsx_runtime.jsx)(MobileCheckoutStepper, {
          steps: steps,
          stepsShow: stepsShow,
          activeStepNo: activeStepNo
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((CheckoutPage_module_default())["center-container"], " ").concat(className),
          children: children
        })]
      }), faq && /*#__PURE__*/(0,jsx_runtime.jsx)(checkoutFaq_CheckoutFaq, {
        faq: faq,
        customerStatus: customerStatus
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(checkoutFooter_CheckoutFooter, {
      orderSummeryVariant: orderSummeryVariant
    })]
  });
};

CheckoutPage.defaultProps = {
  stepsShow: false,
  faq: null,
  stepsWidth: "step-width-65"
};
/* harmony default export */ var checkoutPage_CheckoutPage = (CheckoutPage);

/***/ }),

/***/ 88573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkoutPayment_CheckoutPayment; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./Redux/actions/checkoutAction.js
var checkoutAction = __webpack_require__(39166);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/formHeading/FormHeading.jsx
var FormHeading = __webpack_require__(81083);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./components/atoms/paymentMethodTile/PaymentMethodTile.module.scss
var PaymentMethodTile_module = __webpack_require__(7119);
var PaymentMethodTile_module_default = /*#__PURE__*/__webpack_require__.n(PaymentMethodTile_module);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/paymentMethodTile/PaymentMethodTile.jsx







var PaymentMethodTile = function PaymentMethodTile(_ref) {
  var variant = _ref.variant,
      data = _ref.data,
      handleOnDelete = _ref.handleOnDelete,
      handleOnClick = _ref.handleOnClick,
      selectedItem = _ref.selectedItem,
      deleteOption = _ref.deleteOption,
      id = _ref.id,
      className = _ref.className,
      showDesc = _ref.showDesc,
      defaultIcon = _ref.defaultIcon,
      defaultIconUrl = _ref.defaultIconUrl;
  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() <= 576;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var wrapperClassName = variant == "card" ? (PaymentMethodTile_module_default()).card : (PaymentMethodTile_module_default()).option;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: data && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((PaymentMethodTile_module_default()).paymentMethodTile, " ").concat(wrapperClassName, " ").concat(selectedItem == data.id ? (PaymentMethodTile_module_default()).greenBorder : "", " ").concat(className),
        id: "".concat(id, " ").concat(selectedItem == data.id ? id + "-green-tick" : ""),
        onClick: function onClick() {
          handleOnClick(data);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (PaymentMethodTile_module_default()).top,
          children: [(data.icon || defaultIcon) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (PaymentMethodTile_module_default()).icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: defaultIcon ? defaultIconUrl : data.icon
            })
          }), data.name && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (PaymentMethodTile_module_default()).content,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (PaymentMethodTile_module_default()).heading,
              children: data.name
            }), data.details && variant == "card" && !isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (PaymentMethodTile_module_default()).details,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (PaymentMethodTile_module_default()).number,
                children: data.details.number
              }), data.details.expire && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (PaymentMethodTile_module_default()).expire,
                children: ["Expires ", data.details.expire]
              })]
            })]
          }), data && variant == "card" && deleteOption && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (PaymentMethodTile_module_default())["action-btn"],
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "".concat((PaymentMethodTile_module_default()).btn, " ").concat((PaymentMethodTile_module_default())["delete"]),
                id: "".concat(id, "-delete"),
                onClick: function onClick(e) {
                  e.stopPropagation();
                  handleOnDelete(data);
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("i", {
                  className: "".concat((PaymentMethodTile_module_default()).icon, " ").concat((PaymentMethodTile_module_default()).icon__delete)
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (PaymentMethodTile_module_default()).label,
                  children: "Remove"
                })]
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat(selectedItem == data.id ? (PaymentMethodTile_module_default()).triangle : ["d-none"]),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (PaymentMethodTile_module_default()).click,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: (PaymentMethodTile_module_default())["click-tick"],
                src: "".concat(imagePrefix, "/assets/images/tick.svg"),
                alt: "tick"
              })
            })
          })]
        }), data.details && variant == "card" && isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (PaymentMethodTile_module_default()).bottom,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (PaymentMethodTile_module_default()).content,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (PaymentMethodTile_module_default()).details,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (PaymentMethodTile_module_default()).number,
                children: data.details.number
              }), data.details.expire && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (PaymentMethodTile_module_default()).expire,
                children: ["Expires ", data.details.expire]
              })]
            })
          })
        })]
      }), (data === null || data === void 0 ? void 0 : data.description) && selectedItem == data.id && showDesc && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PaymentMethodTile_module_default()).desc,
        dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(data.description)
      })]
    })
  });
};

PaymentMethodTile.defaultProps = {
  variant: "option",
  data: {},
  deleteOption: true,
  showDesc: true,
  defaultIcon: false
};
/* harmony default export */ var paymentMethodTile_PaymentMethodTile = (PaymentMethodTile);
// EXTERNAL MODULE: ./components/atoms/confirmModal/ConfirmModal.jsx
var ConfirmModal = __webpack_require__(74183);
// EXTERNAL MODULE: ./components/atoms/snackBar/SnackBar.jsx
var SnackBar = __webpack_require__(52932);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./utils/paymentIntegrationServices.js
var paymentIntegrationServices = __webpack_require__(40547);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./context/checkout-journey-context.js
var checkout_journey_context = __webpack_require__(62039);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./components/organisms/checkoutPayment/CheckoutPayment.module.scss
var CheckoutPayment_module = __webpack_require__(51704);
var CheckoutPayment_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutPayment_module);
;// CONCATENATED MODULE: ./components/organisms/checkoutPayment/CheckoutPayment.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var visaLabel = "VisaMasterCard";
var defaultPaymentTypes = [{
  name: visaLabel
}];
var CheckoutPayment = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var setPaymentMethodUrl = _ref.setPaymentMethodUrl,
      continueDisable = _ref.continueDisable,
      userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      navigate = _ref.navigate,
      paymentConfiguration = _ref.paymentConfiguration,
      customerStatus = _ref.customerStatus,
      applicationType = _ref.applicationType,
      currentJourneyType = _ref.currentJourneyType,
      cartDetails = _ref.cartDetails,
      deliveryDetails = _ref.deliveryDetails,
      authDetailsData = _ref.authDetailsData,
      postOrderResponse = _ref.postOrderResponse;
  var env = (config_default()).env;

  var _useState = (0,react.useState)(false),
      viewAnalytics = _useState[0],
      setViewAnalytics = _useState[1];

  var _useState2 = (0,react.useState)({}),
      intentData = _useState2[0],
      setIntentData = _useState2[1];

  var paymentCallbackUrl = applicationType == "normal" ? (config_default()).envConfigs[env].paymentCallback : (config_default()).envConfigs[env].postPaymentCallback;

  var _useState3 = (0,react.useState)([]),
      paymentOptions = _useState3[0],
      setPaymentOptions = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      selectedPaymentOption = _useState4[0],
      setSelectedPaymentOption = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      allCreditCards = _useState5[0],
      setAllCreditCards = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      addCreditCard = _useState6[0],
      setAddCreditCard = _useState6[1];

  var _useState7 = (0,react.useState)(null),
      addCreditCardUrl = _useState7[0],
      setAddCreditCardUrl = _useState7[1];

  var _useState8 = (0,react.useState)(null),
      selectedCreditCard = _useState8[0],
      setSelectedCreditCard = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      showAllCreditCards = _useState9[0],
      setShowAllCreditCards = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      showConfirmModal = _useState10[0],
      setShowConfirmModal = _useState10[1];

  var _useState11 = (0,react.useState)(null),
      deleteId = _useState11[0],
      setDeleteId = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      showSnackBar = _useState12[0],
      setShowSnackBar = _useState12[1];

  var _useState13 = (0,react.useState)(null),
      snackBarMsg = _useState13[0],
      setSnackBarMsg = _useState13[1];

  var _useState14 = (0,react.useState)(false),
      showWarningMsg = _useState14[0],
      setShowWarningMsg = _useState14[1];

  var analyticsData = analyticsUtag/* getUtagData */.GS();
  (0,react.useImperativeHandle)(ref, function () {
    return {
      submit: function submit() {
        analyticsUtag/* link */.p4({
          link_type: "o",
          link_name: "checkout: payment: ".concat(customerStatus, ": continue")
        });
        continueDisable(true);
        navigate("paymentRedirect");
      },
      back: function back() {
        if (applicationType == "normal") {
          analyticsUtag/* link */.p4({
            link_type: "o",
            link_name: "checkout: payment: ".concat(customerStatus, ": back to review")
          });
        } else {
          analyticsUtag/* link */.p4({
            link_type: "o",
            link_name: "checkout: payment: ".concat(customerStatus, ": back")
          });
        }
      }
    };
  });
  /**
   * Call getIntentData function
   *
   * @call page load
   */

  (0,react.useEffect)(function () {
    getIntentData();
  }, []);
  /**
   * Get all Payment intent data
   *
   * @usage MS API call to get all available payment types, saved credit cards, new card url, remove card url etc.
   * @usage Set the state of intentData, allCreditCards, addCreditCardUrl, paymentMethodUrl
   * @call on function call
   */

  var getIntentData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              paymentIntegrationServices/* default.getPaymentIntent */.Z.getPaymentIntent(postOrderResponse === null || postOrderResponse === void 0 ? void 0 : postOrderResponse.productOrderId, paymentCallbackUrl).then(function (res) {
                var _res$response;

                if (!res.fail && (_res$response = res.response) !== null && _res$response !== void 0 && _res$response.data) {
                  var _res$response$data, _res$response$data2, _res$response$data3, _res$response$data4;

                  setIntentData(res.response.data);
                  setAllCreditCards((_res$response$data = res.response.data) === null || _res$response$data === void 0 ? void 0 : _res$response$data.savedCards);
                  setAddCreditCardUrl(paymentConfiguration.paymentGatewayBaseUrl + ((_res$response$data2 = res.response.data) === null || _res$response$data2 === void 0 ? void 0 : _res$response$data2.newCardUrl));
                  setPaymentMethodUrl((_res$response$data3 = res.response.data) === null || _res$response$data3 === void 0 ? void 0 : _res$response$data3.paymentUrl); //Drupal call to get the payment option content

                  getPaymentOptionsContent((_res$response$data4 = res.response.data) === null || _res$response$data4 === void 0 ? void 0 : _res$response$data4.paymentTypes);
                } else {
                  var _res$error, _res$error$data, _res$error$data$resul, _res$error2, _res$error2$data, _res$error3;

                  analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(res !== null && res !== void 0 && (_res$error = res.error) !== null && _res$error !== void 0 && (_res$error$data = _res$error.data) !== null && _res$error$data !== void 0 && (_res$error$data$resul = _res$error$data.result) !== null && _res$error$data$resul !== void 0 && _res$error$data$resul.message ? res.error.data.result.message : res !== null && res !== void 0 && (_res$error2 = res.error) !== null && _res$error2 !== void 0 && (_res$error2$data = _res$error2.data) !== null && _res$error2$data !== void 0 && _res$error2$data.message ? res.error.data.message : ""),
                    page_errors_code: "chk-dxl-g-id-".concat(res === null || res === void 0 ? void 0 : (_res$error3 = res.error) === null || _res$error3 === void 0 ? void 0 : _res$error3.status)
                  })); //Drupal call to get the payment option content

                  getPaymentOptionsContent(defaultPaymentTypes);
                }
              })["catch"](function (err) {
                if (err) {
                  var _err$response;

                  analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(err.message ? err.message : ""),
                    page_errors_code: "chk-dxl-g-id-".concat(err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status)
                  }));
                } //Drupal call to get the payment option content


                getPaymentOptionsContent(defaultPaymentTypes);
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getIntentData() {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Get all payment options
   *
   * @usage Drupal API call to get payment options and add credit card block content
   * @usage Filter all payment options(drupal) with available payment types(MS)
   * @usage Set the state of paymentOptions and addCreditCard
   * @call page load
   */


  var getPaymentOptionsContent = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(paymentTypes) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              paymentIntegrationServices/* default.getPaymentOptionsData */.Z.getPaymentOptionsData().then(function (results) {
                var _results$sections$;

                var allPaymentOptions = results === null || results === void 0 ? void 0 : results.sections[0];
                var allowedMethods = (paymentTypes || []).map(function (m) {
                  return m === null || m === void 0 ? void 0 : m.name;
                });
                var filteredMethods = ((allPaymentOptions === null || allPaymentOptions === void 0 ? void 0 : allPaymentOptions.faqs) || []).filter(function (o) {
                  return allowedMethods.indexOf(o === null || o === void 0 ? void 0 : o.quesId) !== -1;
                });
                setPaymentOptions(filteredMethods);
                setAddCreditCard(results === null || results === void 0 ? void 0 : (_results$sections$ = results.sections[1]) === null || _results$sections$ === void 0 ? void 0 : _results$sections$.faqs[0]);

                if (results && results.status === "error") {
                  analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(results.reason ? results.reason : ""),
                    page_errors_code: "chk-d-g-po"
                  }));
                }

                (0,helperServices/* hideSpinner */.v3)();
              })["catch"](function (err) {
                if (err) {
                  var _err$response2;

                  analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(err.message ? err.message : ""),
                    page_errors_code: "chk-d-g-po-".concat(err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.status)
                  }));
                }

                (0,helperServices/* hideSpinner */.v3)();
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getPaymentOptionsContent(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Get view Analytics
   *
   * @usage Get the required view analytics of the page
   * @call on function call
   */


  function getViewAnalytics() {
    if (applicationType == "normal") {
      return {
        page_event: "view",
        page_name: "checkout: payment: ".concat(customerStatus)
      };
    } else {
      if (currentJourneyType == checkout_journey_context/* journeyType.upgrade */.w.upgrade) {
        var _upgradeResponse, _upgradeResponse2, _upgradeResponse3, _upgradeResponse4;

        return {
          page_event: "view",
          page_name: "checkout: payment: ".concat(customerStatus),
          delivery_type: (deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.receiveType) == "store" ? "collect" : "deliver",
          authentication_id_type: (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) == "PASSPORT" ? "passport" : "id",
          upgrade_eligibility_status: (_upgradeResponse = upgradeResponse) === null || _upgradeResponse === void 0 ? void 0 : _upgradeResponse.eligibilityStatus,
          upgrade_eligible_date: ((_upgradeResponse2 = upgradeResponse) === null || _upgradeResponse2 === void 0 ? void 0 : _upgradeResponse2.upgradeDate) || "",
          upgrade_customer_type: (_upgradeResponse3 = upgradeResponse) !== null && _upgradeResponse3 !== void 0 && _upgradeResponse3.c3dCustomer ? "C3D" : (_upgradeResponse4 = upgradeResponse) !== null && _upgradeResponse4 !== void 0 && _upgradeResponse4.business ? "CBU" : "OTHER"
        };
      } else {
        return {
          page_event: "view",
          page_name: "checkout: payment: ".concat(customerStatus),
          delivery_type: (deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.receiveType) == "store" ? "collect" : "deliver",
          authentication_id_type: (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) == "PASSPORT" ? "passport" : "id"
        };
      }
    }
  }
  /**
   * Page Analytics
   *
   * @usage Excecute page view analytics
   * @call page load
   */


  (0,react.useEffect)(function () {
    if (!viewAnalytics && customerStatus) {
      var analytics = getViewAnalytics();
      analytics.multicart_flag = cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti ? true : false;
      analyticsUtag/* view */.ei(_objectSpread(_objectSpread({}, analytics), analyticsUtag/* getProfileData */.$y(userLoggedIn, profileData, authDetailsData)));
      setViewAnalytics(true);
    }
  }, [customerStatus]);
  /**
   * Continue button enable/disable
   *
   * @usage Enable the continue button on selecting any saved credit card
   * @call on credit card selection
   */

  (0,react.useEffect)(function () {
    if (selectedCreditCard) {
      continueDisable(false);
    }
  }, [selectedCreditCard]);
  (0,react.useEffect)(function () {
    if (showSnackBar) {
      var timer = setTimeout(function () {
        return closeSnackBar();
      }, 3000);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [showSnackBar]);
  /**
   * Add key/value for payment options object
   *
   * @usage Add "id,name" key/value to an existing object for mapping
   * @call on function call
   */

  var mapQuestionIdObjectKey = function mapQuestionIdObjectKey(item) {
    if (item.quesId) {
      item.id = item.quesId;
    }

    if (item.title) {
      item.name = item.title;
    }

    return item;
  };
  /**
   * Get all credit cards
   *
   * @usage MS API call to get all the saved credit card
   * @usage Set the state of allCreditCards
   * @call on function call
   */


  var getAllCreditCardData = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              paymentIntegrationServices/* default.getPaymentIntent */.Z.getPaymentIntent(postOrderResponse === null || postOrderResponse === void 0 ? void 0 : postOrderResponse.productOrderId, paymentCallbackUrl).then(function (res) {
                var _res$response2;

                if (!res.fail && (_res$response2 = res.response) !== null && _res$response2 !== void 0 && _res$response2.data) {
                  var _res$response$data5, _res$response$data5$s;

                  if ((_res$response$data5 = res.response.data) !== null && _res$response$data5 !== void 0 && (_res$response$data5$s = _res$response$data5.savedCards) !== null && _res$response$data5$s !== void 0 && _res$response$data5$s.length) {
                    setAllCreditCards(res.response.data.savedCards);
                  } else {
                    setAllCreditCards([]); //Show warning message

                    setShowWarningMsg(true);
                    continueDisable(false);
                  }
                } else {
                  var _res$error4, _res$error4$data, _res$error4$data$resu, _res$error5, _res$error5$data, _res$error6;

                  setAllCreditCards([]); //Show warning message

                  setShowWarningMsg(true);
                  continueDisable(false);
                  analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(res !== null && res !== void 0 && (_res$error4 = res.error) !== null && _res$error4 !== void 0 && (_res$error4$data = _res$error4.data) !== null && _res$error4$data !== void 0 && (_res$error4$data$resu = _res$error4$data.result) !== null && _res$error4$data$resu !== void 0 && _res$error4$data$resu.message ? res.error.data.result.message : res !== null && res !== void 0 && (_res$error5 = res.error) !== null && _res$error5 !== void 0 && (_res$error5$data = _res$error5.data) !== null && _res$error5$data !== void 0 && _res$error5$data.message ? res.error.data.message : ""),
                    page_errors_code: "chk-dxl-g-sc-".concat(res === null || res === void 0 ? void 0 : (_res$error6 = res.error) === null || _res$error6 === void 0 ? void 0 : _res$error6.status)
                  }));
                }

                (0,helperServices/* hideSpinner */.v3)();
                displaySnackBar(labels/* default.payment.removeCreditCard */.Z.payment.removeCreditCard);
              })["catch"](function (err) {
                if (err) {
                  var _err$response3;

                  analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(err.message ? err.message : ""),
                    page_errors_code: "chk-dxl-g-sc-".concat(err === null || err === void 0 ? void 0 : (_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : _err$response3.status)
                  }));
                }

                setAllCreditCards([]); //Show warning message

                setShowWarningMsg(true);
                continueDisable(false);
                (0,helperServices/* hideSpinner */.v3)();
                displaySnackBar(labels/* default.payment.removeCreditCard */.Z.payment.removeCreditCard);
              });

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function getAllCreditCardData() {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * Set selected payment option
   *
   * @usage Set the state of selectedPaymentOption
   * @usage Enable continue button for guest user
   * @call on click call
   */


  var paymentMethodClickHandler = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(data) {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setSelectedPaymentOption(data.quesId);
              analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                link_type: "o",
                page_tool_event: "use",
                page_tool_name: "checkout: payment: ".concat(customerStatus, ": select payment"),
                filter_query: data.quesId
              }));

              if (!(data.quesId == visaLabel)) {
                _context4.next = 8;
                break;
              }

              setShowAllCreditCards(true);
              setPaymentMethodUrl(intentData === null || intentData === void 0 ? void 0 : intentData.paymentUrl);

              if (allCreditCards.length == 0) {
                setShowWarningMsg(true);
                continueDisable(false);
              } else {
                setShowWarningMsg(false);
                continueDisable(true);
              }

              _context4.next = 12;
              break;

            case 8:
              _context4.next = 10;
              return updatePaymentMethodUrl(data.quesId);

            case 10:
              setShowAllCreditCards(false);
              continueDisable(false);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function paymentMethodClickHandler(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * Update seleted payment method URL
   *
   * @usage Filter payment type from intent data by selected payment method id
   * @usage Set the state of paymentMethodUrl
   * @call on click call
   */


  var updatePaymentMethodUrl = function updatePaymentMethodUrl(id) {
    var _filteredMethod$;

    var filteredMethod = ((intentData === null || intentData === void 0 ? void 0 : intentData.paymentTypes) || []).filter(function (o) {
      return o.name == id;
    });
    setPaymentMethodUrl((_filteredMethod$ = filteredMethod[0]) === null || _filteredMethod$ === void 0 ? void 0 : _filteredMethod$.paymentUrl);
  };
  /**
   * Change payment option
   *
   * @usage Reset the state of selectedPaymentOption, paymentMethodUrl, selectedCreditCard,
   * showWarningMsg, showAllCreditCards
   * @call on click call
   */


  var changePaymentMethod = function changePaymentMethod() {
    setSelectedPaymentOption(null);
    setPaymentMethodUrl(intentData === null || intentData === void 0 ? void 0 : intentData.paymentUrl); //Default value

    setSelectedCreditCard(null);
    setShowAllCreditCards(false);
    setShowWarningMsg(false);
    continueDisable(true);
  };
  /**
   * Set selected credit card
   *
   * @usage Set the state of selectedCreditCard and paymentMethodUrl
   * @call on click call
   */


  var creditCardClickHandler = function creditCardClickHandler(type, data) {
    setSelectedCreditCard(data.id);

    if (type == "add") {
      setPaymentMethodUrl(addCreditCardUrl);
    } else {
      setPaymentMethodUrl(data === null || data === void 0 ? void 0 : data.href);
    }
  };
  /**
   * Display confirm modal
   *
   * @usage Show confirm modal on click of delete button from saved credit card
   * @usage Set the state of delete id of the credit card
   * @call on click call
   */


  var displyConfirmModal = function displyConfirmModal(data) {
    setDeleteId(data.id);
    setShowConfirmModal(true);
    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
      visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
      page_form_event: "start",
      page_form_name: "checkout: payment: ".concat(customerStatus, ": delete card")
    }));
  };
  /**
   * Cancel confirm modal
   *
   * @usage Cancel confirm modal on click of cancel button
   * @call on click call
   */


  var cancelConfirmModel = function cancelConfirmModel() {
    setDeleteId(null);
    setShowConfirmModal(false);
  };
  /**
   * Approve confirm modal
   *
   * @usage Approve confirm modal on click of submit button
   * @usage Call MS API to delete credit card
   * @call on click call
   */


  var approveConfirmModel = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              paymentIntegrationServices/* default.removeStoredCard */.Z.removeStoredCard(deleteId).then(function (res) {
                var _res$response3, _res$response3$data;

                if (!res.fail && ((_res$response3 = res.response) === null || _res$response3 === void 0 ? void 0 : (_res$response3$data = _res$response3.data) === null || _res$response3$data === void 0 ? void 0 : _res$response3$data.responseCode) == "SUCCESS") {
                  setDeleteId(null);
                  setSelectedCreditCard(null);
                  setPaymentMethodUrl(intentData === null || intentData === void 0 ? void 0 : intentData.paymentUrl);
                  getAllCreditCardData();
                } else {
                  var _res$error7, _res$error7$data, _res$error7$data$resu, _res$error8, _res$error8$data, _res$error9;

                  displaySnackBar(labels/* default.payment.removeCreditCardFail */.Z.payment.removeCreditCardFail);
                  analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(res !== null && res !== void 0 && (_res$error7 = res.error) !== null && _res$error7 !== void 0 && (_res$error7$data = _res$error7.data) !== null && _res$error7$data !== void 0 && (_res$error7$data$resu = _res$error7$data.result) !== null && _res$error7$data$resu !== void 0 && _res$error7$data$resu.message ? res.error.data.result.message : res !== null && res !== void 0 && (_res$error8 = res.error) !== null && _res$error8 !== void 0 && (_res$error8$data = _res$error8.data) !== null && _res$error8$data !== void 0 && _res$error8$data.message ? res.error.data.message : ""),
                    page_errors_code: "chk-dxl-p-rc-".concat(res === null || res === void 0 ? void 0 : (_res$error9 = res.error) === null || _res$error9 === void 0 ? void 0 : _res$error9.status)
                  }));
                  (0,helperServices/* hideSpinner */.v3)();
                }
              })["catch"](function (err) {
                if (err) {
                  var _err$response4;

                  analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(err.message ? err.message : ""),
                    page_errors_code: "chk-dxl-p-rc-".concat(err === null || err === void 0 ? void 0 : (_err$response4 = err.response) === null || _err$response4 === void 0 ? void 0 : _err$response4.status)
                  }));
                }

                (0,helperServices/* hideSpinner */.v3)();
              });
              setShowConfirmModal(false);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function approveConfirmModel() {
      return _ref6.apply(this, arguments);
    };
  }();

  var displaySnackBar = function displaySnackBar(msg) {
    setSnackBarMsg(msg);
    setShowSnackBar(true);
  };

  var closeSnackBar = function closeSnackBar() {
    setSnackBarMsg(null);
    setShowSnackBar(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (CheckoutPayment_module_default())["payment-container"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutPayment_module_default())["options-section"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
          title: "Select payment method",
          desc: "How would you like to pay today?",
          id: "checkout-payment-options-section-heading",
          className: (CheckoutPayment_module_default())["top-wrapper"],
          headingClassName: (CheckoutPayment_module_default())["top-wrapper__heading"]
        }), (paymentOptions === null || paymentOptions === void 0 ? void 0 : paymentOptions.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (CheckoutPayment_module_default())["tiles-section"],
            children: [(!showAllCreditCards || !selectedPaymentOption) && paymentOptions.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(paymentMethodTile_PaymentMethodTile, {
                variant: "option",
                data: mapQuestionIdObjectKey(item),
                handleOnClick: paymentMethodClickHandler,
                selectedItem: selectedPaymentOption,
                id: "checkout-payment-option-tile-".concat(index)
              }, index);
            }), showAllCreditCards && paymentOptions.filter(function (item) {
              return item.quesId == selectedPaymentOption;
            }).map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(paymentMethodTile_PaymentMethodTile, {
                variant: "option",
                data: mapQuestionIdObjectKey(item),
                handleOnClick: paymentMethodClickHandler,
                selectedItem: selectedPaymentOption,
                id: "checkout-payment-option-tile-".concat(index),
                showDesc: false
              }, index);
            })]
          }), selectedPaymentOption && showAllCreditCards && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (CheckoutPayment_module_default())["change-payment-label"],
            onClick: changePaymentMethod,
            id: "checkout-payment-option-change",
            children: "Change payment method"
          })]
        })]
      }), selectedPaymentOption == visaLabel && showAllCreditCards && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutPayment_module_default())["all-cards-section"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
          title: "Pay with credit / debit card",
          desc: "Which card would you like to pay with?",
          id: "checkout-payment-all-cards-section-heading",
          className: (CheckoutPayment_module_default())["top-wrapper"],
          headingClassName: (CheckoutPayment_module_default())["top-wrapper__heading"]
        }), showWarningMsg && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (CheckoutPayment_module_default())["error-container"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (CheckoutPayment_module_default()).icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/warning-black.svg")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (CheckoutPayment_module_default()).text,
            children: labels/* default.payment.noCreditCardWarning */.Z.payment.noCreditCardWarning
          })]
        }), (allCreditCards === null || allCreditCards === void 0 ? void 0 : allCreditCards.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (CheckoutPayment_module_default())["tiles-section"],
          children: [allCreditCards.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(paymentMethodTile_PaymentMethodTile, {
              variant: "card",
              data: item,
              defaultIcon: true,
              defaultIconUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-credit-card.svg"),
              handleOnDelete: displyConfirmModal,
              handleOnClick: function handleOnClick(data) {
                return creditCardClickHandler("all", data);
              },
              selectedItem: selectedCreditCard,
              showDesc: false,
              id: "checkout-payment-card-tile-".concat(index)
            }, index);
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(paymentMethodTile_PaymentMethodTile, {
            variant: "card",
            data: mapQuestionIdObjectKey(addCreditCard),
            handleOnClick: function handleOnClick(data) {
              return creditCardClickHandler("add", data);
            },
            selectedItem: selectedCreditCard,
            id: "checkout-payment-add-card-tile",
            deleteOption: false
          })]
        })]
      })]
    }), showConfirmModal ? /*#__PURE__*/(0,jsx_runtime.jsx)(ConfirmModal/* default */.Z, {
      show: showConfirmModal,
      subtext: "You\u2019re about to remove one of your saved cards from your profile. Would you like to continue?",
      handleConfirm: approveConfirmModel,
      handleCancel: cancelConfirmModel,
      cancelLabel: "Cancel",
      confirmLabel: "Remove card"
    }) : null, showSnackBar ? /*#__PURE__*/(0,jsx_runtime.jsx)(SnackBar["default"], {
      message: snackBarMsg,
      className: (CheckoutPayment_module_default())["snack-bar-styling"],
      closeSnackBar: closeSnackBar,
      isVisible: showSnackBar
    }) : null]
  });
});

var mapStateToProps = function mapStateToProps(state) {
  var _state$cartDetails;

  return {
    deliveryDetails: state.creditCheckDetails.deliveryDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    upgradeResponse: state.upgrade.upgradeResponse,
    creditVettingDetails: state.checkoutDetails.creditVettingResult,
    availablePaymentMethods: (_state$cartDetails = state.cartDetails) === null || _state$cartDetails === void 0 ? void 0 : _state$cartDetails.available_payment_methods,
    postOrderResponse: state.checkoutDetails.postOrderResponse
  };
};

var mapDispatchToProps = {
  setPaymentMethodUrl: checkoutAction/* setPaymentMethodUrl */.RL
};
/* harmony default export */ var checkoutPayment_CheckoutPayment = ((0,DependencyHelper.connect)(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(CheckoutPayment));

/***/ }),

/***/ 58651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99599);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28658);
/* harmony import */ var _atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79549);
/* harmony import */ var _atoms_image_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39489);
/* harmony import */ var _services_checkoutService__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34020);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64036);
/* harmony import */ var _data_mockRenderComponent__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29151);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69152);
/* harmony import */ var _Redux_actions_checkoutAction__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(39166);
/* harmony import */ var _utils_paymentIntegrationServices__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(40547);
/* harmony import */ var _CheckoutPaymentError_module_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29579);
/* harmony import */ var _CheckoutPaymentError_module_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_CheckoutPaymentError_module_scss__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var CheckoutPaymentError = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function (_ref, ref) {
  var _postOrderData$paymen;

  var navigate = _ref.navigate,
      profileData = _ref.profileData,
      userLoggedIn = _ref.userLoggedIn,
      customerStatus = _ref.customerStatus,
      applicationType = _ref.applicationType,
      setNormalCheckoutCurrentStep = _ref.setNormalCheckoutCurrentStep,
      setPostCheckoutCurrentStep = _ref.setPostCheckoutCurrentStep,
      removeCreditCheckStates = _ref.removeCreditCheckStates,
      setPaymentMethodUrl = _ref.setPaymentMethodUrl,
      setPostOrderResponse = _ref.setPostOrderResponse,
      paymentOptionsEnabled = _ref.paymentOptionsEnabled,
      paymentConfiguration = _ref.paymentConfiguration,
      isMiniApp = _ref.isMiniApp;
  var router = (0,_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  var authToken = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .getCookieValue */ .Do)("auth_token");
  var vodAuthToken = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .getCookieValue */ .Do)("vod-web-auth-token");
  var analyticsData = _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .getUtagData */ .GS();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      postOrderData = _useState[0],
      setPostOrderData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      paymentUrl = _useState2[0],
      setPaymentUrl = _useState2[1];

  var env = (_config_index__WEBPACK_IMPORTED_MODULE_4___default().env);
  var paymentCallbackUrl = applicationType == "normal" ? (_config_index__WEBPACK_IMPORTED_MODULE_4___default().envConfigs)[env].paymentCallback : (_config_index__WEBPACK_IMPORTED_MODULE_4___default().envConfigs)[env].postPaymentCallback;
  var paymentProvision = (_config_index__WEBPACK_IMPORTED_MODULE_4___default().envConfigs)[env].paymentProvision;
  var paymentConfig = paymentConfiguration;
  var customerIdentifier = userLoggedIn && profileData !== null && profileData !== void 0 && profileData.profileID ? profileData === null || profileData === void 0 ? void 0 : profileData.profileID : "";
  var orderId = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .getCookieValue */ .Do)((_config_index__WEBPACK_IMPORTED_MODULE_4___default().order_id));
  var failCount = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .getCookieValue */ .Do)((_config_index__WEBPACK_IMPORTED_MODULE_4___default().pay_fail_count));

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(failCount && parseInt(failCount) > 2 ? 2 : failCount ? parseInt(failCount) : 0),
      retryCount = _useState3[0],
      setRetryCount = _useState3[1];

  var technicalError = orderId ? false : true;
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(ref, function () {
    return {
      back: function back() {
        if (applicationType == "normal") {
          _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .link */ .p4({
            link_type: "o",
            link_name: "checkout: make payment: ".concat(customerStatus, ": back to delivery")
          });
        } else {
          _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .link */ .p4({
            link_type: "o",
            link_name: "checkout: make payment: ".concat(customerStatus, ": back to lets get started")
          });
        }
      }
    };
  });
  var retryBtnConfig = {
    buttonStyle: "solid red",
    buttonLabel: "Try again"
  };
  var exitBtnConfig = {
    buttonStyle: "solid red",
    buttonLabel: "Exit checkout"
  };
  var headerText = "";
  var descriptionText = "";
  var noteText = "";

  if (!technicalError) {
    if (retryCount < 2) {
      headerText = _config_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lbl_payment_failure_heading */ .Z.lbl_payment_failure_heading + (retryCount == 1 ? " again" : "");
      descriptionText = _config_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lbl_payment_failure_description */ .Z.lbl_payment_failure_description;
      noteText = _config_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lbl_payment_failure_note */ .Z.lbl_payment_failure_note;
    } else {
      headerText = _config_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lbl_payment_failure_heading_error */ .Z.lbl_payment_failure_heading_error;
      descriptionText = userLoggedIn ? _config_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lbl_payment_failure_description_error */ .Z.lbl_payment_failure_description_error : _config_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lbl_payment_failure_description_error_guest */ .Z.lbl_payment_failure_description_error_guest;
      noteText = "";
    }
  } else {
    headerText = _config_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lbl_payment_failure_heading_tech_error */ .Z.lbl_payment_failure_heading_tech_error;
    descriptionText = _config_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lbl_payment_failure_description_tech_error */ .Z.lbl_payment_failure_description_tech_error;
    noteText = "";
  }

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (customerStatus) {
      _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .view */ .ei(_objectSpread({
        page_event: "view",
        page_name: "checkout: make payment: ".concat(customerStatus)
      }, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .getProfileData */ .$y(userLoggedIn, profileData)));
      _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .error */ .vU("".concat(headerText, ". ").concat(descriptionText));
    }
  }, [customerStatus]);

  var handleRetry = function handleRetry(e) {
    e.preventDefault();
    _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .link */ .p4({
      link_type: "o",
      link_name: "checkout: make payment: ".concat(customerStatus, ": try again"),
      page_name: "checkout: make payment: ".concat(customerStatus),
      visitor_login_status: analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.visitor_login_status
    });

    if (orderId) {
      placeOrder();
    } else {
      clearReduxState(false);

      if (applicationType == "normal") {
        _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .link */ .p4({
          link_type: "o",
          link_name: "checkout: make payment: ".concat(customerStatus, ": back to delivery")
        });
        navigate("delivery");
      } else {
        _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .link */ .p4({
          link_type: "o",
          link_name: "checkout: make payment: ".concat(customerStatus, ": back to lets get started")
        });
        navigate("authentication");
      }
    }
  };

  var clearReduxState = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var removeGuest,
          _args = arguments;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              removeGuest = _args.length > 0 && _args[0] !== undefined ? _args[0] : true;
              setNormalCheckoutCurrentStep(null);
              setPostCheckoutCurrentStep(null);
              removeCreditCheckStates(null);
              setPaymentMethodUrl(null);
              setPostOrderResponse({});
              _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__.Cookie.remove((_config_index__WEBPACK_IMPORTED_MODULE_4___default().order_id));
              _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__.Cookie.remove((_config_index__WEBPACK_IMPORTED_MODULE_4___default().pay_fail_count));

              if (removeGuest) {
                _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__.Cookie.remove("guest_checkout");
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function clearReduxState() {
      return _ref2.apply(this, arguments);
    };
  }(); //Clearing cookies on exit


  var handleExitCheckout = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .showSpinner */ .yh)();

              if (!userLoggedIn) {
                _context2.next = 7;
                break;
              }

              _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .link */ .p4({
                link_type: "o",
                link_name: "checkout: make payment: ".concat(customerStatus, ": view order history"),
                page_name: "checkout: make payment: ".concat(customerStatus)
              });
              _context2.next = 5;
              return router.push("".concat(_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .urlPrefix */ .wn, "/view-order-history"));

            case 5:
              _context2.next = 10;
              break;

            case 7:
              _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .link */ .p4({
                link_type: "o",
                link_name: "checkout: make payment: ".concat(customerStatus, ": exit checkout"),
                page_name: "checkout: make payment: ".concat(customerStatus)
              });
              _context2.next = 10;
              return router.push("".concat(_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .urlPrefix */ .wn, "/products"));

            case 10:
              _context2.next = 12;
              return clearReduxState();

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleExitCheckout() {
      return _ref3.apply(this, arguments);
    };
  }();

  var placeOrder = /*#__PURE__*/function () {
    var _ref4 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
      var results, _results$errors;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .showSpinner */ .yh)();
              _context3.next = 4;
              return (0,_services_checkoutService__WEBPACK_IMPORTED_MODULE_9__/* .getSalesOrder */ .It)(orderId);

            case 4:
              results = _context3.sent;

              if (!results.fail) {
                if (results.order && Object.keys(results.order).length > 0) {
                  orderRouter(results);
                } else {
                  updateRetryCount();
                  (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .hideSpinner */ .v3)();
                }
              } else {
                updateRetryCount();
                (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .hideSpinner */ .v3)();
              }

              if (results && results.errors) {
                _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .link */ .p4(_objectSpread(_objectSpread({}, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .getUtagData */ .GS(["page_name"])), {}, {
                  page_form_event: "error",
                  page_errors: "".concat(results.errors[0] ? (_results$errors = results.errors) === null || _results$errors === void 0 ? void 0 : _results$errors[0].message : ""),
                  page_errors_code: "chk-dxl-g-so-".concat(results.status)
                }));
              }

              _context3.next = 13;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              updateRetryCount();
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .hideSpinner */ .v3)();

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 9]]);
    }));

    return function placeOrder() {
      return _ref4.apply(this, arguments);
    };
  }();

  var orderRouter = function orderRouter(orderResult) {
    var _orderResult$order, _orderResult$order2;

    var headers = {};
    var postOrder = JSON.parse(JSON.stringify(_data_mockRenderComponent__WEBPACK_IMPORTED_MODULE_11__.productOrderReq).replace(/\:null/gi, ':""')); //replace null with "" for all attributes

    postOrder.productOrder[0].productOrderState = orderResult === null || orderResult === void 0 ? void 0 : (_orderResult$order = orderResult.order) === null || _orderResult$order === void 0 ? void 0 : _orderResult$order.order_status;
    postOrder.productOrder[0].productOrderId = orderId;
    postOrder.productOrder[0].orderReference = orderResult !== null && orderResult !== void 0 && (_orderResult$order2 = orderResult.order) !== null && _orderResult$order2 !== void 0 && _orderResult$order2.waybill_number ? orderResult.order.waybill_number : "";

    if (vodAuthToken) {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-auth-jwt": "Bearer ".concat(vodAuthToken),
        "x-magento-token": "Bearer ".concat(authToken)
      };
    } else {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json"
      };
    }

    var url = "".concat((_config_index__WEBPACK_IMPORTED_MODULE_4___default().envConfigs)[(_config_index__WEBPACK_IMPORTED_MODULE_4___default().env)].dxl.url).concat((_config_index__WEBPACK_IMPORTED_MODULE_4___default().api.postpaidProductOrder));
    axios__WEBPACK_IMPORTED_MODULE_3___default().post(url, postOrder, {
      headers: headers
    }).then(function (response) {
      var _data$productOrders;

      var _ref5 = response || {},
          data = _ref5.data;

      if (data && data !== null && data !== void 0 && (_data$productOrders = data.productOrders) !== null && _data$productOrders !== void 0 && _data$productOrders.length) {
        var _data$productOrders$;

        setPostOrderData(data.productOrders[0]);

        if ((_data$productOrders$ = data.productOrders[0]) !== null && _data$productOrders$ !== void 0 && _data$productOrders$.payment) {
          if (paymentOptionsEnabled) {
            getIntentData(data.productOrders[0].productOrderId);
          } else {
            redirectToPayment();
          }
        } else {
          _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__.Cookie.remove((_config_index__WEBPACK_IMPORTED_MODULE_4___default().pay_fail_count));
          (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .hideSpinner */ .v3)();
          navigate("orderConfirmation");
        }
      } else {
        updateRetryCount();
        (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .hideSpinner */ .v3)();
      }
    })["catch"](function (err) {
      if (err) {
        var _err$response;

        _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .link */ .p4(_objectSpread(_objectSpread({}, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .getUtagData */ .GS(["page_name"])), {}, {
          page_form_event: "error",
          page_errors: "".concat(err.message ? err.message : ""),
          page_errors_code: "chk-dxl-p-po-".concat(err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status)
        }));
      }

      updateRetryCount();
      (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .hideSpinner */ .v3)();
    });
  };

  var getIntentData = /*#__PURE__*/function () {
    var _ref6 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(productOrderId) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _utils_paymentIntegrationServices__WEBPACK_IMPORTED_MODULE_14__/* ["default"].getPaymentIntent */ .Z.getPaymentIntent(productOrderId, paymentCallbackUrl).then(function (res) {
                var _res$response;

                if (!res.fail && (_res$response = res.response) !== null && _res$response !== void 0 && _res$response.data) {
                  var _res$response$data;

                  setPaymentUrl((_res$response$data = res.response.data) === null || _res$response$data === void 0 ? void 0 : _res$response$data.paymentUrl);
                } else {
                  var _res$error, _res$error$data, _res$error$data$resul, _res$error2, _res$error2$data, _res$error3;

                  _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .link */ .p4(_objectSpread(_objectSpread({}, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .getUtagData */ .GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(res !== null && res !== void 0 && (_res$error = res.error) !== null && _res$error !== void 0 && (_res$error$data = _res$error.data) !== null && _res$error$data !== void 0 && (_res$error$data$resul = _res$error$data.result) !== null && _res$error$data$resul !== void 0 && _res$error$data$resul.message ? res.error.data.result.message : res !== null && res !== void 0 && (_res$error2 = res.error) !== null && _res$error2 !== void 0 && (_res$error2$data = _res$error2.data) !== null && _res$error2$data !== void 0 && _res$error2$data.message ? res.error.data.message : ""),
                    page_errors_code: "chk-dxl-g-id-".concat(res === null || res === void 0 ? void 0 : (_res$error3 = res.error) === null || _res$error3 === void 0 ? void 0 : _res$error3.status)
                  }));
                }

                redirectToPayment();
              })["catch"](function (err) {
                if (err) {
                  var _err$response2;

                  _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .link */ .p4(_objectSpread(_objectSpread({}, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_12__/* .getUtagData */ .GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(err.message ? err.message : ""),
                    page_errors_code: "chk-dxl-g-id-".concat(err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.status)
                  }));
                }

                redirectToPayment();
              });

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function getIntentData(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  var redirectToPayment = function redirectToPayment() {
    if (isMiniApp) {
      window.location = "".concat(_config_index__WEBPACK_IMPORTED_MODULE_4__.EnvConfig.miniAppUrl, "?orderId=").concat(orderId);
      return;
    }

    window.setTimeout(function () {
      document.ucfCheckout.submit.bind(document.ucfCheckout);
      document.ucfCheckout.submit();
    }, 800);
  };

  var updateRetryCount = function updateRetryCount() {
    var newCount = parseInt(retryCount) + 1;
    setRetryCount(newCount);
    (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .setCookieConsentWrapper */ .ol)("cookie_".concat((_config_index__WEBPACK_IMPORTED_MODULE_4___default().pay_fail_count)), [(_config_index__WEBPACK_IMPORTED_MODULE_4___default().cookie_category.strictly_necessary)], "document.cookie='".concat((_config_index__WEBPACK_IMPORTED_MODULE_4___default().pay_fail_count), "=").concat(newCount, ";path=/'"));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__.CustomContainer, {
      className: (_CheckoutPaymentError_module_scss__WEBPACK_IMPORTED_MODULE_17___default()["error-container"]),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__.CustomContainer, {
        className: (_CheckoutPaymentError_module_scss__WEBPACK_IMPORTED_MODULE_17___default().icon),
        id: "error-img",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_image_image__WEBPACK_IMPORTED_MODULE_8__["default"], {
          img_path: "".concat(_utils_helperServices__WEBPACK_IMPORTED_MODULE_10__/* .imagePrefix */ .Sj, "/assets/images/error-warning-red.svg")
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__.CustomContainer, {
        className: (_CheckoutPaymentError_module_scss__WEBPACK_IMPORTED_MODULE_17___default().heading),
        id: "error-title",
        children: headerText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__.CustomContainer, {
        className: (_CheckoutPaymentError_module_scss__WEBPACK_IMPORTED_MODULE_17___default().content),
        id: "error-desc",
        children: descriptionText
      }), noteText !== "" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__.CustomContainer, {
        className: (_CheckoutPaymentError_module_scss__WEBPACK_IMPORTED_MODULE_17___default().content),
        id: "error-note",
        children: noteText
      }) : null, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__.CustomContainer, {
        className: (_CheckoutPaymentError_module_scss__WEBPACK_IMPORTED_MODULE_17___default()["button-wrapper"]),
        children: [retryCount < 2 && !technicalError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_7__["default"], {
          className: (_CheckoutPaymentError_module_scss__WEBPACK_IMPORTED_MODULE_17___default()["try-btn"]),
          handleClick: handleRetry,
          variant: retryBtnConfig.buttonStyle,
          id: "".concat(retryBtnConfig.buttonLabel, "-btn"),
          children: retryBtnConfig.buttonLabel
        }), retryCount === 2 && !technicalError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_7__["default"], {
          className: (_CheckoutPaymentError_module_scss__WEBPACK_IMPORTED_MODULE_17___default()["exit-btn"]),
          handleClick: handleExitCheckout,
          variant: exitBtnConfig.buttonStyle,
          id: "".concat(exitBtnConfig.buttonLabel, "-btn"),
          children: userLoggedIn ? _config_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lbl_go_to_order_page_btn */ .Z.lbl_go_to_order_page_btn : exitBtnConfig.buttonLabel
        }), technicalError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_7__["default"], {
          className: (_CheckoutPaymentError_module_scss__WEBPACK_IMPORTED_MODULE_17___default()["exit-btn"]),
          handleClick: handleExitCheckout,
          variant: exitBtnConfig.buttonStyle,
          children: exitBtnConfig.buttonLabel
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("form", {
        method: "post",
        name: "ucfCheckout",
        id: "ucfCheckout",
        action: paymentOptionsEnabled && paymentUrl ? paymentUrl : paymentConfig.paymentGatewayUrl,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "PayserverUser",
          id: "PayserverUser",
          value: paymentConfig.payServerUser
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "transactionStatusCallbackUrl",
          id: "transactionStatusCallbackUrl",
          value: paymentConfig.transactionStatusCallbackUrl
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "transactionCompletedUrl",
          id: "transactionCompletedUrl",
          value: paymentCallbackUrl
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "redirectURL",
          id: "redirectURL",
          value: paymentCallbackUrl
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "failureURL",
          id: "failureURL",
          value: paymentCallbackUrl
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "TransactionStatusCallbackFormat",
          id: "TransactionStatusCallbackFormat",
          value: paymentConfig.transactionStatusCallbackFormat
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "TransactionStatusCallbackMethod",
          id: "TransactionStatusCallbackMethod",
          value: paymentConfig.transactionStatusCallbackMethod
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "MerchantReference",
          id: "MerchantReference",
          value: postOrderData === null || postOrderData === void 0 ? void 0 : postOrderData.productOrderId
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "Currency",
          id: "Currency",
          value: paymentConfig.currency
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "TransactionType",
          id: "TransactionType",
          value: paymentConfig.transactionType
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "MerchantIdentifier",
          id: "MerchantIdentifier",
          value: paymentConfig.merchantIdentifier
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "CustomerIdentifier",
          id: "CustomerIdentifier",
          value: customerIdentifier
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "EncXML",
          id: "EncXML",
          value: postOrderData === null || postOrderData === void 0 ? void 0 : (_postOrderData$paymen = postOrderData.payment) === null || _postOrderData$paymen === void 0 ? void 0 : _postOrderData$paymen.encryptedPaymentDetails
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
          type: "hidden",
          name: "EncType",
          id: "EncType",
          value: paymentConfig.encType
        })]
      })]
    })
  });
});
var mapDispatchToProps = {
  setNormalCheckoutCurrentStep: _Redux_actions_checkoutAction__WEBPACK_IMPORTED_MODULE_13__/* .setNormalCheckoutCurrentStep */ .Z9,
  setPostCheckoutCurrentStep: _Redux_actions_checkoutAction__WEBPACK_IMPORTED_MODULE_13__/* .setPostCheckoutCurrentStep */ .Gr,
  removeCreditCheckStates: _Redux_actions_checkoutAction__WEBPACK_IMPORTED_MODULE_13__/* .removeCreditCheckStates */ .nK,
  setPaymentMethodUrl: _Redux_actions_checkoutAction__WEBPACK_IMPORTED_MODULE_13__/* .setPaymentMethodUrl */ .RL,
  setPostOrderResponse: _Redux_actions_checkoutAction__WEBPACK_IMPORTED_MODULE_13__/* .setPostOrderResponse */ .wg
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_6__.connect)(null, mapDispatchToProps)(CheckoutPaymentError));

/***/ }),

/***/ 38983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkoutReview_CheckoutReview; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/formHeading/FormHeading.jsx
var FormHeading = __webpack_require__(81083);
// EXTERNAL MODULE: ./components/molecules/reviewOrder/formInlineDetails/FormInlineDetails.module.scss
var FormInlineDetails_module = __webpack_require__(94603);
var FormInlineDetails_module_default = /*#__PURE__*/__webpack_require__.n(FormInlineDetails_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/reviewOrder/formInlineDetails/FormInlineDetails.jsx






var FormInlineDetails = function FormInlineDetails(_ref) {
  var className = _ref.className,
      title = _ref.title,
      value = _ref.value,
      subvalue = _ref.subvalue,
      type = _ref.type,
      applicationType = _ref.applicationType,
      handleOnEdit = _ref.handleOnEdit;

  function contentValue(val) {
    if (val && val !== "") {
      if (Array.isArray(val) && val.length > 0) {
        return val.join(", ");
      } else {
        return val;
      }
    } else {
      return "None";
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat(className, " ").concat((FormInlineDetails_module_default())["inline-details"]),
      children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FormInlineDetails_module_default()).title,
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (FormInlineDetails_module_default()).value,
        children: [value !== "" ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (FormInlineDetails_module_default()).value__first,
          children: contentValue(value)
        }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (FormInlineDetails_module_default()).value__second,
          children: subvalue ? contentValue(subvalue) : "None"
        }), applicationType == "normal" ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (FormInlineDetails_module_default()).value__change,
          id: "".concat(title, "-changes"),
          onClick: function onClick(event) {
            handleOnEdit(type);
          },
          children: type == "instructions" && value == "" ? "Add Instructions" : "Change"
        }) : null]
      })]
    })
  });
};

FormInlineDetails.defaultProps = {
  type: "delivery",
  applicationType: "normal"
};
/* harmony default export */ var formInlineDetails_FormInlineDetails = (FormInlineDetails);
// EXTERNAL MODULE: ./components/molecules/modals/checkoutFormsModal/CheckoutFormsModal.jsx + 1 modules
var CheckoutFormsModal = __webpack_require__(23060);
// EXTERNAL MODULE: ./components/molecules/reviewOrder/deliveryDetails/DeliveryDetails.module.scss
var DeliveryDetails_module = __webpack_require__(61769);
var DeliveryDetails_module_default = /*#__PURE__*/__webpack_require__.n(DeliveryDetails_module);
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
;// CONCATENATED MODULE: ./components/molecules/reviewOrder/deliveryDetails/DeliveryDetails.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var DeliveryDetails = function DeliveryDetails(_ref) {
  var _shippingAddress$regi, _shippingAddress$regi2;

  var addressTypes = _ref.addressTypes,
      statesTypes = _ref.statesTypes,
      countryCode = _ref.countryCode,
      countryName = _ref.countryName,
      shippingAddress = _ref.shippingAddress,
      cartId = _ref.cartId,
      className = _ref.className,
      customerStatus = _ref.customerStatus,
      userLoggedIn = _ref.userLoggedIn,
      applicationType = _ref.applicationType;

  var _useState = (0,react.useState)("delivery"),
      modalType = _useState[0],
      setModalType = _useState[1];

  var _useState2 = (0,react.useState)(false),
      modalShow = _useState2[0],
      setModalShow = _useState2[1];

  var dispatch = (0,DependencyHelper.useDispatch)();

  var createStreetString = function createStreetString(arr) {
    var res = "";

    if (arr && Array.isArray(arr) && arr.length > 0) {
      res = arr.join(", ");
    }

    return res;
  };

  var unitValue = shippingAddress && shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.unit_number && (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.unit_number) !== "" && shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.complex_name && (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.complex_name) !== "" ? shippingAddress.unit_number + " " + shippingAddress.complex_name + ", " : shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.unit_number && (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.unit_number) !== "" ? shippingAddress.unit_number + ", " : shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.complex_name && (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.complex_name) !== "" ? shippingAddress.complex_name + ", " : "";
  var streetValue = shippingAddress && shippingAddress.street_number && shippingAddress.street_number != "" && shippingAddress.street ? shippingAddress.street_number + ", " + createStreetString(shippingAddress.street) + ", " : shippingAddress && shippingAddress.street_number && shippingAddress.street_number != "" ? shippingAddress.street_number + ", " : shippingAddress && shippingAddress.street ? createStreetString(shippingAddress.street) + ", " : "";
  var suburbValue = shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.suburb && (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.suburb) !== "" ? shippingAddress.suburb + ", " : "";
  var townValue = shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.town && (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.town) !== "" ? shippingAddress.town + ", " : "";
  var provinceValue = shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.region && shippingAddress !== null && shippingAddress !== void 0 && (_shippingAddress$regi = shippingAddress.region) !== null && _shippingAddress$regi !== void 0 && _shippingAddress$regi.label ? (shippingAddress === null || shippingAddress === void 0 ? void 0 : (_shippingAddress$regi2 = shippingAddress.region) === null || _shippingAddress$regi2 === void 0 ? void 0 : _shippingAddress$regi2.label) + ", " : "";
  var postalValue = shippingAddress !== null && shippingAddress !== void 0 && shippingAddress.postcode && (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.postcode) !== "" ? shippingAddress.postcode : "";
  var deliveryData = {
    value: shippingAddress && shippingAddress.address_name ? shippingAddress.address_name : "",
    subvalue: unitValue + streetValue + suburbValue + townValue + provinceValue + postalValue
  };
  var contactDetailsData = {
    value: applicationType == "normal" && shippingAddress && shippingAddress.firstname && shippingAddress.lastname ? shippingAddress.firstname + " " + (0,helperServices/* getUpdatedSurname */.we)(shippingAddress.lastname) : "",
    subvalue: shippingAddress && shippingAddress.telephone ? shippingAddress.telephone : ""
  };
  var instructionsData = {
    value: shippingAddress && shippingAddress.instructions ? shippingAddress.instructions : ""
  };

  var getDeliveryType = function getDeliveryType(type) {
    switch (type) {
      case "delivery":
        return "delivery address";

      case "contactDetails":
        return "contact person";

      default:
        return type;
    }
  };

  var showModal = function showModal(type) {
    setModalType(type);
    setModalShow(true);
    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS()), {}, {
      page_form_event: "start",
      page_form_name: "checkout: review order: ".concat(customerStatus, ": change ").concat(getDeliveryType(type))
    }));
  };

  var hideModal = function hideModal(refresh, results) {
    setModalShow(false);

    if (refresh == true) {
      dispatch({
        type: actionTypes/* SET_SHIPPING */.sm,
        payload: results
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((DeliveryDetails_module_default())["main-details"], " ").concat(className),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(formInlineDetails_FormInlineDetails, {
        className: "".concat((DeliveryDetails_module_default())["inline-details"]),
        type: "delivery",
        applicationType: applicationType,
        title: "Delivery address:",
        value: deliveryData.value,
        subvalue: deliveryData.subvalue,
        handleOnEdit: showModal
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(formInlineDetails_FormInlineDetails, {
        className: "".concat((DeliveryDetails_module_default())["inline-details"]),
        type: "contactDetails",
        applicationType: applicationType,
        title: applicationType == "normal" ? "Contact person for delivery:" : "Contact number for delivery:",
        value: contactDetailsData.value,
        subvalue: contactDetailsData.subvalue,
        handleOnEdit: showModal
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutFormsModal/* default */.Z, {
      show: modalShow,
      hide: hideModal,
      formType: modalType,
      variant: "change",
      values: shippingAddress,
      addressTypes: addressTypes,
      statesTypes: statesTypes,
      countryCode: countryCode,
      countryName: countryName,
      cartId: cartId,
      step: "review",
      pageName: "checkout: review order: ".concat(customerStatus),
      isGuestUser: userLoggedIn ? false : true,
      applicationType: applicationType
    })]
  });
};

DeliveryDetails.defaultProps = {
  addressTypes: [],
  statesTypes: [],
  applicationType: "normal"
};
/* harmony default export */ var deliveryDetails_DeliveryDetails = (DeliveryDetails);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/termsCheckbox/TermsCheckbox.jsx
var TermsCheckbox = __webpack_require__(10626);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./components/atoms/label/LabelText.jsx
var LabelText = __webpack_require__(38975);
// EXTERNAL MODULE: ./services/labelBackgroundService.js
var labelBackgroundService = __webpack_require__(24795);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./components/atoms/buttons/buttonWithIcon/ButtonWithIcon.jsx
var ButtonWithIcon = __webpack_require__(30390);
// EXTERNAL MODULE: ./components/molecules/cartProductOptions/CartProductOptions.jsx
var CartProductOptions = __webpack_require__(91710);
// EXTERNAL MODULE: ./components/molecules/changeLabel/ChangeLabelWithOutOfStock.jsx
var ChangeLabelWithOutOfStock = __webpack_require__(61492);
// EXTERNAL MODULE: ./components/molecules/iconWithText/IconWithText.jsx
var IconWithText = __webpack_require__(83318);
// EXTERNAL MODULE: ./components/atoms/stepCounter/StepCounter.jsx
var StepCounter = __webpack_require__(67433);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./config/queries.js
var queries = __webpack_require__(91250);
// EXTERNAL MODULE: ./services/dealService.js
var dealService = __webpack_require__(38126);
// EXTERNAL MODULE: ./components/atoms/confirmModal/ConfirmModal.jsx
var ConfirmModal = __webpack_require__(74183);
// EXTERNAL MODULE: ./Redux/actions/cartAction.js
var cartAction = __webpack_require__(35311);
// EXTERNAL MODULE: ./components/molecules/reviewOrder/inlineItem/InlineItem.module.scss
var InlineItem_module = __webpack_require__(49803);
var InlineItem_module_default = /*#__PURE__*/__webpack_require__.n(InlineItem_module);
;// CONCATENATED MODULE: ./components/molecules/reviewOrder/inlineItem/InlineItem.jsx



function InlineItem_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InlineItem_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InlineItem_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InlineItem_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
























var InlineItem = function InlineItem(_ref) {
  var _cartProduct$product, _cartProduct$config_c, _cartProduct$config_c2, _cartProduct$config_c3, _cartProduct$config_c4, _cartProduct$config_c5, _cartProduct$config_c6, _cartProduct$product3, _cartProduct$product4, _cartProduct$product5, _cartProduct$product9, _cartProduct$product10, _cartProduct$product11, _cartProduct$product34;

  var customerStatus = _ref.customerStatus,
      cartId = _ref.cartId,
      dealSku = _ref.dealSku,
      paymentTerms = _ref.paymentTerms,
      cartProduct = _ref.cartProduct,
      updateItemsofCart = _ref.updateItemsofCart,
      displaySnackBar = _ref.displaySnackBar,
      deleteItemsFromCheckout = _ref.deleteItemsFromCheckout;
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() < 768;
  var isMobile = (0,helperServices/* componentResize */.Y4)();
  var selectedQuantity = cartProduct.quantity;

  var _useState = (0,react.useState)(false),
      showModal = _useState[0],
      setShowModal = _useState[1];

  var _useState2 = (0,react.useState)(false),
      modalShow = _useState2[0],
      setModalShow = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showConfirmModal = _useState3[0],
      setShowConfirmModal = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      confirmModalContent = _useState4[0],
      setConfirmModalContent = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      updatedOptionsAttributes = _useState5[0],
      setUpdatedOptionsAttributes = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      optionsAttributes = _useState6[0],
      setOptionsAttributes = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      updatePage = _useState7[0],
      setUpdatePage = _useState7[1];

  var _useState8 = (0,react.useState)([]),
      dealOptions = _useState8[0],
      setDealOptions = _useState8[1];

  var isDealProduct = (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product = cartProduct.product) === null || _cartProduct$product === void 0 ? void 0 : _cartProduct$product.is_deal_product) === 1 ? true : false;
  var isVASProduct = dealSku && (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.parent_product_sku) == dealSku ? true : false;
  var buyOptionId = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$config_c = cartProduct.config_custom_options) === null || _cartProduct$config_c === void 0 ? void 0 : (_cartProduct$config_c2 = _cartProduct$config_c[0]) === null || _cartProduct$config_c2 === void 0 ? void 0 : _cartProduct$config_c2.id;
  var buyOptionTypeId = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$config_c3 = cartProduct.config_custom_options) === null || _cartProduct$config_c3 === void 0 ? void 0 : (_cartProduct$config_c4 = _cartProduct$config_c3[0]) === null || _cartProduct$config_c4 === void 0 ? void 0 : (_cartProduct$config_c5 = _cartProduct$config_c4.values) === null || _cartProduct$config_c5 === void 0 ? void 0 : (_cartProduct$config_c6 = _cartProduct$config_c5[0]) === null || _cartProduct$config_c6 === void 0 ? void 0 : _cartProduct$config_c6.value;
  var customizable_options = buyOptionId && buyOptionTypeId ? [{
    id: buyOptionId,
    value_string: buyOptionTypeId === null || buyOptionTypeId === void 0 ? void 0 : buyOptionTypeId.toString()
  }] : [];
  (0,react.useEffect)(function () {
    if (isDealProduct) {
      var fetchData = /*#__PURE__*/function () {
        var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
          var _cartProduct$product2, _result$products, _result$products2, _result$products3, _result$products4, result, _result$products5, _result$products6, _items$, _config$find, _config$find$configur, config, items, attributeCode, attributeVals, updatedLabels, dealArray, _iterator, _step, attr, _iterator2, _step2, label;

          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(queries/* getAttributes */.u9, {
                    sku: cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product2 = cartProduct.product) === null || _cartProduct$product2 === void 0 ? void 0 : _cartProduct$product2.primary_product_sku
                  });

                case 3:
                  result = _context.sent;

                  if (Array.isArray(result === null || result === void 0 ? void 0 : (_result$products = result.products) === null || _result$products === void 0 ? void 0 : _result$products.items) && Array.isArray(result === null || result === void 0 ? void 0 : (_result$products2 = result.products) === null || _result$products2 === void 0 ? void 0 : _result$products2.attribute_set_config) && (result === null || result === void 0 ? void 0 : (_result$products3 = result.products) === null || _result$products3 === void 0 ? void 0 : _result$products3.items.length) > 0 && (result === null || result === void 0 ? void 0 : (_result$products4 = result.products) === null || _result$products4 === void 0 ? void 0 : _result$products4.attribute_set_config.length) > 0) {
                    config = result === null || result === void 0 ? void 0 : (_result$products5 = result.products) === null || _result$products5 === void 0 ? void 0 : _result$products5.attribute_set_config;
                    items = (result === null || result === void 0 ? void 0 : (_result$products6 = result.products) === null || _result$products6 === void 0 ? void 0 : _result$products6.items) || [];
                    attributeCode = (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.attribute_set_id;
                    attributeVals = config === null || config === void 0 ? void 0 : (_config$find = config.find(function (val) {
                      return val.attribute_set_id == attributeCode;
                    })) === null || _config$find === void 0 ? void 0 : (_config$find$configur = _config$find.configurable_product_attribute_set_attributes) === null || _config$find$configur === void 0 ? void 0 : _config$find$configur.split(",");
                    updatedLabels = attributeVals === null || attributeVals === void 0 ? void 0 : attributeVals.map(function (val) {
                      return "".concat(val, "_label");
                    });
                    dealArray = [];
                    _iterator = _createForOfIteratorHelper(items);

                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        attr = _step.value;
                        _iterator2 = _createForOfIteratorHelper(updatedLabels);

                        try {
                          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                            label = _step2.value;
                            dealArray.push(attr[label]);
                          }
                        } catch (err) {
                          _iterator2.e(err);
                        } finally {
                          _iterator2.f();
                        }
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }

                    setDealOptions(dealArray);
                  }

                  _context.next = 10;
                  break;

                case 7:
                  _context.prev = 7;
                  _context.t0 = _context["catch"](0);
                  console.error("Error fetching attributes for deal:", _context.t0);

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 7]]);
        }));

        return function fetchData() {
          return _ref2.apply(this, arguments);
        };
      }();

      fetchData();
    }
  }, []);

  var _ref3 = (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.product) || {},
      name = _ref3.name,
      __typename = _ref3.__typename,
      primary_product_name = _ref3.primary_product_name;

  var _ref4 = (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.prices) || {},
      row_total_including_tax = _ref4.row_total_including_tax,
      row_total_original = _ref4.row_total_original;

  var optList = [];

  if (__typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product3 = cartProduct.product) === null || _cartProduct$product3 === void 0 ? void 0 : _cartProduct$product3.variants) !== undefined && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product4 = cartProduct.product) === null || _cartProduct$product4 === void 0 ? void 0 : (_cartProduct$product5 = _cartProduct$product4.variants) === null || _cartProduct$product5 === void 0 ? void 0 : _cartProduct$product5.length) > 0) {
    var _cartProduct$product6;

    var optionsList = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product6 = cartProduct.product) === null || _cartProduct$product6 === void 0 ? void 0 : _cartProduct$product6.configurable_options.map(function (val) {
      var _ref5 = val || {},
          attribute_code = _ref5.attribute_code,
          attribute_id = _ref5.attribute_id;

      return {
        attribute_code: attribute_code,
        attribute_id: attribute_id
      };
    });
    optionsList.forEach(function (option) {
      var _cartProduct$product7, _cartProduct$product8;

      var optionVal = (0,helperServices/* options */.YM)(cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product7 = cartProduct.product) === null || _cartProduct$product7 === void 0 ? void 0 : _cartProduct$product7.configurable_options, option.attribute_code);
      optionVal = optionVal.map(function (opt) {
        var _ref6 = opt || {},
            label = _ref6.label,
            swatch_data = _ref6.swatch_data,
            value_index = _ref6.value_index;

        return {
          label: label,
          swatch_data: swatch_data,
          value_index: value_index,
          attribute_id: option.attribute_id
        };
      });
      var variantsProducts = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product8 = cartProduct.product) === null || _cartProduct$product8 === void 0 ? void 0 : _cartProduct$product8.variants;
      var inStockOptionList = [];

      var _iterator3 = _createForOfIteratorHelper(optionVal),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var oVal = _step3.value;

          var _iterator4 = _createForOfIteratorHelper(variantsProducts),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var variant = _step4.value;

              var _iterator5 = _createForOfIteratorHelper(variant.attributes),
                  _step5;

              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var attr = _step5.value;

                  if (oVal.label === attr.label && (variant.product.stock_status === labels/* default.lbl_in_stock */.Z.lbl_in_stock || variant.product.quantity > 0)) {
                    inStockOptionList.push(oVal);
                  }
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var uniqueinStockOptionList = inStockOptionList.filter(function (item, index) {
        return inStockOptionList.indexOf(item) === index;
      });
      var optionObj = {};
      optionObj[option.attribute_code] = uniqueinStockOptionList;
      optList.push(optionObj);
    });
  }

  var regularPrice, regularPriceString, finalPrice, finalPriceString, selectedVariant, small_image, promoTag, promoForDeal, nonPromoArray, vasDescription;
  var optionObj = {};

  if (__typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product9 = cartProduct.product) === null || _cartProduct$product9 === void 0 ? void 0 : _cartProduct$product9.variants) !== undefined && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product10 = cartProduct.product) === null || _cartProduct$product10 === void 0 ? void 0 : (_cartProduct$product11 = _cartProduct$product10.variants) === null || _cartProduct$product11 === void 0 ? void 0 : _cartProduct$product11.length) > 0) {
    var _cartProduct$product13, _selectedVariant, _selectedVariant$prod, _selectedVariant$prod2, _selectedVariant2, _selectedVariant2$pro;

    var getLabel = function getLabel(label) {
      var _cartProduct$product12;

      var headingObj = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product12 = cartProduct.product) === null || _cartProduct$product12 === void 0 ? void 0 : _cartProduct$product12.configurable_options.find(function (config) {
        return config.attribute_code === label[0];
      });
      return headingObj === null || headingObj === void 0 ? void 0 : headingObj.label;
    };

    optList.forEach(function (obj) {
      cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.configurable_options.forEach(function (addedOption) {
        if (getLabel(Object.keys(obj)) === addedOption.option_label) {
          optionObj[Object.keys(obj)] = addedOption.value_label;
        }
      });
    });
    selectedVariant = (0,helperServices/* getSelectedVariant */.c)(cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product13 = cartProduct.product) === null || _cartProduct$product13 === void 0 ? void 0 : _cartProduct$product13.variants, optionObj);
    small_image = (_selectedVariant = selectedVariant) === null || _selectedVariant === void 0 ? void 0 : (_selectedVariant$prod = _selectedVariant.product) === null || _selectedVariant$prod === void 0 ? void 0 : (_selectedVariant$prod2 = _selectedVariant$prod.small_image) === null || _selectedVariant$prod2 === void 0 ? void 0 : _selectedVariant$prod2.url;
    promoTag = (_selectedVariant2 = selectedVariant) === null || _selectedVariant2 === void 0 ? void 0 : (_selectedVariant2$pro = _selectedVariant2.product) === null || _selectedVariant2$pro === void 0 ? void 0 : _selectedVariant2$pro.promotion_tag_label;
  } else {
    var _cartProduct$product14, _cartProduct$product15, _cartProduct$product16;

    small_image = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product14 = cartProduct.product) === null || _cartProduct$product14 === void 0 ? void 0 : (_cartProduct$product15 = _cartProduct$product14.small_image) === null || _cartProduct$product15 === void 0 ? void 0 : _cartProduct$product15.url;
    promoTag = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product16 = cartProduct.product) === null || _cartProduct$product16 === void 0 ? void 0 : _cartProduct$product16.promotion_tag_label;
  }

  if (isDealProduct || isVASProduct) {
    var _cartProduct$product17, _cartProduct$product18, _cartProduct$product19, _cartProduct$product20, _cartProduct$product21, _cartProduct$product22;

    finalPrice = isDealProduct ? cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product17 = cartProduct.product) === null || _cartProduct$product17 === void 0 ? void 0 : _cartProduct$product17.monthly_recurring : cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.monthly_recurring;
    regularPrice = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product18 = cartProduct.product) === null || _cartProduct$product18 === void 0 ? void 0 : _cartProduct$product18.old_monthly_recurring;
    finalPriceString = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(finalPrice), " \xD7 ").concat(cartProduct !== null && cartProduct !== void 0 && (_cartProduct$product19 = cartProduct.product) !== null && _cartProduct$product19 !== void 0 && _cartProduct$product19.payment_terms_label ? cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product20 = cartProduct.product) === null || _cartProduct$product20 === void 0 ? void 0 : _cartProduct$product20.payment_terms_label : paymentTerms);
    regularPriceString = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(regularPrice), " \xD7 ").concat(cartProduct !== null && cartProduct !== void 0 && (_cartProduct$product21 = cartProduct.product) !== null && _cartProduct$product21 !== void 0 && _cartProduct$product21.payment_terms_label ? cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product22 = cartProduct.product) === null || _cartProduct$product22 === void 0 ? void 0 : _cartProduct$product22.payment_terms_label : paymentTerms);

    if (isDealProduct) {
      var _cartProduct$product23, _cartProduct$product24, _cartProduct$product25, _cartProduct$product26;

      promoForDeal = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product23 = cartProduct.product) === null || _cartProduct$product23 === void 0 ? void 0 : (_cartProduct$product24 = _cartProduct$product23.items.find(function (deal) {
        return deal.title === "Promo";
      })) === null || _cartProduct$product24 === void 0 ? void 0 : (_cartProduct$product25 = _cartProduct$product24.options[0]) === null || _cartProduct$product25 === void 0 ? void 0 : _cartProduct$product25.label;
      var nonPromoValues = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product26 = cartProduct.product) === null || _cartProduct$product26 === void 0 ? void 0 : _cartProduct$product26.items.filter(function (deal) {
        return deal.title !== "Promo" && deal.title !== "Smartphones";
      });
      nonPromoArray = nonPromoValues.map(function (nPmv) {
        return nPmv.options.reduce(function (productAcc, prod) {
          if ((prod === null || prod === void 0 ? void 0 : prod.is_hidden_product) === "0") {
            productAcc.push(prod.label);
          }

          return productAcc;
        }, []);
      }).flat();
    }

    if (isVASProduct) {
      var _cartProduct$product27, _cartProduct$product28, _cartProduct$product29, _cartProduct$product30;

      var categories = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product27 = cartProduct.product) === null || _cartProduct$product27 === void 0 ? void 0 : _cartProduct$product27.categories.sort(function (a, b) {
        return b.level - a.level;
      })[0];
      vasDescription = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product28 = cartProduct.product) === null || _cartProduct$product28 === void 0 ? void 0 : _cartProduct$product28.description;

      if (cartProduct !== null && cartProduct !== void 0 && (_cartProduct$product29 = cartProduct.product) !== null && _cartProduct$product29 !== void 0 && _cartProduct$product29.image.url.match("No_image") || (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product30 = cartProduct.product) === null || _cartProduct$product30 === void 0 ? void 0 : _cartProduct$product30.image.url) == null) {
        small_image = categories === null || categories === void 0 ? void 0 : categories.image;
      } else {
        var _cartProduct$product31;

        small_image = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product31 = cartProduct.product) === null || _cartProduct$product31 === void 0 ? void 0 : _cartProduct$product31.image.url;
      }
    } else {
      var _cartProduct$product32;

      small_image = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product32 = cartProduct.product) === null || _cartProduct$product32 === void 0 ? void 0 : _cartProduct$product32.primary_product_image;
    }
  } else {
    finalPrice = row_total_including_tax === null || row_total_including_tax === void 0 ? void 0 : row_total_including_tax.value;
    regularPrice = row_total_original === null || row_total_original === void 0 ? void 0 : row_total_original.value;
    finalPriceString = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(finalPrice));
    regularPriceString = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(regularPrice));
  }

  (0,react.useEffect)(function () {
    var _cartProduct$configur;

    if ((cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$configur = cartProduct.configurable_options) === null || _cartProduct$configur === void 0 ? void 0 : _cartProduct$configur.length) > 0) {
      var options_attr = [];
      cartProduct.configurable_options.forEach(function (val) {
        options_attr.push({
          id: val === null || val === void 0 ? void 0 : val.id,
          value_string: val === null || val === void 0 ? void 0 : val.value_id
        });
      });

      if (options_attr.length > 0) {
        setOptionsAttributes(options_attr);
      }
    }
  }, [cartProduct]);

  var removeProductFromCart = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _result$removeItemFro;

      var result, _cartProduct$product33;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              _context2.next = 3;
              return deleteItemsFromCheckout(cartId, cartProduct.id);

            case 3:
              result = _context2.sent;
              (0,helperServices/* hideSpinner */.v3)();

              if (result !== null && result !== void 0 && (_result$removeItemFro = result.removeItemFromCart) !== null && _result$removeItemFro !== void 0 && _result$removeItemFro.cart) {
                setShowModal(false);
                displaySnackBar(true, name);
                analyticsUtag/* link */.p4(InlineItem_objectSpread(InlineItem_objectSpread({}, analyticsUtag/* getUtagData */.GS()), {}, {
                  link_type: "o",
                  page_tool_event: "use",
                  page_tool_name: "checkout: review order: ".concat(customerStatus, ": remove product"),
                  filter_query: cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product33 = cartProduct.product) === null || _cartProduct$product33 === void 0 ? void 0 : _cartProduct$product33.name
                }));
              }

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function removeProductFromCart() {
      return _ref7.apply(this, arguments);
    };
  }();

  var promotionLabelColor = (0,labelBackgroundService/* LabelConfiguration */.v)(promoTag ? promoTag : "");

  var showOptions = function showOptions() {
    setShowModal(true);
  };

  var closeOptions = function closeOptions(type) {
    var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var optionsAttr = arguments.length > 2 ? arguments[2] : undefined;
    setShowModal(false);

    if (type && type == "confirmModal") {
      setUpdatedOptionsAttributes(optionsAttr);
      displayConfirmModel(content);
    }
  };

  var renderChangeLable = function renderChangeLable() {
    setModalShow(true);
  };

  var closeChangeable = function closeChangeable() {
    setModalShow(false);
  };

  var unAvailable = (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product34 = cartProduct.product) === null || _cartProduct$product34 === void 0 ? void 0 : _cartProduct$product34.stock_status) === labels/* default.lbl_out_of_stock */.Z.lbl_out_of_stock;

  var stepIncrement = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var qty;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              qty = (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.quantity) + 1;
              _context3.next = 4;
              return updateItemsofCart(cartId, cartProduct.id, qty, optionsAttributes, customizable_options);

            case 4:
              (0,helperServices/* hideSpinner */.v3)();

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function stepIncrement() {
      return _ref8.apply(this, arguments);
    };
  }();

  var stepDecrement = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      var qty;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();

              if (!((cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.quantity) > 1)) {
                _context4.next = 5;
                break;
              }

              qty = (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.quantity) - 1;
              _context4.next = 5;
              return updateItemsofCart(cartId, cartProduct.id, qty, optionsAttributes, customizable_options);

            case 5:
              (0,helperServices/* hideSpinner */.v3)();

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function stepDecrement() {
      return _ref9.apply(this, arguments);
    };
  }();

  var PriceComponent = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!isDealProduct && !isVASProduct && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (InlineItem_module_default())["qty-wrapper"],
      id: "".concat(selectedQuantity, "-qty-parent-inlineitem"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          top: 0
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StepCounter/* default */.Z, {
          id: cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.id,
          value: cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.quantity,
          stepDecrement: stepDecrement,
          stepIncrement: stepIncrement
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (InlineItem_module_default())["price-wrapper"],
      children: unAvailable ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (InlineItem_module_default())["info-text"],
        children: "Currently Unavailable"
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [finalPrice !== regularPrice && regularPrice && /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (InlineItem_module_default()).discount,
          id: "regular-price-inlineitem",
          children: regularPriceString
        }), finalPrice && /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (InlineItem_module_default()).price,
          id: "final-price-inlineitem",
          children: finalPriceString
        })]
      })
    })]
  });

  var optionValues = optionObj && Object.values(optionObj);

  var RenderProductComponent = function RenderProductComponent() {
    if (isDealProduct) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (InlineItem_module_default()).cart,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (InlineItem_module_default())["cart-product"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RenderProductInfo, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderPrice, {})]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderDealInfo, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderPrmoTagAndButton, {})]
      });
    } else {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (InlineItem_module_default()).cart,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (InlineItem_module_default())["cart-product"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RenderProductInfo, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderPrice, {})]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderPrmoTagAndButton, {})]
      });
    }
  };

  var RenderProductInfo = function RenderProductInfo() {
    if (isDealProduct || isVASProduct) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (InlineItem_module_default())["cart-product__info"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: small_image,
          className: !isVASProduct ? (InlineItem_module_default())["product-image"] : (InlineItem_module_default())["vas-product-image"],
          alt: "image"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (InlineItem_module_default()).specs,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: (InlineItem_module_default()).label,
            children: isDealProduct ? primary_product_name : name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderSelectedSpecs, {}), promoTag && isTablet && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (InlineItem_module_default()).tag,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (InlineItem_module_default()).tag__icon,
              children: "\xA0"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (InlineItem_module_default()).tag__label,
              style: {
                color: promotionLabelColor
              },
              children: promoTag
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            children: isVASProduct && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (InlineItem_module_default())["vas-desc"],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                  className: (InlineItem_module_default())["vas-desc--text"],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(vasDescription.html)
                  })
                })
              })
            })
          })]
        }), isMobile && isVASProduct && /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/menu-dots.svg"),
          img_width: "20px",
          img_height: "20px",
          className: (InlineItem_module_default())["cart-product--price-container"],
          onClick: showOptions,
          id: "".concat(cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.id, "-options")
        })]
      });
    } else {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (InlineItem_module_default())["cart-product__info"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: small_image,
          className: (InlineItem_module_default())["product-image"],
          alt: "image"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (InlineItem_module_default()).specs,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: (InlineItem_module_default()).label,
            children: name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderSelectedSpecs, {})]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/menu-dots.svg"),
          img_width: "1.25rem",
          img_height: "1.25rem",
          className: (InlineItem_module_default()).dots,
          onClick: showOptions,
          id: "three-dots-changing"
        })]
      });
    }
  };

  var RenderSelectedSpecs = function RenderSelectedSpecs() {
    var _cartProduct$colorSel, _cartProduct$colorSel2;

    var colorSelection = cartProduct !== null && cartProduct !== void 0 && (_cartProduct$colorSel = cartProduct.colorSelection) !== null && _cartProduct$colorSel !== void 0 && _cartProduct$colorSel.label ? /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      children: [" | ", cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$colorSel2 = cartProduct.colorSelection) === null || _cartProduct$colorSel2 === void 0 ? void 0 : _cartProduct$colorSel2.label, " "]
    }) : null;

    if (__typename !== labels/* default.lbl_product_typeName_simple */.Z.lbl_product_typeName_simple) {
      var op = optionValues && optionValues.length > 0 || dealOptions && dealOptions.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (InlineItem_module_default()).value,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          id: "storage-value",
          children: optionValues && optionValues[0] || dealOptions && dealOptions[0]
        }), optionValues && optionValues.length > 1 || dealOptions && dealOptions.length > 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (InlineItem_module_default())["line-separator"],
          children: "|"
        }) : null]
      }) : null;
      var op1 = optionValues && optionValues.length > 1 || dealOptions && dealOptions.length > 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        className: (InlineItem_module_default()).value,
        id: "color-value",
        children: optionValues[1] || dealOptions[1]
      }) : null;
      var ch = __typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable ? /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        className: (InlineItem_module_default()).change,
        onClick: renderChangeLable,
        children: "Change"
      }) : null;

      if (op || op1 | ch) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (InlineItem_module_default())["display-specs"],
          children: [op, op1, colorSelection, ch]
        });
      }
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: colorSelection
    });
  };

  var RenderPrice = function RenderPrice() {
    if (isDealProduct && !isTablet || !isDealProduct) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (InlineItem_module_default())["cart-product__price"],
        children: PriceComponent
      });
    }

    return null;
  };

  var RenderDealInfo = function RenderDealInfo() {
    var _nonPromoArray;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (InlineItem_module_default())["deal-product"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
        className: (InlineItem_module_default())["deal-promo"],
        children: [labels/* default.deal_details.lbl_on_a */.Z.deal_details.lbl_on_a, " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: promoForDeal
        }), " " + labels/* default.deal_details.lbl_with */.Z.deal_details.lbl_with]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (InlineItem_module_default())["deal-highlight"],
        children: (0,dealService/* getHighlights */._)(cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.product).map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(IconWithText/* default */.Z, {
            icon: item.icon,
            value: item.value,
            description: item.displayUnit,
            valueStyle: (InlineItem_module_default())["deal-highlight__value"],
            typeStyle: (InlineItem_module_default())["deal-highlight__type"],
            imageClass: (InlineItem_module_default())["deal-highlight__icon"],
            descriptionStyle: (InlineItem_module_default())["deal-highlight__description"]
          }, item.value);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (InlineItem_module_default())["additional-item"],
        id: "additional-item",
        children: (_nonPromoArray = nonPromoArray) === null || _nonPromoArray === void 0 ? void 0 : _nonPromoArray.map(function (value) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(IconWithText/* default */.Z, {
            icon: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/add-copy.svg"),
            value: value,
            imageClass: (InlineItem_module_default()).img,
            valueStyle: (InlineItem_module_default()).value,
            className: (InlineItem_module_default())["icon-text"],
            descriptionStyle: (InlineItem_module_default()).description
          }, value);
        })
      }), isTablet && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (InlineItem_module_default())["cart-product__price"],
        children: PriceComponent
      })]
    });
  };

  var RenderPrmoTagAndButton = function RenderPrmoTagAndButton() {
    if (isDealProduct) {
      if (promoTag) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((InlineItem_module_default())["cart-product__buttons"], " ").concat((InlineItem_module_default())["deal-buttons"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "".concat((InlineItem_module_default()).collapse),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: (InlineItem_module_default()).promotion,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (InlineItem_module_default()).icon,
                children: "\xA0"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
                className: (InlineItem_module_default())["main-label"],
                children: [labels/* default.lbl_promotion */.Z.lbl_promotion, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (InlineItem_module_default())["sub-label"],
                  style: {
                    color: promotionLabelColor
                  },
                  children: promoTag
                })]
              })]
            })
          })
        });
      }

      return null;
    } else {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (InlineItem_module_default())["cart-product__buttons"],
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: "".concat((InlineItem_module_default()).collapse),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (InlineItem_module_default()).promotion,
            children: promoTag && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (InlineItem_module_default()).icon,
                children: "\xA0"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
                className: (InlineItem_module_default())["main-label"],
                children: [labels/* default.lbl_promotion */.Z.lbl_promotion, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (InlineItem_module_default())["sub-label"],
                  style: {
                    color: promotionLabelColor
                  },
                  children: promoTag
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (InlineItem_module_default()).trash,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWithIcon/* default */.Z, {
              labelText: labels/* default.lbl_remove */.Z.lbl_remove,
              img_url_inactive: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-trash-inactive.svg"),
              img_url_active: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-trash-active.svg"),
              img_width: 18,
              img_height: 18,
              clickHandler: removeProductFromCart,
              className: (InlineItem_module_default()).btnIcon
            })
          })]
        })
      });
    }
  };

  var displayConfirmModel = function displayConfirmModel(content) {
    setConfirmModalContent(content);
    setShowConfirmModal(true);
  };

  var cancelConfirmModel = function cancelConfirmModel() {
    setShowConfirmModal(false);
    resetConfirmModalContent();
  };

  var approveConfirmModel = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setShowConfirmModal(false);
              (0,helperServices/* showSpinner */.yh)();
              _context5.next = 4;
              return updateItemsofCart(cartId, cartProduct.id, selectedQuantity, updatedOptionsAttributes, customizable_options);

            case 4:
              (0,helperServices/* hideSpinner */.v3)();
              resetConfirmModalContent();

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function approveConfirmModel() {
      return _ref10.apply(this, arguments);
    };
  }();

  var resetConfirmModalContent = function resetConfirmModalContent() {
    setConfirmModalContent("");
    setUpdatedOptionsAttributes([]);
  };

  var renderPage = function renderPage() {
    setUpdatePage(true);
  };

  (0,react.useEffect)(function () {
    setUpdatePage(false);
  }, [updatePage]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [__typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable && /*#__PURE__*/(0,jsx_runtime.jsx)(ChangeLabelWithOutOfStock/* default */.Z, {
      renderPage: renderPage,
      selectedOptions: optionObj,
      optList: optList,
      variant: "review",
      show: modalShow,
      centered: true,
      onHide: closeChangeable,
      closeChangeable: closeChangeable,
      configProduct: __typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable ? cartProduct : null,
      originalPrice: finalPrice,
      customerStatus: customerStatus,
      buyOptionId: buyOptionId,
      buyOptionTypeId: buyOptionTypeId
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderProductComponent, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal, {
      show: showModal,
      onHide: closeOptions,
      dialogClassName: "custom-dialog",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CartProductOptions/* default */.Z, {
        renderPage: renderPage,
        selectedOptions: optionObj,
        optList: optList,
        variant: "review",
        cartProduct: cartProduct,
        show: showModal,
        originalPrice: finalPrice,
        onHide: closeOptions,
        onSnack: displaySnackBar,
        promoTag: promoTag,
        displayConfirmModel: displayConfirmModel,
        removeCartProduct: removeProductFromCart,
        buyOptionId: buyOptionId,
        buyOptionTypeId: buyOptionTypeId
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConfirmModal/* default */.Z, {
      show: showConfirmModal,
      text: confirmModalContent,
      handleConfirm: approveConfirmModel,
      handleCancel: cancelConfirmModel
    })]
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    cartDetails: state.cartDetails
  };
};

/* harmony default export */ var inlineItem_InlineItem = ((0,DependencyHelper.connect)(mapStateToProps, {
  deleteItemsFromCheckout: cartAction/* deleteItemsFromCheckout */.$D,
  updateItemsofCart: cartAction/* updateItemsofCart */.iq
})(InlineItem));
// EXTERNAL MODULE: ./components/atoms/snackBar/SnackBar.jsx
var SnackBar = __webpack_require__(52932);
// EXTERNAL MODULE: ./components/molecules/reviewOrder/itemsDetails/ItemsDetails.module.scss
var ItemsDetails_module = __webpack_require__(41830);
var ItemsDetails_module_default = /*#__PURE__*/__webpack_require__.n(ItemsDetails_module);
;// CONCATENATED MODULE: ./components/molecules/reviewOrder/itemsDetails/ItemsDetails.jsx











var ItemsDetails = function ItemsDetails(_ref) {
  var _dealProduct$product, _dealProduct$product2;

  var customerStatus = _ref.customerStatus,
      cartId = _ref.cartId,
      cartProducts = _ref.cartProducts,
      className = _ref.className,
      itemLabel = _ref.itemLabel,
      priceLabel = _ref.priceLabel,
      price = _ref.price;

  var _useState = (0,react.useState)(null),
      cartProductName = _useState[0],
      setCartProductName = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showSnackBar = _useState2[0],
      setShowSnackBar = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isRemove = _useState3[0],
      setIsRemove = _useState3[1];

  var dealProduct = cartProducts.find(function (cartProduct) {
    var _cartProduct$product;

    return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product = cartProduct.product) === null || _cartProduct$product === void 0 ? void 0 : _cartProduct$product.is_deal_product) === 1;
  });
  var dealSku = dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product = dealProduct.product) === null || _dealProduct$product === void 0 ? void 0 : _dealProduct$product.sku;
  var paymentTerms = null;
  paymentTerms = dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product2 = dealProduct.product) === null || _dealProduct$product2 === void 0 ? void 0 : _dealProduct$product2.payment_terms_label;
  (0,react.useEffect)(function () {
    if (showSnackBar) {
      var timer = setTimeout(function () {
        return closeSnackBar();
      }, 3000);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [showSnackBar]);

  var displaySnackBar = function displaySnackBar(value, name) {
    setCartProductName(name);
    setShowSnackBar(true);
    setIsRemove(value);
  };

  var closeSnackBar = function closeSnackBar() {
    setCartProductName(null);
    setShowSnackBar(false);
    setIsRemove(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((ItemsDetails_module_default())["item-details"], " ").concat(className),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (ItemsDetails_module_default())["item-details__top"],
        id: "item-main-label-checkout-review",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
          className: "".concat((ItemsDetails_module_default())["total-item-label"]),
          children: itemLabel
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (ItemsDetails_module_default())["item-details__mid"],
        children: cartProducts.map(function (cartProduct) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(inlineItem_InlineItem, {
            customerStatus: customerStatus,
            cartId: cartId,
            dealSku: dealSku,
            paymentTerms: paymentTerms,
            cartProduct: cartProduct,
            displaySnackBar: displaySnackBar
          }, cartProduct.id);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (ItemsDetails_module_default())["item-details__bottom"],
        id: "total-due-amount-checkout-review",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
          className: (ItemsDetails_module_default())["total-price-label"],
          uniqueLabelId: "total-due-label-child",
          children: priceLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
          className: (ItemsDetails_module_default())["total-price"],
          uniqueLabelId: "total-price-label",
          children: price
        })]
      })]
    }), showSnackBar && /*#__PURE__*/(0,jsx_runtime.jsx)(SnackBar["default"], {
      message: isRemove ? "".concat(cartProductName, " ").concat(labels/* default.lbl_removed_from_cart */.Z.lbl_removed_from_cart) : labels/* default.lbl_updated_cart */.Z.lbl_updated_cart,
      className: (ItemsDetails_module_default())["snack-bar-styling"],
      closeSnackBar: closeSnackBar,
      isVisible: showSnackBar
    })]
  });
};

ItemsDetails.defaultProps = {
  cartProducts: []
};
/* harmony default export */ var itemsDetails_ItemsDetails = (ItemsDetails);
// EXTERNAL MODULE: ./components/atoms/infoBox/InfoBox.js
var InfoBox = __webpack_require__(91566);
// EXTERNAL MODULE: ./components/organisms/checkoutReview/CheckoutReview.module.scss
var CheckoutReview_module = __webpack_require__(88094);
var CheckoutReview_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutReview_module);
;// CONCATENATED MODULE: ./components/organisms/checkoutReview/ReviewItems.jsx










var ReviewItems = function ReviewItems(_ref) {
  var title = _ref.title,
      price = _ref.price,
      itemLabel = _ref.itemLabel,
      priceLabel = _ref.priceLabel,
      customerStatus = _ref.customerStatus,
      cartProducts = _ref.cartProducts,
      cartId = _ref.cartId,
      isDeal = _ref.isDeal,
      showOnceOff = _ref.showOnceOff;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: (CheckoutReview_module_default()).purchase,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
      title: title,
      className: (CheckoutReview_module_default())["top-wrapper"],
      headingClassName: (CheckoutReview_module_default())["top-wrapper__heading"]
    }), isDeal && showOnceOff ? /*#__PURE__*/(0,jsx_runtime.jsx)(InfoBox/* default */.Z, {
      type: "success",
      className: (CheckoutReview_module_default())["success-msg"],
      imageSrc: "".concat(imagePrefix, "/assets/images/success-circle-white.svg"),
      imageWidth: "1.3125rem",
      imageHeight: "1.3125rem",
      text: itemLabel === "Upgrade" ? labels/* default.lbl_success_auth */.Z.lbl_success_auth : labels/* default.lbl_success_approved */.Z.lbl_success_approved
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(itemsDetails_ItemsDetails, {
      customerStatus: customerStatus,
      cartProducts: cartProducts,
      cartId: cartId,
      className: (CheckoutReview_module_default()).section,
      itemLabel: itemLabel,
      price: price,
      priceLabel: priceLabel
    })]
  });
};

/* harmony default export */ var checkoutReview_ReviewItems = (ReviewItems);
// EXTERNAL MODULE: ./context/checkout-journey-context.js
var checkout_journey_context = __webpack_require__(62039);
// EXTERNAL MODULE: ./utils/miniAppUtil.js
var miniAppUtil = __webpack_require__(21909);
;// CONCATENATED MODULE: ./components/organisms/checkoutReview/CheckoutReview.jsx





function CheckoutReview_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CheckoutReview_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CheckoutReview_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CheckoutReview_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function CheckoutReview_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = CheckoutReview_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function CheckoutReview_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return CheckoutReview_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CheckoutReview_arrayLikeToArray(o, minLen); }

function CheckoutReview_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


















var CheckoutReview = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _helpTextData$, _dealProduct$product;

  var cartProducts = _ref.cartProducts,
      addressTypes = _ref.addressTypes,
      statesTypes = _ref.statesTypes,
      countryCode = _ref.countryCode,
      countryName = _ref.countryName,
      continueDisable = _ref.continueDisable,
      cartId = _ref.cartId,
      navigate = _ref.navigate,
      totalPrice = _ref.totalPrice,
      shippingAddress = _ref.shippingAddress,
      userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      customerStatus = _ref.customerStatus,
      applicationType = _ref.applicationType,
      currentJourneyType = _ref.currentJourneyType,
      deliveryDetails = _ref.deliveryDetails,
      authDetailsData = _ref.authDetailsData,
      upgradeResponse = _ref.upgradeResponse,
      cartDetails = _ref.cartDetails,
      creditVettingDetails = _ref.creditVettingDetails;
  var addressTypesOptions = addressTypes ? addressTypes : [];
  var stateTypesOptions = statesTypes ? statesTypes : [];

  var _useState = (0,react.useState)([]),
      helpTextData = _useState[0],
      setHelpText = _useState[1];

  var finalLabelTerms = (_helpTextData$ = helpTextData[0]) === null || _helpTextData$ === void 0 ? void 0 : _helpTextData$.helpText;

  var _useState2 = (0,react.useState)(false),
      viewAnalytics = _useState2[0],
      setViewAnalytics = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      productsFilter = _useState3[0],
      setProductsFilter = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      normalProducts = _useState4[0],
      setNormalProducts = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      dealProducts = _useState5[0],
      setDealProducts = _useState5[1];

  var _useState6 = (0,react.useState)("R".concat((0,helperServices/* formatNumbersWithComma */.G0)(0))),
      dealPrice = _useState6[0],
      setDealPrice = _useState6[1];

  var _useState7 = (0,react.useState)(true),
      showOnceOff = _useState7[0],
      setShowOnceOff = _useState7[1];

  var analyticsData = analyticsUtag/* getUtagData */.GS();
  var dealProduct = cartProducts.find(function (cartProduct) {
    var _cartProduct$product;

    return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product = cartProduct.product) === null || _cartProduct$product === void 0 ? void 0 : _cartProduct$product.is_deal_product) === 1;
  });
  var dealSku = dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product = dealProduct.product) === null || _dealProduct$product === void 0 ? void 0 : _dealProduct$product.sku;
  (0,react.useImperativeHandle)(ref, function () {
    return {
      submit: function submit() {
        analyticsUtag/* link */.p4({
          link_type: "o",
          link_name: "checkout: review order: ".concat(customerStatus, ": continue")
        });
        continueDisable(true);
      },
      back: function back() {
        if (applicationType == "normal") {
          analyticsUtag/* link */.p4({
            link_type: "o",
            link_name: "checkout: review order: ".concat(customerStatus, ": back to delivery")
          });
        } else {
          analyticsUtag/* link */.p4({
            link_type: "o",
            link_name: "checkout: review order: ".concat(customerStatus, ": back to credit check")
          });
        }
      }
    };
  });
  (0,react.useEffect)(function () {
    function getHelpTextData() {
      return _getHelpTextData.apply(this, arguments);
    }

    function _getHelpTextData() {
      _getHelpTextData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _config$envConfigs$co;

        var isMiniApp, helpTextResults, _helpTextResults$, consentHtml, links, _iterator, _step, link;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isMiniApp = (0,helperServices/* getCookieValue */.Do)("miniApp") === "true";
                _context.next = 3;
                return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "_format=json", "api", (config_default()) === null || (config_default()) === void 0 ? void 0 : (_config$envConfigs$co = (config_default()).envConfigs[(config_default()) === null || (config_default()) === void 0 ? void 0 : (config_default()).env]) === null || _config$envConfigs$co === void 0 ? void 0 : _config$envConfigs$co.helpText);

              case 3:
                helpTextResults = _context.sent;

                if (isMiniApp) {
                  consentHtml = document.createElement("div");
                  consentHtml.innerHTML = ((_helpTextResults$ = helpTextResults[0]) === null || _helpTextResults$ === void 0 ? void 0 : _helpTextResults$.helpText) || "<p></p>";
                  links = consentHtml.getElementsByTagName("a");
                  _iterator = CheckoutReview_createForOfIteratorHelper(links);

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      link = _step.value;
                      link.href = (0,miniAppUtil/* getBreakoutUrl */.H)(link.href);
                      link.target = "_self";
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  helpTextResults[0].helpText = consentHtml.innerHTML.toString();
                }

                setHelpText(helpTextResults);

                if (helpTextResults && helpTextResults.status === "error") {
                  analyticsUtag/* link */.p4(CheckoutReview_objectSpread(CheckoutReview_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(helpTextResults.reason ? helpTextResults.reason : ""),
                    page_errors_code: "chk-d-g-ht"
                  }));
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getHelpTextData.apply(this, arguments);
    }

    getHelpTextData();
  }, []);
  (0,react.useEffect)(function () {
    var _creditVettingDetails;

    if (cartProducts && cartProducts.length) {
      var normalArr = [];
      var dealArr = [];
      cartProducts.forEach(function (cartProduct) {
        var _cartProduct$product2;

        if ((cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product2 = cartProduct.product) === null || _cartProduct$product2 === void 0 ? void 0 : _cartProduct$product2.is_deal_product) === 1) {
          dealArr.push(cartProduct);
        } else {
          if (dealSku && (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.parent_product_sku) == dealSku) {
            dealArr.push(cartProduct);
          } else {
            normalArr.push(cartProduct);
          }
        }
      });
      setNormalProducts(normalArr);
      setDealProducts(dealArr);
    } else {
      setNormalProducts([]);
      setDealProducts([]);
    }

    setProductsFilter(true);

    if (cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && creditVettingDetails && ((creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode) === labels/* default.creditVetting.lbl_resultcode_pended */.Z.creditVetting.lbl_resultcode_pended || (creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode) === labels/* default.creditVetting.lbl_resultcode_pending */.Z.creditVetting.lbl_resultcode_pending || (creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode) === labels/* default.creditVetting.lbl_resultcode_referred */.Z.creditVetting.lbl_resultcode_referred || (creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode) === labels/* default.creditVetting.lbl_resultcode_offline */.Z.creditVetting.lbl_resultcode_offline || creditVettingDetails !== null && creditVettingDetails !== void 0 && (_creditVettingDetails = creditVettingDetails.resultCode) !== null && _creditVettingDetails !== void 0 && _creditVettingDetails.toUpperCase().includes(labels/* default.creditVetting.lbl_unprocessed */.Z.creditVetting.lbl_unprocessed))) {
      setShowOnceOff(false);
    } else {
      setShowOnceOff(true);
    }
  }, [cartProducts]);
  (0,react.useEffect)(function () {
    if (dealProducts) {
      if (dealProducts.length) {
        var _dealProducts$, _dealProducts$$produc;

        var price = dealProducts.reduce(function (accu, ele) {
          var _ele$product;

          if (dealSku && (ele === null || ele === void 0 ? void 0 : ele.parent_product_sku) == dealSku) {
            accu += ele === null || ele === void 0 ? void 0 : ele.monthly_recurring;
            return accu;
          } else if ((ele === null || ele === void 0 ? void 0 : (_ele$product = ele.product) === null || _ele$product === void 0 ? void 0 : _ele$product.is_deal_product) === 1) {
            var _ele$product2;

            accu += ele === null || ele === void 0 ? void 0 : (_ele$product2 = ele.product) === null || _ele$product2 === void 0 ? void 0 : _ele$product2.monthly_recurring;
            return accu;
          }
        }, 0);
        price = dealProducts ? "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(price), " \xD7 ").concat((_dealProducts$ = dealProducts[0]) === null || _dealProducts$ === void 0 ? void 0 : (_dealProducts$$produc = _dealProducts$.product) === null || _dealProducts$$produc === void 0 ? void 0 : _dealProducts$$produc.payment_terms_label) : "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(0));
        setDealPrice(price);
      } else {
        setDealPrice("R".concat((0,helperServices/* formatNumbersWithComma */.G0)(0)));
      }
    }
  }, [dealProducts]);
  (0,react.useEffect)(function () {
    var buttonStatus = checkContinueButtonErrorStatus();

    if (buttonStatus) {
      continueDisable(true);
    } else {
      checkFormError("termsCheckbox");
    }
  }, [dealProducts, normalProducts]);

  function getViewAnalytics() {
    if (applicationType == "normal") {
      return {
        page_event: "view",
        page_name: "checkout: review order: ".concat(customerStatus)
      };
    } else {
      if (currentJourneyType == checkout_journey_context/* journeyType.upgrade */.w.upgrade) {
        return {
          page_event: "view",
          page_name: "checkout: review order: ".concat(customerStatus),
          delivery_type: (deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.receiveType) == "store" ? "collect" : "deliver",
          authentication_id_type: (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) == "PASSPORT" ? "passport" : "id",
          upgrade_eligibility_status: upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.eligibilityStatus,
          upgrade_eligible_date: (upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.upgradeDate) || "",
          upgrade_customer_type: upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.c3dCustomer ? "C3D" : upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.business ? "CBU" : "OTHER"
        };
      } else {
        return {
          page_event: "view",
          page_name: "checkout: review order: ".concat(customerStatus),
          delivery_type: (deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.receiveType) == "store" ? "collect" : "deliver",
          authentication_id_type: (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) == "PASSPORT" ? "passport" : "id"
        };
      }
    }
  }

  (0,react.useEffect)(function () {
    if (!viewAnalytics && customerStatus && productsFilter) {
      var analytics = getViewAnalytics();
      analytics.multicart_flag = cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti ? true : false;
      analyticsUtag/* view */.ei(CheckoutReview_objectSpread(CheckoutReview_objectSpread({}, analytics), {}, {
        sales_product_category: getCategoriesArr(applicationType == "normal" ? normalProducts : dealProducts),
        sales_product_id: getProductNameArr(applicationType == "normal" ? normalProducts : dealProducts),
        sales_product_name: getProductSkuArr(applicationType == "normal" ? normalProducts : dealProducts),
        sales_product_price: getPriceArr(applicationType == "normal" ? normalProducts : dealProducts),
        sales_product_quantity: getQuantityArr(applicationType == "normal" ? normalProducts : dealProducts)
      }, analyticsUtag/* getProfileData */.$y(userLoggedIn, profileData, authDetailsData)));
      setViewAnalytics(true);
    }
  }, [customerStatus, productsFilter]);

  var _useState8 = (0,react.useState)({
    validations: {
      termsCheckbox: {
        terms: true
      }
    },
    fieldErrors: {
      termsCheckbox: {
        terms: false
      },
      fail: false
    },
    fieldValues: {
      termsCheckbox: {
        terms: false
      }
    },
    fieldErrorsMessage: {
      termsCheckbox: {
        terms: "Please accept the terms & conditions before continuing"
      }
    }
  }),
      state = _useState8[0],
      setState = _useState8[1];

  var fieldErrors = state.fieldErrors,
      fieldValues = state.fieldValues,
      fieldErrorsMessage = state.fieldErrorsMessage;

  var getPriceAndLabel = function getPriceAndLabel(dealProducts, normalProducts) {
    var price, priceLabel;

    if ((0,helperServices/* isArrayNotEmpty */.wh)(normalProducts)) {
      price = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(totalPrice));
      priceLabel = labels/* default.lbl_onceoff_subtotal */.Z.lbl_onceoff_subtotal;
    }

    if ((0,helperServices/* isArrayNotEmpty */.wh)(dealProducts)) {
      price = dealPrice;
      priceLabel = labels/* default.lbl_monthly_subtotal */.Z.lbl_monthly_subtotal;
    }

    return {
      price: price,
      priceLabel: priceLabel
    };
  };

  var getTitle = function getTitle(dealProducts, normalProducts) {
    var _dealProducts$2, _dealProducts$2$custo, _dealProducts$2$custo2, _dealProducts$3, _dealProducts$3$custo, _dealProducts$3$custo2;

    if ((0,helperServices/* isArrayNotEmpty */.wh)(normalProducts) && !(cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti)) {
      return "You’re about to purchase:";
    }

    if ((0,helperServices/* isArrayNotEmpty */.wh)(normalProducts) && cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && showOnceOff) {
      return "Your once-off purchase items:";
    }

    if ((0,helperServices/* isArrayNotEmpty */.wh)(dealProducts) && ((_dealProducts$2 = dealProducts[0]) === null || _dealProducts$2 === void 0 ? void 0 : (_dealProducts$2$custo = _dealProducts$2.customizable_options[0]) === null || _dealProducts$2$custo === void 0 ? void 0 : (_dealProducts$2$custo2 = _dealProducts$2$custo.values[0]) === null || _dealProducts$2$custo2 === void 0 ? void 0 : _dealProducts$2$custo2.label) === labels/* default.deal_details.lbl_new_contract_deal_option */.Z.deal_details.lbl_new_contract_deal_option) {
      return "Your contract:";
    }

    if ((0,helperServices/* isArrayNotEmpty */.wh)(dealProducts) && ((_dealProducts$3 = dealProducts[0]) === null || _dealProducts$3 === void 0 ? void 0 : (_dealProducts$3$custo = _dealProducts$3.customizable_options[0]) === null || _dealProducts$3$custo === void 0 ? void 0 : (_dealProducts$3$custo2 = _dealProducts$3$custo.values[0]) === null || _dealProducts$3$custo2 === void 0 ? void 0 : _dealProducts$3$custo2.label) === labels/* default.deal_details.lbl_upgrade_deal_option */.Z.deal_details.lbl_upgrade_deal_option) {
      return "Your upgrade contract:";
    }
  };

  var getItemLabel = function getItemLabel(dealProducts, normalProducts) {
    var _dealProducts$4, _dealProducts$4$custo, _dealProducts$4$custo2, _dealProducts$5, _dealProducts$5$custo, _dealProducts$5$custo2;

    if ((0,helperServices/* isArrayNotEmpty */.wh)(dealProducts) && ((_dealProducts$4 = dealProducts[0]) === null || _dealProducts$4 === void 0 ? void 0 : (_dealProducts$4$custo = _dealProducts$4.customizable_options[0]) === null || _dealProducts$4$custo === void 0 ? void 0 : (_dealProducts$4$custo2 = _dealProducts$4$custo.values[0]) === null || _dealProducts$4$custo2 === void 0 ? void 0 : _dealProducts$4$custo2.label) === labels/* default.deal_details.lbl_upgrade_deal_option */.Z.deal_details.lbl_upgrade_deal_option) {
      return "Upgrade";
    }

    if ((0,helperServices/* isArrayNotEmpty */.wh)(dealProducts) && ((_dealProducts$5 = dealProducts[0]) === null || _dealProducts$5 === void 0 ? void 0 : (_dealProducts$5$custo = _dealProducts$5.customizable_options[0]) === null || _dealProducts$5$custo === void 0 ? void 0 : (_dealProducts$5$custo2 = _dealProducts$5$custo.values[0]) === null || _dealProducts$5$custo2 === void 0 ? void 0 : _dealProducts$5$custo2.label) === labels/* default.deal_details.lbl_new_contract_deal_option */.Z.deal_details.lbl_new_contract_deal_option) {
      return "New contract";
    }

    if ((0,helperServices/* isArrayNotEmpty */.wh)(normalProducts) && showOnceOff) {
      var totalOnceOffItems = normalProducts.reduce(function (acc, curr) {
        return acc + (curr === null || curr === void 0 ? void 0 : curr.quantity);
      }, 0);
      return "".concat(totalOnceOffItems, " items");
    }
  };

  var handleChange = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, val, form) {
      var name, buttonStatus, linkAnalytics;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.persist();
              name = event.target.name;
              _context2.t0 = name;
              _context2.next = _context2.t0 === "terms" ? 5 : 7;
              break;

            case 5:
              if (state.validations[form].terms) {
                fieldErrors[form].terms = !event.target.checked;
                fieldErrors.fail = fieldErrors[form].terms;
              }

              return _context2.abrupt("break", 8);

            case 7:
              return _context2.abrupt("break", 8);

            case 8:
              fieldValues[form][name] = event.target.checked;
              setState(CheckoutReview_objectSpread(CheckoutReview_objectSpread({}, state), {}, {
                fieldErrors: fieldErrors,
                fieldValues: fieldValues
              }));
              buttonStatus = checkContinueButtonErrorStatus();

              if (state.fieldErrors.fail || buttonStatus) {
                continueDisable(true);
              } else {
                checkFormError(form);
              }

              linkAnalytics = CheckoutReview_objectSpread(CheckoutReview_objectSpread({
                page_name: "checkout: review order: ".concat(customerStatus)
              }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "sales_product_category", "sales_product_id", "sales_product_name", "sales_product_price", "sales_product_quantity"])), {}, {
                visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid"
              });

              if (event.target.checked) {
                analyticsUtag/* link */.p4(CheckoutReview_objectSpread(CheckoutReview_objectSpread({}, linkAnalytics), {}, {
                  link_type: "o",
                  page_tool_event: "use",
                  page_tool_name: "checkout: review order: ".concat(customerStatus, ": accept terms and conditions")
                }));
              } else {
                analyticsUtag/* link */.p4(CheckoutReview_objectSpread(CheckoutReview_objectSpread({}, linkAnalytics), {}, {
                  page_form_event: "error",
                  page_errors: state.fieldErrorsMessage.termsCheckbox.terms,
                  page_form_name: "checkout: review order: ".concat(customerStatus, ": terms"),
                  page_error_type: "terms and conditions"
                }));
              }

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  function checkContinueButtonErrorStatus() {
    var isMulti = cartDetails.isMulti,
        contract = cartDetails.contract,
        onceOff = cartDetails.onceOff;

    if (isMulti || contract || onceOff) {
      return false;
    } else {
      return true;
    }
  }

  function checkFormError(form) {
    var values = state.fieldValues[form];
    var entries = Object.entries(state.validations[form]);

    for (var _i = 0, _entries = entries; _i < _entries.length; _i++) {
      var _entries$_i = (0,slicedToArray/* default */.Z)(_entries[_i], 2),
          key = _entries$_i[0],
          value = _entries$_i[1];

      if (!values[key] && value) {
        continueDisable(true);
        return true;
      }
    }

    continueDisable(false);
  }

  var getCategoriesArr = function getCategoriesArr(products) {
    if (products.length > 0) {
      if (applicationType == "normal") {
        return products.map(function (item) {
          var _item$product, _item$product$categor, _item$product$categor2;

          return item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : (_item$product$categor = _item$product.categories) === null || _item$product$categor === void 0 ? void 0 : (_item$product$categor2 = _item$product$categor[0]) === null || _item$product$categor2 === void 0 ? void 0 : _item$product$categor2.name;
        });
      } else {
        return products.map(function (item) {
          var _item$product2, _item$product2$catego, _item$product2$catego2;

          return item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : (_item$product2$catego = _item$product2.categories) === null || _item$product2$catego === void 0 ? void 0 : (_item$product2$catego2 = _item$product2$catego[1]) === null || _item$product2$catego2 === void 0 ? void 0 : _item$product2$catego2.name;
        });
      }
    }

    return [];
  };

  var getQuantityArr = function getQuantityArr(products) {
    if (products.length > 0) {
      return products.map(function (item) {
        return item === null || item === void 0 ? void 0 : item.quantity;
      });
    }

    return [];
  };

  function getDealFormattedPrice(item) {
    var _item$product3, _item$product4;

    return "".concat(item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.monthly_recurring, " x ").concat(item === null || item === void 0 ? void 0 : (_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.payment_terms_label);
  }

  var getPriceArr = function getPriceArr(products) {
    if (products.length > 0) {
      if (applicationType == "normal") {
        return products.map(function (item) {
          var _item$prices, _item$prices$row_tota;

          return item === null || item === void 0 ? void 0 : (_item$prices = item.prices) === null || _item$prices === void 0 ? void 0 : (_item$prices$row_tota = _item$prices.row_total_original) === null || _item$prices$row_tota === void 0 ? void 0 : _item$prices$row_tota.value;
        });
      } else {
        return products.map(function (item) {
          return getDealFormattedPrice(item);
        });
      }
    }

    return [];
  };

  var getProductSkuArr = function getProductSkuArr(products) {
    if (products.length > 0) {
      return products.map(function (item) {
        var _item$product5;

        return item === null || item === void 0 ? void 0 : (_item$product5 = item.product) === null || _item$product5 === void 0 ? void 0 : _item$product5.sku;
      });
    }

    return [];
  };

  var getProductNameArr = function getProductNameArr(products) {
    if (products.length > 0) {
      return products.map(function (item) {
        var _item$product6;

        return item === null || item === void 0 ? void 0 : (_item$product6 = item.product) === null || _item$product6 === void 0 ? void 0 : _item$product6.name;
      });
    }

    return [];
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (CheckoutReview_module_default())["review-container"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutReview_module_default()).agree,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
          title: "The fine print:",
          className: (CheckoutReview_module_default())["top-wrapper"],
          headingClassName: (CheckoutReview_module_default())["top-wrapper__heading"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TermsCheckbox/* default */.Z, {
          fieldName: "terms",
          label: finalLabelTerms && finalLabelTerms,
          fieldValues: state.fieldValues["termsCheckbox"],
          fieldErrors: state.fieldErrors["termsCheckbox"],
          fieldErrorsMessage: state.fieldErrorsMessage["termsCheckbox"],
          onChangeHandler: handleChange,
          onBlurHandler: function onBlurHandler() {},
          className: (CheckoutReview_module_default()).section
        })]
      }), (0,helperServices/* isArrayNotEmpty */.wh)(dealProducts) && /*#__PURE__*/(0,jsx_runtime.jsx)(checkoutReview_ReviewItems, {
        isDeal: true,
        title: getTitle(dealProducts, []),
        price: getPriceAndLabel(dealProducts, []).price,
        itemLabel: getItemLabel(dealProducts, []),
        priceLabel: getPriceAndLabel(dealProducts, []).priceLabel,
        customerStatus: customerStatus,
        cartProducts: dealProducts,
        cartId: cartId,
        showOnceOff: showOnceOff
      }), (0,helperServices/* isArrayNotEmpty */.wh)(normalProducts) && showOnceOff && /*#__PURE__*/(0,jsx_runtime.jsx)(checkoutReview_ReviewItems, {
        isDeal: false,
        title: getTitle([], normalProducts),
        price: getPriceAndLabel([], normalProducts).price,
        itemLabel: getItemLabel([], normalProducts),
        priceLabel: getPriceAndLabel([], normalProducts).priceLabel,
        customerStatus: customerStatus,
        cartProducts: normalProducts,
        cartId: cartId,
        showOnceOff: showOnceOff
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutReview_module_default()).address,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
          title: "Delivery details:",
          className: (CheckoutReview_module_default())["top-wrapper"],
          headingClassName: (CheckoutReview_module_default())["top-wrapper__heading"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(deliveryDetails_DeliveryDetails, {
          addressTypes: addressTypesOptions,
          statesTypes: stateTypesOptions,
          countryCode: countryCode,
          countryName: countryName,
          customerStatus: customerStatus,
          shippingAddress: shippingAddress,
          cartId: cartId,
          className: (CheckoutReview_module_default()).section,
          userLoggedIn: userLoggedIn,
          applicationType: applicationType
        })]
      })]
    })
  });
});
CheckoutReview.defaultProps = {
  cartProducts: [],
  addressTypes: [],
  statesTypes: [],
  totalPrice: 0,
  totalQuantity: 0,
  applicationType: "normal"
};

var CheckoutReview_mapStateToProps = function mapStateToProps(state) {
  return {
    deliveryDetails: state.creditCheckDetails.deliveryDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    upgradeResponse: state.upgrade.upgradeResponse,
    creditVettingDetails: state.checkoutDetails.creditVettingResult
  };
};

/* harmony default export */ var checkoutReview_CheckoutReview = ((0,DependencyHelper.connect)(CheckoutReview_mapStateToProps, null, null, {
  forwardRef: true
})(CheckoutReview));

/***/ }),

/***/ 36603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58223);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99599);
/* harmony import */ var _atoms_label_LabelText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38975);
/* harmony import */ var _atoms_image_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39489);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28658);
/* harmony import */ var _atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79549);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64036);
/* harmony import */ var _emptyProductsContainer_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44025);
/* harmony import */ var _emptyProductsContainer_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_emptyProductsContainer_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);











var env = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().env);
var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().envConfigs)[env].imagePrefix;
var imgUrl = "".concat(imagePrefix, "/assets/images/no-filter.svg");

var EmptyProductsContainer = function EmptyProductsContainer(props) {
  var resetFilter = props.resetFilter,
      ctaHidden = props.ctaHidden,
      ctaLabel = props.ctaLabel,
      message = props.message;
  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_7__/* .componentCheckSize */ .Qj)() < _config_constants__WEBPACK_IMPORTED_MODULE_1__/* .TABLET_WIDTH */ .uU;
  var btnConfig = {
    buttonStyle: 'outline black',
    buttonText: ctaLabel || _config_labels__WEBPACK_IMPORTED_MODULE_2__/* ["default"].lbl_reset_all_filters */ .Z.lbl_reset_all_filters
  };
  var defaultLabelText = _config_labels__WEBPACK_IMPORTED_MODULE_2__/* ["default"].upgrade.lbl_reset_desc.split */ .Z.upgrade.lbl_reset_desc.split(".").filter(function (t) {
    return t;
  }).map(function (msg) {
    return "".concat(msg, ".");
  });
  var displayMessageText = message ? message instanceof Array ? message : [message] : !isMobile ? defaultLabelText : [_config_labels__WEBPACK_IMPORTED_MODULE_2__/* ["default"].upgrade.lbl_reset_desc */ .Z.upgrade.lbl_reset_desc];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.CustomContainer, {
    className: (_emptyProductsContainer_module_scss__WEBPACK_IMPORTED_MODULE_9___default().emptyProductContainer),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms_image_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
      id: "xbtn",
      className: (_emptyProductsContainer_module_scss__WEBPACK_IMPORTED_MODULE_9___default().imageStyle),
      img_path: imgUrl,
      img_width: ctaHidden ? '80px' : '60px',
      img_height: ctaHidden ? '80px' : '60px'
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms_label_LabelText__WEBPACK_IMPORTED_MODULE_3__["default"], {
      id: "filter-errormessage",
      className: (_emptyProductsContainer_module_scss__WEBPACK_IMPORTED_MODULE_9___default().content),
      children: displayMessageText && displayMessageText.map(function (msgText, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          children: msgText
        }, "msg_text_".concat(index));
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.CustomContainer, {
      className: (_emptyProductsContainer_module_scss__WEBPACK_IMPORTED_MODULE_9___default().emptyProductResetBtn),
      children: !ctaHidden && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_6__["default"], {
        id: "".concat(btnConfig.buttonText, "-btn"),
        className: (_emptyProductsContainer_module_scss__WEBPACK_IMPORTED_MODULE_9___default().buttonStyle),
        variant: btnConfig.buttonStyle,
        handleClick: resetFilter,
        btnSizing: "order-details-back-btn",
        children: ctaLabel || btnConfig.buttonText
      })
    })]
  });
};

EmptyProductsContainer.defaultProps = {
  ctaHidden: false,
  message: null
};
/* harmony default export */ __webpack_exports__["Z"] = (EmptyProductsContainer);

/***/ }),

/***/ 11972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28658);
/* harmony import */ var _atoms_image_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39489);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64036);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99599);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69152);
/* harmony import */ var _utils_miniAppUtagUtil__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37613);
/* harmony import */ var _PaymentRedirect_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43819);
/* harmony import */ var _PaymentRedirect_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_PaymentRedirect_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var PaymentRedirect = function PaymentRedirect(_ref) {
  var _postOrderResponse$pa;

  var userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      paymentConfiguration = _ref.paymentConfiguration,
      applicationType = _ref.applicationType,
      paymentMethodUrl = _ref.paymentMethodUrl,
      postOrderResponse = _ref.postOrderResponse,
      paymentOptionsEnabled = _ref.paymentOptionsEnabled,
      customerStatus = _ref.customerStatus,
      cartProducts = _ref.cartProducts,
      deliveryDetails = _ref.deliveryDetails,
      authDetailsData = _ref.authDetailsData,
      isMiniApp = _ref.isMiniApp;
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_6___default().env);
  var paymentCallbackUrl = applicationType == "normal" ? (_config_index__WEBPACK_IMPORTED_MODULE_6___default().envConfigs)[env].paymentCallback : (_config_index__WEBPACK_IMPORTED_MODULE_6___default().envConfigs)[env].postPaymentCallback;
  var paymentProvision = (_config_index__WEBPACK_IMPORTED_MODULE_6___default().envConfigs)[env].paymentProvision;
  var paymentConfig = paymentConfiguration;
  var customerIdentifier = userLoggedIn && profileData !== null && profileData !== void 0 && profileData.profileID ? profileData === null || profileData === void 0 ? void 0 : profileData.profileID : "";
  var niToggle = postOrderResponse === null || postOrderResponse === void 0 ? void 0 : postOrderResponse.niMigrationFeatureToggle;
  var newUrl = postOrderResponse === null || postOrderResponse === void 0 ? void 0 : postOrderResponse.paymentPageUrl;
  /**
   * Redirect to payment gateway
   *
   * @call page load
   */

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (isMiniApp) {
      var salesAnalyticsData = _utils_miniAppUtagUtil__WEBPACK_IMPORTED_MODULE_8__/* .MiniAppUtagUtil.getSalesAnalyticsData */ .E.getSalesAnalyticsData(cartProducts, applicationType);

      var analytics = _objectSpread(_objectSpread(_objectSpread({}, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_7__/* .getProfileData */ .$y(userLoggedIn, profileData)), salesAnalyticsData), {}, {
        delivery_type: (deliveryDetails === null || deliveryDetails === void 0 ? void 0 : deliveryDetails.receiveType) === "store" ? "collect" : "deliver",
        authentication_id_type: (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) === "PASSPORT" ? "passport" : "id",
        customerStatus: customerStatus
      });

      window.location = "".concat(_config_index__WEBPACK_IMPORTED_MODULE_6__.EnvConfig.miniAppUrl, "?orderId=").concat(postOrderResponse === null || postOrderResponse === void 0 ? void 0 : postOrderResponse.productOrderId, "&analytics=").concat(encodeURIComponent(JSON.stringify(analytics)));
      return;
    }

    if (niToggle === true) {
      window.location.href = newUrl;
      return;
    }

    window.setTimeout(function () {
      document.ucfCheckout.submit.bind(document.ucfCheckout);
      document.ucfCheckout.submit();
    }, 800);
  }, []);

  if (isMiniApp) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__.CustomContainer, {
      className: (_PaymentRedirect_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["payment-redirect"]),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__.CustomContainer, {
        className: (_PaymentRedirect_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_atoms_image_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
          img_path: "".concat(_utils_helperServices__WEBPACK_IMPORTED_MODULE_4__/* .imagePrefix */ .Sj, "/assets/images/lock-loading.gif")
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__.CustomContainer, {
        className: (_PaymentRedirect_module_scss__WEBPACK_IMPORTED_MODULE_10___default().desc),
        children: _config_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lbl_payment_redirect */ .Z.lbl_payment_redirect
      })]
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__.CustomContainer, {
      className: (_PaymentRedirect_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["payment-redirect"]),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__.CustomContainer, {
        className: (_PaymentRedirect_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_atoms_image_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
          img_path: "".concat(_utils_helperServices__WEBPACK_IMPORTED_MODULE_4__/* .imagePrefix */ .Sj, "/assets/images/lock-loading.gif")
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__.CustomContainer, {
        className: (_PaymentRedirect_module_scss__WEBPACK_IMPORTED_MODULE_10___default().desc),
        children: _config_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lbl_payment_redirect */ .Z.lbl_payment_redirect
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("form", {
        method: "post",
        name: "ucfCheckout",
        id: "ucfCheckout",
        action: paymentOptionsEnabled && paymentMethodUrl ? paymentMethodUrl : paymentConfig.paymentGatewayUrl,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "PayserverUser",
          id: "PayserverUser",
          value: paymentConfig.payServerUser
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "transactionStatusCallbackUrl",
          id: "transactionStatusCallbackUrl",
          value: paymentConfig.transactionStatusCallbackUrl
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "transactionCompletedUrl",
          id: "transactionCompletedUrl",
          value: paymentCallbackUrl
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "redirectURL",
          id: "redirectURL",
          value: paymentCallbackUrl
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "failureURL",
          id: "failureURL",
          value: paymentCallbackUrl
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "TransactionStatusCallbackFormat",
          id: "TransactionStatusCallbackFormat",
          value: paymentConfig.transactionStatusCallbackFormat
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "TransactionStatusCallbackMethod",
          id: "TransactionStatusCallbackMethod",
          value: paymentConfig.transactionStatusCallbackMethod
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "MerchantReference",
          id: "MerchantReference",
          value: postOrderResponse === null || postOrderResponse === void 0 ? void 0 : postOrderResponse.productOrderId
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "Currency",
          id: "Currency",
          value: paymentConfig.currency
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "TransactionType",
          id: "TransactionType",
          value: paymentConfig.transactionType
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "MerchantIdentifier",
          id: "MerchantIdentifier",
          value: paymentConfig.merchantIdentifier
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "CustomerIdentifier",
          id: "CustomerIdentifier",
          value: customerIdentifier
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "EncXML",
          id: "EncXML",
          value: postOrderResponse === null || postOrderResponse === void 0 ? void 0 : (_postOrderResponse$pa = postOrderResponse.payment) === null || _postOrderResponse$pa === void 0 ? void 0 : _postOrderResponse$pa.encryptedPaymentDetails
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
          type: "hidden",
          name: "EncType",
          id: "EncType",
          value: paymentConfig.encType
        })]
      })]
    })
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    paymentMethodUrl: state.checkoutDetails.paymentMethodUrl,
    postOrderResponse: state.checkoutDetails.postOrderResponse,
    deliveryDetails: state.creditCheckDetails.deliveryDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    isMiniApp: state.navDetails.isMiniApp
  };
};

/* harmony default export */ __webpack_exports__["Z"] = ((0,_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_2__.connect)(mapStateToProps)(PaymentRedirect));

/***/ }),

/***/ 16073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _helperServices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64036);
/* harmony import */ var _services_checkoutService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34020);


/* harmony default export */ __webpack_exports__["Z"] = (function (geoLocation, sku, populateStoreList, serviceDown) {
  var clientType = 'CBU';
  var deviceId = '0'; // anything

  var latitude = geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.latitude; //-25.968857;

  var longitude = geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.longitude; //28.128515;

  var stockCode = sku; //'103004940'; // SKU

  var storeTypes = ["Chatz", "Vodacom4u", "RepairCentre", "Vodacom Approved Dealer", "Vodacom Express", "Vodacom Shop"];

  try {
    (0,_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .showSpinner */ .yh)();
    (0,_services_checkoutService__WEBPACK_IMPORTED_MODULE_1__/* .getGeographicSiteStockService */ .AX)(clientType, deviceId, latitude, longitude, stockCode, storeTypes.join(',')).then(function (results) {
      (0,_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .hideSpinner */ .v3)();

      if (!results.fail) {
        var _results$response, _results$response$dat, _results$response$dat2, _results$response$dat3;

        var sortedLists = results === null || results === void 0 ? void 0 : (_results$response = results.response) === null || _results$response === void 0 ? void 0 : (_results$response$dat = _results$response.data) === null || _results$response$dat === void 0 ? void 0 : (_results$response$dat2 = _results$response$dat.result) === null || _results$response$dat2 === void 0 ? void 0 : (_results$response$dat3 = _results$response$dat2.result) === null || _results$response$dat3 === void 0 ? void 0 : _results$response$dat3.storeList;
        sortedLists = sortedLists.sort(function (a, b) {
          if (a.distance < b.distance) {
            return -1;
          }

          if (a.distance > b.distance) {
            return 1;
          }

          return 0;
        });
        populateStoreList(sortedLists);
        serviceDown(sortedLists.length > 0 ? false : true);
      } else if (results.fail) {
        serviceDown(true);
      }
    }, function (_err) {
      (0,_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .hideSpinner */ .v3)();
    });
  } catch (e) {
    (0,_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .hideSpinner */ .v3)();
    serviceDown(true);
  }
});

/***/ }),

/***/ 37613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ MiniAppUtagUtil; }
/* harmony export */ });
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92777);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82262);
/* harmony import */ var _config_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69842);




var getCategoriesArr = function getCategoriesArr(cartProducts, applicationType) {
  if (cartProducts.length === 0) {
    return [];
  }

  if (applicationType === "normal") {
    return cartProducts.map(function (item) {
      var _item$product, _item$product$categor, _item$product$categor2;

      return item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : (_item$product$categor = _item$product.categories) === null || _item$product$categor === void 0 ? void 0 : (_item$product$categor2 = _item$product$categor[0]) === null || _item$product$categor2 === void 0 ? void 0 : _item$product$categor2.name;
    });
  }

  return cartProducts.map(function (item) {
    var _item$product2, _item$product2$catego, _item$product2$catego2;

    return item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : (_item$product2$catego = _item$product2.categories) === null || _item$product2$catego === void 0 ? void 0 : (_item$product2$catego2 = _item$product2$catego[1]) === null || _item$product2$catego2 === void 0 ? void 0 : _item$product2$catego2.name;
  });
};

var getQuantityArr = function getQuantityArr(cartProducts) {
  if (cartProducts.length > 0) {
    return cartProducts.map(function (item) {
      return item === null || item === void 0 ? void 0 : item.quantity;
    });
  }

  return [];
};

function getDealFormattedPrice(item) {
  var _item$product3, _item$product4;

  return "".concat(item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.monthly_recurring, " x ").concat(item === null || item === void 0 ? void 0 : (_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.payment_terms_label);
}

var getPriceArr = function getPriceArr(cartProducts, applicationType) {
  if (cartProducts.length === 0) {
    return [];
  }

  if (applicationType === "normal") {
    return cartProducts.map(function (item) {
      var _item$prices, _item$prices$row_tota;

      return item === null || item === void 0 ? void 0 : (_item$prices = item.prices) === null || _item$prices === void 0 ? void 0 : (_item$prices$row_tota = _item$prices.row_total_original) === null || _item$prices$row_tota === void 0 ? void 0 : _item$prices$row_tota.value;
    });
  }

  return cartProducts.map(function (item) {
    return getDealFormattedPrice(item);
  });
};

var getProductSkuArr = function getProductSkuArr(cartProducts) {
  if (cartProducts.length > 0) {
    return cartProducts.map(function (item) {
      var _item$product5;

      return item === null || item === void 0 ? void 0 : (_item$product5 = item.product) === null || _item$product5 === void 0 ? void 0 : _item$product5.sku;
    });
  }

  return [];
};

var getProductNameArr = function getProductNameArr(cartProducts) {
  if (cartProducts.length > 0) {
    return cartProducts.map(function (item) {
      var _item$product6;

      return item === null || item === void 0 ? void 0 : (_item$product6 = item.product) === null || _item$product6 === void 0 ? void 0 : _item$product6.name;
    });
  }

  return [];
};

var isPreOrder = function isPreOrder(cartProducts) {
  var preOrderFound = cartProducts.filter(function (item) {
    var _item$product7, _item$product8;

    return (item === null || item === void 0 ? void 0 : (_item$product7 = item.product) === null || _item$product7 === void 0 ? void 0 : _item$product7.badges_label) && (item === null || item === void 0 ? void 0 : (_item$product8 = item.product) === null || _item$product8 === void 0 ? void 0 : _item$product8.badges_label.toLowerCase().indexOf(_config_types__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TYPE_PREORDER.toLowerCase */ .Z.TYPE_PREORDER.toLowerCase())) > -1;
  });
  return preOrderFound && preOrderFound.length > 0;
};

var MiniAppUtagUtil = /*#__PURE__*/function () {
  function MiniAppUtagUtil() {
    (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, MiniAppUtagUtil);
  }

  (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(MiniAppUtagUtil, null, [{
    key: "getSalesAnalyticsData",
    value: function getSalesAnalyticsData(cartProducts, applicationType) {
      var salesAnalyticsData = {
        sales_product_category: getCategoriesArr(cartProducts, applicationType),
        sales_product_id: getProductNameArr(cartProducts),
        sales_product_name: getProductSkuArr(cartProducts),
        sales_product_price: getPriceArr(cartProducts, applicationType),
        sales_product_quantity: getQuantityArr(cartProducts),
        preorder_sales_event: isPreOrder(cartProducts) ? "cbu_pre_order" : ""
      };
      salesAnalyticsData.multicart_flag = false; // TODO: add logic when multicart gets implemented

      return salesAnalyticsData;
    }
  }]);

  return MiniAppUtagUtil;
}();

/***/ }),

/***/ 21909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ getBreakoutUrl; },
/* harmony export */   "W": function() { return /* binding */ openBreakoutUrl; }
/* harmony export */ });
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_0__);

var openBreakoutUrl = function openBreakoutUrl(url, successUrl, failureUrl) {
  if (!url) {
    return;
  }

  window.location = getBreakoutUrl(url, successUrl, failureUrl);
};
var getBreakoutUrl = function getBreakoutUrl(url, successUrl, failureUrl) {
  if (!url) {
    return '';
  }

  var redirectUrl = "".concat(_config_index__WEBPACK_IMPORTED_MODULE_0__.EnvConfig.miniAppUrl, "?url=").concat(window.encodeURIComponent(url));

  if (successUrl) {
    redirectUrl += "&successUrl=".concat(window.encodeURIComponent(successUrl));
  }

  if (failureUrl) {
    redirectUrl += "&failureUrl=".concat(window.encodeURIComponent(failureUrl));
  }

  return "".concat(redirectUrl, "#/browser");
};

/***/ }),

/***/ 65754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"delivery-option-step":"DeliveryOptionTitle_delivery-option-step__bKomW","delivery-option-step__subtitle":"DeliveryOptionTitle_delivery-option-step__subtitle__E1_lz","delivery-option-step__infobox":"DeliveryOptionTitle_delivery-option-step__infobox__jAWn4","number-transfer-wrapper":"DeliveryOptionTitle_number-transfer-wrapper__zRI_G","delivery-option-step__infobox-wraper":"DeliveryOptionTitle_delivery-option-step__infobox-wraper__DLyds","delivery-option-step__infobox-hide":"DeliveryOptionTitle_delivery-option-step__infobox-hide__fgtzu","delivery-option-step__icon-hide":"DeliveryOptionTitle_delivery-option-step__icon-hide__xhjFE","delivery-option-step__subtitle-collapse":"DeliveryOptionTitle_delivery-option-step__subtitle-collapse__2kdGv","wraper-height":"DeliveryOptionTitle_wraper-height__a9wk_"};

/***/ }),

/***/ 73352:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__mvFn_","accordion__toggle":"Accordion_accordion__toggle__HIVCS","accordion__toggle--active":"Accordion_accordion__toggle--active__NVuEn","accordion__collapse":"Accordion_accordion__collapse__w_DPn"};

/***/ }),

/***/ 5399:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addAddress":"AddAddress_addAddress__scjNw","addAddress__section":"AddAddress_addAddress__section__5Xaxg","addAddress-add":"AddAddress_addAddress-add__c9acb","addAddress-arrow":"AddAddress_addAddress-arrow__5Ve_Z","addAddress__address":"AddAddress_addAddress__address__82Ut4","addAddress__tile":"AddAddress_addAddress__tile__wMo4u"};

/***/ }),

/***/ 46176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addressTile":"AddressTile_addressTile__MkX2m","addressTile-greenBorder":"AddressTile_addressTile-greenBorder__gTviy","addressTile__heading":"AddressTile_addressTile__heading___nWCA","addressTile__action-btn":"AddressTile_addressTile__action-btn__UlLou","btn":"AddressTile_btn__qx_Fx","icon":"AddressTile_icon__uHnN9","icon__edit":"AddressTile_icon__edit__GzExD","icon__delete":"AddressTile_icon__delete__S5EEF","label":"AddressTile_label__OESVo","delete":"AddressTile_delete__zZwfC","addressTile__content":"AddressTile_addressTile__content__fRwDO","addressTile__value":"AddressTile_addressTile__value__QUufc","addressTile__value__second":"AddressTile_addressTile__value__second__IDRVV","addressTile__triangle":"AddressTile_addressTile__triangle__8AGqz","addressTile__click":"AddressTile_addressTile__click__y_aIa","addressTile__click-tick":"AddressTile_addressTile__click-tick__9GxrU","edit":"AddressTile_edit__hpHny"};

/***/ }),

/***/ 23935:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"CompanyVat_main-container__1qtr1","address-check-row":"CompanyVat_address-check-row__Qpdxr","address-check-form-group":"CompanyVat_address-check-form-group__vmzbv","vat-address-container":"CompanyVat_vat-address-container__a_Oqd","vat-address-row":"CompanyVat_vat-address-row__Ods3B","future-check-row":"CompanyVat_future-check-row__GGkCO"};

/***/ }),

/***/ 22210:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"TermsCheckbox_main-container__KcpUU","invalid":"TermsCheckbox_invalid__V5CvJ","main-row":"TermsCheckbox_main-row__Q1HgN","form-checkbox-label":"TermsCheckbox_form-checkbox-label__hBqtB","invalid-feedback":"TermsCheckbox_invalid-feedback__ILqvr"};

/***/ }),

/***/ 92930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"CheckoutPageError_main-container__xyh5a","icon":"CheckoutPageError_icon__xWNaH","title":"CheckoutPageError_title__APegZ","desc":"CheckoutPageError_desc__I__Lz","divider":"CheckoutPageError_divider__hiZCB","sub-title":"CheckoutPageError_sub-title__hq35G","sub-desc":"CheckoutPageError_sub-desc__uN2nG","cta-title":"CheckoutPageError_cta-title__jZTRk","radio-buttons-wrapper":"CheckoutPageError_radio-buttons-wrapper__9tRCl","button":"CheckoutPageError_button__UpvMg","button-wrapper":"CheckoutPageError_button-wrapper__uG9Fh","primary":"CheckoutPageError_primary__FVeVJ","p-success":"CheckoutPageError_p-success__FdJU1","secondary":"CheckoutPageError_secondary__CiIwG"};

/***/ }),

/***/ 71127:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"deliveryTitle":"DeliveryTitle_deliveryTitle__I_NKg","deliveryTitle__title":"DeliveryTitle_deliveryTitle__title__Wpqxx","deliveryTitle__content":"DeliveryTitle_deliveryTitle__content__Ry3yI","item":"DeliveryTitle_item__vyqOk","icon":"DeliveryTitle_icon__wvtzh","desc":"DeliveryTitle_desc__ssBxE","content-ul":"DeliveryTitle_content-ul__0Zbu5"};

/***/ }),

/***/ 2814:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdown-button":"DropDownStyle_dropdown-button__x0hHN","dropdown":"DropDownStyle_dropdown__L3VfC","item":"DropDownStyle_item__y08eJ","roaming-image":"DropDownStyle_roaming-image__9IeYI","sort-menu":"DropDownStyle_sort-menu__yCnB_"};

/***/ }),

/***/ 72819:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FaqItem_container__JQk_w","heading":"FaqItem_heading__3Snmv","icon":"FaqItem_icon__i24MP","label":"FaqItem_label__zA8h6","desc":"FaqItem_desc__YGQmZ","select-row":"FaqItem_select-row__njeL4","select-group":"FaqItem_select-group__HXxyg","select-desc":"FaqItem_select-desc__InEEE"};

/***/ }),

/***/ 7119:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paymentMethodTile":"PaymentMethodTile_paymentMethodTile__qL60o","greenBorder":"PaymentMethodTile_greenBorder__kmHz7","top":"PaymentMethodTile_top__HSre2","bottom":"PaymentMethodTile_bottom__FzIi_","content":"PaymentMethodTile_content__mQONV","heading":"PaymentMethodTile_heading__j4_Gw","details":"PaymentMethodTile_details__b1IPe","number":"PaymentMethodTile_number__0T_sX","expire":"PaymentMethodTile_expire__6E_UE","action-btn":"PaymentMethodTile_action-btn__2ARKN","btn":"PaymentMethodTile_btn__YDJb2","icon":"PaymentMethodTile_icon__kXgFC","icon__delete":"PaymentMethodTile_icon__delete__lbwib","label":"PaymentMethodTile_label__g_nrB","triangle":"PaymentMethodTile_triangle__v9CjV","click":"PaymentMethodTile_click__FhkHS","click-tick":"PaymentMethodTile_click-tick__9Tw9F","option":"PaymentMethodTile_option__Wcob5","card":"PaymentMethodTile_card__UDeyf","desc":"PaymentMethodTile_desc__AxCbE"};

/***/ }),

/***/ 88192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"StaticForms_main-container__mtcLc","main-row":"StaticForms_main-row__wdHDr","form-group":"StaticForms_form-group__f_NwD","invalid":"StaticForms_invalid__JErtF","invalid-feedback":"StaticForms_invalid-feedback__9PyAm","hint-text":"StaticForms_hint-text__xPvpq","form-control-area":"StaticForms_form-control-area__V2tLt","form-label":"StaticForms_form-label__5CDqm","form-checkbox-label":"StaticForms_form-checkbox-label__RNHl7","checkbox-row":"StaticForms_checkbox-row__AMqfj","document-row":"StaticForms_document-row__V4dQf","full-row":"StaticForms_full-row__H3Hcj"};

/***/ }),

/***/ 10161:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"step":"Step_step__oS8lh","step__box":"Step_step__box__J_Aq2","step__circle":"Step_step__circle__vDzQ6","step__circle--check":"Step_step__circle--check__yT3gs","step__title":"Step_step__title__ybE_e","step--active":"Step_step--active__BOatn","step--complete":"Step_step--complete__HtRHa"};

/***/ }),

/***/ 63511:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"step-card":"StepMobile_step-card__s_eNv","step-card__count":"StepMobile_step-card__count__W0W6N","step-card__title":"StepMobile_step-card__title__Q0YNw","step-card__next":"StepMobile_step-card__next__N4zn7","step-card-progress":"StepMobile_step-card-progress__0vUUg"};

/***/ }),

/***/ 86801:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storeCard-modal":"storeCard_storeCard-modal__dwvnb","storeCard-modal-distance":"storeCard_storeCard-modal-distance__7RUou","storeCard-button":"storeCard_storeCard-button__KXHlJ","greyOutCard":"storeCard_greyOutCard__RIb_l","show-more-btn":"storeCard_show-more-btn__U5k2a","storeCard":"storeCard_storeCard__d8gbD","storeCard-greenBorder":"storeCard_storeCard-greenBorder__j4h8f","storeCard__triangle":"storeCard_storeCard__triangle__vEbuT","storeCard__click":"storeCard_storeCard__click__BHeh_","storeCard__click-tick":"storeCard_storeCard__click-tick__zjBmZ","storeCard__heading-container":"storeCard_storeCard__heading-container__JAkNf","storeCard__heading":"storeCard_storeCard__heading__FqLpQ","storeCard__no-stock":"storeCard_storeCard__no-stock__8Db2A","storeCard__no-click-and-collect":"storeCard_storeCard__no-click-and-collect__UEEJS","storeCard__content":"storeCard_storeCard__content__VG_G3","storeCard__location":"storeCard_storeCard__location__NLMei","storeCard__tracker-icon":"storeCard_storeCard__tracker-icon__UlvKP"};

/***/ }),

/***/ 73872:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"CheckoutFaq_main-container__ozCgk","container":"CheckoutFaq_container__DJfbZ","top-wrapper__heading":"CheckoutFaq_top-wrapper__heading__bTA4m","accordion-wrapper":"CheckoutFaq_accordion-wrapper___ocfm","accordion-wrapper__item":"CheckoutFaq_accordion-wrapper__item__gvWFX","accordion-wrapper__item--active":"CheckoutFaq_accordion-wrapper__item--active__GYSvB","accordion-wrapper__subitem":"CheckoutFaq_accordion-wrapper__subitem__n_zIZ","select-row":"CheckoutFaq_select-row__iDotq","select-group":"CheckoutFaq_select-group__vvk4o","select-desc":"CheckoutFaq_select-desc__VoQad","items-wrapper":"CheckoutFaq_items-wrapper__vdSNC"};

/***/ }),

/***/ 85871:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkout-footer":"CheckoutFooter_checkout-footer__e1R_4","step-popup":"CheckoutFooter_step-popup__EGnam","container":"CheckoutFooter_container__0l507","left-section":"CheckoutFooter_left-section__f2yCb","secure-img":"CheckoutFooter_secure-img__6sJuS","right-section":"CheckoutFooter_right-section__2CXGW","question-img":"CheckoutFooter_question-img__g8V7d","help-text":"CheckoutFooter_help-text__j_jq2","contact-text":"CheckoutFooter_contact-text__r3wNN"};

/***/ }),

/***/ 77421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkout-nav":"CheckoutNav_checkout-nav__APKw_","container":"CheckoutNav_container__GgVuJ","title-font":"CheckoutNav_title-font__ZF1sm","exit-btn":"CheckoutNav_exit-btn__cAUvp","logo":"CheckoutNav_logo__xTuwr","col-mid":"CheckoutNav_col-mid__rZELN","col-side":"CheckoutNav_col-side__Ai8aT"};

/***/ }),

/***/ 58628:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkout-summary":"CheckoutOrderSummary_checkout-summary__jrMvo","swipe":"CheckoutOrderSummary_swipe__CfBvs","title":"CheckoutOrderSummary_title__UAAPa","wrapper":"CheckoutOrderSummary_wrapper__0GZqM","wrapper-value":"CheckoutOrderSummary_wrapper-value__bR49J","wrapper-label":"CheckoutOrderSummary_wrapper-label___uzt_","delivery-lbl-spacing":"CheckoutOrderSummary_delivery-lbl-spacing__se8SD","wrapper-title":"CheckoutOrderSummary_wrapper-title__dZaOf","wrapper-total":"CheckoutOrderSummary_wrapper-total__rOqeS","label":"CheckoutOrderSummary_label__YDlZk","value":"CheckoutOrderSummary_value__2Pclr","total":"CheckoutOrderSummary_total__jtMGW","total-value":"CheckoutOrderSummary_total-value__e0J1Y","horizantal-line":"CheckoutOrderSummary_horizantal-line__McnKP","continue-button":"CheckoutOrderSummary_continue-button__ie61u","button-label":"CheckoutOrderSummary_button-label__2_9Cn","open":"CheckoutOrderSummary_open___of1F","plain":"CheckoutOrderSummary_plain__1MUbR","total-line":"CheckoutOrderSummary_total-line__x6sk_"};

/***/ }),

/***/ 85665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stepper-container":"CheckoutStepper_stepper-container__SaD0f","stepper":"CheckoutStepper_stepper__JR68L","step-width-65":"CheckoutStepper_step-width-65__PYkN6","step-width-75":"CheckoutStepper_step-width-75__9TwF5"};

/***/ }),

/***/ 73842:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"next-steps-info":"NextStepsInfo_next-steps-info__7C1jf","section-heading":"NextStepsInfo_section-heading__sULwl","main-wrapper":"NextStepsInfo_main-wrapper__ys_w4","items":"NextStepsInfo_items__Pl8_M","item":"NextStepsInfo_item__OkGKy","icon":"NextStepsInfo_icon__nnPBG","title":"NextStepsInfo_title__J8vx7","desc":"NextStepsInfo_desc__dCygg","step-type":"NextStepsInfo_step-type__Xc3tP","sub-content":"NextStepsInfo_sub-content__vkQ0A"};

/***/ }),

/***/ 44907:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section-heading":"PurchasedSectionInfo_section-heading__4teV4","container":"PurchasedSectionInfo_container__Nqi9z","title":"PurchasedSectionInfo_title__mHY_B","value":"PurchasedSectionInfo_value__XG4D2"};

/***/ }),

/***/ 73422:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"ReceiveType_main-container__tQyGS","checkedDiv":"ReceiveType_checkedDiv__K_Cea","disableTab":"ReceiveType_disableTab__cJJdM","checkedButton":"ReceiveType_checkedButton__VKq8H","mobile-view-tab":"ReceiveType_mobile-view-tab__RXdIj","dropDown":"ReceiveType_dropDown__Q_8H3","delivery-icon":"ReceiveType_delivery-icon__iytol","heading":"ReceiveType_heading__xsj23","radio-buttons-wrapper":"ReceiveType_radio-buttons-wrapper__kJ0q6","button":"ReceiveType_button__oMnoT","buttons-wrapper":"ReceiveType_buttons-wrapper__ifE9D","buttons-wrapper__container":"ReceiveType_buttons-wrapper__container__jvIrs"};

/***/ }),

/***/ 61769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-details":"DeliveryDetails_main-details__mN53T","inline-details":"DeliveryDetails_inline-details__kFuku"};

/***/ }),

/***/ 94603:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inline-details":"FormInlineDetails_inline-details__rWsxi","title":"FormInlineDetails_title__6fPLy","value":"FormInlineDetails_value__d8zvQ","value__first":"FormInlineDetails_value__first__JWuj3","value__change":"FormInlineDetails_value__change__CzGC6"};

/***/ }),

/***/ 49803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cart":"InlineItem_cart__CJnzQ","cart-product__info":"InlineItem_cart-product__info__lr_uT","product-image":"InlineItem_product-image__Au__s","vas-product-image":"InlineItem_vas-product-image__FfiaG","specs":"InlineItem_specs__kKsrM","label":"InlineItem_label__kd9kF","vas-desc":"InlineItem_vas-desc__22l_v","vas-desc--text":"InlineItem_vas-desc--text__4Gvtc","display-specs":"InlineItem_display-specs__S2ohk","change":"InlineItem_change__j_yYU","value":"InlineItem_value__spCKI","line-separator":"InlineItem_line-separator__hKyBo","tag":"InlineItem_tag__1q8EN","tag__icon":"InlineItem_tag__icon__Fo7R9","tag__label":"InlineItem_tag__label__u1v29","cart-product__price":"InlineItem_cart-product__price__Cb6AE","qty-wrapper":"InlineItem_qty-wrapper__aD5Dp","qty":"InlineItem_qty__gEl66","price-wrapper":"InlineItem_price-wrapper__408Ss","discount":"InlineItem_discount__pxVaw","price":"InlineItem_price__YTXjL","cart-product":"InlineItem_cart-product__OyM7r","accordion-toggle-wrapper":"InlineItem_accordion-toggle-wrapper__MHScL","accordion-toggle":"InlineItem_accordion-toggle__hRxtu","active":"InlineItem_active__FAgTw","cart-product__buttons":"InlineItem_cart-product__buttons__3auLC","deal-buttons":"InlineItem_deal-buttons__vAtBb","collapse":"InlineItem_collapse__ADE0p","btnIcon":"InlineItem_btnIcon__DernQ","promotion":"InlineItem_promotion___V1Nh","icon":"InlineItem_icon__aifkW","main-label":"InlineItem_main-label__Kj_Rc","sub-label":"InlineItem_sub-label__o46jb","trash":"InlineItem_trash___qTlW","deal-product":"InlineItem_deal-product__ykum1","deal-promo":"InlineItem_deal-promo__qx29G","deal-highlight":"InlineItem_deal-highlight__ub_ta","deal-highlight__icon":"InlineItem_deal-highlight__icon__A3wJf","deal-highlight__description":"InlineItem_deal-highlight__description__FZ7NG","deal-highlight__value":"InlineItem_deal-highlight__value__F_HsZ","deal-highlight__type":"InlineItem_deal-highlight__type__pDYGO","additional-item":"InlineItem_additional-item__BAS_Q","icon-text":"InlineItem_icon-text__5z8ZT","description":"InlineItem_description__tcIdR","img":"InlineItem_img__ap_pe","dots":"InlineItem_dots__Qw6J6"};

/***/ }),

/***/ 41830:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item-details":"ItemsDetails_item-details__VdUDg","item-details__top":"ItemsDetails_item-details__top__RZrkk","total-item-label":"ItemsDetails_total-item-label__UNnTX","item-details__mid":"ItemsDetails_item-details__mid__137Kr","item-details__bottom":"ItemsDetails_item-details__bottom__23q1U","total-price-label":"ItemsDetails_total-price-label__TF__L","total-price":"ItemsDetails_total-price__bcG2y","snack-bar-styling":"ItemsDetails_snack-bar-styling__w0MaC"};

/***/ }),

/***/ 14305:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"payment-button":"ButtonPayment_payment-button__obFyG","secure":"ButtonPayment_secure__VOdn5"};

/***/ }),

/***/ 55207:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"delivery-container":"CheckoutDelivery_delivery-container__tUF0S","standard-box":"CheckoutDelivery_standard-box__aONA5","search-wrapper":"CheckoutDelivery_search-wrapper__mGmaI","search-wrapper__input":"CheckoutDelivery_search-wrapper__input__FesLE","tiles-section":"CheckoutDelivery_tiles-section__DPZIb","section":"CheckoutDelivery_section__humcA","collectInStoreBox":"CheckoutDelivery_collectInStoreBox__pqWWc","dropdown-container":"CheckoutDelivery_dropdown-container__8xHDq","dropdown-label":"CheckoutDelivery_dropdown-label__TfuNz","result":"CheckoutDelivery_result__O2b_Q","result-label":"CheckoutDelivery_result-label__xHKbt","result-grey-out":"CheckoutDelivery_result-grey-out__0OMPX","storeCard":"CheckoutDelivery_storeCard__kiy2r","storeCard-list":"CheckoutDelivery_storeCard-list__eX_kE","serviceDown":"CheckoutDelivery_serviceDown__mGgYh","serviceDown__icon":"CheckoutDelivery_serviceDown__icon__xKC0d","storeContainer":"CheckoutDelivery_storeContainer__mUIM3","emptyProductsContainer_emptyProductContainer":"CheckoutDelivery_emptyProductsContainer_emptyProductContainer__D5m5o","value":"CheckoutDelivery_value___5DPy","value__second":"CheckoutDelivery_value__second___1DkJ","order-1":"CheckoutDelivery_order-1__wF3wt","storeCard-container":"CheckoutDelivery_storeCard-container__xUnMS","empty-wrapper":"CheckoutDelivery_empty-wrapper__GJ7d6"};

/***/ }),

/***/ 54006:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"success-container":"CheckoutOrderConfirmation_success-container__kwYoY","top":"CheckoutOrderConfirmation_top__h0vw2","icon":"CheckoutOrderConfirmation_icon__sABcG","heading":"CheckoutOrderConfirmation_heading__QlXB9","main-content":"CheckoutOrderConfirmation_main-content__11G6e","sub-content":"CheckoutOrderConfirmation_sub-content__lop11","title":"CheckoutOrderConfirmation_title__eRydk","days":"CheckoutOrderConfirmation_days__fusM7","reference":"CheckoutOrderConfirmation_reference__96MMS","value":"CheckoutOrderConfirmation_value__NH9v_","button-section":"CheckoutOrderConfirmation_button-section__505ck","track-btn":"CheckoutOrderConfirmation_track-btn__F4VW2","email-doc-btn":"CheckoutOrderConfirmation_email-doc-btn__yohNY","mid":"CheckoutOrderConfirmation_mid__TZ3JN","next-steps":"CheckoutOrderConfirmation_next-steps____c_w","debi-check-container":"CheckoutOrderConfirmation_debi-check-container__W_j5y","bottom":"CheckoutOrderConfirmation_bottom__2yQFs","info-section":"CheckoutOrderConfirmation_info-section__eajqz","purchased-items":"CheckoutOrderConfirmation_purchased-items__b76DR","continue-btn":"CheckoutOrderConfirmation_continue-btn__n3Qwp","btn":"CheckoutOrderConfirmation_btn__YrvKR","error-container":"CheckoutOrderConfirmation_error-container__xBb7b","desc":"CheckoutOrderConfirmation_desc__xou0_","button-wrapper":"CheckoutOrderConfirmation_button-wrapper__c9WUB","retry-btn":"CheckoutOrderConfirmation_retry-btn__q9cTe","top-notification":"CheckoutOrderConfirmation_top-notification__Hidg8","dismiss":"CheckoutOrderConfirmation_dismiss__tE24B"};

/***/ }),

/***/ 52923:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-wrapper":"CheckoutPage_main-wrapper__rA5xW","content-wrapper":"CheckoutPage_content-wrapper__cTgw9","success":"CheckoutPage_success___sE8I","center-container":"CheckoutPage_center-container__SpWiF","main-row":"CheckoutPage_main-row__I715Q","back-button":"CheckoutPage_back-button__8CLOR","top-wrapper":"CheckoutPage_top-wrapper__Fn6xE","top-wrapper__heading":"CheckoutPage_top-wrapper__heading___iGXJ","top-wrapper__desc":"CheckoutPage_top-wrapper__desc__3B_Xq","main-section":"CheckoutPage_main-section__ldOHy","post-checkout-main-section":"CheckoutPage_post-checkout-main-section__Vms_e","right":"CheckoutPage_right__ItLdH","notify-wrapper":"CheckoutPage_notify-wrapper__BjU_N","notify-container":"CheckoutPage_notify-container__mfhkm","msg":"CheckoutPage_msg__yUXqK","text-style":"CheckoutPage_text-style__TlYuh","error-tooltip":"CheckoutPage_error-tooltip__YDqOW","left":"CheckoutPage_left__gR15G","col-left":"CheckoutPage_col-left__uL8ZS","col-right":"CheckoutPage_col-right__QBRdJ"};

/***/ }),

/***/ 51704:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"payment-container":"CheckoutPayment_payment-container__z7DZ2","top-wrapper__heading":"CheckoutPayment_top-wrapper__heading__Uklfj","tiles-section":"CheckoutPayment_tiles-section__hA2aw","change-payment-label":"CheckoutPayment_change-payment-label__6M8Nz","error-container":"CheckoutPayment_error-container__O4mXr","icon":"CheckoutPayment_icon__FQX3H","text":"CheckoutPayment_text__3Zsiq","snack-bar-styling":"CheckoutPayment_snack-bar-styling__NOIct"};

/***/ }),

/***/ 29579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error-container":"CheckoutPaymentError_error-container__8ZC6V","icon":"CheckoutPaymentError_icon__yA0gU","heading":"CheckoutPaymentError_heading__6bjoe","content":"CheckoutPaymentError_content__qWtxT","button-wrapper":"CheckoutPaymentError_button-wrapper__Yjkvq","try-btn":"CheckoutPaymentError_try-btn__8osEa","try-btn__primary":"CheckoutPaymentError_try-btn__primary__2AX7Q","link":"CheckoutPaymentError_link__ittBt"};

/***/ }),

/***/ 88094:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"review-container":"CheckoutReview_review-container__pyyvu","top-wrapper":"CheckoutReview_top-wrapper__xuW_C","top-wrapper__heading":"CheckoutReview_top-wrapper__heading__El3wz","section":"CheckoutReview_section__711qK","success-msg":"CheckoutReview_success-msg__YdN2T"};

/***/ }),

/***/ 43550:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"debi_link_container":"DebicheckLink_debi_link_container__wVACS","debi_link_container_top":"DebicheckLink_debi_link_container_top__Wt2zx","debi_link_icon":"DebicheckLink_debi_link_icon__0RzGx","debi_link_info":"DebicheckLink_debi_link_info__ELzlI","debi_mandate_link_head":"DebicheckLink_debi_mandate_link_head__2hMdz","debi_mandate_link_descr":"DebicheckLink_debi_mandate_link_descr__95PY2","debi_mandate_action_link":"DebicheckLink_debi_mandate_action_link__0uxOW","debi_link_anc_icon":"DebicheckLink_debi_link_anc_icon__vrvUp","action_link":"DebicheckLink_action_link__ILN5H"};

/***/ }),

/***/ 44025:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"emptyProductContainer":"emptyProductsContainer_emptyProductContainer__ClTiq","content":"emptyProductsContainer_content__dQ1Ik","resetBtn":"emptyProductsContainer_resetBtn__TIPe4","emptyProductResetBtn":"emptyProductsContainer_emptyProductResetBtn__6lRYk","imageStyle":"emptyProductsContainer_imageStyle__vMBiK","buttonStyle":"emptyProductsContainer_buttonStyle__y6jNn"};

/***/ }),

/***/ 43819:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"payment-redirect":"PaymentRedirect_payment-redirect__Pap3y","icon":"PaymentRedirect_icon__joeGh","desc":"PaymentRedirect_desc__3qtvj"};

/***/ })

}]);